var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));

// src/AppAdminRoutes.tsx
import { Navigate as Navigate38 } from "react-router-dom";
import { ErrorContainer as ErrorContainer11 } from "shared-ui";
import { DebuggerConfig } from "app-core";

// src/public/SignIn/SignInLoader.tsx
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  useCustomEventListener,
  useClearNextLocation,
  useNextLocation
} from "shared-lib";
import { jsx } from "react/jsx-runtime";
var SignInLoader = () => {
  const navigate = useNavigate();
  const clearLocation = useClearNextLocation();
  const [nextLocation] = useNextLocation();
  const [nextPage, setNextPage] = useState(null);
  useEffect(() => {
    if (!nextPage) {
      return;
    }
    if (nextPage.startsWith("http")) {
      window.location.href = nextPage;
    } else {
      navigate(nextPage, { replace: true });
    }
  }, [navigate, nextPage]);
  useCustomEventListener(
    "user-signed-in",
    () => {
      if (nextLocation) {
        setNextPage(nextLocation);
        clearLocation();
      } else {
        setNextPage("../app");
      }
    },
    [nextLocation]
  );
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Link, { to: `../app`, children: "Go To App" }) });
};

// src/public/HomePage.tsx
import { useNavigate as useNavigate2 } from "react-router-dom";
import { EdLink } from "shared-ui";
import { useOIDC } from "app-core";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var HomePage = () => {
  const navigate = useNavigate2();
  const { signIn } = useOIDC();
  async function onSignIn() {
    await signIn("app");
    navigate("app");
  }
  return /* @__PURE__ */ jsx2("div", { className: "container", children: /* @__PURE__ */ jsx2("div", { className: "bg-white", children: /* @__PURE__ */ jsxs("div", { className: "mx-auto max-w-7xl px-4 py-12 text-center sm:px-6 lg:px-8 lg:py-16", children: [
    /* @__PURE__ */ jsx2("h2", { className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl", children: /* @__PURE__ */ jsx2("span", { className: "block", children: "Myn Administration" }) }),
    /* @__PURE__ */ jsxs("div", { className: "mt-8 flex justify-center", children: [
      /* @__PURE__ */ jsx2("div", { className: "inline-flex rounded-md shadow", children: /* @__PURE__ */ jsx2(
        "a",
        {
          onClick: onSignIn,
          className: "bg-info-600 hover:bg-info-700 rounded-md border border-transparent px-5 py-3 text-base font-medium text-white",
          children: "Sign In"
        }
      ) }),
      /* @__PURE__ */ jsx2("div", { className: "ml-3 inline-flex", children: /* @__PURE__ */ jsx2(EdLink, { href: "public/signup", name: "signup-link", children: /* @__PURE__ */ jsx2("div", { className: "bg-info-100 text-info-700 hover:bg-info-200 inline-flex items-center justify-center rounded-md border border-transparent px-5 py-3 text-base font-medium", children: "Sign Up" }) }) })
    ] })
  ] }) }) });
};

// src/secure/index.ts
var secure_exports = {};
__export(secure_exports, {
  Account: () => Account,
  AccountsHomeList: () => AccountsHomeList,
  AdminLayout: () => AdminLayout,
  AdminNotificationsLayout: () => AdminNotificationsLayout,
  AdminUserGroupsListRoute: () => AdminUserGroupsListRoute,
  AdminUsersListRoute: () => AdminUsersListRoute,
  AppAdminSecureLayout: () => AppAdminSecureLayout,
  AppAdminSecureRoutes: () => AppAdminSecureRoutes,
  BullhornLayoutPage: () => BullhornLayoutPage,
  BullhornTenantCandidatesPage: () => BullhornTenantCandidatesPage,
  BullhornTenantDetailsPage: () => BullhornTenantDetailsPage,
  BullhornTenantEventsPage: () => BullhornTenantEventsPage,
  BullhornTenantJobOrderPage: () => BullhornTenantJobOrderPage,
  BullhornTenantJobOrdersPage: () => BullhornTenantJobOrdersPage,
  BullhornTenantsListPage: () => BullhornTenantsListPage,
  CustomDataFieldMappingDetailPage: () => CustomDataFieldMappingDetailPage,
  CustomDataFieldMappingListPage: () => CustomDataFieldMappingListPage,
  CustomDataFieldMappingNewPage: () => CustomDataFieldMappingNewPage,
  CustomDataFieldMappingsLayoutPage: () => CustomDataFieldMappingsLayoutPage,
  CustomDataHome: () => CustomDataHome,
  EmployersLayout: () => EmployersLayout,
  EmployersListRoute: () => EmployersListRoute,
  IntegrationsConfigEmployerMappingDetailPage: () => IntegrationsConfigEmployerMappingDetailPage,
  IntegrationsConfigEmployerMappingListPage: () => IntegrationsConfigEmployerMappingListPage,
  IntegrationsConfigEmployerMappingNewPage: () => IntegrationsConfigEmployerMappingNewPage,
  IntegrationsConfigLayoutPage: () => IntegrationsConfigLayoutPage,
  IntegrationsLayout: () => IntegrationsLayout,
  SystemsLayout: () => SystemsLayout,
  WorkflowDesignerPage: () => WorkflowDesignerPage,
  WorkflowHomePage: () => WorkflowHomePage,
  WorkflowsLayout: () => WorkflowsLayout,
  createAdminRoutes: () => createAdminRoutes,
  createAppAdminAccountsRoutes: () => createAppAdminAccountsRoutes,
  createAppAdminRecruitRoutes: () => createAppAdminRecruitRoutes,
  createCustomDataRoutes: () => createCustomDataRoutes,
  createEmployersRoutes: () => createEmployersRoutes,
  createNotificationRoutes: () => createNotificationRoutes,
  createTalentPoolsRoutes: () => createTalentPoolsRoutes,
  loader: () => loader,
  useAdminUserCreate: () => useAdminUserCreate,
  useAdminUserDisable: () => useAdminUserDisable,
  useAdminUserEnable: () => useAdminUserEnable,
  useAdminUserGroupCreate: () => useAdminUserGroupCreate,
  useAdminUserGroupUpdate: () => useAdminUserGroupUpdate,
  useAdminUserGroupUpdatePermissions: () => useAdminUserGroupUpdatePermissions,
  useAdminUserJoinGroup: () => useAdminUserJoinGroup,
  useAdminUserLeaveGroup: () => useAdminUserLeaveGroup,
  useAdminUserUpdate: () => useAdminUserUpdate
});

// src/secure/__generated__/AppAdminSecureLayoutQuery.graphql.ts
var node = function() {
  var v0 = [
    {
      "alias": "account",
      "args": null,
      "concreteType": "AccountsAdminUser",
      "kind": "LinkedField",
      "name": "accountsAdminUserViewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTestUser",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "AppAdminSecureLayoutQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "AppAdminSecureLayoutQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "05a7a8095b58d7c33204003520c26605",
      "id": null,
      "metadata": {},
      "name": "AppAdminSecureLayoutQuery",
      "operationKind": "query",
      "text": "query AppAdminSecureLayoutQuery {\n  account: accountsAdminUserViewer {\n    id\n    code\n    accountId\n    createdAt\n    updatedAt\n    firstName\n    lastName\n    emailAddress\n    isTestUser\n  }\n}\n"
    }
  };
}();
node.hash = "ae743f9aa5af9503c3466cc034d1cfc4";
var AppAdminSecureLayoutQuery_graphql_default = node;

// src/secure/AppAdminSecureLayout.tsx
import { useCallback } from "react";
import {
  loadQuery,
  usePreloadedQuery
} from "react-relay";
import {
  Outlet,
  useLoaderData,
  useLocation
} from "react-router-dom";
import {
  ArrowRightOnRectangleIcon,
  CircleStackIcon,
  CubeIcon,
  PhotoIcon,
  Squares2X2Icon,
  DocumentTextIcon
} from "@heroicons/react/24/outline";
import {
  Button,
  CandidateShell,
  createLinkState,
  Size
} from "shared-ui";
import { useAuth, OutletRoute } from "app-core";
import { createDataManagementRoutes } from "feature-data-management";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var queryDef = AppAdminSecureLayoutQuery_graphql_default;
var AppAdminSecureRoutes = (environment, context) => {
  return [
    {
      path: "accounts/*",
      element: /* @__PURE__ */ jsx3(OutletRoute, {}),
      children: createAppAdminAccountsRoutes(environment, context)
    },
    { path: "account/*", element: /* @__PURE__ */ jsx3(Account, {}) },
    {
      path: "custom-data/*",
      element: /* @__PURE__ */ jsx3(OutletRoute, {}),
      children: createCustomDataRoutes(environment, context)
    },
    {
      path: "data-management/*",
      element: /* @__PURE__ */ jsx3(OutletRoute, {}),
      children: createDataManagementRoutes(environment, context)
    },
    {
      path: "recruit/*",
      element: /* @__PURE__ */ jsx3(OutletRoute, {}),
      children: createAppAdminRecruitRoutes(environment, context)
    },
    {
      path: "notifications/*",
      element: /* @__PURE__ */ jsx3(OutletRoute, {}),
      children: createNotificationRoutes(environment, context)
    },
    { path: "integrations/*", element: /* @__PURE__ */ jsx3(IntegrationsLayout, {}) },
    { path: "workflows/*", element: /* @__PURE__ */ jsx3(WorkflowsLayout, {}) },
    { path: "system/*", element: /* @__PURE__ */ jsx3(SystemsLayout, {}) },
    {
      path: "*",
      element: /* @__PURE__ */ jsx3("div", { className: "p-4", children: /* @__PURE__ */ jsx3("h3", { children: "Welcome" }) })
    }
  ];
};
var AppAdminSecureLayout = () => {
  const auth = useAuth();
  const preloadedQuery = useLoaderData();
  const data = usePreloadedQuery(queryDef, preloadedQuery);
  const { account } = data;
  const location = useLocation();
  const accountLink = createLinkState(
    location,
    "Account",
    `account`,
    Squares2X2Icon
  );
  const sidebarNavigation = [
    accountLink,
    createLinkState(location, "Accounts", `accounts`, PhotoIcon),
    createLinkState(location, "Integrations", `integrations`, CubeIcon),
    createLinkState(location, "Recruit", `recruit`, DocumentTextIcon),
    createLinkState(
      location,
      "Notifications",
      `notifications`,
      CircleStackIcon
    ),
    createLinkState(location, "Custom Data", `custom-data`, CircleStackIcon),
    createLinkState(location, "Data", `data-management`, CircleStackIcon),
    createLinkState(location, "Workflows", `workflows`, CubeIcon),
    createLinkState(location, "System", `system`, CubeIcon)
  ];
  const trayNavigation = [
    createLinkState(location, "Accounts", `accounts`, PhotoIcon),
    createLinkState(location, "Recruit", `recruit`, DocumentTextIcon),
    createLinkState(location, "Integrations", `integrations`, CubeIcon),
    createLinkState(
      location,
      "Notifications",
      `notifications`,
      CircleStackIcon
    )
  ];
  const onSignOut = useCallback(async () => {
    await auth?.signOutRedirect();
  }, [auth]);
  const userNavigation = [
    accountLink,
    {
      name: "Sign out",
      to: ".",
      icon: ArrowRightOnRectangleIcon,
      onClick: onSignOut
    }
  ];
  if (!account) {
    return /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx3("div", { className: "p-4 font-bold", children: "Logged Out" }),
      /* @__PURE__ */ jsx3("div", { className: "p-4", children: /* @__PURE__ */ jsx3(Button, { color: "primary", size: Size.lg, clicked: onSignOut, children: "Sign In" }) })
    ] });
  }
  return /* @__PURE__ */ jsx3(
    CandidateShell,
    {
      accountLink: "/admin/app/account",
      sidebarNavigation,
      userNavigation,
      trayNavigation,
      accountInfo: {
        firstName: account.firstName,
        lastName: account.lastName
      },
      children: /* @__PURE__ */ jsx3(Outlet, {})
    }
  );
};
async function loader(environment) {
  return loadQuery(environment, queryDef, {});
}

// src/secure/account/Account.tsx
import { useCallback as useCallback2, useState as useState2 } from "react";
import { useCopyToClipboard, useTimeoutFn } from "react-use";
import { Transition } from "@headlessui/react";
import { Button as Button2 } from "shared-ui";
import { getAuthTokenKey, useAuth as useAuth2, useIdentityLink } from "app-core";
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var Account = () => {
  const [authKey] = useState2(() => {
    return getAuthTokenKey();
  });
  const auth = useAuth2();
  const [state, copyToClipboard] = useCopyToClipboard();
  const [isShowing, setIsShowing] = useState2(false);
  const [isReady, cancel, reset] = useTimeoutFn(() => {
    setIsShowing(false);
  }, 2e3);
  const accountLink = useIdentityLink();
  const copyAuthToken = useCallback2(() => {
    cancel();
    if (!auth || !auth.userData) {
      alert("not logged in");
      setIsShowing(false);
      return;
    }
    copyToClipboard(
      `"Authorization": "Bearer ${auth?.userData?.access_token}"`
    );
    setIsShowing(true);
    reset();
  }, [auth]);
  if (auth && auth.userData) {
    return /* @__PURE__ */ jsxs3("div", { className: "p-8", children: [
      /* @__PURE__ */ jsxs3("div", { className: "border bg-white p-8 sm:w-1/2", children: [
        /* @__PURE__ */ jsxs3("p", { className: "p-2", children: [
          "Name: ",
          auth?.userData?.profile?.ElevateAccountName
        ] }),
        /* @__PURE__ */ jsxs3("p", { className: "p-2", children: [
          "Email: ",
          auth?.userData?.profile?.email
        ] }),
        /* @__PURE__ */ jsx4("div", { className: "p-2", children: /* @__PURE__ */ jsxs3("div", { className: "flex space-x-2 py-2", children: [
          /* @__PURE__ */ jsx4(
            "a",
            {
              className: "bg-primary-800 text-md rounded-lg border px-2.5 py-1 font-medium text-white",
              href: accountLink,
              target: "identity",
              children: "Go To Identity Account"
            }
          ),
          /* @__PURE__ */ jsx4(Button2, { clicked: () => auth.signOutRedirect(), children: "Log out!" }),
          /* @__PURE__ */ jsx4(Button2, { color: "primary", clicked: copyAuthToken, children: "Copy Auth Token" })
        ] }) }),
        /* @__PURE__ */ jsxs3(Transition, { show: isShowing, className: "flex p-2", children: [
          state.value ? /* @__PURE__ */ jsx4("div", { className: "text-success-500 w-48 rounded-md border p-2 font-medium", children: "Copied" }) : null,
          state.error ? /* @__PURE__ */ jsx4("div", { className: "text-danger-500 rounded-md border p-2", children: /* @__PURE__ */ jsxs3("p", { children: [
            "Unable to copy value: ",
            state.error.message
          ] }) }) : null
        ] })
      ] }),
      /* @__PURE__ */ jsx4("div", { className: "flex mt-4", children: /* @__PURE__ */ jsxs3("div", { className: "bg-white border flex gap-2 p-2", children: [
        /* @__PURE__ */ jsx4("div", { className: "text-primary-500 font-bold", children: "Auth Key" }),
        /* @__PURE__ */ jsx4("div", { className: "text-gray-800 font-bold", children: authKey })
      ] }) })
    ] });
  }
  return /* @__PURE__ */ jsx4("div", { children: "Not logged in! Try to refresh to be redirected to Google." });
};

// src/secure/custom_data/CustomDataLayout.tsx
import { Suspense as Suspense21 } from "react";
import { Navigate as Navigate9, Outlet as Outlet5, useLocation as useLocation4 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary4 } from "react-error-boundary";
import {
  InformationCircleIcon,
  DocumentIcon,
  BuildingStorefrontIcon,
  HomeIcon
} from "@heroicons/react/24/outline";
import { ErrorBoundaryFallback as ErrorBoundaryFallback4 } from "app-core";
import { createLinkState as createLinkState4, TabUnderline as TabUnderline3 } from "shared-ui";
import { OutletRoute as OutletRoute7 } from "app-core";

// src/secure/custom_data/form-templates/FormTemplatesRoute.tsx
import { Suspense as Suspense9 } from "react";
import { Navigate as Navigate3 } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import {
  ErrorBoundaryFallback,
  FormTemplateListContainer,
  OutletRoute as OutletRoute3
} from "app-core";

// src/secure/custom_data/form-templates/FormTemplateRoute.tsx
import { Navigate as Navigate2 } from "react-router-dom";
import { ErrorContainer } from "shared-ui";

// src/secure/custom_data/form-templates/__generated__/FormTemplateLayoutQuery.graphql.ts
var node2 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "alias": "formTemplate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "formTemplateCode"
        }
      ],
      "concreteType": "FormTemplate",
      "kind": "LinkedField",
      "name": "customDataFormTemplateByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formTemplateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "dbaea3ef06147a68b0b47f50f76bf0f9",
      "id": null,
      "metadata": {},
      "name": "FormTemplateLayoutQuery",
      "operationKind": "query",
      "text": "query FormTemplateLayoutQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    code\n    key\n    name\n    description\n  }\n}\n"
    }
  };
}();
node2.hash = "365f1a9ae1ac686ab40b28164855fa78";
var FormTemplateLayoutQuery_graphql_default = node2;

// src/secure/custom_data/form-templates/FormTemplateLayout.tsx
import { Suspense, useMemo } from "react";
import {
  Link as Link2,
  Outlet as Outlet2,
  useLocation as useLocation2,
  useLoaderData as useLoaderData2,
  useRouteLoaderData
} from "react-router-dom";
import {
  loadQuery as loadQuery2,
  usePreloadedQuery as usePreloadedQuery2
} from "react-relay";
import {
  createLinkState as createLinkState2,
  DynamicBreadcrumb,
  ExpandButton,
  TabUnderline
} from "shared-ui";
import { Fragment, jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var routeId = "form-template-home";
var formTemplateLayoutLayoutQueryDef = FormTemplateLayoutQuery_graphql_default;
var FormTemplateLayout = ({ showHeader }) => {
  const location = useLocation2();
  const tabs4 = useMemo(() => {
    return [
      createLinkState2(location, "Details", `../details`),
      createLinkState2(location, "Viewer", `../viewer`),
      createLinkState2(location, "Editor", `../editor`),
      createLinkState2(location, "Access", `../access`)
    ];
  }, [location]);
  const preloadedQuery = useLoaderData2();
  const data = usePreloadedQuery2(
    formTemplateLayoutLayoutQueryDef,
    preloadedQuery
  );
  const { formTemplate } = data;
  if (formTemplate === null || formTemplate === void 0) {
    return /* @__PURE__ */ jsx5("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx5(Suspense, { fallback: "Loading...", children: /* @__PURE__ */ jsxs4("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsxs4(Fragment, { children: [
      /* @__PURE__ */ jsxs4("div", { className: "flex flex-wrap items-center justify-between border-b", children: [
        /* @__PURE__ */ jsx5("div", { className: "p-2", children: /* @__PURE__ */ jsx5(
          ExpandButton,
          {
            to: `../../../${formTemplate.code}`,
            label: "View Form Template"
          }
        ) }),
        /* @__PURE__ */ jsx5(DynamicBreadcrumb, {}),
        /* @__PURE__ */ jsx5("div", { className: "text-primary-500 px-2 font-medium uppercase sm:px-8", children: formTemplate.name })
      ] }),
      /* @__PURE__ */ jsx5("div", { className: "flex flex-wrap items-center gap-2 border-b p-4", children: /* @__PURE__ */ jsx5("div", { className: "text-primary-500 font-medium uppercase", children: formTemplate.description }) })
    ] }),
    /* @__PURE__ */ jsx5("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx5(TabUnderline, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx5(Outlet2, {})
  ] }) });
};
var FormTemplateLink = ({ routeId: routeId6, label }) => {
  const data = useFormTemplateRouteData(routeId6);
  if (!data.formTemplate) {
    return /* @__PURE__ */ jsx5(Fragment, {});
  }
  const name = `${data.formTemplate.name}`;
  return /* @__PURE__ */ jsx5(Suspense, { fallback: "Loading...", children: /* @__PURE__ */ jsx5(Link2, { to: ".", children: label || name }) });
};
async function loader2(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery2(
    environment,
    formTemplateLayoutLayoutQueryDef,
    {
      formTemplateCode
    }
  );
}
function useFormTemplateRouteData(routeId6) {
  const queryRef = useRouteLoaderData(
    routeId6
  );
  const data = usePreloadedQuery2(
    formTemplateLayoutLayoutQueryDef,
    queryRef
  );
  return data;
}

// src/secure/custom_data/form-templates/__generated__/FormTemplateDetailsRouteQuery.graphql.ts
var node3 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "alias": "formTemplate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "formTemplateCode"
        }
      ],
      "concreteType": "FormTemplate",
      "kind": "LinkedField",
      "name": "customDataFormTemplateByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formTemplateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateDetailsRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateDetailsRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "ace209220d40c0276a39b2d53cc67b29",
      "id": null,
      "metadata": {},
      "name": "FormTemplateDetailsRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateDetailsRouteQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    code\n    key\n    name\n    description\n    updatedAt\n  }\n}\n"
    }
  };
}();
node3.hash = "2da8f9b77cb1001e0b9c6953e7d043e2";
var FormTemplateDetailsRouteQuery_graphql_default = node3;

// src/secure/custom_data/form-templates/FormTemplateDetails.tsx
import { Suspense as Suspense2 } from "react";
import { loadQuery as loadQuery3 } from "react-relay";
import { Link as Link3 } from "react-router-dom";
import { timeAgo, useRouteData } from "shared-lib";
import { EdSkeleton } from "shared-ui";
import { Fragment as Fragment2, jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var queryDef2 = FormTemplateDetailsRouteQuery_graphql_default;
async function loader3(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery3(environment, queryDef2, {
    formTemplateCode
  });
}
var FormTemplateDetails = ({ routeId: routeId6, inList }) => {
  const data = useRouteData(queryDef2, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx6(Fragment2, { children: "Loading..." });
  }
  const { formTemplate } = data;
  if (!formTemplate) {
    return /* @__PURE__ */ jsx6(Fragment2, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx6(Suspense2, { fallback: /* @__PURE__ */ jsx6(EdSkeleton, {}), children: /* @__PURE__ */ jsx6("div", { className: "grid gap-2 border-b bg-white p-4 sm:grid-cols-3", children: /* @__PURE__ */ jsxs5("div", { className: "my-4 flex flex-col gap-2", children: [
    /* @__PURE__ */ jsxs5("div", { className: "flex items-center justify-between gap-2 border-b", children: [
      /* @__PURE__ */ jsx6("div", { className: "text-primary-500 p-4 text-lg font-medium", children: formTemplate.name }),
      /* @__PURE__ */ jsxs5("div", { className: "text-primary-500 p-4 text-sm", children: [
        "Updated ",
        timeAgo(formTemplate.updatedAt)
      ] })
    ] }),
    /* @__PURE__ */ jsx6("div", { className: "text-md p-4 text-gray-900", children: formTemplate.description })
  ] }) }) });
};
var createRoute = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-form-template-root`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx6(FormTemplateDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx6(Link3, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader3(environment, params);
    }
  };
};

// src/secure/custom_data/form-templates/__generated__/FormTemplateEditRouteQuery.graphql.ts
var node4 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "formTemplateCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateId",
    "storageKey": null
  }, v4 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateEditRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FormTemplateEditor_formTemplate"
            },
            v4
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateEditRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "typeId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowPreFilling",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requiresSignature",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uiSchema",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dataSchema",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "documentTypeId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "htmlTemplate",
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0c8a9ad97a2b76ac402ee3e206e93f9b",
      "id": null,
      "metadata": {},
      "name": "FormTemplateEditRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateEditRouteQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    ...FormTemplateEditor_formTemplate\n  }\n}\n\nfragment FormTemplateEditor_formTemplate on FormTemplate {\n  id\n  formTemplateId\n  version\n  code\n  createdAt\n  updatedAt\n  key\n  name\n  description\n  typeId\n  allowPreFilling\n  requiresSignature\n  uiSchema\n  dataSchema\n  documentTypeId\n  htmlTemplate\n}\n"
    }
  };
}();
node4.hash = "6173452a179b4685e1444659bf694748";
var FormTemplateEditRouteQuery_graphql_default = node4;

// src/secure/custom_data/form-templates/FormTemplateEdit.tsx
import { Suspense as Suspense3, useCallback as useCallback3 } from "react";
import { loadQuery as loadQuery4 } from "react-relay";
import { Link as Link4, useNavigate as useNavigate3 } from "react-router-dom";
import { useRouteData as useRouteData2 } from "shared-lib";
import { EdSkeleton as EdSkeleton2 } from "shared-ui";
import { FormTemplateEditor } from "app-core";
import { Fragment as Fragment3, jsx as jsx7 } from "react/jsx-runtime";
var queryDef3 = FormTemplateEditRouteQuery_graphql_default;
async function loader4(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery4(environment, queryDef3, {
    formTemplateCode
  });
}
var FormTemplateEdit = ({ routeId: routeId6, inList }) => {
  const navigate = useNavigate3();
  const data = useRouteData2(queryDef3, routeId6);
  const onNavigateToDetails = useCallback3(() => {
    navigate("../details");
  }, []);
  if (!data) {
    return /* @__PURE__ */ jsx7(Fragment3, { children: "Loading..." });
  }
  const { formTemplate } = data;
  if (!formTemplate) {
    return /* @__PURE__ */ jsx7(Fragment3, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx7(Suspense3, { fallback: /* @__PURE__ */ jsx7(EdSkeleton2, {}), children: /* @__PURE__ */ jsx7(
    FormTemplateEditor,
    {
      fragmentRef: formTemplate,
      onSaved: onNavigateToDetails,
      onCancel: onNavigateToDetails
    }
  ) });
};
var createRoute2 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-form-template-edit`;
  return {
    id: routeId6,
    path: "edit",
    element: /* @__PURE__ */ jsx7(FormTemplateEdit, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx7(Link4, { to: "edit", children: "Editor" })
    },
    loader: ({ params }) => {
      return loader4(environment, params);
    }
  };
};

// src/secure/custom_data/form-templates/__generated__/FormTemplateViewerRouteQuery.graphql.ts
var node5 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "alias": "formTemplate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "formTemplateCode"
        }
      ],
      "concreteType": "FormTemplate",
      "kind": "LinkedField",
      "name": "customDataFormTemplateByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formTemplateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dataSchema",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uiSchema",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateViewerRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateViewerRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "b82374716bd6ae6cc28da8a862961f97",
      "id": null,
      "metadata": {},
      "name": "FormTemplateViewerRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateViewerRouteQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    code\n    key\n    name\n    description\n    updatedAt\n    dataSchema\n    uiSchema\n  }\n}\n"
    }
  };
}();
node5.hash = "37e096beb392f87b233d610b5fcaa43c";
var FormTemplateViewerRouteQuery_graphql_default = node5;

// src/secure/custom_data/form-templates/FormTemplateViewer.tsx
import { Suspense as Suspense4, useCallback as useCallback4, useState as useState3 } from "react";
import { loadQuery as loadQuery5 } from "react-relay";
import { Link as Link5 } from "react-router-dom";
import { JsonForms } from "@jsonforms/react";
import { JsonFormsStyleContext } from "@jsonforms/vanilla-renderers";
import { useRouteData as useRouteData3, useToggle } from "shared-lib";
import {
  Button as Button3,
  ButtonList,
  EdSkeleton as EdSkeleton3,
  elevateJsonFormsCells,
  elevateJsonFormsRenderers,
  elevateJsonFormsStyleContext
} from "shared-ui";
import { Fragment as Fragment4, jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var queryDef4 = FormTemplateViewerRouteQuery_graphql_default;
async function loader5(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery5(environment, queryDef4, {
    formTemplateCode
  });
}
var FormTemplateViewer = ({ routeId: routeId6, inList }) => {
  const data = useRouteData3(queryDef4, routeId6);
  const [hasErrors, setHasErrors] = useState3(false);
  const [formData, setFormData] = useState3({});
  const [renderJson, toggleRenderJson] = useToggle();
  const onChange = useCallback4(
    (form) => {
      setFormData(form);
    },
    [formData]
  );
  const onSave = useCallback4(() => {
    toggleRenderJson();
  }, [toggleRenderJson]);
  const onCancel = useCallback4(() => {
    toggleRenderJson();
  }, [toggleRenderJson]);
  const onFormChanged = useCallback4(
    ({ data: data2, errors }) => {
      onChange(data2);
      if (errors) {
        const hasError = errors.filter((e) => e.data).length > 0;
        setHasErrors(hasError);
      } else {
        setHasErrors(false);
      }
    },
    [onChange, setHasErrors]
  );
  if (!data) {
    return /* @__PURE__ */ jsx8(Fragment4, { children: "Loading..." });
  }
  const { formTemplate } = data;
  if (!formTemplate) {
    return /* @__PURE__ */ jsx8(Fragment4, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx8(Suspense4, { fallback: /* @__PURE__ */ jsx8(EdSkeleton3, {}), children: formTemplate.dataSchema && formTemplate.uiSchema && /* @__PURE__ */ jsxs6("div", { className: "m-8 border bg-white px-8 py-2", children: [
    /* @__PURE__ */ jsx8(JsonFormsStyleContext.Provider, { value: elevateJsonFormsStyleContext, children: /* @__PURE__ */ jsx8(
      JsonForms,
      {
        data: formData,
        schema: JSON.parse(formTemplate.dataSchema),
        uischema: JSON.parse(formTemplate.uiSchema),
        renderers: elevateJsonFormsRenderers,
        cells: elevateJsonFormsCells,
        onChange: onFormChanged
      }
    ) }),
    renderJson && /* @__PURE__ */ jsx8("div", { className: "border bg-white p-4", children: JSON.stringify(formData) }),
    /* @__PURE__ */ jsx8("div", { className: "mt-4 border-t py-4", children: /* @__PURE__ */ jsxs6(ButtonList, { children: [
      /* @__PURE__ */ jsx8("div", { children: /* @__PURE__ */ jsx8(Button3, { color: "primary", disabled: hasErrors, clicked: onSave, children: "Save" }) }),
      /* @__PURE__ */ jsx8("div", { children: /* @__PURE__ */ jsx8(
        Button3,
        {
          color: "gray",
          clicked: () => {
            onCancel();
          },
          children: "Cancel"
        }
      ) })
    ] }) })
  ] }) });
};
var createRoute3 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-form-template-viewer`;
  return {
    id: routeId6,
    path: "viewer",
    element: /* @__PURE__ */ jsx8(FormTemplateViewer, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx8(Link5, { to: "", children: "Viewer" })
    },
    loader: ({ params }) => {
      return loader5(environment, params);
    }
  };
};

// src/secure/custom_data/form-templates/__generated__/FormTemplateAccessRouteQuery.graphql.ts
var node6 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "formTemplateCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateTypeId",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateAccessRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "FormTemplateType",
              "kind": "LinkedField",
              "name": "formTemplateType",
              "plural": false,
              "selections": [
                v4
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateAccessRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "FormTemplateType",
              "kind": "LinkedField",
              "name": "formTemplateType",
              "plural": false,
              "selections": [
                v4,
                v2
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b238631b4ba9cd73ea0edb83d4199f51",
      "id": null,
      "metadata": {},
      "name": "FormTemplateAccessRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateAccessRouteQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    formTemplateType {\n      formTemplateTypeId\n      id\n    }\n  }\n}\n"
    }
  };
}();
node6.hash = "5eef71c170166f44a456fa9a0799fc69";
var FormTemplateAccessRouteQuery_graphql_default = node6;

// src/secure/custom_data/form-templates/FormTemplateAccessRoute.tsx
import { Suspense as Suspense7 } from "react";
import { loadQuery as loadQuery8 } from "react-relay";
import { Navigate } from "react-router-dom";
import { useRouteData as useRouteData6 } from "shared-lib";
import { EdSkeleton as EdSkeleton6, EdTextLink } from "shared-ui";
import {
  OutletRoute as OutletRoute2,
  FormTemplateAccessListContainer
} from "app-core";

// src/secure/custom_data/form-templates/__generated__/FormTemplateAccessAddRouteQuery.graphql.ts
var node7 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "formTemplateCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateTypeId",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateAccessAddRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "FormTemplateType",
              "kind": "LinkedField",
              "name": "formTemplateType",
              "plural": false,
              "selections": [
                v4
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FormTemplateTypeAddAccess_formTemplate"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateAccessAddRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "FormTemplateType",
              "kind": "LinkedField",
              "name": "formTemplateType",
              "plural": false,
              "selections": [
                v4,
                v2
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "typeId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowPreFilling",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requiresSignature",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uiSchema",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dataSchema",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "documentTypeId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "htmlTemplate",
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e5e85b4c687fee404e2166e4e7d7aec2",
      "id": null,
      "metadata": {},
      "name": "FormTemplateAccessAddRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateAccessAddRouteQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    formTemplateType {\n      formTemplateTypeId\n      id\n    }\n    ...FormTemplateTypeAddAccess_formTemplate\n  }\n}\n\nfragment FormTemplateTypeAddAccess_formTemplate on FormTemplate {\n  id\n  formTemplateId\n  formTemplateType {\n    id\n    formTemplateTypeId\n  }\n  version\n  code\n  createdAt\n  updatedAt\n  key\n  name\n  description\n  typeId\n  allowPreFilling\n  requiresSignature\n  uiSchema\n  dataSchema\n  documentTypeId\n  htmlTemplate\n}\n"
    }
  };
}();
node7.hash = "c46274a98b90d9913b019da742a0eab5";
var FormTemplateAccessAddRouteQuery_graphql_default = node7;

// src/secure/custom_data/form-templates/FormTemplateAccessAddRoute.tsx
import { Suspense as Suspense5, useCallback as useCallback5 } from "react";
import { loadQuery as loadQuery6 } from "react-relay";
import { useNavigate as useNavigate4 } from "react-router-dom";
import { useRouteData as useRouteData4 } from "shared-lib";
import { EdSkeleton as EdSkeleton4 } from "shared-ui";
import { FormTemplateTypeAddAccess } from "app-core";
import { Fragment as Fragment5, jsx as jsx9 } from "react/jsx-runtime";
var queryDef5 = FormTemplateAccessAddRouteQuery_graphql_default;
async function loader6(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery6(environment, queryDef5, {
    formTemplateCode
  });
}
var FormTemplateAccessAddRoute = ({ routeId: routeId6, inList }) => {
  const navigate = useNavigate4();
  const data = useRouteData4(queryDef5, routeId6);
  const onNavigateToList = useCallback5(() => {
    navigate("../");
  }, [navigate]);
  if (!data) {
    return /* @__PURE__ */ jsx9(Fragment5, { children: "Loading..." });
  }
  const { formTemplate } = data;
  if (!formTemplate) {
    return /* @__PURE__ */ jsx9(Fragment5, { children: "Add Loading..." });
  }
  return /* @__PURE__ */ jsx9(Suspense5, { fallback: /* @__PURE__ */ jsx9(EdSkeleton4, {}), children: /* @__PURE__ */ jsx9("div", { className: "md:m-4 lg:m-8", children: /* @__PURE__ */ jsx9(
    FormTemplateTypeAddAccess,
    {
      fragmentRef: formTemplate,
      onSaved: onNavigateToList,
      onCancel: onNavigateToList
    }
  ) }) });
};

// src/secure/custom_data/form-templates/__generated__/FormTemplateAccessViewRouteQuery.graphql.ts
var node8 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateAccessCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "formTemplateAccessCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateAccessId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateAccessViewRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "FormTemplateAccess",
          "kind": "LinkedField",
          "name": "customDataFormTemplateAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FormTemplateAccessContainer_access"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateAccessViewRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "FormTemplateAccess",
          "kind": "LinkedField",
          "name": "customDataFormTemplateAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Organisation",
              "kind": "LinkedField",
              "name": "organisation",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "externalOrganisationName",
                  "storageKey": null
                },
                v2
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "285775f8a04ef056eed3fa2ef2f83e3e",
      "id": null,
      "metadata": {},
      "name": "FormTemplateAccessViewRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateAccessViewRouteQuery(\n  $formTemplateAccessCode: Int!\n) {\n  access: customDataFormTemplateAccessByCode(code: $formTemplateAccessCode) {\n    id\n    formTemplateAccessId\n    code\n    ...FormTemplateAccessContainer_access\n  }\n}\n\nfragment FormTemplateAccessContainer_access on FormTemplateAccess {\n  id\n  formTemplateAccessId\n  code\n  createdAt\n  updatedAt\n  status\n  version\n  organisation {\n    externalOrganisationName\n    id\n  }\n}\n"
    }
  };
}();
node8.hash = "555c61625f1a2b39352bc7c84966434f";
var FormTemplateAccessViewRouteQuery_graphql_default = node8;

// src/secure/custom_data/form-templates/FormTemplateAccessViewRoute.tsx
import { Suspense as Suspense6, useCallback as useCallback6 } from "react";
import { loadQuery as loadQuery7 } from "react-relay";
import { useNavigate as useNavigate5 } from "react-router-dom";
import { useRouteData as useRouteData5 } from "shared-lib";
import { EdSkeleton as EdSkeleton5 } from "shared-ui";
import { FormTemplateAccessContainer } from "app-core";
import { Fragment as Fragment6, jsx as jsx10 } from "react/jsx-runtime";
var queryDef6 = FormTemplateAccessViewRouteQuery_graphql_default;
async function loader7(environment, params) {
  const code = params.formTemplateAccessCode;
  const formTemplateAccessCode = parseInt(code);
  return loadQuery7(environment, queryDef6, {
    formTemplateAccessCode
  });
}
var FormTemplateAccessViewRoute = ({ routeId: routeId6, inList }) => {
  const navigate = useNavigate5();
  const data = useRouteData5(
    queryDef6,
    routeId6
  );
  const onNavigateToList = useCallback6(() => {
    navigate("../");
  }, [navigate]);
  if (!data) {
    return /* @__PURE__ */ jsx10(Fragment6, { children: "Loading..." });
  }
  const { access } = data;
  if (!access) {
    return /* @__PURE__ */ jsx10(Fragment6, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx10(Suspense6, { fallback: /* @__PURE__ */ jsx10(EdSkeleton5, {}), children: /* @__PURE__ */ jsx10("div", { className: "flex-1 md:m-4 lg:m-8", children: /* @__PURE__ */ jsx10(
    FormTemplateAccessContainer,
    {
      fragmentRef: access,
      onRemoved: onNavigateToList
    }
  ) }) });
};

// src/secure/custom_data/form-templates/FormTemplateAccessRoute.tsx
import { Fragment as Fragment7, jsx as jsx11 } from "react/jsx-runtime";
var queryDef7 = FormTemplateAccessRouteQuery_graphql_default;
async function loader8(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery8(environment, queryDef7, {
    formTemplateCode
  });
}
var ListHeader = () => {
  return /* @__PURE__ */ jsx11("div", { className: "flex justify-end border-b p-2", children: /* @__PURE__ */ jsx11(EdTextLink, { id: "add-link", to: "../add", label: "Add" }) });
};
var List = ({ routeId: routeId6, inList }) => {
  const data = useRouteData6(queryDef7, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx11(Fragment7, { children: "Loading..." });
  }
  const { formTemplate } = data;
  if (!formTemplate) {
    return /* @__PURE__ */ jsx11(Fragment7, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx11(Suspense7, { fallback: /* @__PURE__ */ jsx11(EdSkeleton6, {}), children: /* @__PURE__ */ jsx11(
    FormTemplateAccessListContainer,
    {
      formTemplateTypeId: formTemplate?.formTemplateType.formTemplateTypeId,
      listHeader: /* @__PURE__ */ jsx11(ListHeader, {})
    }
  ) });
};
var createRoute4 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-form-template-access`;
  const listRouteId = `${routeId6}-list`;
  const editRouteId = `${routeId6}-edit`;
  const editListRouteId = `${listRouteId}-edit`;
  const addRouteId = `${routeId6}-add`;
  return {
    id: routeId6,
    path: "access",
    element: /* @__PURE__ */ jsx11(OutletRoute2, {}),
    loader: ({ params }) => {
      return loader8(environment, params);
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx11(List, { routeId: routeId6, inList }),
        children: [
          {
            id: editListRouteId,
            path: ":formTemplateAccessCode",
            element: /* @__PURE__ */ jsx11(
              FormTemplateAccessViewRoute,
              {
                routeId: editListRouteId,
                inList
              }
            ),
            loader: ({ params }) => {
              return loader7(environment, params);
            }
          }
        ]
      },
      {
        id: editRouteId,
        path: ":formTemplateAccessCode",
        element: /* @__PURE__ */ jsx11(FormTemplateAccessViewRoute, { routeId: routeId6, inList }),
        loader: ({ params }) => {
          return loader7(environment, params);
        }
      },
      {
        id: addRouteId,
        path: "add",
        element: /* @__PURE__ */ jsx11(FormTemplateAccessAddRoute, { routeId: addRouteId, inList }),
        loader: ({ params }) => {
          return loader6(environment, params);
        }
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx11(Navigate, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/custom_data/form-templates/FormTemplateRoute.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var createFormTemplateRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId6 = `${routePrefix}-${routeId}`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx12(FormTemplateLayout, { showHeader }),
      errorElement: /* @__PURE__ */ jsx12(ErrorContainer, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx12(FormTemplateLink, { routeId: routeId6 })
      },
      loader: ({ params }) => {
        return loader2(environment, params);
      },
      children: [
        createRoute(routePrefix, environment, context, inList),
        createRoute2(routePrefix, environment, context, inList),
        createRoute3(routePrefix, environment, context, inList),
        createRoute4(routePrefix, environment, context, inList),
        {
          path: "*",
          element: /* @__PURE__ */ jsx12(Navigate2, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/custom_data/form-templates/FormTemplateCreate.tsx
import { Suspense as Suspense8, useCallback as useCallback7 } from "react";
import { useNavigate as useNavigate6 } from "react-router-dom";
import { EdSkeleton as EdSkeleton7 } from "shared-ui";
import { FormTemplateCreate } from "app-core";
import { jsx as jsx13 } from "react/jsx-runtime";
var FormTemplateCreateContainer = () => {
  const navigate = useNavigate6();
  const onCreated = useCallback7((template) => {
    navigate(`../${template.code}`);
  }, []);
  const onCancel = useCallback7(() => {
    navigate("../list");
  }, []);
  return /* @__PURE__ */ jsx13(Suspense8, { fallback: /* @__PURE__ */ jsx13(EdSkeleton7, {}), children: /* @__PURE__ */ jsx13(FormTemplateCreate, { onCreated, onCancel }) });
};

// src/secure/custom_data/form-templates/FormTemplatesRoute.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var Layout = () => {
  return /* @__PURE__ */ jsx14(Suspense9, { fallback: "Loading Form Templates...", children: /* @__PURE__ */ jsx14(ErrorBoundary, { FallbackComponent: ErrorBoundaryFallback, children: /* @__PURE__ */ jsx14(FormTemplateListContainer, {}) }) });
};
var createFormTemplatesRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-list`;
  return [
    {
      id: routeId6,
      path: "list/*",
      element: /* @__PURE__ */ jsx14(Layout, {}),
      children: [
        {
          id: `${routeId6}-template`,
          path: ":formTemplateCode/*",
          element: /* @__PURE__ */ jsx14(OutletRoute3, {}),
          children: createFormTemplateRoutes(
            `${routeId6}-template`,
            environment,
            context,
            true,
            true
          )
        }
      ]
    },
    {
      id: `${routePrefix}-template`,
      path: ":formTemplateCode/*",
      element: /* @__PURE__ */ jsx14(OutletRoute3, {}),
      children: createFormTemplateRoutes(
        `${routePrefix}-template`,
        environment,
        context,
        false,
        false
      )
    },
    {
      id: `${routePrefix}-create`,
      path: "create",
      element: /* @__PURE__ */ jsx14(FormTemplateCreateContainer, {})
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx14(Navigate3, { to: "list", replace: true })
    }
  ];
};

// src/secure/custom_data/organisations/OrganisationsRoute.tsx
import { Suspense as Suspense13 } from "react";
import { Navigate as Navigate5 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary2 } from "react-error-boundary";
import {
  ErrorBoundaryFallback as ErrorBoundaryFallback2,
  OrganisationListContainer,
  OutletRoute as OutletRoute4
} from "app-core";

// src/secure/custom_data/organisations/OrganisationRoute.tsx
import { Navigate as Navigate4 } from "react-router-dom";
import { ErrorContainer as ErrorContainer2 } from "shared-ui";

// src/secure/custom_data/organisations/__generated__/OrganisationLayoutQuery.graphql.ts
var node9 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organisationCode"
    }
  ], v1 = [
    {
      "alias": "organisation",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "organisationCode"
        }
      ],
      "concreteType": "Organisation",
      "kind": "LinkedField",
      "name": "customDataOrganisationByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "organisationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalOrganisationName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalOrganisationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OrganisationLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OrganisationLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "69397cd329429bd2fd99d50eaac958eb",
      "id": null,
      "metadata": {},
      "name": "OrganisationLayoutQuery",
      "operationKind": "query",
      "text": "query OrganisationLayoutQuery(\n  $organisationCode: Int!\n) {\n  organisation: customDataOrganisationByCode(code: $organisationCode) {\n    id\n    organisationId\n    createdAt\n    updatedAt\n    code\n    externalOrganisationName\n    externalOrganisationId\n    status\n  }\n}\n"
    }
  };
}();
node9.hash = "56b5cba04649edb5f28db6eeae564ed5";
var OrganisationLayoutQuery_graphql_default = node9;

// src/secure/custom_data/organisations/OrganisationLayout.tsx
import { Suspense as Suspense10 } from "react";
import {
  Link as Link6,
  Outlet as Outlet3,
  useLoaderData as useLoaderData3,
  useRouteLoaderData as useRouteLoaderData2
} from "react-router-dom";
import {
  loadQuery as loadQuery9,
  usePreloadedQuery as usePreloadedQuery3
} from "react-relay";
import { DynamicBreadcrumb as DynamicBreadcrumb2, EdTextLink as EdTextLink2 } from "shared-ui";
import { Fragment as Fragment8, jsx as jsx15, jsxs as jsxs7 } from "react/jsx-runtime";
var routeId2 = "form-template-home";
var organisationLayoutLayoutQueryDef = OrganisationLayoutQuery_graphql_default;
var OrganisationLayout = ({ showHeader }) => {
  const preloadedQuery = useLoaderData3();
  const data = usePreloadedQuery3(
    organisationLayoutLayoutQueryDef,
    preloadedQuery
  );
  const { organisation } = data;
  if (organisation === null || organisation === void 0) {
    return /* @__PURE__ */ jsx15("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx15(Suspense10, { fallback: "Loading...", children: /* @__PURE__ */ jsxs7("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsx15("div", { children: /* @__PURE__ */ jsxs7("div", { className: "flex flex-wrap items-center justify-between border-b", children: [
      /* @__PURE__ */ jsx15(DynamicBreadcrumb2, {}),
      /* @__PURE__ */ jsx15("div", { className: "text-primary-500 px-2 font-medium uppercase sm:px-8", children: organisation.externalOrganisationName })
    ] }) }),
    /* @__PURE__ */ jsxs7("div", { className: "flex flex-wrap items-center gap-2 border-b bg-gray-50 px-4", children: [
      /* @__PURE__ */ jsx15(
        EdTextLink2,
        {
          id: "form-template-root-link",
          to: "details",
          label: "Details"
        }
      ),
      /* @__PURE__ */ jsx15(EdTextLink2, { id: "form-template-root-link", to: "viewer", label: "Viewer" })
    ] }),
    /* @__PURE__ */ jsx15(Outlet3, {})
  ] }) });
};
var OrganisationLink = ({ routeId: routeId6, label }) => {
  const data = useOrganisationRouteData(routeId6);
  if (!data.organisation) {
    return /* @__PURE__ */ jsx15(Fragment8, {});
  }
  const name = `${data.organisation.externalOrganisationName}`;
  return /* @__PURE__ */ jsx15(Suspense10, { fallback: "Loading...", children: /* @__PURE__ */ jsx15(Link6, { to: ".", children: label || name }) });
};
async function loader9(environment, params) {
  const code = params.organisationCode;
  const organisationCode = parseInt(code);
  return loadQuery9(
    environment,
    organisationLayoutLayoutQueryDef,
    {
      organisationCode
    }
  );
}
function useOrganisationRouteData(routeId6) {
  const queryRef = useRouteLoaderData2(
    routeId6
  );
  const data = usePreloadedQuery3(
    organisationLayoutLayoutQueryDef,
    queryRef
  );
  return data;
}

// src/secure/custom_data/organisations/__generated__/OrganisationDetailsRouteQuery.graphql.ts
var node10 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organisationCode"
    }
  ], v1 = [
    {
      "alias": "organisation",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "organisationCode"
        }
      ],
      "concreteType": "Organisation",
      "kind": "LinkedField",
      "name": "customDataOrganisationByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "organisationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalOrganisationName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalOrganisationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OrganisationDetailsRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OrganisationDetailsRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "6f85a95576aa1500c52f0c1cfcc21ea3",
      "id": null,
      "metadata": {},
      "name": "OrganisationDetailsRouteQuery",
      "operationKind": "query",
      "text": "query OrganisationDetailsRouteQuery(\n  $organisationCode: Int!\n) {\n  organisation: customDataOrganisationByCode(code: $organisationCode) {\n    id\n    organisationId\n    createdAt\n    updatedAt\n    code\n    externalOrganisationName\n    externalOrganisationId\n    status\n  }\n}\n"
    }
  };
}();
node10.hash = "01aa91c932c2252af67e75e7cc969012";
var OrganisationDetailsRouteQuery_graphql_default = node10;

// src/secure/custom_data/organisations/OrganisationDetails.tsx
import { Suspense as Suspense11 } from "react";
import { loadQuery as loadQuery10 } from "react-relay";
import { Link as Link7 } from "react-router-dom";
import { timeAgo as timeAgo2, useRouteData as useRouteData7 } from "shared-lib";
import { EdSkeleton as EdSkeleton8 } from "shared-ui";
import { Fragment as Fragment9, jsx as jsx16, jsxs as jsxs8 } from "react/jsx-runtime";
var queryDef8 = OrganisationDetailsRouteQuery_graphql_default;
async function loader10(environment, params) {
  const code = params.organisationCode;
  const organisationCode = parseInt(code);
  try {
    return loadQuery10(environment, queryDef8, {
      organisationCode
    });
  } catch (e) {
    console.error("OrganisationDetails Loader Failed.");
    console.error(e);
    throw e;
  }
}
var OrganisationDetails = ({ routeId: routeId6, inList }) => {
  const data = useRouteData7(queryDef8, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx16(Fragment9, { children: "Loading..." });
  }
  const { organisation } = data;
  if (!organisation) {
    return /* @__PURE__ */ jsx16(Fragment9, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx16(Suspense11, { fallback: /* @__PURE__ */ jsx16(EdSkeleton8, {}), children: /* @__PURE__ */ jsxs8("div", { className: "grid gap-2 border-b bg-white p-4 sm:grid-cols-3", children: [
    /* @__PURE__ */ jsxs8("div", { className: "my-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx16("div", { className: "text-primary-500 px-4 text-lg font-medium", children: organisation.externalOrganisationName }),
      /* @__PURE__ */ jsxs8("div", { className: "text-primary-500 text-md px-4", children: [
        "Updated ",
        timeAgo2(organisation.updatedAt)
      ] })
    ] }),
    inList && /* @__PURE__ */ jsx16("div", { children: /* @__PURE__ */ jsx16(Link7, { to: `../../../${organisation.code}`, children: "View" }) })
  ] }) });
};
var createRoute5 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-form-template-root`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx16(OrganisationDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx16(Link7, { to: "details", children: "Organisation" })
    },
    loader: ({ params }) => {
      return loader10(environment, params);
    }
  };
};

// src/secure/custom_data/organisations/OrganisationRoute.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
var createOrganisationRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId6 = `${routePrefix}-${routeId2}`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx17(OrganisationLayout, { showHeader }),
      errorElement: /* @__PURE__ */ jsx17(ErrorContainer2, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx17(OrganisationLink, { routeId: routeId6 })
      },
      loader: ({ params }) => {
        return loader9(environment, params);
      },
      children: [
        createRoute5(routePrefix, environment, context, inList),
        {
          path: "*",
          element: /* @__PURE__ */ jsx17(Navigate4, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/custom_data/organisations/OrganisationCreate.tsx
import { Suspense as Suspense12, useCallback as useCallback9 } from "react";
import { useNavigate as useNavigate7 } from "react-router-dom";
import { EdSkeleton as EdSkeleton9 } from "shared-ui";

// src/secure/custom_data/organisations/OrganisationCreateContainer.tsx
import { useCallback as useCallback8, useState as useState4 } from "react";
import { createClientMutationId } from "shared-lib";
import { Button as Button4, Size as Size2 } from "shared-ui";
import {
  EmployerSearchContainer
} from "feature-employer-accounts";
import { useCustomDataOrganisationCreate } from "app-core";
import { jsx as jsx18, jsxs as jsxs9 } from "react/jsx-runtime";
var OrganisationCreateContainer = ({
  onDone,
  onCancel
}) => {
  const [create, isCreating] = useCustomDataOrganisationCreate();
  const [employer, setEmployer] = useState4(null);
  const onEmployerChange = useCallback8(
    (e) => {
      setEmployer(e);
    },
    [setEmployer]
  );
  const onCreate = useCallback8(
    async () => {
      if (!employer) {
        return;
      }
      const input = {
        externalOrganisationId: employer.employerId,
        externalOrganisationName: employer.name,
        clientMutationId: createClientMutationId()
      };
      const response = await create({ input });
      if (response.data.organisation?.node) {
        onDone(response.data.organisation?.node);
      }
    },
    [employer, create, onDone]
  );
  return /* @__PURE__ */ jsxs9("div", { className: "flex flex-col gap-2 p-8 bg-white border my-8 mx-auto md:w-1/2", children: [
    /* @__PURE__ */ jsxs9("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx18("div", { className: "text-primary-500 text-lg", children: /* @__PURE__ */ jsx18("label", { children: "Select Employer" }) }),
      /* @__PURE__ */ jsx18("div", { children: /* @__PURE__ */ jsx18(EmployerSearchContainer, { onSearchCompleted: onEmployerChange }) })
    ] }),
    /* @__PURE__ */ jsx18("div", { className: "flex items-center justify-end gap-2 mt-8", children: /* @__PURE__ */ jsx18("div", { children: /* @__PURE__ */ jsx18(
      Button4,
      {
        disabled: isCreating,
        size: Size2.xl,
        color: "primary",
        clicked: onCreate,
        children: "Create"
      }
    ) }) })
  ] });
};

// src/secure/custom_data/organisations/OrganisationCreate.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
var OrganisationCreate = () => {
  const navigate = useNavigate7();
  const onCancel = useCallback9(() => {
    navigate(`../list`);
  }, [navigate]);
  const onDone = useCallback9(
    (data) => {
      navigate(`../${data.code}`);
    },
    [navigate]
  );
  return /* @__PURE__ */ jsx19(Suspense12, { fallback: /* @__PURE__ */ jsx19(EdSkeleton9, {}), children: /* @__PURE__ */ jsx19(
    OrganisationCreateContainer,
    {
      onDone,
      onCancel
    }
  ) });
};

// src/secure/custom_data/organisations/OrganisationsRoute.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
var Layout2 = () => {
  return /* @__PURE__ */ jsx20(Suspense13, { fallback: "Loading Organisations...", children: /* @__PURE__ */ jsx20(ErrorBoundary2, { FallbackComponent: ErrorBoundaryFallback2, children: /* @__PURE__ */ jsx20(OrganisationListContainer, {}) }) });
};
var createOrganisationsRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-list`;
  const createRouteId = `${routePrefix}-create`;
  return [
    {
      id: routeId6,
      path: "list/*",
      element: /* @__PURE__ */ jsx20(Layout2, {}),
      children: [
        {
          id: `${routeId6}-template`,
          path: ":organisationCode/*",
          element: /* @__PURE__ */ jsx20(OutletRoute4, {}),
          children: createOrganisationRoutes(
            `${routeId6}-template`,
            environment,
            context,
            true,
            true
          )
        }
      ]
    },
    {
      id: createRouteId,
      path: "create",
      element: /* @__PURE__ */ jsx20(OrganisationCreate, {})
    },
    {
      id: `${routePrefix}-template`,
      path: ":organisationCode/*",
      element: /* @__PURE__ */ jsx20(OutletRoute4, {}),
      children: createOrganisationRoutes(
        `${routePrefix}-template`,
        environment,
        context,
        false,
        false
      )
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx20(Navigate5, { to: "list", replace: true })
    }
  ];
};

// src/secure/custom_data/document-types/DocumentTypesRoute.tsx
import { Suspense as Suspense20 } from "react";
import { Navigate as Navigate8 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary3 } from "react-error-boundary";
import {
  ErrorBoundaryFallback as ErrorBoundaryFallback3,
  DocumentTypeListContainer,
  OutletRoute as OutletRoute6
} from "app-core";

// src/secure/custom_data/document-types/__generated__/DocumentTypeRouteQuery.graphql.ts
var node11 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentTypeCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    v1,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v3 = [
    {
      "alias": "documentType",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "documentTypeCode"
        }
      ],
      "concreteType": "DocumentType",
      "kind": "LinkedField",
      "name": "customDataDocumentTypeByCode",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentTypeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountId",
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": v2,
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountId",
          "kind": "LinkedField",
          "name": "updatedBy",
          "plural": false,
          "selections": v2,
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sampleUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresExpiryDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresIssueDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresIssueNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "htmlTemplate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canGeneratePdf",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "generatesDocument",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeRouteQuery",
      "selections": v3,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeRouteQuery",
      "selections": v3
    },
    "params": {
      "cacheID": "90bffd0b1b6ae780a9a3c564bb25cc83",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeRouteQuery",
      "operationKind": "query",
      "text": "query DocumentTypeRouteQuery(\n  $documentTypeCode: Int!\n) {\n  documentType: customDataDocumentTypeByCode(code: $documentTypeCode) {\n    id\n    documentTypeId\n    code\n    version\n    createdAt\n    createdBy {\n      id\n      accountType\n    }\n    updatedAt\n    updatedBy {\n      id\n      accountType\n    }\n    name\n    description\n    sampleUrl\n    requiresExpiryDate\n    requiresIssueDate\n    requiresIssueNumber\n    htmlTemplate\n    canGeneratePdf\n    generatesDocument\n  }\n}\n"
    }
  };
}();
node11.hash = "2bacd4a5207eb5a8584faa7b989f6269";
var DocumentTypeRouteQuery_graphql_default = node11;

// src/secure/custom_data/document-types/DocumentTypeRoute.tsx
import { Suspense as Suspense18, useMemo as useMemo2 } from "react";
import {
  Navigate as Navigate7,
  Outlet as Outlet4,
  useLocation as useLocation3,
  useLoaderData as useLoaderData4
} from "react-router-dom";
import {
  loadQuery as loadQuery15,
  usePreloadedQuery as usePreloadedQuery4
} from "react-relay";
import {
  createLinkState as createLinkState3,
  DynamicBreadcrumb as DynamicBreadcrumb3,
  ErrorContainer as ErrorContainer3,
  ExpandButton as ExpandButton2,
  TabUnderline as TabUnderline2
} from "shared-ui";

// src/secure/custom_data/document-types/__generated__/DocumentTypeAccessRouteQuery.graphql.ts
var node12 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentTypeCode"
    }
  ], v1 = [
    {
      "alias": "documentType",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "documentTypeCode"
        }
      ],
      "concreteType": "DocumentType",
      "kind": "LinkedField",
      "name": "customDataDocumentTypeByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentTypeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeAccessRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeAccessRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "91dae105a0d93b5906b2f6b4cd3ba06c",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeAccessRouteQuery",
      "operationKind": "query",
      "text": "query DocumentTypeAccessRouteQuery(\n  $documentTypeCode: Int!\n) {\n  documentType: customDataDocumentTypeByCode(code: $documentTypeCode) {\n    id\n    documentTypeId\n    code\n    version\n  }\n}\n"
    }
  };
}();
node12.hash = "7ca4d5605dcf72883dc0ef2ede8e61fc";
var DocumentTypeAccessRouteQuery_graphql_default = node12;

// src/secure/custom_data/document-types/DocumentTypeAccessRoute.tsx
import { Suspense as Suspense16 } from "react";
import { loadQuery as loadQuery13 } from "react-relay";
import { Navigate as Navigate6 } from "react-router-dom";
import { useRouteData as useRouteData10 } from "shared-lib";
import { EdSkeleton as EdSkeleton12, EdTextLink as EdTextLink3 } from "shared-ui";
import {
  OutletRoute as OutletRoute5,
  DocumentTypeAccessListContainer
} from "app-core";

// src/secure/custom_data/document-types/__generated__/DocumentTypeAccessAddRouteQuery.graphql.ts
var node13 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentTypeCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "documentTypeCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "documentTypeId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeAccessAddRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "DocumentType",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DocumentTypeAddAccess_document"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeAccessAddRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "DocumentType",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1224d2e7a1b4aa09443b05499985fe5e",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeAccessAddRouteQuery",
      "operationKind": "query",
      "text": "query DocumentTypeAccessAddRouteQuery(\n  $documentTypeCode: Int!\n) {\n  access: customDataDocumentTypeByCode(code: $documentTypeCode) {\n    id\n    documentTypeId\n    code\n    ...DocumentTypeAddAccess_document\n  }\n}\n\nfragment DocumentTypeAddAccess_document on DocumentType {\n  id\n  documentTypeId\n  version\n  code\n  createdAt\n  updatedAt\n  name\n  description\n}\n"
    }
  };
}();
node13.hash = "35c0979f5b90d3e896b1fd267f261d23";
var DocumentTypeAccessAddRouteQuery_graphql_default = node13;

// src/secure/custom_data/document-types/DocumentTypeAccessAddRoute.tsx
import { Suspense as Suspense14, useCallback as useCallback10 } from "react";
import { loadQuery as loadQuery11 } from "react-relay";
import { useNavigate as useNavigate8 } from "react-router-dom";
import { useRouteData as useRouteData8 } from "shared-lib";
import { EdSkeleton as EdSkeleton10 } from "shared-ui";
import { DocumentTypeAddAccess } from "app-core";
import { Fragment as Fragment10, jsx as jsx21 } from "react/jsx-runtime";
var queryDef9 = DocumentTypeAccessAddRouteQuery_graphql_default;
async function loader11(environment, params) {
  const code = params.documentTypeCode;
  const documentTypeCode = parseInt(code);
  return loadQuery11(environment, queryDef9, {
    documentTypeCode
  });
}
var DocumentTypeAccessAddRoute = ({ routeId: routeId6, inList }) => {
  const navigate = useNavigate8();
  const data = useRouteData8(queryDef9, routeId6);
  const onNavigateToList = useCallback10(() => {
    navigate("../");
  }, [navigate]);
  if (!data) {
    return /* @__PURE__ */ jsx21(Fragment10, { children: "Loading..." });
  }
  const { access } = data;
  if (!access) {
    return /* @__PURE__ */ jsx21(Fragment10, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx21(Suspense14, { fallback: /* @__PURE__ */ jsx21(EdSkeleton10, {}), children: /* @__PURE__ */ jsx21("div", { className: "flex-1 md:m-4 lg:m-8", children: /* @__PURE__ */ jsx21(
    DocumentTypeAddAccess,
    {
      fragmentRef: access,
      onSaved: onNavigateToList,
      onCancel: onNavigateToList
    }
  ) }) });
};

// src/secure/custom_data/document-types/__generated__/DocumentTypeAccessViewRouteQuery.graphql.ts
var node14 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentTypeAccessCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "documentTypeAccessCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "documentTypeAccessId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "externalOrganisationName",
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeAccessViewRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "DocumentTypeAccess",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "Organisation",
              "kind": "LinkedField",
              "name": "organisation",
              "plural": false,
              "selections": [
                v9
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeAccessViewRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "DocumentTypeAccess",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "Organisation",
              "kind": "LinkedField",
              "name": "organisation",
              "plural": false,
              "selections": [
                v9,
                v2
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6717d84c87cfaa9f018f54cc56b6736b",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeAccessViewRouteQuery",
      "operationKind": "query",
      "text": "query DocumentTypeAccessViewRouteQuery(\n  $documentTypeAccessCode: Int!\n) {\n  access: customDataDocumentTypeAccessByCode(code: $documentTypeAccessCode) {\n    id\n    documentTypeAccessId\n    code\n    createdAt\n    updatedAt\n    status\n    version\n    organisation {\n      externalOrganisationName\n      id\n    }\n  }\n}\n"
    }
  };
}();
node14.hash = "829cfb5d331193537e604b1b42542c09";
var DocumentTypeAccessViewRouteQuery_graphql_default = node14;

// src/secure/custom_data/document-types/DocumentTypeAccessViewRoute.tsx
import { Suspense as Suspense15, useCallback as useCallback11 } from "react";
import { ConnectionHandler, loadQuery as loadQuery12 } from "react-relay";
import { useNavigate as useNavigate9 } from "react-router-dom";
import { createClientMutationId as createClientMutationId2, timeAgo as timeAgo3, useRouteData as useRouteData9 } from "shared-lib";
import {
  Button as Button5,
  ButtonList as ButtonList2,
  DescriptionItem,
  DescriptionList,
  EdSkeleton as EdSkeleton11,
  Size as Size3
} from "shared-ui";
import {
  useDocumentTypeRemoveAccess
} from "app-core";
import { Fragment as Fragment11, jsx as jsx22, jsxs as jsxs10 } from "react/jsx-runtime";
var queryDef10 = DocumentTypeAccessViewRouteQuery_graphql_default;
async function loader12(environment, params) {
  const code = params.documentTypeAccessCode;
  const documentTypeAccessCode = parseInt(code);
  return loadQuery12(environment, queryDef10, {
    documentTypeAccessCode
  });
}
var DocumentTypeAccessViewRoute = ({ routeId: routeId6, inList }) => {
  const navigate = useNavigate9();
  const data = useRouteData9(
    queryDef10,
    routeId6
  );
  const { access } = data;
  const [removeAccess, isRemoving] = useDocumentTypeRemoveAccess();
  const connectionId = ConnectionHandler.getConnectionID(
    "root",
    "DocumentTypeAccessList_list"
  );
  const onNavigateToList = useCallback11(() => {
    navigate("../");
  }, [navigate]);
  const onRemoveOrganisationAccess = useCallback11(async () => {
    if (!access) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId2(),
      documentTypeAccessId: access.documentTypeAccessId
    };
    const response = await removeAccess({
      connections: [connectionId],
      input
    });
    if (response.data.result) {
      onNavigateToList();
    }
  }, [access, removeAccess, onNavigateToList, connectionId]);
  if (!data) {
    return /* @__PURE__ */ jsx22(Fragment11, { children: "Loading..." });
  }
  if (!access) {
    return /* @__PURE__ */ jsx22(Fragment11, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx22(Suspense15, { fallback: /* @__PURE__ */ jsx22(EdSkeleton11, {}), children: /* @__PURE__ */ jsx22("div", { className: "flex-1 md:m-4 lg:m-8", children: /* @__PURE__ */ jsxs10("div", { className: "rounded-lg border bg-gray-100", children: [
    /* @__PURE__ */ jsx22(
      DescriptionList,
      {
        classes: "w-full",
        heading: /* @__PURE__ */ jsx22("div", { className: "p-2", children: /* @__PURE__ */ jsx22("div", { className: "text-primary-500", children: access.organisation.externalOrganisationName }) }),
        items: /* @__PURE__ */ jsxs10(Fragment11, { children: [
          /* @__PURE__ */ jsx22(DescriptionItem, { label: "Status", children: /* @__PURE__ */ jsx22("div", { children: access.status }) }),
          /* @__PURE__ */ jsx22(DescriptionItem, { label: "Version", children: /* @__PURE__ */ jsx22("div", { children: access.version }) }),
          /* @__PURE__ */ jsx22(DescriptionItem, { label: "Created", children: timeAgo3(access.createdAt) }),
          /* @__PURE__ */ jsx22(DescriptionItem, { label: "Updated", children: timeAgo3(access.updatedAt) })
        ] })
      }
    ),
    /* @__PURE__ */ jsx22("div", { className: "p-4", children: /* @__PURE__ */ jsx22(ButtonList2, { children: /* @__PURE__ */ jsx22(
      Button5,
      {
        size: Size3.lg,
        color: "danger",
        disabled: isRemoving,
        clicked: onRemoveOrganisationAccess,
        children: "Remove"
      }
    ) }) })
  ] }) }) });
};

// src/secure/custom_data/document-types/DocumentTypeAccessRoute.tsx
import { Fragment as Fragment12, jsx as jsx23 } from "react/jsx-runtime";
var queryDef11 = DocumentTypeAccessRouteQuery_graphql_default;
async function loader13(environment, params) {
  const code = params.documentTypeCode;
  const documentTypeCode = parseInt(code);
  return loadQuery13(environment, queryDef11, {
    documentTypeCode
  });
}
var ListHeader2 = () => {
  return /* @__PURE__ */ jsx23("div", { className: "flex justify-end border-b p-2", children: /* @__PURE__ */ jsx23(EdTextLink3, { id: "add-link", to: "../add", label: "Add" }) });
};
var List2 = ({ routeId: routeId6, inList }) => {
  const data = useRouteData10(queryDef11, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx23(Fragment12, { children: "Loading..." });
  }
  const { documentType } = data;
  if (!documentType) {
    return /* @__PURE__ */ jsx23(Fragment12, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx23(Suspense16, { fallback: /* @__PURE__ */ jsx23(EdSkeleton12, {}), children: /* @__PURE__ */ jsx23(
    DocumentTypeAccessListContainer,
    {
      documentTypeId: documentType.documentTypeId,
      listHeader: /* @__PURE__ */ jsx23(ListHeader2, {})
    }
  ) });
};
var createRoute6 = (documentTypeRouteId, environment, context, inList = true) => {
  const routeId6 = `${documentTypeRouteId}-access`;
  const listRouteId = `${routeId6}-list`;
  const editRouteId = `${routeId6}-edit`;
  const editListRouteId = `${listRouteId}-edit`;
  const addRouteId = `${routeId6}-add`;
  return {
    id: routeId6,
    path: "access",
    element: /* @__PURE__ */ jsx23(OutletRoute5, {}),
    loader: ({ params }) => {
      return loader13(environment, params);
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx23(List2, { routeId: routeId6, inList }),
        children: [
          {
            id: editListRouteId,
            path: ":documentTypeAccessCode",
            element: /* @__PURE__ */ jsx23(
              DocumentTypeAccessViewRoute,
              {
                routeId: editListRouteId,
                inList
              }
            ),
            loader: ({ params }) => {
              return loader12(environment, params);
            }
          }
        ]
      },
      {
        id: editRouteId,
        path: ":documentTypeAccessCode",
        element: /* @__PURE__ */ jsx23(DocumentTypeAccessViewRoute, { routeId: routeId6, inList }),
        loader: ({ params }) => {
          return loader12(environment, params);
        }
      },
      {
        id: addRouteId,
        path: "add",
        element: /* @__PURE__ */ jsx23(DocumentTypeAccessAddRoute, { routeId: addRouteId, inList }),
        loader: ({ params }) => {
          return loader11(environment, params);
        }
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx23(Navigate6, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/custom_data/document-types/__generated__/DocumentTypeDetailsRouteQuery.graphql.ts
var node15 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentTypeCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    v1,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v3 = [
    {
      "alias": "documentType",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "documentTypeCode"
        }
      ],
      "concreteType": "DocumentType",
      "kind": "LinkedField",
      "name": "customDataDocumentTypeByCode",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentTypeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountId",
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": v2,
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountId",
          "kind": "LinkedField",
          "name": "updatedBy",
          "plural": false,
          "selections": v2,
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sampleUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresExpiryDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresIssueDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresIssueNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "htmlTemplate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canGeneratePdf",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "generatesDocument",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeDetailsRouteQuery",
      "selections": v3,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeDetailsRouteQuery",
      "selections": v3
    },
    "params": {
      "cacheID": "4864416de922b028964be69d73611444",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeDetailsRouteQuery",
      "operationKind": "query",
      "text": "query DocumentTypeDetailsRouteQuery(\n  $documentTypeCode: Int!\n) {\n  documentType: customDataDocumentTypeByCode(code: $documentTypeCode) {\n    id\n    documentTypeId\n    code\n    version\n    createdAt\n    createdBy {\n      id\n      accountType\n    }\n    updatedAt\n    updatedBy {\n      id\n      accountType\n    }\n    name\n    description\n    sampleUrl\n    requiresExpiryDate\n    requiresIssueDate\n    requiresIssueNumber\n    htmlTemplate\n    canGeneratePdf\n    generatesDocument\n  }\n}\n"
    }
  };
}();
node15.hash = "4e0f4f9b4e5309d7015f1cb893838374";
var DocumentTypeDetailsRouteQuery_graphql_default = node15;

// src/secure/custom_data/document-types/DocumentTypeDetailsRoute.tsx
import { Suspense as Suspense17 } from "react";
import { loadQuery as loadQuery14 } from "react-relay";
import { Link as Link8 } from "react-router-dom";
import { timeAgo as timeAgo4, useRouteData as useRouteData11 } from "shared-lib";
import { EdSkeleton as EdSkeleton13 } from "shared-ui";
import { Fragment as Fragment13, jsx as jsx24, jsxs as jsxs11 } from "react/jsx-runtime";
var queryDef12 = DocumentTypeDetailsRouteQuery_graphql_default;
async function loader14(environment, params) {
  const code = params.documentTypeCode;
  const documentTypeCode = parseInt(code);
  return loadQuery14(environment, queryDef12, {
    documentTypeCode
  });
}
var Container = ({ routeId: routeId6, inList }) => {
  const data = useRouteData11(queryDef12, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx24(Fragment13, { children: "Loading..." });
  }
  const { documentType } = data;
  if (!documentType) {
    return /* @__PURE__ */ jsx24(Fragment13, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx24(Suspense17, { fallback: /* @__PURE__ */ jsx24(EdSkeleton13, {}), children: /* @__PURE__ */ jsx24("div", { className: "grid gap-2 border-b bg-white p-4 sm:grid-cols-3", children: /* @__PURE__ */ jsxs11("div", { className: "my-4 flex flex-col gap-2", children: [
    /* @__PURE__ */ jsxs11("div", { className: "flex items-center justify-between gap-2 border-b", children: [
      /* @__PURE__ */ jsx24("div", { className: "text-primary-500 p-4 text-lg font-medium", children: documentType.name }),
      /* @__PURE__ */ jsxs11("div", { className: "text-primary-500 p-4 text-sm", children: [
        "Updated ",
        timeAgo4(documentType.updatedAt)
      ] })
    ] }),
    /* @__PURE__ */ jsx24("div", { className: "text-md p-4 text-gray-900", children: documentType.description })
  ] }) }) });
};
var createRoute7 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-details`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx24(Container, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx24(Link8, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader14(environment, params);
    }
  };
};

// src/secure/custom_data/document-types/DocumentTypeRoute.tsx
import { jsx as jsx25, jsxs as jsxs12 } from "react/jsx-runtime";
var documentTypeRouteQueryDef = DocumentTypeRouteQuery_graphql_default;
async function loader15(environment, params) {
  const code = params.documentTypeCode;
  const documentTypeCode = parseInt(code);
  return loadQuery15(
    environment,
    documentTypeRouteQueryDef,
    {
      documentTypeCode
    }
  );
}
var Layout3 = () => {
  const location = useLocation3();
  const tabs4 = useMemo2(() => {
    return [
      createLinkState3(location, "Details", `../details`),
      createLinkState3(location, "Access", `../access`)
    ];
  }, [location]);
  const preloadedQuery = useLoaderData4();
  const data = usePreloadedQuery4(documentTypeRouteQueryDef, preloadedQuery);
  const { documentType } = data;
  if (documentType === null || documentType === void 0) {
    return /* @__PURE__ */ jsx25("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx25(Suspense18, { fallback: "Loading...", children: /* @__PURE__ */ jsxs12("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsxs12("div", { className: "flex flex-wrap items-center justify-between border-b", children: [
      /* @__PURE__ */ jsx25("div", { className: "p-2", children: /* @__PURE__ */ jsx25(ExpandButton2, { to: `../../../${documentType.code}`, label: "View" }) }),
      /* @__PURE__ */ jsx25(DynamicBreadcrumb3, {}),
      /* @__PURE__ */ jsx25("div", { className: "text-primary-500 px-2 font-medium uppercase sm:px-8", children: documentType.name })
    ] }),
    /* @__PURE__ */ jsx25("div", { className: "flex flex-wrap items-center gap-2 border-b p-4", children: /* @__PURE__ */ jsx25("div", { className: "text-primary-500 font-medium uppercase", children: documentType.description }) }),
    /* @__PURE__ */ jsx25("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx25(TabUnderline2, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx25(Outlet4, {})
  ] }) });
};
var createDocumentTypeRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId6 = `${routePrefix}-document-type`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx25(Layout3, {}),
      errorElement: /* @__PURE__ */ jsx25(ErrorContainer3, {}),
      loader: ({ params }) => {
        return loader15(environment, params);
      },
      children: [
        createRoute7(routePrefix, environment, context, inList),
        createRoute6(routePrefix, environment, context, inList),
        {
          path: "*",
          element: /* @__PURE__ */ jsx25(Navigate7, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/custom_data/document-types/DocumentTypeCreate.tsx
import { Suspense as Suspense19, useCallback as useCallback12 } from "react";
import { useNavigate as useNavigate10 } from "react-router-dom";
import { DocumentTypeCreate } from "app-core";
import { EdSkeleton as EdSkeleton14 } from "shared-ui";
import { jsx as jsx26 } from "react/jsx-runtime";
var DocumentTypesCreateContainer = () => {
  const navigate = useNavigate10();
  const onCreated = useCallback12((documentType) => {
    navigate(`../list`);
  }, []);
  const onCancel = useCallback12(() => {
    navigate("../list");
  }, []);
  return /* @__PURE__ */ jsx26(Suspense19, { fallback: /* @__PURE__ */ jsx26(EdSkeleton14, {}), children: /* @__PURE__ */ jsx26(DocumentTypeCreate, { onCreated, onCancel }) });
};

// src/secure/custom_data/document-types/DocumentTypesRoute.tsx
import { jsx as jsx27 } from "react/jsx-runtime";
var Layout4 = () => {
  return /* @__PURE__ */ jsx27(Suspense20, { fallback: "Loading Document Types...", children: /* @__PURE__ */ jsx27(ErrorBoundary3, { FallbackComponent: ErrorBoundaryFallback3, children: /* @__PURE__ */ jsx27(DocumentTypeListContainer, { listHeader: /* @__PURE__ */ jsx27("div", {}) }) }) });
};
var createDocumentTypesRoutes = (routePrefix, environment, context) => {
  const listRouteId = `${routePrefix}-list`;
  const listDocumentRouteId = `${listRouteId}-list-document`;
  const documentRouteId = `${listRouteId}-document`;
  return [
    {
      id: listRouteId,
      path: "list/*",
      element: /* @__PURE__ */ jsx27(Layout4, {}),
      children: [
        {
          id: listDocumentRouteId,
          path: ":documentTypeCode/*",
          element: /* @__PURE__ */ jsx27(OutletRoute6, {}),
          children: createDocumentTypeRoutes(
            listDocumentRouteId,
            environment,
            context,
            true,
            true
          )
        }
      ]
    },
    {
      id: documentRouteId,
      path: ":documentTypeCode/*",
      element: /* @__PURE__ */ jsx27(OutletRoute6, {}),
      children: createDocumentTypeRoutes(
        documentRouteId,
        environment,
        context,
        false,
        false
      )
    },
    {
      id: `${routePrefix}-create`,
      path: "create",
      element: /* @__PURE__ */ jsx27(DocumentTypesCreateContainer, {})
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx27(Navigate8, { to: "list", replace: true })
    }
  ];
};

// src/secure/custom_data/CustomDataLayout.tsx
import { jsx as jsx28, jsxs as jsxs13 } from "react/jsx-runtime";
var Layout5 = () => {
  const location = useLocation4();
  const tabs4 = [
    createLinkState4(location, "Home", `home`, HomeIcon),
    createLinkState4(
      location,
      "Organisations",
      `organisations`,
      BuildingStorefrontIcon
    ),
    createLinkState4(
      location,
      "Form Templates",
      `form-templates`,
      InformationCircleIcon
    ),
    createLinkState4(location, "Document Types", `document-types`, DocumentIcon)
  ];
  return /* @__PURE__ */ jsx28(Suspense21, { fallback: "Loading Custom Data Management...", children: /* @__PURE__ */ jsx28(ErrorBoundary4, { FallbackComponent: ErrorBoundaryFallback4, children: /* @__PURE__ */ jsxs13("div", { className: "bg-white", children: [
    /* @__PURE__ */ jsxs13("div", { className: "flex-col gap-2 border-b", children: [
      /* @__PURE__ */ jsx28("div", { className: "border-b", children: /* @__PURE__ */ jsx28("div", { className: "text-primary-500 p-4 font-medium", children: "Custom Data Management" }) }),
      /* @__PURE__ */ jsx28("div", { className: "p-2", children: /* @__PURE__ */ jsx28(TabUnderline3, { tabs: tabs4 }) })
    ] }),
    /* @__PURE__ */ jsx28("div", { className: "", children: /* @__PURE__ */ jsx28(Outlet5, {}) })
  ] }) }) });
};
var CustomDataHome = () => {
  return /* @__PURE__ */ jsx28(Suspense21, { fallback: "Loading Form Templates...", children: /* @__PURE__ */ jsx28("div", { className: "border-b px-4 py-2 sm:px-8", children: /* @__PURE__ */ jsx28("h1", { children: "Custom Data" }) }) });
};
var createCustomDataRoutes = (environment, context) => {
  return [
    {
      path: "",
      element: /* @__PURE__ */ jsx28(Layout5, {}),
      children: [
        {
          path: "home",
          element: /* @__PURE__ */ jsx28(CustomDataHome, {})
        },
        {
          path: "organisations/*",
          element: /* @__PURE__ */ jsx28(OutletRoute7, {}),
          children: createOrganisationsRoutes(
            "custom-data-organisations",
            environment,
            context
          )
        },
        {
          path: "form-templates/*",
          element: /* @__PURE__ */ jsx28(OutletRoute7, {}),
          children: createFormTemplatesRoutes(
            "custom-data-form-templates",
            environment,
            context
          )
        },
        {
          path: "document-types/*",
          element: /* @__PURE__ */ jsx28(OutletRoute7, {}),
          children: createDocumentTypesRoutes(
            "custom-data-document-types",
            environment,
            context
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx28(Navigate9, { to: "home", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/index.ts
var accounts_exports = {};
__export(accounts_exports, {
  AccountsHomeList: () => AccountsHomeList,
  AdminLayout: () => AdminLayout,
  AdminUserGroupsListRoute: () => AdminUserGroupsListRoute,
  AdminUsersListRoute: () => AdminUsersListRoute,
  EmployersLayout: () => EmployersLayout,
  EmployersListRoute: () => EmployersListRoute,
  createAdminRoutes: () => createAdminRoutes,
  createAppAdminAccountsRoutes: () => createAppAdminAccountsRoutes,
  createEmployersRoutes: () => createEmployersRoutes,
  useAdminUserCreate: () => useAdminUserCreate,
  useAdminUserDisable: () => useAdminUserDisable,
  useAdminUserEnable: () => useAdminUserEnable,
  useAdminUserGroupCreate: () => useAdminUserGroupCreate,
  useAdminUserGroupUpdate: () => useAdminUserGroupUpdate,
  useAdminUserGroupUpdatePermissions: () => useAdminUserGroupUpdatePermissions,
  useAdminUserJoinGroup: () => useAdminUserJoinGroup,
  useAdminUserLeaveGroup: () => useAdminUserLeaveGroup,
  useAdminUserUpdate: () => useAdminUserUpdate
});

// src/secure/accounts/administrators/components/AdminRoute.tsx
import { Suspense as Suspense36 } from "react";
import { Navigate as Navigate12, Outlet as Outlet8, useLocation as useLocation5 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary5 } from "react-error-boundary";
import { UsersIcon, UserGroupIcon } from "@heroicons/react/24/outline";
import {
  Button as Button8,
  createLinkState as createLinkState5,
  EdLink as EdLink2,
  PageHeading,
  TabPills
} from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback5, OutletRoute as OutletRoute9 } from "app-core";

// src/secure/accounts/administrators/components/AdminUserRoute.tsx
import { Navigate as Navigate10 } from "react-router-dom";
import { ErrorContainer as ErrorContainer4 } from "shared-ui";

// src/secure/accounts/administrators/components/__generated__/AdminUserLayoutQuery.graphql.ts
var node16 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserCode"
    }
  ], v1 = [
    {
      "alias": "adminUser",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "adminUserCode"
        }
      ],
      "concreteType": "AccountsAdminUser",
      "kind": "LinkedField",
      "name": "accountAdminUserByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "7cd6e8fe845c6cf82c3f746708f7c45a",
      "id": null,
      "metadata": {},
      "name": "AdminUserLayoutQuery",
      "operationKind": "query",
      "text": "query AdminUserLayoutQuery(\n  $adminUserCode: Long!\n) {\n  adminUser: accountAdminUserByCode(code: $adminUserCode) {\n    id\n    code\n    accountId\n    createdAt\n    updatedAt\n    firstName\n    lastName\n    emailAddress\n  }\n}\n"
    }
  };
}();
node16.hash = "a0a8aefa6d296c0ef71a518a5f876af4";
var AdminUserLayoutQuery_graphql_default = node16;

// src/secure/accounts/administrators/components/AdminUserLayout.tsx
import { Suspense as Suspense22 } from "react";
import {
  Link as Link9,
  Outlet as Outlet6,
  useLoaderData as useLoaderData5,
  useRouteLoaderData as useRouteLoaderData3
} from "react-router-dom";
import {
  loadQuery as loadQuery16,
  usePreloadedQuery as usePreloadedQuery5
} from "react-relay";
import { ArrowsPointingOutIcon } from "@heroicons/react/24/outline";
import {
  DynamicBreadcrumb as DynamicBreadcrumb4,
  EdButtonLink,
  EdTextLink as EdTextLink4,
  IconJustify
} from "shared-ui";
import { Fragment as Fragment14, jsx as jsx29, jsxs as jsxs14 } from "react/jsx-runtime";
var routeId3 = "admin-user-home";
var queryDef13 = AdminUserLayoutQuery_graphql_default;
var AdminUserLayout = ({ showHeader, inList }) => {
  const preloadedQuery = useLoaderData5();
  const data = usePreloadedQuery5(queryDef13, preloadedQuery);
  const { adminUser } = data;
  if (adminUser === null || adminUser === void 0) {
    return /* @__PURE__ */ jsx29("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx29(Suspense22, { fallback: "Loading...", children: /* @__PURE__ */ jsxs14("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsx29("div", { children: /* @__PURE__ */ jsxs14("div", { className: "flex flex-wrap items-center justify-between border-b", children: [
      /* @__PURE__ */ jsx29(DynamicBreadcrumb4, {}),
      /* @__PURE__ */ jsxs14("div", { className: "text-primary-500 flex items-center gap-2 font-medium uppercase", children: [
        /* @__PURE__ */ jsx29("div", { children: adminUser.firstName }),
        /* @__PURE__ */ jsx29("div", { children: adminUser.lastName })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs14("div", { className: "flex flex-wrap items-center justify-between border-b p-2", children: [
      /* @__PURE__ */ jsx29("div", { className: "flex flex-wrap items-center gap-2 border-b bg-gray-50 px-4", children: /* @__PURE__ */ jsx29(
        EdTextLink4,
        {
          id: "identity-user-root-link",
          to: "details",
          label: "Details"
        }
      ) }),
      inList && /* @__PURE__ */ jsx29("div", { children: /* @__PURE__ */ jsx29(
        EdButtonLink,
        {
          to: `../../../../${adminUser.code}`,
          name: "View",
          icon: ArrowsPointingOutIcon,
          iconJustify: IconJustify.Right
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx29(Outlet6, {})
  ] }) });
};
var AdminUserGroupLink = ({ routeId: routeId6, label }) => {
  const data = useAdminUserRouteData(routeId6);
  if (!data.adminUser) {
    return /* @__PURE__ */ jsx29(Fragment14, {});
  }
  const name = `${data.adminUser.firstName} ${data.adminUser.lastName}`;
  return /* @__PURE__ */ jsx29(Suspense22, { fallback: "Loading...", children: /* @__PURE__ */ jsx29(Link9, { to: ".", children: label || name }) });
};
async function loader16(environment, params) {
  const code = params.adminUserCode;
  const adminUserCode = parseInt(code);
  return loadQuery16(environment, queryDef13, {
    adminUserCode
  });
}
function useAdminUserRouteData(routeId6) {
  const queryRef = useRouteLoaderData3(
    routeId6
  );
  const data = usePreloadedQuery5(queryDef13, queryRef);
  return data;
}

// src/secure/accounts/administrators/components/__generated__/AdminUserDetailsRouteQuery.graphql.ts
var node17 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDeleted",
    "storageKey": null
  }, v4 = [
    {
      "alias": "adminUser",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "adminUserCode"
        }
      ],
      "concreteType": "AccountsAdminUser",
      "kind": "LinkedField",
      "name": "accountAdminUserByCode",
      "plural": false,
      "selections": [
        v1,
        v2,
        v3,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountsAdminUserGroup",
          "kind": "LinkedField",
          "name": "userGroups",
          "plural": true,
          "selections": [
            v1,
            v2,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            v3,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adminUserGroupId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserDetailsRouteQuery",
      "selections": v4,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserDetailsRouteQuery",
      "selections": v4
    },
    "params": {
      "cacheID": "8a4381ad43af5b47bf4885123a026d59",
      "id": null,
      "metadata": {},
      "name": "AdminUserDetailsRouteQuery",
      "operationKind": "query",
      "text": "query AdminUserDetailsRouteQuery(\n  $adminUserCode: Long!\n) {\n  adminUser: accountAdminUserByCode(code: $adminUserCode) {\n    id\n    code\n    isDeleted\n    accountId\n    createdAt\n    updatedAt\n    firstName\n    lastName\n    emailAddress\n    userGroups {\n      id\n      code\n      name\n      isDeleted\n      adminUserGroupId\n    }\n  }\n}\n"
    }
  };
}();
node17.hash = "1d4b5ef317ff7a389a556fe400a2fd57";
var AdminUserDetailsRouteQuery_graphql_default = node17;

// src/secure/accounts/administrators/components/AdminUserDetails.tsx
import { Suspense as Suspense23, useCallback as useCallback13 } from "react";
import { loadQuery as loadQuery17 } from "react-relay";
import { Link as Link10 } from "react-router-dom";
import { createClientMutationId as createClientMutationId3, timeAgo as timeAgo5, useRouteData as useRouteData12 } from "shared-lib";
import { Button as Button6, Card, EdSkeleton as EdSkeleton15, Size as Size4 } from "shared-ui";

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserCreateMutation.graphql.ts
var node18 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUser",
    "kind": "LinkedField",
    "name": "adminUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserCreatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserCreatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1a3f7a030a514cf5731f581af44236f5",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserCreateMutation(\n  $input: AccountsAdminUserCreateInput!\n) {\n  data: accountsAdminUserCreate(input: $input) {\n    adminUser {\n      node {\n        id\n        code\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node18.hash = "5f2a1e1719e214e40dc8f07783a794eb";
var UseAdminUserCreateMutation_graphql_default = node18;

// src/secure/accounts/administrators/mutations/UseAdminUserCreate.ts
import { useAsyncMutation } from "shared-lib";
var mutationDef = UseAdminUserCreateMutation_graphql_default;
function useAdminUserCreate() {
  const [commit, isBusy] = useAsyncMutation(mutationDef);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserGroupCreateMutation.graphql.ts
var node19 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUserGroup",
    "kind": "LinkedField",
    "name": "adminUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUserGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminUserGroupId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PermissionSet",
            "kind": "LinkedField",
            "name": "permissionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourcePermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserGroupCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupCreatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserGroupCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupCreatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e346f54ed792c1a35ebb6e100952bc60",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserGroupCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserGroupCreateMutation(\n  $input: AccountsAdminUserGroupCreateInput!\n) {\n  data: accountsAdminUserGroupCreate(input: $input) {\n    adminUserGroup {\n      node {\n        id\n        code\n        adminUserGroupId\n        name\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node19.hash = "ace95ff0655e9f91170e744eb4805f04";
var UseAdminUserGroupCreateMutation_graphql_default = node19;

// src/secure/accounts/administrators/mutations/UseAdminUserGroupCreate.ts
import { useAsyncMutation as useAsyncMutation2 } from "shared-lib";
var mutationDef2 = UseAdminUserGroupCreateMutation_graphql_default;
function useAdminUserGroupCreate() {
  const [commit, isBusy] = useAsyncMutation2(mutationDef2);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserGroupUpdateMutation.graphql.ts
var node20 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUserGroup",
    "kind": "LinkedField",
    "name": "adminUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUserGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PermissionSet",
            "kind": "LinkedField",
            "name": "permissionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourcePermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserGroupUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserGroupUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8fc57d545b102e9bc2198151e74b9398",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserGroupUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserGroupUpdateMutation(\n  $input: AccountsAdminUserGroupUpdateInput!\n) {\n  data: accountsAdminUserGroupUpdate(input: $input) {\n    adminUserGroup {\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node20.hash = "0da80a3bd6d061ebabd27e688482701e";
var UseAdminUserGroupUpdateMutation_graphql_default = node20;

// src/secure/accounts/administrators/mutations/UseAdminUserGroupUpdate.ts
import { useAsyncMutation as useAsyncMutation3 } from "shared-lib";
var mutationDef3 = UseAdminUserGroupUpdateMutation_graphql_default;
function useAdminUserGroupUpdate() {
  const [commit, isBusy] = useAsyncMutation3(mutationDef3);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserGroupUpdatePermissionsMutation.graphql.ts
var node21 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUserGroup",
    "kind": "LinkedField",
    "name": "adminUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUserGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PermissionSet",
            "kind": "LinkedField",
            "name": "permissionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourcePermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserGroupUpdatePermissionsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupPermissionsPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupPermissions",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserGroupUpdatePermissionsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupPermissionsPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupPermissions",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2726dc734ff1cde5329d110e2a4faa39",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserGroupUpdatePermissionsMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserGroupUpdatePermissionsMutation(\n  $input: AccountsAdminUserGroupPermissionsInput!\n) {\n  data: accountsAdminUserGroupPermissions(input: $input) {\n    adminUserGroup {\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node21.hash = "6fb4463311f76327f41d9f83e01fa21a";
var UseAdminUserGroupUpdatePermissionsMutation_graphql_default = node21;

// src/secure/accounts/administrators/mutations/UseAdminUserGroupUpdatePermissions.ts
import { useAsyncMutation as useAsyncMutation4 } from "shared-lib";
var mutationDef4 = UseAdminUserGroupUpdatePermissionsMutation_graphql_default;
function useAdminUserGroupUpdatePermissions() {
  const [commit, isBusy] = useAsyncMutation4(mutationDef4);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserJoinGroupMutation.graphql.ts
var node22 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUser",
    "kind": "LinkedField",
    "name": "adminUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserJoinGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserJoinGroupPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserJoinGroup",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserJoinGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserJoinGroupPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserJoinGroup",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "88588e64d1d47df1c4f661c6107ce28c",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserJoinGroupMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserJoinGroupMutation(\n  $input: AccountsAdminUserJoinGroupInput!\n) {\n  data: accountsAdminUserJoinGroup(input: $input) {\n    adminUser {\n      node {\n        id\n        code\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node22.hash = "7ce86be2d4aa725886b4e462dcf465e6";
var UseAdminUserJoinGroupMutation_graphql_default = node22;

// src/secure/accounts/administrators/mutations/UseAdminUserJoinGroup.ts
import { useAsyncMutation as useAsyncMutation5 } from "shared-lib";
var mutationDef5 = UseAdminUserJoinGroupMutation_graphql_default;
function useAdminUserJoinGroup() {
  const [commit, isBusy] = useAsyncMutation5(mutationDef5);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserLeaveGroupMutation.graphql.ts
var node23 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "connections"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserLeaveGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserLeaveGroupPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserLeaveGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfAdminUser",
              "kind": "LinkedField",
              "name": "adminUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserLeaveGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserLeaveGroupPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserLeaveGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfAdminUser",
              "kind": "LinkedField",
              "name": "adminUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "filters": null,
                      "handle": "deleteEdge",
                      "key": "",
                      "kind": "ScalarHandle",
                      "name": "id",
                      "handleArgs": [
                        {
                          "kind": "Variable",
                          "name": "connections",
                          "variableName": "connections"
                        }
                      ]
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "ee8f3a9c2170431b7d5cfa56fd673460",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserLeaveGroupMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserLeaveGroupMutation(\n  $input: AccountsAdminUserLeaveGroupInput!\n) {\n  data: accountsAdminUserLeaveGroup(input: $input) {\n    adminUser {\n      node {\n        id\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node23.hash = "c87dd5995dfa0e215379c3e85282615e";
var UseAdminUserLeaveGroupMutation_graphql_default = node23;

// src/secure/accounts/administrators/mutations/UseAdminUserLeaveGroup.ts
import { useAsyncMutation as useAsyncMutation6 } from "shared-lib";
var mutationDef6 = UseAdminUserLeaveGroupMutation_graphql_default;
function useAdminUserLeaveGroup() {
  const [commit, isBusy] = useAsyncMutation6(mutationDef6);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserUpdateMutation.graphql.ts
var node24 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUser",
    "kind": "LinkedField",
    "name": "adminUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8d9d389d9ef8073cd1d90c2aec5aa595",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserUpdateMutation(\n  $input: AccountsAdminUserUpdateInput!\n) {\n  data: accountsAdminUserUpdate(input: $input) {\n    adminUser {\n      node {\n        id\n        code\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node24.hash = "4e43bcd431666f831934df4a01210adc";
var UseAdminUserUpdateMutation_graphql_default = node24;

// src/secure/accounts/administrators/mutations/UseAdminUserUpdate.ts
import { useAsyncMutation as useAsyncMutation7 } from "shared-lib";
var mutationDef7 = UseAdminUserUpdateMutation_graphql_default;
function useAdminUserUpdate() {
  const [commit, isBusy] = useAsyncMutation7(mutationDef7);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserEnableMutation.graphql.ts
var node25 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUser",
    "kind": "LinkedField",
    "name": "adminUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserEnableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserEnablePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserEnable",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserEnableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserEnablePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserEnable",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b4ece84697e7a5231d8842c1d79f10aa",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserEnableMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserEnableMutation(\n  $input: AccountsAdminUserEnableInput!\n) {\n  data: accountsAdminUserEnable(input: $input) {\n    adminUser {\n      node {\n        id\n        code\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node25.hash = "70913c6f9d15a4aa38f89fbf28f08695";
var UseAdminUserEnableMutation_graphql_default = node25;

// src/secure/accounts/administrators/mutations/UseAdminUserEnable.ts
import { useAsyncMutation as useAsyncMutation8 } from "shared-lib";
var mutationDef8 = UseAdminUserEnableMutation_graphql_default;
function useAdminUserEnable() {
  const [commit, isBusy] = useAsyncMutation8(mutationDef8);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserDisableMutation.graphql.ts
var node26 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUser",
    "kind": "LinkedField",
    "name": "adminUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserDisableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserDisablePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserDisable",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserDisableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserDisablePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserDisable",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "21b053f355e057f04ae41b78bc8eef84",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserDisableMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserDisableMutation(\n  $input: AccountsAdminUserDisableInput!\n) {\n  data: accountsAdminUserDisable(input: $input) {\n    adminUser {\n      node {\n        id\n        code\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node26.hash = "bbb2df7c8f11f541a63dbf88468227a2";
var UseAdminUserDisableMutation_graphql_default = node26;

// src/secure/accounts/administrators/mutations/UseAdminUserDisable.ts
import { useAsyncMutation as useAsyncMutation9 } from "shared-lib";
var mutationDef9 = UseAdminUserDisableMutation_graphql_default;
function useAdminUserDisable() {
  const [commit, isBusy] = useAsyncMutation9(mutationDef9);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/components/AdminUserDetails.tsx
import { Fragment as Fragment15, jsx as jsx30, jsxs as jsxs15 } from "react/jsx-runtime";
var queryDef14 = AdminUserDetailsRouteQuery_graphql_default;
async function loader17(environment, params) {
  const code = params.adminUserCode;
  const adminUserCode = parseInt(code);
  return loadQuery17(environment, queryDef14, {
    adminUserCode
  });
}
var AdminUserDetails = ({ routeId: routeId6, inList }) => {
  const data = useRouteData12(queryDef14, routeId6);
  const [enable, isEnabling] = useAdminUserEnable();
  const [disable, isDisabling] = useAdminUserDisable();
  const { adminUser } = data;
  const onEnable = useCallback13(async () => {
    const input = {
      clientMutationId: createClientMutationId3(),
      groupId: adminUser?.userGroups?.[0]?.adminUserGroupId || "",
      userId: adminUser?.accountId || ""
    };
    await enable({ input });
  }, [adminUser?.accountId, adminUser?.userGroups, enable]);
  const onDisable = useCallback13(async () => {
    const input = {
      clientMutationId: createClientMutationId3(),
      groupId: adminUser?.userGroups?.[0]?.adminUserGroupId || "",
      userId: adminUser?.accountId || ""
    };
    await disable({ input });
  }, [adminUser?.accountId, adminUser?.userGroups, disable]);
  if (!data) {
    return /* @__PURE__ */ jsx30(Fragment15, { children: "Loading..." });
  }
  if (!adminUser) {
    return /* @__PURE__ */ jsx30(Fragment15, { children: "Loading..." });
  }
  const groupsList = adminUser.userGroups.map((g) => {
    return /* @__PURE__ */ jsx30("div", { className: "flex gap-5", children: /* @__PURE__ */ jsx30("div", { className: "bg-primary-500 w-1/3 cursor-pointer rounded-lg border p-2 text-white", children: /* @__PURE__ */ jsx30("div", { children: g.name }) }) }, g.code);
  });
  return /* @__PURE__ */ jsx30(Suspense23, { fallback: /* @__PURE__ */ jsx30(EdSkeleton15, {}), children: /* @__PURE__ */ jsxs15(Card, { className: "m-4 flex flex-col gap-2 bg-white p-4", children: [
    /* @__PURE__ */ jsxs15("div", { className: "my-4 flex justify-between gap-2", children: [
      /* @__PURE__ */ jsxs15("div", { className: "my-4 flex flex-col gap-2", children: [
        adminUser.isDeleted && /* @__PURE__ */ jsx30("div", { className: "mb-4 max-w-sm border bg-gray-100 px-8 py-4", children: /* @__PURE__ */ jsx30("div", { className: "text-danger-500 text-xl font-bold", children: "Disabled" }) }),
        /* @__PURE__ */ jsxs15("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx30("div", { children: adminUser.firstName }),
          /* @__PURE__ */ jsx30("div", { children: adminUser.lastName })
        ] }),
        /* @__PURE__ */ jsx30("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx30("div", { children: adminUser.emailAddress }) }),
        /* @__PURE__ */ jsxs15("div", { className: "flex items-center gap-2", children: [
          "Updated: ",
          timeAgo5(adminUser.updatedAt)
        ] })
      ] }),
      /* @__PURE__ */ jsx30("div", { className: "p-4", children: adminUser.isDeleted ? /* @__PURE__ */ jsx30("div", { children: /* @__PURE__ */ jsx30(
        Button6,
        {
          color: "danger",
          size: Size4.xl,
          disabled: isEnabling,
          confirmMessage: "Are you sure ?",
          onClick: onEnable,
          children: "Enable"
        }
      ) }) : /* @__PURE__ */ jsx30("div", { children: /* @__PURE__ */ jsx30(
        Button6,
        {
          color: "danger",
          size: Size4.xl,
          disabled: isDisabling,
          confirmMessage: "Are you sure ?",
          onClick: onDisable,
          children: "Disable"
        }
      ) }) })
    ] }),
    /* @__PURE__ */ jsxs15("div", { className: "my-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx30("div", { className: "text-primary-500 flex items-center gap-2 font-medium uppercase", children: "Groups" }),
      /* @__PURE__ */ jsx30("div", { className: "flex flex-col gap-2 py-4", children: groupsList })
    ] })
  ] }) });
};
var createRoute8 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-admin-user-details`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx30(AdminUserDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx30(Link10, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader17(environment, params);
    }
  };
};

// src/secure/accounts/administrators/components/AdminUserRoute.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
var createAdminUserRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId6 = `${routePrefix}-${routeId3}`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx31(AdminUserLayout, { inList, showHeader }),
      errorElement: /* @__PURE__ */ jsx31(ErrorContainer4, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx31(AdminUserGroupLink, { routeId: routeId6 })
      },
      loader: ({ params }) => {
        return loader16(environment, params);
      },
      children: [
        createRoute8(routePrefix, environment, context, inList),
        {
          path: "*",
          element: /* @__PURE__ */ jsx31(Navigate10, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/administrators/components/AdminUserCreate.tsx
import { Suspense as Suspense24, useCallback as useCallback15 } from "react";
import { useNavigate as useNavigate11 } from "react-router-dom";
import { EdSkeleton as EdSkeleton16 } from "shared-ui";

// src/secure/accounts/administrators/components/AdminUserCreateContainer.tsx
import { useCallback as useCallback14 } from "react";
import * as zod from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId4,
  useSetUserErrorCodes,
  useUserErrorCode
} from "shared-lib";
import {
  ActionContainer,
  ErrorField,
  FormErrorCode,
  FormErrorCodes,
  FormInputRow,
  InputField,
  SwitchInput
} from "shared-ui";

// src/secure/accounts/administrators/lib/error-codes.ts
var AdminUserAccountsErrorCodes = class {
};
AdminUserAccountsErrorCodes.USER_EMAIL_IS_IN_USE = "ACCOUNTS_ADMIN_USER_EMAIL_IS_IN_USE";

// src/secure/accounts/administrators/components/AdminUserCreateContainer.tsx
import { jsx as jsx32, jsxs as jsxs16 } from "react/jsx-runtime";
var formSchema = zod.object({
  firstName: zod.string().min(1, { message: "Firstname is required" }),
  lastName: zod.string().min(1, { message: "Lastname is required" }),
  email: zod.string().min(1, { message: "Email is required" }).email({
    message: "Must be a valid email"
  }),
  isTestUser: zod.boolean()
});
var AdminUserCreateContainer = ({ onCreate, onCancel }) => {
  const defaultValues = {
    firstName: "",
    lastName: "",
    email: "",
    isTestUser: true
  };
  const setErrorCode = useSetUserErrorCodes();
  const { register, handleSubmit, watch, formState, control } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode();
  const [createAdminUser, isCreatingAdminUser] = useAdminUserCreate();
  const onSave = useCallback14(
    async (form) => {
      setErrorCode(null);
      if (!form.firstName || !form.lastName || !form.email) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId4(),
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        isTestUser: form.isTestUser
      };
      const response = await createAdminUser({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.adminUser?.node) {
        onCreate();
      }
    },
    [createAdminUser]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  let errorDisplay = /* @__PURE__ */ jsx32(FormErrorCodes, {});
  if (userErrorCode && userErrorCode === AdminUserAccountsErrorCodes.USER_EMAIL_IS_IN_USE) {
    errorDisplay = /* @__PURE__ */ jsx32(FormErrorCode, { message: "Email is already in use" });
  }
  return /* @__PURE__ */ jsxs16("div", { className: "m-4 flex flex-col items-center justify-center", children: [
    errorDisplay,
    /* @__PURE__ */ jsx32("form", { onSubmit, children: /* @__PURE__ */ jsxs16(
      ActionContainer,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        onCancel,
        isDisabled: isCreatingAdminUser,
        titleTop: `Create AdminUser`,
        children: [
          /* @__PURE__ */ jsxs16(FormInputRow, { name: "firstName", title: "First Name *", children: [
            /* @__PURE__ */ jsx32(
              InputField,
              {
                register,
                name: "firstName",
                required: true,
                placeholder: "Admin User First Name"
              }
            ),
            /* @__PURE__ */ jsx32(ErrorField, { field: errors.firstName })
          ] }),
          /* @__PURE__ */ jsxs16(FormInputRow, { name: "lastName", title: "Last Name *", children: [
            /* @__PURE__ */ jsx32(
              InputField,
              {
                register,
                name: "lastName",
                required: true,
                placeholder: "Admin User Last Name"
              }
            ),
            /* @__PURE__ */ jsx32(ErrorField, { field: errors.lastName })
          ] }),
          /* @__PURE__ */ jsxs16(FormInputRow, { name: "email", title: "Email *", children: [
            /* @__PURE__ */ jsx32(
              InputField,
              {
                register,
                name: "email",
                required: true,
                placeholder: "Admin User Email"
              }
            ),
            /* @__PURE__ */ jsx32(ErrorField, { field: errors.email })
          ] }),
          /* @__PURE__ */ jsxs16(FormInputRow, { name: "isTestUser", title: "Test Account *", children: [
            /* @__PURE__ */ jsx32(
              SwitchInput,
              {
                control,
                name: "isTestUser",
                defaultChecked: false
              }
            ),
            /* @__PURE__ */ jsx32(ErrorField, { field: errors.isTestUser })
          ] })
        ]
      }
    ) })
  ] });
};

// src/secure/accounts/administrators/components/AdminUserCreate.tsx
import { jsx as jsx33 } from "react/jsx-runtime";
var AdminUserCreate = () => {
  const navigate = useNavigate11();
  const onCompleteAction = useCallback15(() => {
    navigate(`../`);
  }, [navigate]);
  return /* @__PURE__ */ jsx33(Suspense24, { fallback: /* @__PURE__ */ jsx33(EdSkeleton16, {}), children: /* @__PURE__ */ jsx33(
    AdminUserCreateContainer,
    {
      onCreate: onCompleteAction,
      onCancel: onCompleteAction
    }
  ) });
};

// src/secure/accounts/administrators/components/__generated__/AdminUserListContainerQuery.graphql.ts
var node27 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AdminUserList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "AccountAdminUsersConnection",
          "kind": "LinkedField",
          "name": "accountAdminUsers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUsersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "AdminUsersList_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUsers"
        }
      ]
    },
    "params": {
      "cacheID": "036994bf557854fd13a8b9716b820666",
      "id": null,
      "metadata": {},
      "name": "AdminUserListContainerQuery",
      "operationKind": "query",
      "text": "query AdminUserListContainerQuery(\n  $where: AccountsAdminUserFilter!\n) {\n  ...AdminUserList_list\n}\n\nfragment AdminUserList_list on Query {\n  list: accountAdminUsers(first: 10, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        updatedAt\n        createdAt\n        firstName\n        lastName\n        emailAddress\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node27.hash = "4532429833ab1dca588f32cfd0a727ae";
var AdminUserListContainerQuery_graphql_default = node27;

// src/secure/accounts/administrators/components/AdminUserListContainer.tsx
import { Suspense as Suspense25, useState as useState5 } from "react";
import { useLazyLoadQuery } from "react-relay";
import { Input, Loading } from "shared-ui";
import { useDebounce } from "shared-lib";

// src/secure/accounts/administrators/components/__generated__/AdminUsersListPaginationQuery.graphql.ts
var node28 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUsersListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "AdminUserList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUsersListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "AccountAdminUsersConnection",
          "kind": "LinkedField",
          "name": "accountAdminUsers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUsersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "AdminUsersList_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUsers"
        }
      ]
    },
    "params": {
      "cacheID": "3d0a4336c1ae22d6813a0ee58459beed",
      "id": null,
      "metadata": {},
      "name": "AdminUsersListPaginationQuery",
      "operationKind": "query",
      "text": "query AdminUsersListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: AccountsAdminUserFilter\n) {\n  ...AdminUserList_list_2HEEH6\n}\n\nfragment AdminUserList_list_2HEEH6 on Query {\n  list: accountAdminUsers(first: $first, after: $after, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        updatedAt\n        createdAt\n        firstName\n        lastName\n        emailAddress\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node28.hash = "7e298323240146163159303f98658fbc";
var AdminUsersListPaginationQuery_graphql_default = node28;

// src/secure/accounts/administrators/components/__generated__/AdminUserList_list.graphql.ts
var node29 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": AdminUsersListPaginationQuery_graphql_default
      }
    },
    "name": "AdminUserList_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "firstName": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountAdminUsersConnection",
        "kind": "LinkedField",
        "name": "__AdminUsersList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountAdminUsersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsAdminUser",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node29.hash = "7e298323240146163159303f98658fbc";
var AdminUserList_list_graphql_default = node29;

// src/secure/accounts/administrators/components/AdminUserList.tsx
import { useCallback as useCallback16 } from "react";
import { usePaginationFragment } from "react-relay";
import { formatDistanceToNow, parseISO } from "date-fns";
import {
  DefaultListLayoutItemHeader,
  DefaultListLayoutSectionElement,
  ListLayout
} from "shared-ui";
import { isNotNullOrUndefined } from "shared-lib";
import { jsx as jsx34, jsxs as jsxs17 } from "react/jsx-runtime";
var fragmentDef = AdminUserList_list_graphql_default;
function createLinkTo(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var AdminUserList = ({ fragmentRef }) => {
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment(
    fragmentDef,
    fragmentRef
  );
  const onLoadNext = useCallback16(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined).map((e) => e.node).map((ft) => {
    const name = `${ft.firstName} ${ft.lastName}`;
    return {
      key: ft.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx34("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs17("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsxs17("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx34("div", { className: "text-md font-medium uppercase", children: ft.firstName }),
          /* @__PURE__ */ jsx34("div", { className: "text-md font-medium uppercase", children: ft.lastName })
        ] }),
        /* @__PURE__ */ jsx34("div", { className: "text-md text-blue-500", children: ft.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs17("div", { className: "pt-2 text-sm", children: [
        "Updated ",
        formatDistanceToNow(parseISO(ft.updatedAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: ft.code
      },
      element: /* @__PURE__ */ jsx34(DefaultListLayoutSectionElement, { children: /* @__PURE__ */ jsx34("div", { className: "grid", children: /* @__PURE__ */ jsx34("div", { children: ft.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx34(
    ListLayout,
    {
      title: "Admin Users",
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx34(
        DefaultListLayoutItemHeader,
        {
          title: "Admin Users",
          to: createLinkTo,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  );
};

// src/secure/accounts/administrators/components/AdminUserListContainer.tsx
import { jsx as jsx35, jsxs as jsxs18 } from "react/jsx-runtime";
var queryDef15 = AdminUserListContainerQuery_graphql_default;
var AdminUserListContainer = () => {
  const [filter, setFilter] = useState5(null);
  const searchTerm = useDebounce(filter, 500);
  let where2 = {};
  if (searchTerm) {
    where2 = {
      or: [
        { firstName: { startsWith: filter } },
        { lastName: { startsWith: filter } },
        { emailAddress: { startsWith: filter } }
      ]
    };
  }
  const query = useLazyLoadQuery(
    queryDef15,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs18("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx35("div", { className: "flex items-center justify-between space-x-4 border-b bg-white", children: /* @__PURE__ */ jsxs18("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx35("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx35("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx35(
        Input,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx35("div", { className: "flex-1", children: /* @__PURE__ */ jsx35(Suspense25, { fallback: /* @__PURE__ */ jsx35(Loading, {}), children: /* @__PURE__ */ jsx35(AdminUserList, { fragmentRef: query }) }) })
  ] });
};

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupListContainerQuery.graphql.ts
var node30 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AdminUserGroupListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "AccountAdminUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountAdminUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "adminUserGroupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PermissionSet",
                      "kind": "LinkedField",
                      "name": "permissionSet",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ResourcePermissions",
                          "kind": "LinkedField",
                          "name": "permissions",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "actions",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resource",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "AdminUserGroupListContainer_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "d62783874da9d6a5cabc1b08f9027405",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupListContainerQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupListContainerQuery(\n  $where: AccountsAdminUserGroupFilter!\n) {\n  ...AdminUserGroupListContainer_list\n}\n\nfragment AdminUserGroupListContainer_list on Query {\n  list: accountAdminUserGroups(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        adminUserGroupId\n        updatedAt\n        createdAt\n        name\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node30.hash = "f266eb231a8111e5cee69bbabc485bdd";
var AdminUserGroupListContainerQuery_graphql_default = node30;

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupListPaginationQuery.graphql.ts
var node31 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "AdminUserGroupListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "AccountAdminUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountAdminUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "adminUserGroupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PermissionSet",
                      "kind": "LinkedField",
                      "name": "permissionSet",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ResourcePermissions",
                          "kind": "LinkedField",
                          "name": "permissions",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "actions",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resource",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "AdminUserGroupListContainer_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "c85e417da6c9934896e0e1d88e1ab2ad",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupListPaginationQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: AccountsAdminUserGroupFilter\n) {\n  ...AdminUserGroupListContainer_list_2HEEH6\n}\n\nfragment AdminUserGroupListContainer_list_2HEEH6 on Query {\n  list: accountAdminUserGroups(first: $first, after: $after, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        adminUserGroupId\n        updatedAt\n        createdAt\n        name\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node31.hash = "68ba3d6636d0a1c510c273140e013789";
var AdminUserGroupListPaginationQuery_graphql_default = node31;

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupListContainer_list.graphql.ts
var node32 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": AdminUserGroupListPaginationQuery_graphql_default
      }
    },
    "name": "AdminUserGroupListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountAdminUserGroupsConnection",
        "kind": "LinkedField",
        "name": "__AdminUserGroupListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountAdminUserGroupsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsAdminUserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adminUserGroupId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PermissionSet",
                    "kind": "LinkedField",
                    "name": "permissionSet",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResourcePermissions",
                        "kind": "LinkedField",
                        "name": "permissions",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actions",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "resource",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node32.hash = "68ba3d6636d0a1c510c273140e013789";
var AdminUserGroupListContainer_list_graphql_default = node32;

// src/secure/accounts/administrators/components/AdminUserGroupListContainer.tsx
import { Suspense as Suspense26, useCallback as useCallback17, useState as useState6 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery2, usePaginationFragment as usePaginationFragment2 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow2, parseISO as parseISO2 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined2, useDebounce as useDebounce2 } from "shared-lib";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader2,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement2,
  EdSkeleton as EdSkeleton17,
  Input as Input2,
  ListLayout as ListLayout2
} from "shared-ui";
import { jsx as jsx36, jsxs as jsxs19 } from "react/jsx-runtime";
var queryDef16 = AdminUserGroupListContainerQuery_graphql_default;
var fragmentDef2 = AdminUserGroupListContainer_list_graphql_default;
function createLinkTo2(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var AdminUserList2 = ({ fragmentRef }) => {
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment2(fragmentDef2, fragmentRef);
  const onLoadNext = useCallback17(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined2).map((e) => e.node).map((ft) => {
    const name = `${ft.name}`;
    return {
      key: ft.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx36("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs19("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx36("div", { className: "text-md font-medium uppercase", children: ft.name }),
        /* @__PURE__ */ jsx36("div", { className: "text-md text-blue-500", children: ft.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs19("div", { className: "pt-2 text-sm", children: [
        "Updated ",
        formatDistanceToNow2(parseISO2(ft.updatedAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: ft.code
      },
      element: /* @__PURE__ */ jsx36(Suspense26, { fallback: /* @__PURE__ */ jsx36(EdSkeleton17, {}), children: /* @__PURE__ */ jsx36(DefaultListLayoutSectionElement2, { children: /* @__PURE__ */ jsx36("div", { className: "grid", children: /* @__PURE__ */ jsx36("div", { children: ft.code }) }) }) })
    };
  });
  return /* @__PURE__ */ jsx36(
    ListLayout2,
    {
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx36(
        DefaultListLayoutItemHeader2,
        {
          title: "Admin Users",
          to: createLinkTo2,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false
    }
  );
};
var AdminUserGroupListContainer = () => {
  const [filter, setFilter] = useState6(null);
  const searchTerm = useDebounce2(filter, 500);
  let where2 = {};
  if (searchTerm) {
    where2 = { name: { startsWith: filter } };
  }
  const query = useLazyLoadQuery2(
    queryDef16,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs19("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx36("div", { className: "flex items-center justify-between space-x-4 border-b bg-white", children: /* @__PURE__ */ jsxs19("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx36("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx36("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx36(
        Input2,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx36("div", { className: "flex-1", children: /* @__PURE__ */ jsx36(Suspense26, { fallback: /* @__PURE__ */ jsx36(EdSkeleton17, {}), children: /* @__PURE__ */ jsx36(AdminUserList2, { fragmentRef: query }) }) })
  ] });
};

// src/secure/accounts/administrators/components/AdminUserGroupRoute.tsx
import { Navigate as Navigate11 } from "react-router-dom";
import { ErrorContainer as ErrorContainer5 } from "shared-ui";

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupLayoutQuery.graphql.ts
var node33 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserGroupCode"
    }
  ], v1 = [
    {
      "alias": "adminUserGroup",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "adminUserGroupCode"
        }
      ],
      "concreteType": "AccountsAdminUserGroup",
      "kind": "LinkedField",
      "name": "accountAdminUserGroupByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "adminUserGroupId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PermissionSet",
          "kind": "LinkedField",
          "name": "permissionSet",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ResourcePermissions",
              "kind": "LinkedField",
              "name": "permissions",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "actions",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "resource",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "1c674deed3e3c510bd08c626bb6abb1c",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupLayoutQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupLayoutQuery(\n  $adminUserGroupCode: Long!\n) {\n  adminUserGroup: accountAdminUserGroupByCode(code: $adminUserGroupCode) {\n    id\n    code\n    adminUserGroupId\n    createdAt\n    updatedAt\n    name\n    permissionSet {\n      permissions {\n        actions\n        resource\n      }\n    }\n  }\n}\n"
    }
  };
}();
node33.hash = "446cf9ef26c9d05bcc4f378b002d909d";
var AdminUserGroupLayoutQuery_graphql_default = node33;

// src/secure/accounts/administrators/components/AdminUserGroupLayout.tsx
import { Suspense as Suspense27 } from "react";
import {
  Link as Link11,
  Outlet as Outlet7,
  useLoaderData as useLoaderData6,
  useRouteLoaderData as useRouteLoaderData4
} from "react-router-dom";
import {
  loadQuery as loadQuery18,
  usePreloadedQuery as usePreloadedQuery6
} from "react-relay";
import { ArrowsPointingOutIcon as ArrowsPointingOutIcon2 } from "@heroicons/react/24/outline";
import {
  DynamicBreadcrumb as DynamicBreadcrumb5,
  EdButtonLink as EdButtonLink2,
  EdTextLink as EdTextLink5,
  IconJustify as IconJustify2
} from "shared-ui";
import { Fragment as Fragment16, jsx as jsx37, jsxs as jsxs20 } from "react/jsx-runtime";
var routeId4 = "admin-user-group-home";
var queryDef17 = AdminUserGroupLayoutQuery_graphql_default;
var AdminUserGroupLayout = ({ inList, showHeader }) => {
  const preloadedQuery = useLoaderData6();
  const data = usePreloadedQuery6(queryDef17, preloadedQuery);
  const { adminUserGroup } = data;
  if (adminUserGroup === null || adminUserGroup === void 0) {
    return /* @__PURE__ */ jsx37("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx37(Suspense27, { fallback: "Loading...", children: /* @__PURE__ */ jsxs20("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsx37("div", { children: /* @__PURE__ */ jsxs20("div", { className: "flex flex-wrap items-center justify-between border-b", children: [
      /* @__PURE__ */ jsx37(DynamicBreadcrumb5, {}),
      /* @__PURE__ */ jsx37("div", { className: "text-primary-500 px-2 font-medium uppercase sm:px-8", children: adminUserGroup.name })
    ] }) }),
    /* @__PURE__ */ jsxs20("div", { className: "flex flex-wrap items-center justify-between border-b bg-white p-2", children: [
      /* @__PURE__ */ jsxs20("div", { className: "flex flex-wrap items-center gap-2 px-4", children: [
        /* @__PURE__ */ jsx37(
          EdTextLink5,
          {
            id: "form-template-root-link",
            to: "details",
            label: "Details"
          }
        ),
        /* @__PURE__ */ jsx37(
          EdTextLink5,
          {
            id: "form-template-permissions-link",
            to: "permissions",
            label: "Permissions"
          }
        ),
        /* @__PURE__ */ jsx37(
          EdTextLink5,
          {
            id: "form-template-users-link",
            to: "users",
            label: "Users"
          }
        )
      ] }),
      inList && /* @__PURE__ */ jsx37("div", { children: /* @__PURE__ */ jsx37(
        EdButtonLink2,
        {
          to: `../../../../group/${adminUserGroup.code}`,
          name: "View",
          icon: ArrowsPointingOutIcon2,
          iconJustify: IconJustify2.Right
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx37(Outlet7, {})
  ] }) });
};
var AdminUserGroupLink2 = ({ routeId: routeId6, label }) => {
  const data = useAdminUserGroupRouteData(routeId6);
  if (!data.adminUserGroup) {
    return /* @__PURE__ */ jsx37(Fragment16, {});
  }
  const name = `${data.adminUserGroup.name}`;
  return /* @__PURE__ */ jsx37(Suspense27, { fallback: "Loading...", children: /* @__PURE__ */ jsx37(Link11, { to: ".", children: label || name }) });
};
async function loader18(environment, params) {
  const code = params.adminUserGroupCode;
  const adminUserGroupCode = parseInt(code);
  return loadQuery18(environment, queryDef17, {
    adminUserGroupCode
  });
}
function useAdminUserGroupRouteData(routeId6) {
  const queryRef = useRouteLoaderData4(
    routeId6
  );
  const data = usePreloadedQuery6(queryDef17, queryRef);
  return data;
}

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupDetailsRouteQuery.graphql.ts
var node34 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserGroupCode"
    }
  ], v1 = [
    {
      "alias": "adminUserGroup",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "adminUserGroupCode"
        }
      ],
      "concreteType": "AccountsAdminUserGroup",
      "kind": "LinkedField",
      "name": "accountAdminUserGroupByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "adminUserGroupId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupDetailsRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupDetailsRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "fa737f446ce898ce96363860280bbcc1",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupDetailsRouteQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupDetailsRouteQuery(\n  $adminUserGroupCode: Long!\n) {\n  adminUserGroup: accountAdminUserGroupByCode(code: $adminUserGroupCode) {\n    id\n    code\n    adminUserGroupId\n    createdAt\n    updatedAt\n    name\n    description\n  }\n}\n"
    }
  };
}();
node34.hash = "68269ee548deca9ab99b61f2c4b22b1c";
var AdminUserGroupDetailsRouteQuery_graphql_default = node34;

// src/secure/accounts/administrators/components/AdminUserGroupDetails.tsx
import { Suspense as Suspense28 } from "react";
import { loadQuery as loadQuery19 } from "react-relay";
import { Link as Link12 } from "react-router-dom";
import { timeAgo as timeAgo6, useRouteData as useRouteData13 } from "shared-lib";
import { EdSkeleton as EdSkeleton18 } from "shared-ui";
import { Fragment as Fragment17, jsx as jsx38, jsxs as jsxs21 } from "react/jsx-runtime";
var queryDef18 = AdminUserGroupDetailsRouteQuery_graphql_default;
async function loader19(environment, params) {
  const code = params.adminUserGroupCode;
  const adminUserGroupCode = parseInt(code);
  return loadQuery19(environment, queryDef18, {
    adminUserGroupCode
  });
}
var AdminUserGroupDetails = ({ routeId: routeId6, inList }) => {
  const data = useRouteData13(queryDef18, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx38(Fragment17, { children: "Loading..." });
  }
  const { adminUserGroup } = data;
  if (!adminUserGroup) {
    return /* @__PURE__ */ jsx38(Fragment17, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx38(Suspense28, { fallback: /* @__PURE__ */ jsx38(EdSkeleton18, {}), children: /* @__PURE__ */ jsxs21("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx38("div", { className: "mt-4 flex flex-col gap-2 p-4", children: /* @__PURE__ */ jsxs21("div", { className: "flex items-center gap-2 border-b pb-2", children: [
      /* @__PURE__ */ jsx38("div", { className: "text-primary-500 text-xl font-medium uppercase", children: adminUserGroup.name }),
      /* @__PURE__ */ jsxs21("div", { className: "text-sm text-gray-500", children: [
        "Updated ",
        timeAgo6(adminUserGroup.updatedAt)
      ] })
    ] }) }),
    /* @__PURE__ */ jsx38("div", { className: "mt-4 flex flex-col gap-2 p-4", children: /* @__PURE__ */ jsx38("div", { className: "font-medium text-gray-900", children: /* @__PURE__ */ jsx38("div", { children: adminUserGroup.description }) }) })
  ] }) });
};
var createRoute9 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-admin-user-group-details`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx38(AdminUserGroupDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx38(Link12, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader19(environment, params);
    }
  };
};

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupPermissionsRouteQuery.graphql.ts
var node35 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserGroupCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "adminUserGroupCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "adminUserGroupId",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v8 = [
    v6,
    v7
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupPermissionsRouteQuery",
      "selections": [
        {
          "alias": "adminUserGroup",
          "args": v1,
          "concreteType": "AccountsAdminUserGroup",
          "kind": "LinkedField",
          "name": "accountAdminUserGroupByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AdminUserGroupPermissionsEditorContainer_group"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupPermissionsRouteQuery",
      "selections": [
        {
          "alias": "adminUserGroup",
          "args": v1,
          "concreteType": "AccountsAdminUserGroup",
          "kind": "LinkedField",
          "name": "accountAdminUserGroupByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v6,
            v7,
            {
              "alias": "groupId",
              "args": null,
              "kind": "ScalarField",
              "name": "adminUserGroupId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAdminGroup",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isDefault",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PermissionSet",
              "kind": "LinkedField",
              "name": "permissionSet",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ResourcePermissions",
                  "kind": "LinkedField",
                  "name": "permissions",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "actions",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resource",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Authorizable",
              "kind": "LinkedField",
              "name": "authorizableSets",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuthorizableResource",
                  "kind": "LinkedField",
                  "name": "resource",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuthorizableCategory",
                  "kind": "LinkedField",
                  "name": "category",
                  "plural": false,
                  "selections": [
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "label",
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuthorizableAction",
                  "kind": "LinkedField",
                  "name": "actions",
                  "plural": true,
                  "selections": v8,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "019da22a6302f7f9e283c61189515e1e",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupPermissionsRouteQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupPermissionsRouteQuery(\n  $adminUserGroupCode: Long!\n) {\n  adminUserGroup: accountAdminUserGroupByCode(code: $adminUserGroupCode) {\n    id\n    code\n    adminUserGroupId\n    ...AdminUserGroupPermissionsEditorContainer_group\n  }\n}\n\nfragment AdminUserGroupPermissionsEditorContainer_group on AccountsAdminUserGroup {\n  id\n  name\n  description\n  groupId: adminUserGroupId\n  isAdminGroup\n  isDefault\n  permissionSet {\n    permissions {\n      actions\n      resource\n    }\n  }\n  authorizableSets {\n    resource {\n      name\n      description\n    }\n    category {\n      name\n      label\n      description\n    }\n    actions {\n      name\n      description\n    }\n  }\n}\n"
    }
  };
}();
node35.hash = "912f3ca9e3f89390e61c97e288fe8471";
var AdminUserGroupPermissionsRouteQuery_graphql_default = node35;

// src/secure/accounts/administrators/components/AdminUserGroupPermissions.tsx
import { Suspense as Suspense31 } from "react";
import { loadQuery as loadQuery20 } from "react-relay";
import { Link as Link13 } from "react-router-dom";
import { useRouteData as useRouteData14 } from "shared-lib";
import { EdSkeleton as EdSkeleton21 } from "shared-ui";

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupPermissionsEditorContainer_group.graphql.ts
var node36 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v2 = [
    v0,
    v1
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminUserGroupPermissionsEditorContainer_group",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      v0,
      v1,
      {
        "alias": "groupId",
        "args": null,
        "kind": "ScalarField",
        "name": "adminUserGroupId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAdminGroup",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDefault",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PermissionSet",
        "kind": "LinkedField",
        "name": "permissionSet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResourcePermissions",
            "kind": "LinkedField",
            "name": "permissions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "actions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resource",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Authorizable",
        "kind": "LinkedField",
        "name": "authorizableSets",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthorizableResource",
            "kind": "LinkedField",
            "name": "resource",
            "plural": false,
            "selections": v2,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthorizableCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              v1
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthorizableAction",
            "kind": "LinkedField",
            "name": "actions",
            "plural": true,
            "selections": v2,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "AccountsAdminUserGroup",
    "abstractKey": null
  };
}();
node36.hash = "a5089cf9f3a964c7d611968ddcdb53e0";
var AdminUserGroupPermissionsEditorContainer_group_graphql_default = node36;

// src/secure/accounts/administrators/components/AdminUserGroupPermissionsEditorContainer.tsx
import { Suspense as Suspense30, useCallback as useCallback19, useMemo as useMemo3, useState as useState7 } from "react";
import { useFragment } from "react-relay";
import {
  createAuthorizableGroups,
  createAuthorizables,
  createPermissionKeyableSet
} from "app-core";
import { classNames, EdSkeleton as EdSkeleton20 } from "shared-ui";

// src/secure/accounts/administrators/components/AdminUserGroupPermissionsEditor.tsx
import { Suspense as Suspense29, useCallback as useCallback18 } from "react";
import { createClientMutationId as createClientMutationId5 } from "shared-lib";
import { EdSkeleton as EdSkeleton19 } from "shared-ui";
import { AuthorizableGroupEditor } from "app-core";
import { jsx as jsx39 } from "react/jsx-runtime";
var AdminUserGroupPermissionsEditor = ({
  groups,
  selectedCategoryLabel
}) => {
  const [updateGroup, isUpdatingGroup] = useAdminUserGroupUpdatePermissions();
  const onUpdateGroup = useCallback18(
    async (group) => {
      if (!group) {
        return;
      }
      const allPermissions = groups.filter((g) => g.id !== group.id).flatMap((g) => g.permissions).map((p) => ({
        resource: p.resource,
        actions: p.actions.filter((as) => as.checked).map((as) => as.name)
      }));
      const groupPermissions = group.permissions.map((p) => ({
        resource: p.resource,
        actions: p.actions.filter((as) => as.checked).map((as) => as.name)
      }));
      const input = {
        clientMutationId: createClientMutationId5(),
        permissions: [...allPermissions, ...groupPermissions],
        groupId: group.groupId
      };
      await updateGroup({ input });
    },
    [updateGroup]
  );
  let activeGroups = [];
  if (selectedCategoryLabel && groups) {
    activeGroups = groups.filter((g) => g.category === selectedCategoryLabel);
  }
  const groupList = activeGroups.map((g) => {
    return /* @__PURE__ */ jsx39(
      AuthorizableGroupEditor,
      {
        group: g,
        isBusy: isUpdatingGroup,
        onUpdate: onUpdateGroup
      },
      g.id
    );
  });
  return /* @__PURE__ */ jsx39(Suspense29, { fallback: /* @__PURE__ */ jsx39(EdSkeleton19, {}), children: groupList });
};

// src/secure/accounts/administrators/components/AdminUserGroupPermissionsEditorContainer.tsx
import { jsx as jsx40, jsxs as jsxs22 } from "react/jsx-runtime";
var fragmentDef3 = AdminUserGroupPermissionsEditorContainer_group_graphql_default;
var AdminUserGroupPermissionsEditorContainer = ({
  fragmentRef
}) => {
  const adminUserGroup = useFragment(fragmentDef3, fragmentRef);
  const [selectedCategoryLabel, setSelectedCategoryLabel] = useState7();
  const onSelect = useCallback19(
    (groupCategory) => {
      setSelectedCategoryLabel(groupCategory);
    },
    [setSelectedCategoryLabel]
  );
  const authorizableSets = useMemo3(() => {
    if (adminUserGroup === null) {
      return [];
    }
    return createAuthorizables(adminUserGroup?.authorizableSets || []);
  }, [adminUserGroup]);
  const groups = useMemo3(() => {
    if (adminUserGroup === null) {
      return [];
    }
    const permissionsList = adminUserGroup.permissionSet.permissions.filter(
      (p) => p.actions.length > 0
    );
    const permissions = createPermissionKeyableSet(permissionsList);
    const groups2 = createAuthorizableGroups(
      adminUserGroup,
      permissions,
      authorizableSets
    );
    return groups2;
  }, [adminUserGroup]);
  const categoryLabels = groups.map((g) => {
    const isSelected = selectedCategoryLabel && g.category === selectedCategoryLabel;
    return /* @__PURE__ */ jsx40(
      "div",
      {
        className: classNames(
          "cursor-pointer border-b p-3 hover:bg-gray-100",
          isSelected ? "font-bold" : ""
        ),
        onClick: () => onSelect(g.category),
        children: g.category
      },
      g.id
    );
  });
  return /* @__PURE__ */ jsx40(Suspense30, { fallback: /* @__PURE__ */ jsx40(EdSkeleton20, {}), children: /* @__PURE__ */ jsxs22("div", { className: "mx-4 flex items-start gap-2 border bg-white px-4", children: [
    /* @__PURE__ */ jsxs22("div", { className: "sticky top-0 flex w-1/5 flex-col", children: [
      /* @__PURE__ */ jsx40("div", { className: "text-primary-500 p-3 font-medium", children: "Categories" }),
      categoryLabels
    ] }),
    /* @__PURE__ */ jsxs22("div", { className: "flex-1", children: [
      /* @__PURE__ */ jsx40("div", { className: "text-primary-500 p-3 font-medium", children: "Groups" }),
      selectedCategoryLabel && /* @__PURE__ */ jsx40(
        AdminUserGroupPermissionsEditor,
        {
          groups,
          selectedCategoryLabel
        }
      )
    ] })
  ] }) });
};

// src/secure/accounts/administrators/components/AdminUserGroupPermissions.tsx
import { Fragment as Fragment18, jsx as jsx41 } from "react/jsx-runtime";
var queryDef19 = AdminUserGroupPermissionsRouteQuery_graphql_default;
async function loader20(environment, params) {
  const code = params.adminUserGroupCode;
  const adminUserGroupCode = parseInt(code);
  return loadQuery20(environment, queryDef19, {
    adminUserGroupCode
  });
}
var AdminUserGroupPermissions = ({ routeId: routeId6, inList }) => {
  const data = useRouteData14(
    queryDef19,
    routeId6
  );
  if (!data) {
    return /* @__PURE__ */ jsx41(Fragment18, { children: "Loading..." });
  }
  const { adminUserGroup } = data;
  if (!adminUserGroup) {
    return /* @__PURE__ */ jsx41(Fragment18, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx41(Suspense31, { fallback: /* @__PURE__ */ jsx41(EdSkeleton21, {}), children: /* @__PURE__ */ jsx41("div", { className: "my-2 flex flex-col gap-2", children: /* @__PURE__ */ jsx41(
    AdminUserGroupPermissionsEditorContainer,
    {
      fragmentRef: adminUserGroup
    }
  ) }) });
};
var createRoute10 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-admin-user-group-permissions`;
  return {
    id: routeId6,
    path: "permissions",
    element: /* @__PURE__ */ jsx41(AdminUserGroupPermissions, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx41(Link13, { to: "permissions", children: "Permissions" })
    },
    loader: ({ params }) => {
      return loader20(environment, params);
    }
  };
};

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupUsersRouteQuery.graphql.ts
var node37 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserGroupCode"
    }
  ], v1 = [
    {
      "alias": "adminUserGroup",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "adminUserGroupCode"
        }
      ],
      "concreteType": "AccountsAdminUserGroup",
      "kind": "LinkedField",
      "name": "accountAdminUserGroupByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "adminUserGroupId",
          "storageKey": null
        },
        {
          "alias": "groupId",
          "args": null,
          "kind": "ScalarField",
          "name": "adminUserGroupId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAdminGroup",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDefault",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupUsersRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupUsersRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "ad30710486b70d6abb2abd0b87e8975d",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupUsersRouteQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupUsersRouteQuery(\n  $adminUserGroupCode: Long!\n) {\n  adminUserGroup: accountAdminUserGroupByCode(code: $adminUserGroupCode) {\n    id\n    code\n    adminUserGroupId\n    groupId: adminUserGroupId\n    createdAt\n    updatedAt\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node37.hash = "e363024d3a9d11367025ed4c1ca3a669";
var AdminUserGroupUsersRouteQuery_graphql_default = node37;

// src/secure/accounts/administrators/components/AdminUserGroupUsers.tsx
import { Suspense as Suspense35 } from "react";
import { loadQuery as loadQuery22 } from "react-relay";
import { Link as Link15 } from "react-router-dom";
import { useRouteData as useRouteData16 } from "shared-lib";
import { EdSkeleton as EdSkeleton23 } from "shared-ui";
import { OutletRoute as OutletRoute8 } from "app-core";

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupUsersContainerQuery.graphql.ts
var node38 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userGroupId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "userGroupId",
    "variableName": "userGroupId"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    v1,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupUsersContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "AdminUserGroupUsersList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupUsersContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v2,
          "concreteType": "AccountAdminUsersByUserGroupConnection",
          "kind": "LinkedField",
          "name": "accountAdminUsersByUserGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUsersByUserGroupEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v2,
          "filters": [],
          "handle": "connection",
          "key": "AdminUsersList_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUsersByUserGroup"
        }
      ]
    },
    "params": {
      "cacheID": "ea284cf20f61e1610ccfda4b2d806b09",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupUsersContainerQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupUsersContainerQuery(\n  $userGroupId: UUID!\n  $where: AccountsAdminUserFilter!\n) {\n  ...AdminUserGroupUsersList_list_2BWF27\n}\n\nfragment AdminUserGroupUsersList_list_2BWF27 on Query {\n  list: accountAdminUsersByUserGroup(userGroupId: $userGroupId, first: 10, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        updatedAt\n        createdAt\n        firstName\n        lastName\n        emailAddress\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node38.hash = "a7ffde28d8e8e8dfc8c4f3ebba6d51dd";
var AdminUserGroupUsersContainerQuery_graphql_default = node38;

// src/secure/accounts/administrators/components/AdminUserGroupUsersContainer.tsx
import { Suspense as Suspense33, useState as useState8 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery3 } from "react-relay";
import { Input as Input3 } from "shared-ui";
import { useDebounce as useDebounce3 } from "shared-lib";

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupUsersListPaginationQuery.graphql.ts
var node39 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userGroupId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "userGroupId",
    "variableName": "userGroupId"
  }, v4 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    v3,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupUsersListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "AdminUserGroupUsersList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupUsersListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "AccountAdminUsersByUserGroupConnection",
          "kind": "LinkedField",
          "name": "accountAdminUsersByUserGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUsersByUserGroupEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "AdminUsersList_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUsersByUserGroup"
        }
      ]
    },
    "params": {
      "cacheID": "5828fc984883ad99e84622766ae52dad",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupUsersListPaginationQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupUsersListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $userGroupId: UUID!\n  $where: AccountsAdminUserFilter\n) {\n  ...AdminUserGroupUsersList_list_2Lqwyl\n}\n\nfragment AdminUserGroupUsersList_list_2Lqwyl on Query {\n  list: accountAdminUsersByUserGroup(userGroupId: $userGroupId, first: $first, after: $after, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        updatedAt\n        createdAt\n        firstName\n        lastName\n        emailAddress\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node39.hash = "74953e8dd47aa20fdad5147194d03ed7";
var AdminUserGroupUsersListPaginationQuery_graphql_default = node39;

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupUsersList_list.graphql.ts
var node40 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userGroupId"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": AdminUserGroupUsersListPaginationQuery_graphql_default
      }
    },
    "name": "AdminUserGroupUsersList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "AccountAdminUsersByUserGroupConnection",
        "kind": "LinkedField",
        "name": "__AdminUsersList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountAdminUsersByUserGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsAdminUser",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node40.hash = "74953e8dd47aa20fdad5147194d03ed7";
var AdminUserGroupUsersList_list_graphql_default = node40;

// src/secure/accounts/administrators/components/AdminUserGroupUsersList.tsx
import { Suspense as Suspense32, useCallback as useCallback20 } from "react";
import { usePaginationFragment as usePaginationFragment3 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow3, parseISO as parseISO3 } from "date-fns";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader3,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement3,
  ListLayout as ListLayout3
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined3 } from "shared-lib";
import { jsx as jsx42, jsxs as jsxs23 } from "react/jsx-runtime";
var fragmentDef4 = AdminUserGroupUsersList_list_graphql_default;
function createLinkTo3(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var AdminUserGroupUsersList = ({ fragmentRef }) => {
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment3(fragmentDef4, fragmentRef);
  const onLoadNext = useCallback20(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined3).map((e) => e.node).map((ft) => {
    const name = `${ft.firstName} ${ft.lastName}`;
    return {
      key: ft.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx42("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs23("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsxs23("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx42("div", { className: "text-md font-medium uppercase", children: ft.firstName }),
          /* @__PURE__ */ jsx42("div", { className: "text-md font-medium uppercase", children: ft.lastName })
        ] }),
        /* @__PURE__ */ jsx42("div", { className: "text-md text-blue-500", children: ft.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs23("div", { className: "pt-2 text-sm", children: [
        "Updated ",
        formatDistanceToNow3(parseISO3(ft.updatedAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: ft.code
      },
      element: /* @__PURE__ */ jsx42(Suspense32, { fallback: "Loading...", children: /* @__PURE__ */ jsx42(DefaultListLayoutSectionElement3, { children: /* @__PURE__ */ jsx42("div", { className: "grid", children: /* @__PURE__ */ jsx42("div", { children: ft.code }) }) }) })
    };
  });
  return /* @__PURE__ */ jsx42(
    ListLayout3,
    {
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx42(
        DefaultListLayoutItemHeader3,
        {
          title: "Admin Users",
          to: createLinkTo3,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false
    }
  );
};

// src/secure/accounts/administrators/components/AdminUserGroupUsersContainer.tsx
import { jsx as jsx43, jsxs as jsxs24 } from "react/jsx-runtime";
var queryDef20 = AdminUserGroupUsersContainerQuery_graphql_default;
var AdminUserGroupUsersContainer = ({ userGroupId }) => {
  const [filter, setFilter] = useState8(null);
  const searchTerm = useDebounce3(filter, 500);
  let where2 = {};
  if (searchTerm) {
    where2 = {
      or: [
        { firstName: { startsWith: filter } },
        { lastName: { startsWith: filter } },
        { emailAddress: { startsWith: filter } }
      ]
    };
  }
  const query = useLazyLoadQuery3(
    queryDef20,
    { userGroupId, where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs24("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx43("div", { className: "flex items-center justify-between space-x-4 border-b bg-white", children: /* @__PURE__ */ jsxs24("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx43("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx43("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx43(
        Input3,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx43("div", { className: "flex-1", children: /* @__PURE__ */ jsx43(Suspense33, { fallback: "Loading...", children: /* @__PURE__ */ jsx43(AdminUserGroupUsersList, { fragmentRef: query }) }) })
  ] });
};

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupUserDetailsRouteQuery.graphql.ts
var node41 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = [
    {
      "alias": "adminUser",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "adminUserCode"
        }
      ],
      "concreteType": "AccountsAdminUser",
      "kind": "LinkedField",
      "name": "accountAdminUserByCode",
      "plural": false,
      "selections": [
        v1,
        v2,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountsAdminUserGroup",
          "kind": "LinkedField",
          "name": "userGroups",
          "plural": true,
          "selections": [
            v1,
            v2,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupUserDetailsRouteQuery",
      "selections": v3,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupUserDetailsRouteQuery",
      "selections": v3
    },
    "params": {
      "cacheID": "7d8d3c8d9a07fa515249e088820de7d8",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupUserDetailsRouteQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupUserDetailsRouteQuery(\n  $adminUserCode: Long!\n) {\n  adminUser: accountAdminUserByCode(code: $adminUserCode) {\n    id\n    code\n    accountId\n    createdAt\n    updatedAt\n    firstName\n    lastName\n    emailAddress\n    userGroups {\n      id\n      code\n      name\n    }\n  }\n}\n"
    }
  };
}();
node41.hash = "432c0a8049fe68247bcabe6a78471888";
var AdminUserGroupUserDetailsRouteQuery_graphql_default = node41;

// src/secure/accounts/administrators/components/AdminUserGroupUserDetails.tsx
import { Suspense as Suspense34, useCallback as useCallback21 } from "react";
import { ConnectionHandler as ConnectionHandler2, loadQuery as loadQuery21 } from "react-relay";
import { Link as Link14, useNavigate as useNavigate12 } from "react-router-dom";
import { createClientMutationId as createClientMutationId6, timeAgo as timeAgo7, useRouteData as useRouteData15 } from "shared-lib";
import { Button as Button7, EdSkeleton as EdSkeleton22 } from "shared-ui";
import { Fragment as Fragment19, jsx as jsx44, jsxs as jsxs25 } from "react/jsx-runtime";
var queryDef21 = AdminUserGroupUserDetailsRouteQuery_graphql_default;
async function loader21(environment, params) {
  const code = params.adminUserCode;
  const adminUserCode = parseInt(code);
  return loadQuery21(environment, queryDef21, {
    adminUserCode
  });
}
var AdminUserGroupUserDetails = ({
  routeId: routeId6,
  groupRouteId
}) => {
  const navigate = useNavigate12();
  const groupData = useAdminUserGroupUsersRouteData(groupRouteId);
  const userData = useRouteData15(
    queryDef21,
    routeId6
  );
  const connectionId = ConnectionHandler2.getConnectionID(
    "root",
    "AdminUsersList_list"
  );
  const onRemoved = useCallback21(() => {
    navigate("../../");
  }, [navigate]);
  const [remove, isRemoving] = useAdminUserLeaveGroup();
  const onRemoveUser = useCallback21(async () => {
    if (!groupData.adminUserGroup || !userData.adminUser) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId6(),
      groupId: groupData.adminUserGroup?.adminUserGroupId,
      userId: userData.adminUser.accountId
    };
    const result = await remove({ connections: [connectionId], input });
    if (result.data.adminUser) {
      onRemoved();
    }
  }, [remove]);
  if (!userData) {
    return /* @__PURE__ */ jsx44(Fragment19, { children: "Loading..." });
  }
  const { adminUser } = userData;
  if (!adminUser) {
    return /* @__PURE__ */ jsx44(Fragment19, { children: "Loading..." });
  }
  const groupsList = adminUser.userGroups.map((g) => {
    return /* @__PURE__ */ jsx44("div", { className: "flex", children: /* @__PURE__ */ jsx44("div", { className: "bg-primary-500 w-1/3 cursor-pointer rounded-lg border p-2 text-white", children: /* @__PURE__ */ jsx44("div", { children: g.name }) }) }, g.code);
  });
  return /* @__PURE__ */ jsx44(Suspense34, { fallback: /* @__PURE__ */ jsx44(EdSkeleton22, {}), children: /* @__PURE__ */ jsxs25("div", { className: "flex flex-1 flex-col gap-2 border-b bg-white p-4", children: [
    /* @__PURE__ */ jsxs25("div", { className: "my-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsxs25("div", { className: "text-primary-500 flex items-center gap-2 border-b pb-2 font-medium uppercase", children: [
        /* @__PURE__ */ jsx44("div", { children: adminUser.firstName }),
        /* @__PURE__ */ jsx44("div", { children: adminUser.lastName })
      ] }),
      /* @__PURE__ */ jsx44("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsxs25("div", { className: "text-sm text-gray-500", children: [
        "Updated ",
        timeAgo7(adminUser.updatedAt)
      ] }) })
    ] }),
    /* @__PURE__ */ jsx44("div", { className: "my-4 flex flex-col gap-2 border-b border-t py-4", children: /* @__PURE__ */ jsx44("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx44("div", { children: /* @__PURE__ */ jsx44(
      Button7,
      {
        color: "primary",
        clicked: onRemoveUser,
        confirmMessage: "Remove, are you sure ? ",
        children: "Remove"
      }
    ) }) }) }),
    /* @__PURE__ */ jsxs25("div", { className: "my-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx44("div", { className: "text-primary-500 flex items-center gap-2 font-medium uppercase", children: "Groups" }),
      /* @__PURE__ */ jsx44("div", { className: "flex flex-col gap-2 py-4", children: groupsList })
    ] })
  ] }) });
};
var createRoute11 = (routePrefix, environment, context, groupRouteId) => {
  const routeId6 = `${routePrefix}-admin-user-details`;
  return {
    id: routeId6,
    path: "*",
    element: /* @__PURE__ */ jsx44(
      AdminUserGroupUserDetails,
      {
        routeId: routeId6,
        groupRouteId
      }
    ),
    handle: {
      crumb: () => /* @__PURE__ */ jsx44(Link14, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader21(environment, params);
    }
  };
};

// src/secure/accounts/administrators/components/AdminUserGroupUsers.tsx
import { Fragment as Fragment20, jsx as jsx45 } from "react/jsx-runtime";
var queryDef22 = AdminUserGroupUsersRouteQuery_graphql_default;
async function loader22(environment, params) {
  const code = params.adminUserGroupCode;
  const adminUserGroupCode = parseInt(code);
  return loadQuery22(environment, queryDef22, {
    adminUserGroupCode
  });
}
var useAdminUserGroupUsersRouteData = (routeId6) => {
  const data = useRouteData16(queryDef22, routeId6);
  return data;
};
var AdminUserGroupUsers = ({ routeId: routeId6, inList }) => {
  const data = useAdminUserGroupUsersRouteData(routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx45(Fragment20, { children: "Loading..." });
  }
  const { adminUserGroup } = data;
  if (!adminUserGroup) {
    return /* @__PURE__ */ jsx45(Fragment20, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx45(Suspense35, { fallback: /* @__PURE__ */ jsx45(EdSkeleton23, {}), children: /* @__PURE__ */ jsx45(
    AdminUserGroupUsersContainer,
    {
      userGroupId: adminUserGroup.adminUserGroupId
    }
  ) });
};
var createRoute12 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-admin-user-group-users`;
  return {
    id: routeId6,
    path: "users",
    element: /* @__PURE__ */ jsx45(AdminUserGroupUsers, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx45(Link15, { to: "users", children: "Users" })
    },
    loader: ({ params }) => {
      return loader22(environment, params);
    },
    children: [
      {
        id: `${routeId6}-admin-user`,
        path: ":adminUserCode/*",
        element: /* @__PURE__ */ jsx45(OutletRoute8, {}),
        children: [
          createRoute11(`${routeId6}-admin-user`, environment, context, routeId6)
        ]
      }
    ]
  };
};

// src/secure/accounts/administrators/components/AdminUserGroupRoute.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
var createAdminUserGroupRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId6 = `${routePrefix}-${routeId4}`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx46(AdminUserGroupLayout, { inList, showHeader }),
      errorElement: /* @__PURE__ */ jsx46(ErrorContainer5, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx46(AdminUserGroupLink2, { routeId: routeId6 })
      },
      loader: ({ params }) => {
        return loader18(environment, params);
      },
      children: [
        createRoute9(routePrefix, environment, context, inList),
        createRoute10(routePrefix, environment, context, inList),
        createRoute12(routePrefix, environment, context, inList),
        {
          path: "*",
          element: /* @__PURE__ */ jsx46(Navigate11, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/administrators/components/AdminRoute.tsx
import { jsx as jsx47, jsxs as jsxs26 } from "react/jsx-runtime";
var AdminLayout = () => {
  const location = useLocation5();
  const tabs4 = [
    createLinkState5(location, "Users", `users`, UsersIcon),
    createLinkState5(location, "Groups", `groups`, UserGroupIcon)
  ];
  return /* @__PURE__ */ jsx47(Suspense36, { fallback: "Loading Admin...", children: /* @__PURE__ */ jsx47(ErrorBoundary5, { FallbackComponent: ErrorBoundaryFallback5, children: /* @__PURE__ */ jsxs26("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs26("div", { className: "flex items-center justify-between border-b bg-white px-4", children: [
      /* @__PURE__ */ jsxs26("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsx47(EdLink2, { href: "../../", name: "List Admin Users", children: /* @__PURE__ */ jsx47(Button8, { color: "primary", children: "Back" }) }),
        /* @__PURE__ */ jsx47(TabPills, { tabs: tabs4 })
      ] }),
      /* @__PURE__ */ jsxs26("div", { className: "flex items-center gap-2 p-4", children: [
        /* @__PURE__ */ jsx47(PageHeading, { children: "Myn User Admin" }),
        /* @__PURE__ */ jsx47(EdLink2, { href: "create", name: "Create Admin Users", children: /* @__PURE__ */ jsx47(Button8, { color: "primary", children: "Create Admin User" }) })
      ] })
    ] }),
    /* @__PURE__ */ jsx47("div", { children: /* @__PURE__ */ jsx47(Outlet8, {}) })
  ] }) }) });
};
var AdminUsersListRoute = () => {
  return /* @__PURE__ */ jsx47(Suspense36, { fallback: "Loading Admin Users...", children: /* @__PURE__ */ jsx47(ErrorBoundary5, { FallbackComponent: ErrorBoundaryFallback5, children: /* @__PURE__ */ jsx47(AdminUserListContainer, {}) }) });
};
var AdminUserGroupsListRoute = () => {
  return /* @__PURE__ */ jsx47(Suspense36, { fallback: "Loading Admin User Groups...", children: /* @__PURE__ */ jsx47(ErrorBoundary5, { FallbackComponent: ErrorBoundaryFallback5, children: /* @__PURE__ */ jsx47(AdminUserGroupListContainer, {}) }) });
};
var createAdminRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-admin-users`;
  const listRouteId = `${routeId6}-list`;
  const groupListRouteId = `${routeId6}-groups-list`;
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx47(AdminLayout, {}),
      children: [
        {
          id: listRouteId,
          path: "users/*",
          element: /* @__PURE__ */ jsx47(AdminUsersListRoute, {}),
          children: [
            {
              id: `${listRouteId}-admin-users`,
              path: ":adminUserCode/*",
              element: /* @__PURE__ */ jsx47(OutletRoute9, {}),
              children: createAdminUserRoutes(
                `${listRouteId}-admin-user`,
                environment,
                context,
                true,
                true
              )
            }
          ]
        },
        {
          id: groupListRouteId,
          path: "groups/*",
          element: /* @__PURE__ */ jsx47(AdminUserGroupsListRoute, {}),
          children: [
            {
              id: `${groupListRouteId}-admin-user-groups`,
              path: ":adminUserGroupCode/*",
              element: /* @__PURE__ */ jsx47(OutletRoute9, {}),
              children: createAdminUserGroupRoutes(
                `${groupListRouteId}-list-admin-user-group`,
                environment,
                context,
                true,
                true
              )
            }
          ]
        },
        {
          id: `${routePrefix}-admin-user-group`,
          path: "group/:adminUserGroupCode/*",
          element: /* @__PURE__ */ jsx47(OutletRoute9, {}),
          children: createAdminUserGroupRoutes(
            `${groupListRouteId}-admin-user-group`,
            environment,
            context,
            true,
            false
          )
        },
        {
          id: `${routeId6}-admin-user`,
          path: ":adminUserCode/*",
          element: /* @__PURE__ */ jsx47(OutletRoute9, {}),
          children: createAdminUserRoutes(
            `${routePrefix}-admin-user`,
            environment,
            context,
            false,
            false
          )
        },
        {
          id: `${routeId6}-create`,
          path: "create/*",
          element: /* @__PURE__ */ jsx47(AdminUserCreate, {})
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx47(Navigate12, { to: "users", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/employers/components/EmployersRoute.tsx
import { Suspense as Suspense46 } from "react";
import { Navigate as Navigate16, Outlet as Outlet11 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary6 } from "react-error-boundary";
import { PlusIcon } from "@heroicons/react/24/solid";
import { Button as Button14, EdLink as EdLink3, PageHeading as PageHeading2 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback6, OutletRoute as OutletRoute12 } from "app-core";
import { EmployersListContainer } from "feature-employer-accounts";

// src/secure/accounts/employers/components/EmployerRoute.tsx
import { Navigate as Navigate15 } from "react-router-dom";
import { ErrorContainer as ErrorContainer8 } from "shared-ui";
import { OutletRoute as OutletRoute11 } from "app-core";
import { createEmployerUserGroupsRoutes } from "feature-employer-accounts";

// src/secure/accounts/employers/components/__generated__/EmployerLayoutQuery.graphql.ts
var node42 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = [
    {
      "alias": "employer",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "employerCode"
        }
      ],
      "concreteType": "Employer",
      "kind": "LinkedField",
      "name": "accountsEmployerByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canonicalCompanyName",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "0c2b8c722a4200c113b6a1d87d5747a2",
      "id": null,
      "metadata": {},
      "name": "EmployerLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerLayoutQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    employerId\n    createdAt\n    updatedAt\n    code\n    name\n    canonicalCompanyName\n  }\n}\n"
    }
  };
}();
node42.hash = "a349afbfc78a01130df5b5f42a519814";
var EmployerLayoutQuery_graphql_default = node42;

// src/secure/accounts/employers/components/EmployerLayout.tsx
import { Suspense as Suspense37, useMemo as useMemo4 } from "react";
import {
  Link as Link16,
  Outlet as Outlet9,
  useLoaderData as useLoaderData7,
  useLocation as useLocation6,
  useRouteLoaderData as useRouteLoaderData5
} from "react-router-dom";
import {
  loadQuery as loadQuery23,
  usePreloadedQuery as usePreloadedQuery7
} from "react-relay";
import { ArrowsPointingOutIcon as ArrowsPointingOutIcon3 } from "@heroicons/react/24/outline";
import {
  createLinkState as createLinkState6,
  EdButtonLink as EdButtonLink3,
  IconJustify as IconJustify3,
  TabUnderline as TabUnderline4
} from "shared-ui";
import { Fragment as Fragment21, jsx as jsx48, jsxs as jsxs27 } from "react/jsx-runtime";
var routeId5 = "employer-layout";
var queryDef23 = EmployerLayoutQuery_graphql_default;
var EmployerLayout = ({ showHeader, inList }) => {
  const location = useLocation6();
  const preloadedQuery = useLoaderData7();
  const data = usePreloadedQuery7(queryDef23, preloadedQuery);
  const tabs4 = useMemo4(() => {
    return [
      createLinkState6(location, "Details", `details`),
      createLinkState6(location, "Users", `users`),
      createLinkState6(location, "User Groups", `user-groups/list`),
      createLinkState6(location, "Email", `email-config`),
      createLinkState6(location, "Job Publishing", `job-publishing`)
    ];
  }, [location]);
  const { employer } = data;
  if (employer === null || employer === void 0) {
    return /* @__PURE__ */ jsx48("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx48(Suspense37, { fallback: "Loading...", children: /* @__PURE__ */ jsxs27("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsx48("div", { children: /* @__PURE__ */ jsx48("div", { className: "flex flex-wrap items-center justify-between border-b py-4", children: /* @__PURE__ */ jsx48("div", { className: "text-primary-500 px-2 font-medium uppercase sm:px-8", children: employer.name }) }) }),
    /* @__PURE__ */ jsxs27("div", { className: "flex flex-wrap items-center justify-between border-b bg-white py-3", children: [
      /* @__PURE__ */ jsx48("div", { className: "px-4", children: /* @__PURE__ */ jsx48(TabUnderline4, { tabs: tabs4 }) }),
      inList && /* @__PURE__ */ jsx48("div", { children: /* @__PURE__ */ jsx48(
        EdButtonLink3,
        {
          to: `../../../../${employer.code}`,
          name: "View",
          icon: ArrowsPointingOutIcon3,
          iconJustify: IconJustify3.Right
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx48(Outlet9, {})
  ] }) });
};
var EmployerLink = ({ routeId: routeId6, label }) => {
  const data = useEmployerLayoutRouteData(routeId6);
  if (!data.employer) {
    return /* @__PURE__ */ jsx48(Fragment21, {});
  }
  const name = `${data.employer.name}`;
  return /* @__PURE__ */ jsx48(Suspense37, { fallback: "Loading...", children: /* @__PURE__ */ jsx48(Link16, { to: ".", children: label || name }) });
};
async function loader23(environment, params) {
  const code = params.employerCode;
  const employerCode = parseInt(code);
  return loadQuery23(environment, queryDef23, {
    employerCode
  });
}
function useEmployerLayoutRouteData(routeId6) {
  const queryRef = useRouteLoaderData5(
    routeId6
  );
  const data = usePreloadedQuery7(queryDef23, queryRef);
  return data;
}

// src/secure/accounts/employers/components/__generated__/EmployerDetailsRouteQuery.graphql.ts
var node43 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "employerCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canonicalCompanyName",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerDetailsRouteQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerEditor_employer"
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerDetailsRouteQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isApproved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isActive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isDeleted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canViewTelephoneNumbers",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canonicalCompanyId",
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f2fd248921880711fd2ee0f030c1a680",
      "id": null,
      "metadata": {},
      "name": "EmployerDetailsRouteQuery",
      "operationKind": "query",
      "text": "query EmployerDetailsRouteQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    employerId\n    createdAt\n    updatedAt\n    code\n    name\n    canonicalCompanyName\n    ...EmployerEditor_employer\n  }\n}\n\nfragment EmployerEditor_employer on Employer {\n  id\n  code\n  employerId\n  updatedAt\n  isApproved\n  isActive\n  isDeleted\n  canViewTelephoneNumbers\n  isTest\n  canonicalCompanyId\n  canonicalCompanyName\n}\n"
    }
  };
}();
node43.hash = "e938481d84625dc2151df62d72d99f2b";
var EmployerDetailsRouteQuery_graphql_default = node43;

// src/secure/accounts/employers/components/EmployerDetails.tsx
import { Suspense as Suspense39 } from "react";
import { loadQuery as loadQuery24 } from "react-relay";
import { Link as Link17 } from "react-router-dom";
import { useForm as useForm2 } from "react-hook-form";
import { zodResolver as zodResolver2 } from "@hookform/resolvers/zod";
import * as z from "zod";
import {
  createClientMutationId as createClientMutationId8,
  timeAgo as timeAgo8,
  useRouteData as useRouteData17,
  useToggle as useToggle2
} from "shared-lib";
import { Button as Button10, EdSkeleton as EdSkeleton25, Error as Error2, InputField as InputField2, Spinner } from "shared-ui";
import {
  useEmployerNameUpdateMutation
} from "feature-employer-accounts";

// src/secure/accounts/employers/components/__generated__/EmployerEditor_employer.graphql.ts
var node44 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerEditor_employer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isApproved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canViewTelephoneNumbers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTest",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canonicalCompanyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canonicalCompanyName",
      "storageKey": null
    }
  ],
  "type": "Employer",
  "abstractKey": null
};
node44.hash = "6eba937130c08556ef323fde993a0f6d";
var EmployerEditor_employer_graphql_default = node44;

// src/secure/accounts/employers/components/EmployerEditor.tsx
import { Suspense as Suspense38, useCallback as useCallback22 } from "react";
import { useFragment as useFragment2 } from "react-relay";
import { createClientMutationId as createClientMutationId7 } from "shared-lib";
import { BooleanActionItem, Button as Button9, EdSkeleton as EdSkeleton24, Size as Size5 } from "shared-ui";
import {
  useEmployerActivate,
  useEmployerApprove,
  useEmployerChangeCanonicalCompany,
  useEmployerDeactivate,
  useEmployerSetIsTestAccount,
  useEmployerSetPhoneNumberVisibility
} from "feature-employer-accounts";
import {
  CompaniesSearchContainer
} from "feature-data-management";
import { jsx as jsx49, jsxs as jsxs28 } from "react/jsx-runtime";
var fragmentDef5 = EmployerEditor_employer_graphql_default;
var EmployerEditor = ({ fragmentRef }) => {
  const data = useFragment2(
    fragmentDef5,
    fragmentRef
  );
  const [activate, isActivating] = useEmployerActivate();
  const [deactivate, isDeactivating] = useEmployerDeactivate();
  const [approve, isApproving] = useEmployerApprove();
  const [setIsTestAccount, isSettingIsTestAccount] = useEmployerSetIsTestAccount();
  const [setPhoneNumberVisibility, isSettingPhoneNumberVisibility] = useEmployerSetPhoneNumberVisibility();
  const [setCanonicalCompany, isSettingCanonicalCompany] = useEmployerChangeCanonicalCompany();
  const onActivate = useCallback22(async () => {
    const input = {
      employerId: data.employerId,
      clientMutationId: createClientMutationId7()
    };
    await activate({ input });
  }, [activate]);
  const onDeactivate = useCallback22(async () => {
    const input = {
      employerId: data.employerId,
      clientMutationId: createClientMutationId7()
    };
    await deactivate({ input });
  }, [deactivate]);
  const onApprove = useCallback22(async () => {
    const input = {
      employerId: data.employerId,
      clientMutationId: createClientMutationId7()
    };
    await approve({ input });
  }, [approve]);
  const onSetIsTestAccount = useCallback22(async () => {
    const input = {
      isTestAccount: !data.isTest,
      employerId: data.employerId,
      clientMutationId: createClientMutationId7()
    };
    await setIsTestAccount({ input });
  }, [setIsTestAccount]);
  const onTogglePhoneNumberVisibility = useCallback22(async () => {
    const input = {
      employerId: data.employerId,
      clientMutationId: createClientMutationId7()
    };
    await setPhoneNumberVisibility({ input });
  }, [setPhoneNumberVisibility]);
  const onSetCompany = useCallback22(
    async (company2) => {
      const input = {
        canonicalId: company2.id,
        canonicalName: company2.name,
        clientMutationId: createClientMutationId7(),
        employerId: data.employerId
      };
      await setCanonicalCompany({ input });
    },
    [setCanonicalCompany]
  );
  if (data === null) {
    return /* @__PURE__ */ jsx49(EdSkeleton24, {});
  }
  let company = null;
  if (data.canonicalCompanyId && data.canonicalCompanyName) {
    company = {
      id: data.canonicalCompanyId,
      name: data.canonicalCompanyName,
      isVerified: true,
      //assumed/irrelevant
      industry: null
    };
  }
  return /* @__PURE__ */ jsx49(Suspense38, { fallback: /* @__PURE__ */ jsx49(EdSkeleton24, {}), children: /* @__PURE__ */ jsx49("div", { className: "flex", children: /* @__PURE__ */ jsxs28("div", { className: "flex flex-col gap-4 border p-4 sm:w-1/2", children: [
    /* @__PURE__ */ jsx49(
      BooleanActionItem,
      {
        label: "Active",
        value: data.isActive,
        action: /* @__PURE__ */ jsx49("div", { children: data.isActive ? /* @__PURE__ */ jsx49(
          Button9,
          {
            color: "warning",
            size: Size5.lg,
            clicked: onDeactivate,
            disabled: isDeactivating,
            children: "Deactivate"
          }
        ) : /* @__PURE__ */ jsx49(
          Button9,
          {
            color: "primary",
            size: Size5.lg,
            clicked: onActivate,
            disabled: isActivating,
            children: "Activate"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx49(
      BooleanActionItem,
      {
        label: "Approved",
        value: data.isApproved,
        action: /* @__PURE__ */ jsx49("div", { children: data.isApproved ? /* @__PURE__ */ jsx49("div", { children: "No Action" }) : /* @__PURE__ */ jsx49(
          Button9,
          {
            color: "primary",
            size: Size5.lg,
            clicked: onApprove,
            disabled: isApproving,
            children: "Approve"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx49(
      BooleanActionItem,
      {
        label: "Test Account",
        value: data.isTest,
        action: /* @__PURE__ */ jsx49("div", { children: data.isTest ? /* @__PURE__ */ jsx49("div", { children: "No Action" }) : /* @__PURE__ */ jsx49(
          Button9,
          {
            color: "warning",
            size: Size5.lg,
            clicked: onSetIsTestAccount,
            disabled: isSettingIsTestAccount,
            children: "Set Test Account"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx49(
      BooleanActionItem,
      {
        label: "View Telephone Numbers",
        value: data.canViewTelephoneNumbers,
        action: /* @__PURE__ */ jsx49("div", { children: /* @__PURE__ */ jsx49(
          Button9,
          {
            color: "primary",
            size: Size5.lg,
            clicked: onTogglePhoneNumberVisibility,
            disabled: isSettingPhoneNumberVisibility,
            children: "Toggle"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx49(
      BooleanActionItem,
      {
        label: "Canonical Company",
        value: !!data.canonicalCompanyName,
        action: /* @__PURE__ */ jsx49(
          CompaniesSearchContainer,
          {
            name: `companies-search`,
            onSearchCompleted: onSetCompany,
            value: company,
            disabled: isSettingCanonicalCompany
          }
        )
      }
    )
  ] }) }) });
};

// src/secure/accounts/employers/components/EmployerDetails.tsx
import { Fragment as Fragment22, jsx as jsx50, jsxs as jsxs29 } from "react/jsx-runtime";
var queryDef24 = EmployerDetailsRouteQuery_graphql_default;
async function loader24(environment, params) {
  const code = params.employerCode;
  const employerCode = parseInt(code);
  try {
    return loadQuery24(environment, queryDef24, {
      employerCode
    });
  } catch (e) {
    console.error("EmployerDetails Loader Failed.");
    console.error(e);
    throw e;
  }
}
var formSchema2 = z.object({
  name: z.string().min(3, "Name is required"),
  employerId: z.string().min(1, "employerId is required")
});
var EmployerDetails = ({ routeId: routeId6, inList }) => {
  const data = useRouteData17(queryDef24, routeId6);
  const [updateName, isUpdatingName] = useEmployerNameUpdateMutation();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm2({
    resolver: zodResolver2(formSchema2),
    defaultValues: {
      name: data?.employer?.name || "",
      employerId: data?.employer?.employerId || ""
    }
  });
  const onSave = handleSubmit(async (form) => {
    const updateNameInput = {
      name: form.name,
      clientMutationId: createClientMutationId8(),
      employerId: form.employerId
    };
    await updateName({
      input: updateNameInput
    });
    toggleEditing();
  });
  const [isEditing, toggleEditing] = useToggle2();
  if (!data) {
    return /* @__PURE__ */ jsx50(Fragment22, { children: "Loading..." });
  }
  const { employer } = data;
  if (!employer) {
    return /* @__PURE__ */ jsx50(Fragment22, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx50(Suspense39, { fallback: /* @__PURE__ */ jsx50(EdSkeleton25, {}), children: /* @__PURE__ */ jsxs29("div", { className: "flex flex-col gap-2 border-b bg-white p-4", children: [
    /* @__PURE__ */ jsxs29("div", { className: "my-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsxs29("div", { className: "flex items-baseline gap-2 px-4", children: [
        /* @__PURE__ */ jsx50("div", { children: isEditing ? /* @__PURE__ */ jsxs29("div", { children: [
          /* @__PURE__ */ jsx50(
            InputField2,
            {
              defaultValue: employer.name,
              name: "name",
              register,
              required: false
            }
          ),
          /* @__PURE__ */ jsx50(Error2, { children: errors.name?.message })
        ] }) : /* @__PURE__ */ jsx50("div", { className: "text-primary-500  text-lg font-medium", children: employer.name }) }),
        /* @__PURE__ */ jsx50(Button10, { onClick: toggleEditing, color: "primary", children: isEditing ? "Cancel" : "Edit" }),
        isEditing && /* @__PURE__ */ jsx50(Button10, { onClick: onSave, color: "green", children: "Save" }),
        isUpdatingName && /* @__PURE__ */ jsx50(Spinner, {})
      ] }),
      /* @__PURE__ */ jsxs29("div", { className: "text-primary-500 text-md px-4", children: [
        "Updated ",
        timeAgo8(employer.updatedAt)
      ] })
    ] }),
    /* @__PURE__ */ jsx50(EmployerEditor, { fragmentRef: employer })
  ] }) });
};
var createRoute13 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-employer-details`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx50(EmployerDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx50(Link17, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader24(environment, params);
    }
  };
};

// src/secure/accounts/employers/components/EmployerUsers.tsx
import { Navigate as Navigate14 } from "react-router-dom";
import { ErrorContainer as ErrorContainer7 } from "shared-ui";
import { OutletRoute as OutletRoute10 } from "app-core";
import {
  EmployerUsersHome,
  EmployerUserCreate,
  EmployerUsersListLoader,
  employerUsersLoader
} from "feature-employer-accounts";

// src/secure/accounts/employers/components/__generated__/EmployerUserQuery.graphql.ts
var node45 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "code"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDeleted",
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserQuery",
      "selections": [
        {
          "alias": "user",
          "args": v1,
          "concreteType": "AccountsEmployerUser",
          "kind": "LinkedField",
          "name": "accountEmployerUserByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserDetailsEditor_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserGroupsViewer_user"
            },
            v10
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserQuery",
      "selections": [
        {
          "alias": "user",
          "args": v1,
          "concreteType": "AccountsEmployerUser",
          "kind": "LinkedField",
          "name": "accountEmployerUserByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployerUserGroup",
              "kind": "LinkedField",
              "name": "userGroups",
              "plural": true,
              "selections": [
                v2,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAdminGroup",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDefault",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "groupId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4206e18b8b0507a08d61e00c75492fc1",
      "id": null,
      "metadata": {},
      "name": "EmployerUserQuery",
      "operationKind": "query",
      "text": "query EmployerUserQuery(\n  $code: Long!\n) {\n  user: accountEmployerUserByCode(code: $code) {\n    id\n    code\n    accountId\n    firstName\n    lastName\n    emailAddress\n    updatedAt\n    isDeleted\n    ...EmployerUserDetailsEditor_user\n    ...EmployerUserGroupsViewer_user\n  }\n}\n\nfragment EmployerUserDetailsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  updatedAt\n  createdAt\n  isTest\n  isDeleted\n  userGroups {\n    id\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n\nfragment EmployerUserGroupsViewer_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  updatedAt\n  userGroups {\n    id\n    groupId\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node45.hash = "111e1871db9000cb2a9310a086839f6e";
var EmployerUserQuery_graphql_default = node45;

// src/secure/accounts/employers/components/EmployerUser.tsx
import { Suspense as Suspense42, useMemo as useMemo5 } from "react";
import {
  loadQuery as loadQuery25,
  usePreloadedQuery as usePreloadedQuery8
} from "react-relay";
import {
  Navigate as Navigate13,
  Outlet as Outlet10,
  useLocation as useLocation7,
  useRouteLoaderData as useRouteLoaderData6
} from "react-router-dom";
import { ArrowsPointingOutIcon as ArrowsPointingOutIcon4 } from "@heroicons/react/24/outline";
import {
  createLinkState as createLinkState7,
  EdButtonLink as EdButtonLink4,
  EdSkeleton as EdSkeleton28,
  ErrorContainer as ErrorContainer6,
  IconJustify as IconJustify4,
  TabUnderline as TabUnderline5
} from "shared-ui";
import { createImpersonateRoute } from "feature-employer-accounts";

// src/secure/accounts/employers/components/EmployerUserDetails.tsx
import { Suspense as Suspense40 } from "react";
import { useToggle as useToggle3 } from "shared-lib";
import { EdSkeleton as EdSkeleton26 } from "shared-ui";
import {
  EmployerUserDetailsView,
  EmployerUserGroupsViewer,
  EmployerUserDetailsEditor
} from "feature-employer-accounts";
import { jsx as jsx51, jsxs as jsxs30 } from "react/jsx-runtime";
var EmployerUserDetails = ({ routeId: routeId6 }) => {
  const { user } = useEmployerUserRouteData(routeId6);
  const [isEditing, toggleIsEditing] = useToggle3();
  if (user === null || user === void 0) {
    return /* @__PURE__ */ jsx51(EdSkeleton26, {});
  }
  let details = /* @__PURE__ */ jsx51("div", {});
  if (user) {
    details = isEditing ? /* @__PURE__ */ jsx51(
      EmployerUserDetailsEditor,
      {
        fragmentRef: user,
        onCancel: toggleIsEditing,
        onEnabled: toggleIsEditing,
        onDisabled: toggleIsEditing,
        onDone: toggleIsEditing
      }
    ) : /* @__PURE__ */ jsx51(EmployerUserDetailsView, { user, onEdit: toggleIsEditing });
  }
  return /* @__PURE__ */ jsxs30(Suspense40, { fallback: /* @__PURE__ */ jsx51(EdSkeleton26, {}), children: [
    /* @__PURE__ */ jsx51("div", { className: "m-2 sm:m-4", children: details }),
    /* @__PURE__ */ jsx51("div", { className: "m-2 sm:m-4", children: user && /* @__PURE__ */ jsx51(EmployerUserGroupsViewer, { fragmentRef: user }) })
  ] });
};

// src/secure/accounts/employers/components/__generated__/EmployerUserIdentityQuery.graphql.ts
var node46 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "accountUserId"
    }
  ], v1 = [
    {
      "alias": "identity",
      "args": [
        {
          "kind": "Variable",
          "name": "accountUserId",
          "variableName": "accountUserId"
        }
      ],
      "concreteType": "IdentityUser",
      "kind": "LinkedField",
      "name": "identityUserByAccountUserId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountTypes",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserIdentityQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserIdentityQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "0b0273e45934b2021cfcc45d7af7e1ef",
      "id": null,
      "metadata": {},
      "name": "EmployerUserIdentityQuery",
      "operationKind": "query",
      "text": "query EmployerUserIdentityQuery(\n  $accountUserId: UUID!\n) {\n  identity: identityUserByAccountUserId(accountUserId: $accountUserId) {\n    id\n    code\n    createdAt\n    updatedAt\n    firstName\n    lastName\n    email\n    accountTypes\n  }\n}\n"
    }
  };
}();
node46.hash = "ad4ba1bf7536bcce77be199bea88dfbd";
var EmployerUserIdentityQuery_graphql_default = node46;

// src/secure/accounts/employers/components/EmployerUserIdentity.tsx
import { Suspense as Suspense41, useCallback as useCallback23, useState as useState9 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery4 } from "react-relay";
import { useNavigate as useNavigate13 } from "react-router-dom";
import { createClientMutationId as createClientMutationId9, timeAgo as timeAgo9, useToggle as useToggle4 } from "shared-lib";
import { Button as Button11, ButtonList as ButtonList3, EdSkeleton as EdSkeleton27 } from "shared-ui";
import {
  IdentityUserSearchBoxContainer
} from "app-core";

// src/secure/accounts/employers/mutations/__generated__/UseEmployerUserChangeAccountMappingMutation.graphql.ts
var node47 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserChangeAccountMappingMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangeIdentityPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangeIdentity",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserChangeAccountMappingMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangeIdentityPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangeIdentity",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a9c709cad558a2fd4a2e3cab4dd476c0",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserChangeAccountMappingMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserChangeAccountMappingMutation(\n  $input: AccountsEmployerUserChangeIdentityInput!\n) {\n  data: accountsEmployerUserChangeIdentity(input: $input) {\n    employerUser {\n      node {\n        id\n        accountId\n        code\n        createdAt\n        updatedAt\n        firstName\n        lastName\n        emailAddress\n        employerId\n        isTest\n        isDeleted\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node47.hash = "f20e5141e926bc82fdc99af8a5bbc637";
var UseEmployerUserChangeAccountMappingMutation_graphql_default = node47;

// src/secure/accounts/employers/mutations/UseEmployerUserChangeAccountMapping.ts
import { useAsyncMutation as useAsyncMutation10 } from "shared-lib";
var mutationDef10 = UseEmployerUserChangeAccountMappingMutation_graphql_default;
function useEmployerUserChangeAccountMapping() {
  const [commit, isBusy] = useAsyncMutation10(mutationDef10);
  return [commit, isBusy];
}

// src/secure/accounts/employers/components/EmployerUserIdentity.tsx
import { jsx as jsx52, jsxs as jsxs31 } from "react/jsx-runtime";
var queryDef25 = EmployerUserIdentityQuery_graphql_default;
var EmployerUserIdentity = ({ routeId: routeId6 }) => {
  const navigate = useNavigate13();
  const { user } = useEmployerUserRouteData(routeId6);
  const [changeIdentity, isChangingIdentity] = useEmployerUserChangeAccountMapping();
  const [selectedIdentity, setSelectedIdentity] = useState9();
  const onSearchCompleted = useCallback23(
    (result) => {
      setSelectedIdentity(result);
    },
    [setSelectedIdentity]
  );
  const query = useLazyLoadQuery4(
    queryDef25,
    { accountUserId: user.accountId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { identity } = query;
  const [isEditing, toggleIsEditing] = useToggle4(false);
  const onChange = useCallback23(async () => {
    if (!user || !selectedIdentity) {
      return;
    }
    const input = {
      userId: user.accountId,
      email: selectedIdentity.email,
      newIdentityId: selectedIdentity.identityUserId,
      clientMutationId: createClientMutationId9()
    };
    const response = await changeIdentity({ input });
    if (response.data.employerUser) {
      toggleIsEditing();
      navigate(0);
    }
  }, [changeIdentity]);
  if (user === null || user === void 0 || identity == null || identity == void 0) {
    return /* @__PURE__ */ jsx52(EdSkeleton27, {});
  }
  let content = /* @__PURE__ */ jsx52("div", {});
  if (isEditing) {
    content = /* @__PURE__ */ jsxs31("div", { className: "flex flex-col gap-2 border bg-white p-4", children: [
      /* @__PURE__ */ jsxs31("div", { className: "flex flex-col gap-2 p-4", children: [
        /* @__PURE__ */ jsx52("div", { className: "text-primary-500 font-medium", children: identity.email }),
        /* @__PURE__ */ jsx52("div", { className: "text-sm text-gray-500", children: /* @__PURE__ */ jsxs31("div", { children: [
          "Updated: ",
          timeAgo9(user.updatedAt)
        ] }) })
      ] }),
      /* @__PURE__ */ jsxs31("div", { className: "flex flex-col gap-2 p-4", children: [
        /* @__PURE__ */ jsx52("div", { className: "text-gray-500", children: "Search for Identity" }),
        /* @__PURE__ */ jsx52(
          IdentityUserSearchBoxContainer,
          {
            onSearchCompleted
          }
        ),
        selectedIdentity && /* @__PURE__ */ jsxs31("div", { className: "flex flex-col gap-2 px-2 py-4", children: [
          /* @__PURE__ */ jsx52("div", { className: "text-primary-500 font-medium", children: selectedIdentity.email }),
          /* @__PURE__ */ jsx52("div", { className: "my-2 border-t p-4", children: /* @__PURE__ */ jsx52(ButtonList3, { children: /* @__PURE__ */ jsx52(
            Button11,
            {
              color: "primary",
              clicked: onChange,
              disabled: isChangingIdentity,
              children: "Use Identity"
            }
          ) }) })
        ] })
      ] })
    ] });
  } else {
    content = /* @__PURE__ */ jsxs31("div", { className: "flex flex-col gap-2 border bg-white p-4", children: [
      /* @__PURE__ */ jsxs31("div", { className: "flex items-center justify-between gap-2 border-b p-4", children: [
        /* @__PURE__ */ jsx52("div", { className: "text-primary-500 font-medium", children: identity.email }),
        /* @__PURE__ */ jsx52("div", { className: "", children: /* @__PURE__ */ jsx52(Button11, { color: "primary", clicked: toggleIsEditing, children: "Edit" }) })
      ] }),
      /* @__PURE__ */ jsxs31("div", { className: "flex flex-col gap-2 p-4", children: [
        /* @__PURE__ */ jsx52("div", { className: "text-gray-500", children: "Account Types" }),
        /* @__PURE__ */ jsx52("div", { className: "flex items-center gap-2", children: identity.accountTypes.map((a) => {
          return /* @__PURE__ */ jsx52("span", { className: "bg-primary-500 rounded-xl p-2 font-bold text-white", children: a });
        }) })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsx52(Suspense41, { fallback: /* @__PURE__ */ jsx52(EdSkeleton27, {}), children: /* @__PURE__ */ jsx52("div", { className: "md:w-1/2", children: /* @__PURE__ */ jsx52("div", { className: "m-2 sm:m-4", children: content }) }) });
};

// src/secure/accounts/employers/components/EmployerUser.tsx
import { jsx as jsx53, jsxs as jsxs32 } from "react/jsx-runtime";
var queryDef26 = EmployerUserQuery_graphql_default;
async function loader25(environment, params) {
  const employerUserCode = params.employerUserCode;
  const code = Number(employerUserCode);
  const queryRef = loadQuery25(environment, queryDef26, {
    code
  });
  return {
    queryRef
  };
}
function useEmployerUserRouteData(routeId6) {
  const { queryRef } = useRouteLoaderData6(routeId6);
  return usePreloadedQuery8(queryDef26, queryRef);
}
var Layout6 = ({
  routeId: routeId6,
  inList
}) => {
  const data = useEmployerUserRouteData(routeId6);
  const location = useLocation7();
  const tabs4 = useMemo5(() => {
    return [
      createLinkState7(location, "Details", `details`),
      createLinkState7(location, "Impersonate", `impersonate`),
      createLinkState7(location, "Identity", `identity`)
    ];
  }, [location]);
  const { user } = data;
  if (!user) {
    return /* @__PURE__ */ jsx53(EdSkeleton28, {});
  }
  return /* @__PURE__ */ jsx53(Suspense42, { fallback: /* @__PURE__ */ jsx53(EdSkeleton28, {}), children: /* @__PURE__ */ jsxs32("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsxs32("div", { className: "flex flex-wrap items-center justify-between border-b bg-white p-2", children: [
      /* @__PURE__ */ jsx53("div", { className: "px-4", children: /* @__PURE__ */ jsx53(TabUnderline5, { tabs: tabs4 }) }),
      inList && /* @__PURE__ */ jsx53("div", { children: /* @__PURE__ */ jsx53(
        EdButtonLink4,
        {
          to: `../../../../user/${user.code}`,
          name: "View",
          icon: ArrowsPointingOutIcon4,
          iconJustify: IconJustify4.Right
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx53("div", { className: "flex-1", children: /* @__PURE__ */ jsx53(Outlet10, {}) })
  ] }) });
};
var createEmployersUserRoutes = (routePrefix, environment, context, inList) => {
  const routeId6 = `${routePrefix}-employer-user`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx53(Layout6, { routeId: routeId6, inList }),
      errorElement: /* @__PURE__ */ jsx53(ErrorContainer6, {}),
      loader: ({ params }) => {
        return loader25(environment, params);
      },
      children: [
        {
          path: "details",
          id: `${routeId6}-details`,
          element: /* @__PURE__ */ jsx53(EmployerUserDetails, { routeId: routeId6 }),
          errorElement: /* @__PURE__ */ jsx53(ErrorContainer6, {})
        },
        {
          path: "identity",
          id: `${routeId6}-identity`,
          element: /* @__PURE__ */ jsx53(EmployerUserIdentity, { routeId: routeId6 }),
          errorElement: /* @__PURE__ */ jsx53(ErrorContainer6, {})
        },
        createImpersonateRoute(routeId6, environment),
        {
          path: "*",
          element: /* @__PURE__ */ jsx53(Navigate13, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/employers/components/EmployerUsers.tsx
import { jsx as jsx54 } from "react/jsx-runtime";
var createEmployersUsersRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-employer-users`;
  return [
    {
      path: "list/*",
      id: routeId6,
      element: /* @__PURE__ */ jsx54(EmployerUsersListLoader, { routeId: routeId6 }),
      errorElement: /* @__PURE__ */ jsx54(ErrorContainer7, {}),
      loader: ({ params }) => {
        return employerUsersLoader(environment, params, context);
      },
      children: [
        {
          path: "*",
          element: /* @__PURE__ */ jsx54(EmployerUsersHome, {})
        },
        {
          path: "create/*",
          element: /* @__PURE__ */ jsx54(EmployerUserCreate, { canSearchIdentities: true, listRouteId: routeId6 })
        },
        {
          path: ":employerUserCode/*",
          element: /* @__PURE__ */ jsx54(OutletRoute10, {}),
          children: createEmployersUserRoutes(
            routeId6,
            environment,
            context,
            true
          )
        }
      ]
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx54(Navigate14, { to: "list", replace: true })
    }
  ];
};

// src/secure/accounts/employers/components/__generated__/EmployerEmailConfigurationRouteQuery.graphql.ts
var node48 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "alias": "config",
      "args": [
        {
          "kind": "Variable",
          "name": "employerId",
          "variableName": "employerId"
        }
      ],
      "concreteType": "EmployerSendingConfig",
      "kind": "LinkedField",
      "name": "notificationsEmployerEmailSendingConfigById",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailProvider",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isVerified",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailProviderConfig",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerEmailConfigurationRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerEmailConfigurationRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "647776295dc05bece2580de2b7bfe6d4",
      "id": null,
      "metadata": {},
      "name": "EmployerEmailConfigurationRouteQuery",
      "operationKind": "query",
      "text": "query EmployerEmailConfigurationRouteQuery(\n  $employerId: UUID!\n) {\n  config: notificationsEmployerEmailSendingConfigById(employerId: $employerId) {\n    id\n    employerId\n    updatedAt\n    email\n    emailProvider\n    isVerified\n    emailProviderConfig\n  }\n}\n"
    }
  };
}();
node48.hash = "eea8a9701a638d26f2a7986a3cdbe78d";
var EmployerEmailConfigurationRouteQuery_graphql_default = node48;

// src/secure/accounts/employers/components/EmployerEmailConfiguration.tsx
import { Suspense as Suspense43 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery5 } from "react-relay";
import { Link as Link18 } from "react-router-dom";
import { useToggle as useToggle5 } from "shared-lib";
import { Button as Button12, EdSkeleton as EdSkeleton29 } from "shared-ui";
import { EmployerEmailConfigurationForm } from "feature-employer-accounts";
import { Fragment as Fragment23, jsx as jsx55, jsxs as jsxs33 } from "react/jsx-runtime";
var queryDef27 = EmployerEmailConfigurationRouteQuery_graphql_default;
var EmployerEmailConfiguration = ({ layoutRouteId }) => {
  const [isEditing, toggleIsEditing] = useToggle5();
  const data = useEmployerLayoutRouteData(layoutRouteId);
  const { employer } = data;
  const query = useLazyLoadQuery5(
    queryDef27,
    { employerId: employer.employerId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (!data || !query) {
    return /* @__PURE__ */ jsx55(Fragment23, { children: "Loading..." });
  }
  const { config } = query;
  if (!employer) {
    return /* @__PURE__ */ jsx55(Fragment23, { children: "Loading..." });
  }
  let content = null;
  if (isEditing) {
    content = /* @__PURE__ */ jsx55("div", { className: "flex", children: /* @__PURE__ */ jsx55(
      EmployerEmailConfigurationForm,
      {
        employerId: employer.employerId,
        onDone: toggleIsEditing
      }
    ) });
  } else if (config) {
    content = /* @__PURE__ */ jsx55("div", { className: "flex flex-col gap-2 p-4", children: /* @__PURE__ */ jsx55("div", { children: config.email }) });
  } else {
    content = /* @__PURE__ */ jsx55("div", { className: "text-warning-500 flex flex-col gap-2 p-4", children: /* @__PURE__ */ jsx55("div", { children: "No custom sending email configured" }) });
  }
  return /* @__PURE__ */ jsx55(Suspense43, { fallback: /* @__PURE__ */ jsx55(EdSkeleton29, {}), children: /* @__PURE__ */ jsxs33("div", { className: "flex flex-col gap-2 border-b bg-white p-4", children: [
    /* @__PURE__ */ jsxs33("div", { className: "flex items-center justify-between gap-2 border-b", children: [
      /* @__PURE__ */ jsx55("div", { className: "my-4 flex flex-col gap-2", children: /* @__PURE__ */ jsx55("div", { className: "text-primary-500 px-4 text-lg font-medium", children: "Custom Email From Address" }) }),
      /* @__PURE__ */ jsx55("div", { children: /* @__PURE__ */ jsx55(Button12, { color: "primary", clicked: toggleIsEditing, children: "Edit" }) })
    ] }),
    content
  ] }) });
};
var createRoute14 = (layoutRouteId) => {
  const routeId6 = `${layoutRouteId}-employer-email`;
  return {
    id: routeId6,
    path: "email-config",
    element: /* @__PURE__ */ jsx55(EmployerEmailConfiguration, { layoutRouteId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx55(Link18, { to: "email", children: "Email" })
    }
  };
};

// src/secure/accounts/employers/components/__generated__/EmployerJobPublishingRouteQuery.graphql.ts
var node49 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "employerCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canonicalCompanyName",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v10 = [
    {
      "kind": "Variable",
      "name": "employerCode",
      "variableName": "employerCode"
    }
  ], v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "idibuConfigId",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerJobPublishingRouteQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerEditor_employer"
            },
            v9
          ],
          "storageKey": null
        },
        {
          "alias": "config",
          "args": v10,
          "concreteType": "RecruitIdibuConfig",
          "kind": "LinkedField",
          "name": "recruitIdibuConfigByEmployerCode",
          "plural": false,
          "selections": [
            v2,
            v11,
            v4,
            v5,
            v6,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "IdibuConfigContainer_config"
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerJobPublishingRouteQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isApproved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isActive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isDeleted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canViewTelephoneNumbers",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canonicalCompanyId",
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        },
        {
          "alias": "config",
          "args": v10,
          "concreteType": "RecruitIdibuConfig",
          "kind": "LinkedField",
          "name": "recruitIdibuConfigByEmployerCode",
          "plural": false,
          "selections": [
            v2,
            v11,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdByAccountType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedByAccountType",
              "storageKey": null
            },
            v3,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uppHash",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uppSenderId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAdminOnly",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Employer",
              "kind": "LinkedField",
              "name": "employer",
              "plural": false,
              "selections": [
                v7,
                v2
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "36acd5cb09b25b4c3e598fa37f6e42da",
      "id": null,
      "metadata": {},
      "name": "EmployerJobPublishingRouteQuery",
      "operationKind": "query",
      "text": "query EmployerJobPublishingRouteQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    employerId\n    createdAt\n    updatedAt\n    code\n    name\n    canonicalCompanyName\n    ...EmployerEditor_employer\n  }\n  config: recruitIdibuConfigByEmployerCode(employerCode: $employerCode) {\n    id\n    idibuConfigId\n    createdAt\n    updatedAt\n    code\n    ...IdibuConfigContainer_config\n  }\n}\n\nfragment EmployerEditor_employer on Employer {\n  id\n  code\n  employerId\n  updatedAt\n  isApproved\n  isActive\n  isDeleted\n  canViewTelephoneNumbers\n  isTest\n  canonicalCompanyId\n  canonicalCompanyName\n}\n\nfragment IdibuConfigContainer_config on RecruitIdibuConfig {\n  id\n  idibuConfigId\n  version\n  code\n  createdAt\n  createdById\n  createdByAccountType\n  updatedAt\n  updatedById\n  updatedByAccountType\n  employerId\n  uppHash\n  uppSenderId\n  isEnabled\n  isAdminOnly\n  employer {\n    name\n    id\n  }\n}\n"
    }
  };
}();
node49.hash = "58118f20ba23977923212a65dcf0688c";
var EmployerJobPublishingRouteQuery_graphql_default = node49;

// src/secure/accounts/employers/components/EmployerJobPublishing.tsx
import { Suspense as Suspense44 } from "react";
import { loadQuery as loadQuery26 } from "react-relay";
import { Link as Link19 } from "react-router-dom";
import { useRouteData as useRouteData18, useToggle as useToggle6 } from "shared-lib";
import { Button as Button13, EdSkeleton as EdSkeleton30, Size as Size6 } from "shared-ui";
import { IdibuConfigContainer, IdibuConfigEditor } from "feature-recruit";
import { Fragment as Fragment24, jsx as jsx56, jsxs as jsxs34 } from "react/jsx-runtime";
var queryDef28 = EmployerJobPublishingRouteQuery_graphql_default;
async function loader26(environment, params) {
  const code = params.employerCode;
  const employerCode = parseInt(code);
  return loadQuery26(environment, queryDef28, {
    employerCode
  });
}
var EmployerJobPublishing = ({ routeId: routeId6, inList }) => {
  const [isEditing, toggleIsEditing] = useToggle6();
  const data = useRouteData18(queryDef28, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx56(Fragment24, { children: "Loading..." });
  }
  const { employer, config } = data;
  if (!employer) {
    return /* @__PURE__ */ jsx56(Fragment24, { children: "Loading..." });
  }
  let content = null;
  if (isEditing) {
    content = /* @__PURE__ */ jsx56("div", { className: "flex py-4", children: /* @__PURE__ */ jsx56(
      IdibuConfigEditor,
      {
        employerId: employer.employerId,
        onDone: toggleIsEditing,
        onCancel: toggleIsEditing
      }
    ) });
  } else if (config) {
    content = /* @__PURE__ */ jsx56("div", { className: "flex py-4", children: /* @__PURE__ */ jsx56(IdibuConfigContainer, { fragmentRef: config }) });
  } else {
    content = /* @__PURE__ */ jsx56("div", { className: "flex border p-4", children: /* @__PURE__ */ jsx56("div", { className: "text-warning-500 font-bold", children: "No Config Set" }) });
  }
  return /* @__PURE__ */ jsx56(Suspense44, { fallback: /* @__PURE__ */ jsx56(EdSkeleton30, {}), children: /* @__PURE__ */ jsxs34("div", { className: "flex flex-col gap-2 border-b bg-white p-4", children: [
    /* @__PURE__ */ jsxs34("div", { className: "flex items-center justify-between gap-2 border-b", children: [
      /* @__PURE__ */ jsx56("div", { className: "my-4 flex flex-col gap-2", children: /* @__PURE__ */ jsx56("div", { className: "text-primary-500 px-4 text-lg font-medium", children: "Idibu Config" }) }),
      /* @__PURE__ */ jsx56("div", { children: /* @__PURE__ */ jsx56(Button13, { size: Size6.lg, color: "primary", clicked: toggleIsEditing, children: "Edit Configuration" }) })
    ] }),
    content
  ] }) });
};
var createRoute15 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-job-publishing`;
  return {
    id: routeId6,
    path: "job-publishing",
    element: /* @__PURE__ */ jsx56(EmployerJobPublishing, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx56(Link19, { to: "job-publishing", children: "Job Publishing" })
    },
    loader: ({ params }) => {
      return loader26(environment, params);
    }
  };
};

// src/secure/accounts/employers/components/EmployerRoute.tsx
import { jsx as jsx57 } from "react/jsx-runtime";
var createEmployerRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const layoutRouteId = `${routePrefix}-${routeId5}`;
  return [
    {
      path: "*",
      id: layoutRouteId,
      element: /* @__PURE__ */ jsx57(EmployerLayout, { inList, showHeader }),
      errorElement: /* @__PURE__ */ jsx57(ErrorContainer8, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx57(EmployerLink, { routeId: layoutRouteId })
      },
      loader: ({ params }) => {
        return loader23(environment, params);
      },
      children: [
        createRoute13(routePrefix, environment, context, inList),
        createRoute15(routePrefix, environment, context, inList),
        createRoute14(layoutRouteId),
        {
          path: "users/*",
          element: /* @__PURE__ */ jsx57(OutletRoute11, {}),
          children: createEmployersUsersRoutes(
            `${layoutRouteId}-users`,
            environment,
            context
          )
        },
        {
          path: "user/:employerUserCode/*",
          element: /* @__PURE__ */ jsx57(OutletRoute11, {}),
          children: createEmployersUserRoutes(
            `${layoutRouteId}-users-user`,
            environment,
            context,
            false
          )
        },
        {
          path: "user-groups/*",
          element: /* @__PURE__ */ jsx57(OutletRoute11, {}),
          children: createEmployerUserGroupsRoutes(
            `${layoutRouteId}-user-groups`,
            environment,
            context
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx57(Navigate15, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/employers/components/EmployerCreate.tsx
import { Suspense as Suspense45, useCallback as useCallback24 } from "react";
import { useNavigate as useNavigate14 } from "react-router-dom";
import { EdSkeleton as EdSkeleton31 } from "shared-ui";
import {
  EmployerCreateContainer
} from "feature-employer-accounts";
import { jsx as jsx58 } from "react/jsx-runtime";
var EmployerCreate = () => {
  const navigate = useNavigate14();
  const onCreated = useCallback24(
    (employer) => {
      navigate(`../${employer.code}`);
    },
    [navigate]
  );
  const onCancel = useCallback24(() => {
    navigate(`../`);
  }, [navigate]);
  return /* @__PURE__ */ jsx58(Suspense45, { fallback: /* @__PURE__ */ jsx58(EdSkeleton31, {}), children: /* @__PURE__ */ jsx58(EmployerCreateContainer, { onCreate: onCreated, onCancel }) });
};

// src/secure/accounts/employers/components/EmployersRoute.tsx
import { jsx as jsx59, jsxs as jsxs35 } from "react/jsx-runtime";
var EmployersLayout = () => {
  return /* @__PURE__ */ jsx59(Suspense46, { fallback: "Loading Employers...", children: /* @__PURE__ */ jsx59(ErrorBoundary6, { FallbackComponent: ErrorBoundaryFallback6, children: /* @__PURE__ */ jsxs35("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs35("div", { className: "flex items-center justify-between border-b bg-white p-4", children: [
      /* @__PURE__ */ jsxs35("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsx59(EdLink3, { href: "../../", name: "List Employers", children: /* @__PURE__ */ jsx59(Button14, { color: "primary", children: "Back" }) }),
        /* @__PURE__ */ jsx59(PageHeading2, { children: "Employers" })
      ] }),
      /* @__PURE__ */ jsx59("div", { children: /* @__PURE__ */ jsx59(EdLink3, { href: "../create", name: "Create Employer", children: /* @__PURE__ */ jsxs35(Button14, { color: "primary", children: [
        "Create Employer \xA0",
        /* @__PURE__ */ jsx59(PlusIcon, { className: "h-5 w-5" })
      ] }) }) })
    ] }),
    /* @__PURE__ */ jsx59("div", { children: /* @__PURE__ */ jsx59(Outlet11, {}) })
  ] }) }) });
};
var EmployersListRoute = () => {
  return /* @__PURE__ */ jsx59(Suspense46, { fallback: "Loading Employers...", children: /* @__PURE__ */ jsx59(ErrorBoundary6, { FallbackComponent: ErrorBoundaryFallback6, children: /* @__PURE__ */ jsx59(EmployersListContainer, {}) }) });
};
var createEmployersRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-employers`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx59(EmployersLayout, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx59(EmployersListRoute, {}),
          children: [
            {
              id: `${listRouteId}-employer`,
              path: ":employerCode/*",
              element: /* @__PURE__ */ jsx59(OutletRoute12, {}),
              children: createEmployerRoutes(
                `${routeId6}-employer`,
                environment,
                context,
                false,
                true
              )
            }
          ]
        },
        {
          id: `${routeId6}-create`,
          path: "create/*",
          element: /* @__PURE__ */ jsx59(EmployerCreate, {})
        },
        {
          id: `${routeId6}-employer`,
          path: ":employerCode/*",
          element: /* @__PURE__ */ jsx59(OutletRoute12, {}),
          children: createEmployerRoutes(
            `${routePrefix}-employer`,
            environment,
            context,
            true,
            false
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx59(Navigate16, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/index.ts
__reExport(accounts_exports, identity_star);
import * as identity_star from "app-core/src/accounts/identity";

// src/secure/accounts/AccountsLayout.tsx
import { Suspense as Suspense60 } from "react";
import { Navigate as Navigate21 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary8 } from "react-error-boundary";
import { EdLink as EdLink5 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback8, OutletRoute as OutletRoute16 } from "app-core";
import { createIdentityRoutes } from "app-core";

// src/secure/accounts/candidates/components/CandidatesRoute.tsx
import { Suspense as Suspense59 } from "react";
import { Navigate as Navigate20, Outlet as Outlet13 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary7 } from "react-error-boundary";
import { Button as Button18, EdLink as EdLink4, PageHeading as PageHeading3 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback7, OutletRoute as OutletRoute15 } from "app-core";
import { CandidateAccountsListContainer } from "feature-candidate-accounts";

// src/secure/accounts/candidates/components/CandidateRoute.tsx
import { Navigate as Navigate19 } from "react-router-dom";
import { ErrorContainer as ErrorContainer9 } from "shared-ui";
import { createCandidateImpersonateRoute } from "feature-candidate-accounts";

// src/secure/accounts/candidates/components/__generated__/CandidateLayoutQuery.graphql.ts
var node50 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateCode"
    }
  ], v1 = [
    {
      "alias": "candidate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "candidateCode"
        }
      ],
      "concreteType": "AccountsCandidateAccount",
      "kind": "LinkedField",
      "name": "accountCandidateAccountByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "91875c5e10df40de446994beb8f5f9ef",
      "id": null,
      "metadata": {},
      "name": "CandidateLayoutQuery",
      "operationKind": "query",
      "text": "query CandidateLayoutQuery(\n  $candidateCode: Long!\n) {\n  candidate: accountCandidateAccountByCode(code: $candidateCode) {\n    id\n    accountId\n    code\n    updatedAt\n    firstName\n    lastName\n    email\n  }\n}\n"
    }
  };
}();
node50.hash = "b9ecdb0d7a9735cb72f4fdddd22ee5dc";
var CandidateLayoutQuery_graphql_default = node50;

// src/secure/accounts/candidates/components/CandidateLayout.tsx
import { Suspense as Suspense47, useMemo as useMemo6 } from "react";
import {
  Link as Link20,
  Outlet as Outlet12,
  useLoaderData as useLoaderData8,
  useLocation as useLocation8,
  useRouteLoaderData as useRouteLoaderData7
} from "react-router-dom";
import {
  loadQuery as loadQuery27,
  usePreloadedQuery as usePreloadedQuery9
} from "react-relay";
import { ArrowsPointingOutIcon as ArrowsPointingOutIcon5 } from "@heroicons/react/24/outline";
import {
  createLinkState as createLinkState8,
  EdButtonLink as EdButtonLink5,
  IconJustify as IconJustify5,
  TabUnderline as TabUnderline6
} from "shared-ui";
import { Fragment as Fragment25, jsx as jsx60, jsxs as jsxs36 } from "react/jsx-runtime";
var layoutQueryDef = CandidateLayoutQuery_graphql_default;
function useCandidateLayoutRouteData(routeId6) {
  const queryRef = useRouteLoaderData7(
    routeId6
  );
  const data = usePreloadedQuery9(
    layoutQueryDef,
    queryRef
  );
  return data;
}
var CandidateLayout = ({ showHeader, inList }) => {
  const location = useLocation8();
  const preloadedQuery = useLoaderData8();
  const data = usePreloadedQuery9(layoutQueryDef, preloadedQuery);
  const tabs4 = useMemo6(() => {
    return [
      createLinkState8(location, "Details", `details`),
      createLinkState8(location, "Impersonate", `impersonate`),
      createLinkState8(location, "Notifications", `notifications`),
      createLinkState8(location, "Support", `support`),
      createLinkState8(location, "Close", `close`)
    ];
  }, [location]);
  const { candidate } = data;
  if (candidate === null || candidate === void 0) {
    return /* @__PURE__ */ jsx60("div", { children: "Not Found" });
  }
  const name = `${candidate.firstName} ${candidate.lastName}`;
  return /* @__PURE__ */ jsx60(Suspense47, { fallback: "Loading...", children: /* @__PURE__ */ jsxs36("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsx60("div", { className: "flex flex-wrap items-center justify-between border-b py-4", children: /* @__PURE__ */ jsx60("div", { className: "text-primary-500 px-2 font-medium uppercase sm:px-8", children: name }) }),
    /* @__PURE__ */ jsxs36("div", { className: "flex flex-wrap items-center justify-between border-b bg-white py-3", children: [
      /* @__PURE__ */ jsx60("div", { className: "px-4", children: /* @__PURE__ */ jsx60(TabUnderline6, { tabs: tabs4 }) }),
      inList && /* @__PURE__ */ jsx60("div", { children: /* @__PURE__ */ jsx60(
        EdButtonLink5,
        {
          to: `../../../../${candidate.code}`,
          name: "View",
          icon: ArrowsPointingOutIcon5,
          iconJustify: IconJustify5.Right
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx60(Outlet12, {})
  ] }) });
};
var CandidateLink = ({ routeId: routeId6, label }) => {
  const data = useCandidateLayoutRouteData(routeId6);
  const { candidate } = data;
  if (!candidate) {
    return /* @__PURE__ */ jsx60(Fragment25, {});
  }
  const name = `${candidate.firstName} ${candidate.lastName}`;
  return /* @__PURE__ */ jsx60(Suspense47, { fallback: "Loading...", children: /* @__PURE__ */ jsx60(Link20, { to: ".", children: label || name }) });
};
async function loader27(environment, params) {
  const code = params.candidateCode;
  const candidateCode = parseInt(code);
  return loadQuery27(environment, layoutQueryDef, {
    candidateCode
  });
}

// src/secure/accounts/candidates/components/__generated__/CandidateDetailsRouteQuery.graphql.ts
var node51 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateCode"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "code",
    "variableName": "candidateCode"
  }, v2 = [
    v1
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v12 = {
    "alias": "approvalLogs",
    "args": [
      v1,
      {
        "kind": "Literal",
        "name": "order",
        "value": {
          "createdAt": "DESC"
        }
      }
    ],
    "concreteType": "RecruitCandidateApprovalLogsByCandidateCodeConnection",
    "kind": "LinkedField",
    "name": "recruitCandidateApprovalLogsByCandidateCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNextPage",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitCandidateApprovalLogsByCandidateCodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitCandidateApprovalLog",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              v3,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateApprovalLogId",
                "storageKey": null
              },
              v5,
              v11,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reasons",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateDetailsRouteQuery",
      "selections": [
        {
          "alias": "candidate",
          "args": v2,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountByCode",
          "plural": false,
          "selections": [
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CandidateAccountEditor_candidate"
            },
            v10
          ],
          "storageKey": null
        },
        v12
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateDetailsRouteQuery",
      "selections": [
        {
          "alias": "candidate",
          "args": v2,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountByCode",
          "plural": false,
          "selections": [
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v11,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileThumbNailImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileImageS3Path",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTestUser",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSuspended",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAnonymised",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "approvedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "anonymisedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isEmailVerified",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountApproved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountActivated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSignUpComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasAgreedToTerms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGdprConsented",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CandidatePhoneVerification",
              "kind": "LinkedField",
              "name": "phone",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneCountryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneCountryPrefix",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneVerificationStatus",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        },
        v12
      ]
    },
    "params": {
      "cacheID": "a39bac4a0e05c193fae38733e16c7a47",
      "id": null,
      "metadata": {},
      "name": "CandidateDetailsRouteQuery",
      "operationKind": "query",
      "text": "query CandidateDetailsRouteQuery(\n  $candidateCode: Long!\n) {\n  candidate: accountCandidateAccountByCode(code: $candidateCode) {\n    id\n    accountId\n    code\n    firstName\n    lastName\n    email\n    updatedAt\n    ...CandidateAccountEditor_candidate\n  }\n  approvalLogs: recruitCandidateApprovalLogsByCandidateCode(code: $candidateCode, order: {createdAt: DESC}) {\n    pageInfo {\n      hasNextPage\n    }\n    totalCount\n    edges {\n      node {\n        id\n        candidateApprovalLogId\n        code\n        createdAt\n        version\n        candidateId\n        status\n        reasons\n      }\n    }\n  }\n}\n\nfragment CandidateAccountEditor_candidate on AccountsCandidateAccount {\n  id\n  accountId\n  code\n  createdAt\n  updatedAt\n  firstName\n  lastName\n  email\n  profileImageUrl\n  profileThumbNailImageUrl\n  profileImageS3Path\n  isTestUser\n  isSuspended\n  isAnonymised\n  approvedOn\n  anonymisedOn\n  isEmailVerified\n  isAccountApproved\n  isAccountActivated\n  isSignUpComplete\n  hasAgreedToTerms\n  isGdprConsented\n  phone {\n    phoneCountryCode\n    phoneCountryPrefix\n    phoneNumber\n    phoneVerificationStatus\n  }\n}\n"
    }
  };
}();
node51.hash = "1be99f032ddf3f13b07a18c440c95f91";
var CandidateDetailsRouteQuery_graphql_default = node51;

// src/secure/accounts/candidates/components/__generated__/CandidateDetails_IdentityUserQuery.graphql.ts
var node52 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "accountUserId"
    }
  ], v1 = [
    {
      "alias": "identityUser",
      "args": [
        {
          "kind": "Variable",
          "name": "accountUserId",
          "variableName": "accountUserId"
        }
      ],
      "concreteType": "IdentityUser",
      "kind": "LinkedField",
      "name": "identityUserByAccountUserId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastLoggedIn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identityUserId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateDetails_IdentityUserQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateDetails_IdentityUserQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "3fe026253ddaf83212ef5a3f9a87f998",
      "id": null,
      "metadata": {},
      "name": "CandidateDetails_IdentityUserQuery",
      "operationKind": "query",
      "text": "query CandidateDetails_IdentityUserQuery(\n  $accountUserId: UUID!\n) {\n  identityUser: identityUserByAccountUserId(accountUserId: $accountUserId) {\n    id\n    code\n    lastLoggedIn\n    identityUserId\n  }\n}\n"
    }
  };
}();
node52.hash = "757de097e4bc3d95d53b807f00994995";
var CandidateDetails_IdentityUserQuery_graphql_default = node52;

// src/secure/accounts/candidates/components/CandidateDetails.tsx
import { Suspense as Suspense49 } from "react";
import { loadQuery as loadQuery28, useLazyLoadQuery as useLazyLoadQuery6 } from "react-relay";
import { Link as Link21 } from "react-router-dom";
import { timeAgo as timeAgo11, useRouteData as useRouteData19 } from "shared-lib";
import { EdSkeleton as EdSkeleton33 } from "shared-ui";

// src/secure/accounts/candidates/components/__generated__/CandidateAccountEditor_candidate.graphql.ts
var node53 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountEditor_candidate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileThumbNailImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileImageS3Path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTestUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuspended",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAnonymised",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approvedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anonymisedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccountApproved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccountActivated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSignUpComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAgreedToTerms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGdprConsented",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CandidatePhoneVerification",
      "kind": "LinkedField",
      "name": "phone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryPrefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneVerificationStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node53.hash = "106c82bb1677c58ef263095ef3a8b2f7";
var CandidateAccountEditor_candidate_graphql_default = node53;

// src/secure/accounts/candidates/components/CandidateAccountEditor.tsx
import { Suspense as Suspense48, useCallback as useCallback25 } from "react";
import { useFragment as useFragment3 } from "react-relay";
import {
  CalendarDaysIcon,
  EnvelopeIcon,
  InformationCircleIcon as InformationCircleIcon2,
  UserIcon
} from "@heroicons/react/24/outline";
import { createClientMutationId as createClientMutationId10, timeAgo as timeAgo10 } from "shared-lib";
import { BooleanActionItem as BooleanActionItem2, Button as Button15, EdSkeleton as EdSkeleton32, Size as Size7 } from "shared-ui";

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountApproveMutation.graphql.ts
var node54 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileThumbNailImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageS3Path",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuspended",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAnonymised",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "anonymisedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountActivated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAgreedToTerms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGdprConsented",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountApproveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountApprovePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountApprove",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountApproveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountApprovePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountApprove",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e17dfc0d5eb27f87ef1c2bd8350498ba",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountApproveMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountApproveMutation(\n  $input: AccountsCandidateAccountApproveInput!\n) {\n  data: accountsCandidateAccountApprove(input: $input) {\n    candidateAccount {\n      node {\n        id\n        accountId\n        code\n        createdAt\n        updatedAt\n        firstName\n        lastName\n        email\n        profileImageUrl\n        profileThumbNailImageUrl\n        profileImageS3Path\n        isTestUser\n        isSuspended\n        isAnonymised\n        anonymisedOn\n        isEmailVerified\n        isAccountApproved\n        isAccountActivated\n        hasAgreedToTerms\n        isGdprConsented\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n          phoneVerificationStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node54.hash = "15e929f26f5c91070d99bde9bd630030";
var UseCandidateAccountApproveMutation_graphql_default = node54;

// src/secure/accounts/candidates/mutations/UseCandidateAccountApprove.ts
import { useAsyncMutation as useAsyncMutation11 } from "shared-lib";
var mutationDef11 = UseCandidateAccountApproveMutation_graphql_default;
function useCandidateAccountApprove() {
  const [commit, isBusy] = useAsyncMutation11(mutationDef11);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountCloseScheduleMutation.graphql.ts
var node55 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = [
    v2,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccountCloseQueueItem",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccountCloseRequest",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountCloseRequestId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v3,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v3,
            "storageKey": null
          },
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ipAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userAgent",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountCloseScheduleMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountCloseSchedulePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountCloseSchedule",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountCloseScheduleMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountCloseSchedulePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountCloseSchedule",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "12c7392b5883f490577f8dac2e3a1ed2",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountCloseScheduleMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountCloseScheduleMutation(\n  $input: AccountsCandidateAccountCloseScheduleInput!\n) {\n  data: accountsCandidateAccountCloseSchedule(input: $input) {\n    payload {\n      node {\n        id\n        accountCloseRequestId\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        code\n        status\n        ipAddress\n        userAgent\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node55.hash = "1ebbeb386e5d463036d6c256d7dad6ac";
var UseCandidateAccountCloseScheduleMutation_graphql_default = node55;

// src/secure/accounts/candidates/mutations/UseCandidateAccountCloseSchedule.ts
import { useAsyncMutation as useAsyncMutation12 } from "shared-lib";
var mutationDef12 = UseCandidateAccountCloseScheduleMutation_graphql_default;
function useCandidateAccountCloseSchedule() {
  const [commit, isBusy] = useAsyncMutation12(mutationDef12);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountCloseCancelMutation.graphql.ts
var node56 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = [
    v2,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccountCloseQueueItem",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccountCloseRequest",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountCloseRequestId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v3,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v3,
            "storageKey": null
          },
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ipAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userAgent",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountCloseCancelMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountCloseCancelPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountCloseCancel",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountCloseCancelMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountCloseCancelPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountCloseCancel",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5d0450589be05ff42492491e33926bf3",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountCloseCancelMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountCloseCancelMutation(\n  $input: AccountsCandidateAccountCloseCancelInput!\n) {\n  data: accountsCandidateAccountCloseCancel(input: $input) {\n    payload {\n      node {\n        id\n        accountCloseRequestId\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        code\n        status\n        ipAddress\n        userAgent\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node56.hash = "2c502abe11b8e376068eebe11d28090b";
var UseCandidateAccountCloseCancelMutation_graphql_default = node56;

// src/secure/accounts/candidates/mutations/UseCandidateAccountCloseCancel.ts
import { useAsyncMutation as useAsyncMutation13 } from "shared-lib";
var mutationDef13 = UseCandidateAccountCloseCancelMutation_graphql_default;
function useCandidateAccountCloseCancel() {
  const [commit, isBusy] = useAsyncMutation13(mutationDef13);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountSetSignUpCompleteMutation.graphql.ts
var node57 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileThumbNailImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageS3Path",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuspended",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAnonymised",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "anonymisedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountActivated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAgreedToTerms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGdprConsented",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountSetSignUpCompleteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountSetSignupCompletePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSetSignupComplete",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountSetSignUpCompleteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountSetSignupCompletePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSetSignupComplete",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4f407b3cf84dbf6c4a55a19aaa3f54e8",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountSetSignUpCompleteMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountSetSignUpCompleteMutation(\n  $input: AccountsCandidateAccountSetSignupCompleteInput!\n) {\n  data: accountsCandidateAccountSetSignupComplete(input: $input) {\n    candidateAccount {\n      node {\n        id\n        accountId\n        code\n        createdAt\n        updatedAt\n        firstName\n        lastName\n        email\n        profileImageUrl\n        profileThumbNailImageUrl\n        profileImageS3Path\n        isTestUser\n        isSuspended\n        isAnonymised\n        anonymisedOn\n        isEmailVerified\n        isAccountApproved\n        isAccountActivated\n        hasAgreedToTerms\n        isGdprConsented\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n          phoneVerificationStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node57.hash = "b11bccfb43c243d6bb565b6e45aef2d2";
var UseCandidateAccountSetSignUpCompleteMutation_graphql_default = node57;

// src/secure/accounts/candidates/mutations/UseCandidateAccountSetSignUpComplete.ts
import { useAsyncMutation as useAsyncMutation14 } from "shared-lib";
var mutationDef14 = UseCandidateAccountSetSignUpCompleteMutation_graphql_default;
function useCandidateAccountSetSignUpComplete() {
  const [commit, isBusy] = useAsyncMutation14(mutationDef14);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountSuspendMutation.graphql.ts
var node58 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileThumbNailImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageS3Path",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuspended",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAnonymised",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "anonymisedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountActivated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAgreedToTerms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGdprConsented",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountSuspendMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountSuspendPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSuspend",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountSuspendMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountSuspendPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSuspend",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a691ce58ebe407673751281dcc176532",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountSuspendMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountSuspendMutation(\n  $input: AccountsCandidateAccountSuspendInput!\n) {\n  data: accountsCandidateAccountSuspend(input: $input) {\n    candidateAccount {\n      node {\n        id\n        accountId\n        code\n        createdAt\n        updatedAt\n        firstName\n        lastName\n        email\n        profileImageUrl\n        profileThumbNailImageUrl\n        profileImageS3Path\n        isTestUser\n        isSuspended\n        isAnonymised\n        anonymisedOn\n        isEmailVerified\n        isAccountApproved\n        isAccountActivated\n        hasAgreedToTerms\n        isGdprConsented\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n          phoneVerificationStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node58.hash = "9b5ca48c1c86e919d351452f1d13322d";
var UseCandidateAccountSuspendMutation_graphql_default = node58;

// src/secure/accounts/candidates/mutations/UseCandidateAccountSuspend.ts
import { useAsyncMutation as useAsyncMutation15 } from "shared-lib";
var mutationDef15 = UseCandidateAccountSuspendMutation_graphql_default;
function useCandidateAccountSuspend() {
  const [commit, isBusy] = useAsyncMutation15(mutationDef15);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountToggleTestUserMutation.graphql.ts
var node59 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileThumbNailImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageS3Path",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuspended",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAnonymised",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "anonymisedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountActivated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAgreedToTerms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGdprConsented",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountToggleTestUserMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountToggleIsTestUserPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountToggleIsTestUser",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountToggleTestUserMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountToggleIsTestUserPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountToggleIsTestUser",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "01fdf4f0b44ad8309ad5fe6b6babe560",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountToggleTestUserMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountToggleTestUserMutation(\n  $input: AccountsCandidateAccountToggleIsTestUserInput!\n) {\n  data: accountsCandidateAccountToggleIsTestUser(input: $input) {\n    candidateAccount {\n      node {\n        id\n        accountId\n        code\n        createdAt\n        updatedAt\n        firstName\n        lastName\n        email\n        profileImageUrl\n        profileThumbNailImageUrl\n        profileImageS3Path\n        isTestUser\n        isSuspended\n        isAnonymised\n        anonymisedOn\n        isEmailVerified\n        isAccountApproved\n        isAccountActivated\n        hasAgreedToTerms\n        isGdprConsented\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n          phoneVerificationStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node59.hash = "2531b7dbb0a993810d2ca4215daaa91a";
var UseCandidateAccountToggleTestUserMutation_graphql_default = node59;

// src/secure/accounts/candidates/mutations/UseCandidateAccountToggleTestUser.ts
import { useAsyncMutation as useAsyncMutation16 } from "shared-lib";
var mutationDef16 = UseCandidateAccountToggleTestUserMutation_graphql_default;
function useCandidateAccountToggleTestUser() {
  const [commit, isBusy] = useAsyncMutation16(mutationDef16);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateSupportConversationAddMessageMutation.graphql.ts
var node60 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateSupportConversation",
    "kind": "LinkedField",
    "name": "candidateSupportConversation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateSupportConversation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          v3,
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateUnreadCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateSupportConversationMessage",
            "kind": "LinkedField",
            "name": "messages",
            "plural": true,
            "selections": [
              v2,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateSupportConversationMessageId",
                "storageKey": null
              },
              v3,
              v5,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "conversationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "administratorStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsUser",
                "kind": "LinkedField",
                "name": "createdByUser",
                "plural": false,
                "selections": [
                  v2,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailAddress",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v7 = {
    "kind": "InlineFragment",
    "selections": [
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateSupportConversationAddMessageMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomerServicesCandidateSupportConversationCreateMessagePayload",
          "kind": "LinkedField",
          "name": "customerServicesCandidateSupportConversationCreateMessage",
          "plural": false,
          "selections": [
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateSupportConversationAddMessageMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomerServicesCandidateSupportConversationCreateMessagePayload",
          "kind": "LinkedField",
          "name": "customerServicesCandidateSupportConversationCreateMessage",
          "plural": false,
          "selections": [
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1917b6c92cb1f209aaae74fe429f711a",
      "id": null,
      "metadata": {},
      "name": "UseCandidateSupportConversationAddMessageMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateSupportConversationAddMessageMutation(\n  $input: CustomerServicesCandidateSupportConversationCreateMessageInput!\n) {\n  data: customerServicesCandidateSupportConversationCreateMessage(input: $input) {\n    candidateSupportConversation {\n      node {\n        id\n        version\n        updatedAt\n        candidateUnreadCount\n        status\n        messages {\n          id\n          candidateSupportConversationMessageId\n          version\n          code\n          createdAt\n          updatedAt\n          conversationId\n          content\n          candidateStatus\n          administratorStatus\n          createdByUser {\n            id\n            firstName\n            lastName\n            accountType\n            emailAddress\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node60.hash = "87b4c9617ae045c41261232e49f86225";
var UseCandidateSupportConversationAddMessageMutation_graphql_default = node60;

// src/secure/accounts/candidates/mutations/UseCandidateSupportConversationAddMessage.ts
import { useAsyncMutation as useAsyncMutation17 } from "shared-lib";
var mutationDef17 = UseCandidateSupportConversationAddMessageMutation_graphql_default;
function useCandidateSupportConversationAddMessage() {
  const [commit, isBusy] = useAsyncMutation17(
    mutationDef17
  );
  return [commit, isBusy];
}

// src/secure/accounts/candidates/components/CandidateAccountEditor.tsx
import { jsx as jsx61, jsxs as jsxs37 } from "react/jsx-runtime";
var fragmentDef6 = CandidateAccountEditor_candidate_graphql_default;
var CandidateAccountEditor = ({
  fragmentRef,
  lastLoggedIn
}) => {
  const data = useFragment3(
    fragmentDef6,
    fragmentRef
  );
  const [approve, isApproving] = useCandidateAccountApprove();
  const [setSignUpComplete, isSettingSignUpComplete] = useCandidateAccountSetSignUpComplete();
  const [suspend, isSuspending] = useCandidateAccountSuspend();
  const [toggleTestAccount, isTogglingTestAccount] = useCandidateAccountToggleTestUser();
  const onSuspend = useCallback25(async () => {
    const input = {
      candidateId: data.accountId,
      clientMutationId: createClientMutationId10(),
      remindInMonths: 6
    };
    await suspend({ input });
  }, [suspend]);
  const onSetSignUpComplete = useCallback25(async () => {
    const input = {
      candidateId: data.accountId,
      clientMutationId: createClientMutationId10()
    };
    await setSignUpComplete({ input });
  }, [setSignUpComplete]);
  const onApprove = useCallback25(async () => {
    const input = {
      candidateId: data.accountId,
      clientMutationId: createClientMutationId10()
    };
    await approve({ input });
  }, [approve]);
  const onToggleTestAccount = useCallback25(async () => {
    const input = {
      candidateId: data.accountId,
      clientMutationId: createClientMutationId10()
    };
    await toggleTestAccount({ input });
  }, [toggleTestAccount]);
  if (data === null) {
    return /* @__PURE__ */ jsx61(EdSkeleton32, {});
  }
  const DetailItems = ({ label, value, icon }) => {
    return /* @__PURE__ */ jsxs37("div", { className: "mb-2 flex items-center justify-between gap-10 border-b pb-4", children: [
      /* @__PURE__ */ jsxs37("div", { className: "flex items-center gap-4", children: [
        /* @__PURE__ */ jsx61("div", { className: "w-16 border-r pr-3", children: icon }),
        /* @__PURE__ */ jsx61("div", { className: "text-primary-500 text-lg font-bold", children: label })
      ] }),
      /* @__PURE__ */ jsx61("div", { className: "capitalize", children: value })
    ] });
  };
  const approvedOnDate = data?.approvedOn ? timeAgo10(data?.approvedOn) : "";
  return /* @__PURE__ */ jsx61(Suspense48, { fallback: /* @__PURE__ */ jsx61(EdSkeleton32, {}), children: /* @__PURE__ */ jsx61("div", { className: "xl:flex", children: /* @__PURE__ */ jsxs37("div", { className: "flex flex-col gap-4 border bg-white p-8", children: [
    /* @__PURE__ */ jsx61(
      DetailItems,
      {
        label: "Name",
        value: `${data?.firstName} ${data?.lastName}`,
        icon: /* @__PURE__ */ jsx61(UserIcon, { className: "h-5 w-5 flex-shrink-0", "aria-hidden": "true" })
      }
    ),
    /* @__PURE__ */ jsx61(
      DetailItems,
      {
        label: "Email",
        value: data?.email,
        icon: /* @__PURE__ */ jsx61(
          EnvelopeIcon,
          {
            className: "h-5 w-5 flex-shrink-0",
            "aria-hidden": "true"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx61(
      DetailItems,
      {
        label: " Last Logged in Date",
        value: lastLoggedIn,
        icon: /* @__PURE__ */ jsx61(
          InformationCircleIcon2,
          {
            className: "h-5 w-5 flex-shrink-0",
            "aria-hidden": "true"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx61(
      BooleanActionItem2,
      {
        label: "Email Verified",
        value: data.isEmailVerified
      }
    ),
    /* @__PURE__ */ jsx61(
      BooleanActionItem2,
      {
        label: "Approved",
        value: data.isAccountApproved,
        action: /* @__PURE__ */ jsx61("div", { children: !data.isAccountApproved && /* @__PURE__ */ jsx61(
          Button15,
          {
            color: "primary",
            size: Size7.lg,
            clicked: onApprove,
            disabled: isApproving,
            children: "Approve"
          }
        ) })
      }
    ),
    data.isAccountApproved && /* @__PURE__ */ jsx61(
      DetailItems,
      {
        label: "Approved on Date",
        value: approvedOnDate,
        icon: /* @__PURE__ */ jsx61(
          CalendarDaysIcon,
          {
            className: "h-5 w-5 flex-shrink-0",
            "aria-hidden": "true"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx61(
      BooleanActionItem2,
      {
        label: "Suspended",
        value: data.isSuspended,
        action: /* @__PURE__ */ jsx61("div", { children: !data.isSuspended && /* @__PURE__ */ jsx61(
          Button15,
          {
            color: "warning",
            size: Size7.lg,
            clicked: onSuspend,
            disabled: isSuspending,
            children: "Suspend"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx61(
      BooleanActionItem2,
      {
        label: "Sign Up Complete",
        value: data.isSignUpComplete,
        action: /* @__PURE__ */ jsx61("div", { children: !data.isSignUpComplete && /* @__PURE__ */ jsx61(
          Button15,
          {
            color: "primary",
            size: Size7.lg,
            clicked: onSetSignUpComplete,
            disabled: isSettingSignUpComplete,
            children: "Set Sign Up Complete"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx61(
      BooleanActionItem2,
      {
        label: "Test Account",
        value: data.isTestUser,
        action: /* @__PURE__ */ jsx61("div", { children: data.isTestUser ? /* @__PURE__ */ jsx61(
          Button15,
          {
            color: "warning",
            size: Size7.lg,
            disabled: isTogglingTestAccount,
            clicked: onToggleTestAccount,
            children: "Set Normal Account"
          }
        ) : /* @__PURE__ */ jsx61(
          Button15,
          {
            color: "warning",
            size: Size7.lg,
            disabled: isTogglingTestAccount,
            clicked: onToggleTestAccount,
            children: "Set Test Account"
          }
        ) })
      }
    )
  ] }) }) });
};

// src/secure/accounts/candidates/components/CandidateDetails.tsx
import { Fragment as Fragment26, jsx as jsx62, jsxs as jsxs38 } from "react/jsx-runtime";
var queryDef29 = CandidateDetailsRouteQuery_graphql_default;
var identityUserDef = CandidateDetails_IdentityUserQuery_graphql_default;
async function loader28(environment, params) {
  const code = params.candidateCode;
  const candidateCode = parseInt(code);
  return loadQuery28(environment, queryDef29, {
    candidateCode
  });
}
var CandidateDetails = ({ routeId: routeId6 }) => {
  const data = useRouteData19(queryDef29, routeId6);
  const accountId = data?.candidate?.accountId || "";
  const identityUserData = useLazyLoadQuery6(
    identityUserDef,
    { accountUserId: accountId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (!data) {
    return /* @__PURE__ */ jsx62(Fragment26, { children: "Loading..." });
  }
  const { candidate, approvalLogs } = data;
  if (!candidate) {
    return /* @__PURE__ */ jsx62(Fragment26, { children: "Loading..." });
  }
  const approvalLogsList = (approvalLogs?.edges || []).map((e) => e.node).map((l) => {
    const reasonList = l.reasons.map((reason) => {
      return /* @__PURE__ */ jsx62("li", { children: reason }, reason);
    });
    return /* @__PURE__ */ jsxs38("tr", { children: [
      /* @__PURE__ */ jsx62("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx62("div", { className: "text-primary-500 font-medium", children: timeAgo11(l.createdAt) }) }),
      /* @__PURE__ */ jsx62("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx62("div", { className: "text-sm text-gray-500", children: l.status }) }),
      /* @__PURE__ */ jsx62("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: reasonList })
    ] }, l.id);
  });
  const lastLoggedInAt = identityUserData?.identityUser?.lastLoggedIn && timeAgo11(identityUserData?.identityUser?.lastLoggedIn) || "";
  return /* @__PURE__ */ jsx62(Suspense49, { fallback: /* @__PURE__ */ jsx62(EdSkeleton33, {}), children: /* @__PURE__ */ jsxs38("div", { className: "p-4", children: [
    /* @__PURE__ */ jsx62("div", { className: "text-primary-500 mb-4 mt-4 px-2 text-xl font-medium", children: "Candidate Details" }),
    /* @__PURE__ */ jsx62(
      CandidateAccountEditor,
      {
        fragmentRef: candidate,
        lastLoggedIn: lastLoggedInAt
      }
    ),
    approvalLogs && /* @__PURE__ */ jsxs38("div", { className: "", children: [
      /* @__PURE__ */ jsx62("div", { className: "text-primary-500 mt-4 px-2 text-xl font-medium", children: "Approval Logs" }),
      /* @__PURE__ */ jsx62("div", { className: "py-4", children: /* @__PURE__ */ jsxs38("table", { className: "min-w-full divide-y divide-gray-300 border", children: [
        /* @__PURE__ */ jsx62("thead", { children: /* @__PURE__ */ jsxs38("tr", { children: [
          /* @__PURE__ */ jsx62(
            "th",
            {
              scope: "col",
              className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
              children: "Occurred On"
            }
          ),
          /* @__PURE__ */ jsx62(
            "th",
            {
              scope: "col",
              className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
              children: "Status"
            }
          ),
          /* @__PURE__ */ jsx62(
            "th",
            {
              scope: "col",
              className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
              children: "Reasons"
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx62("tbody", { className: "divide-y divide-gray-200 bg-white", children: approvalLogsList })
      ] }) })
    ] })
  ] }) });
};
var createRoute16 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-details`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx62(CandidateDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx62(Link21, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader28(environment, params);
    }
  };
};

// src/secure/accounts/candidates/components/__generated__/CandidateCloseRouteQuery.graphql.ts
var node61 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateCode"
    }
  ], v1 = [
    {
      "alias": "candidate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "candidateCode"
        }
      ],
      "concreteType": "AccountsCandidateAccount",
      "kind": "LinkedField",
      "name": "accountCandidateAccountByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateCloseRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateCloseRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "44a1cfb2e1abe259bb817056adc85dc7",
      "id": null,
      "metadata": {},
      "name": "CandidateCloseRouteQuery",
      "operationKind": "query",
      "text": "query CandidateCloseRouteQuery(\n  $candidateCode: Long!\n) {\n  candidate: accountCandidateAccountByCode(code: $candidateCode) {\n    id\n    accountId\n    code\n  }\n}\n"
    }
  };
}();
node61.hash = "76b9be624438508dc6fd72852488bedb";
var CandidateCloseRouteQuery_graphql_default = node61;

// src/secure/accounts/candidates/components/CandidateClose.tsx
import { Suspense as Suspense52 } from "react";
import { loadQuery as loadQuery29 } from "react-relay";
import { Link as Link22 } from "react-router-dom";
import { useRouteData as useRouteData20 } from "shared-lib";
import { EdSkeleton as EdSkeleton36 } from "shared-ui";

// src/secure/accounts/candidates/components/__generated__/CandidateAccountCloseContainerQuery.graphql.ts
var node62 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateCode"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "candidateCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v11 = [
    v2,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v12 = {
    "alias": "queue",
    "args": [
      {
        "kind": "Literal",
        "name": "order",
        "value": {
          "createdAt": "DESC"
        }
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "AccountCandidateAccountCloseRequestsConnection",
    "kind": "LinkedField",
    "name": "accountCandidateAccountCloseRequests",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountCandidateAccountCloseRequestsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsCandidateAccountCloseRequest",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              v2,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountCloseRequestId",
                "storageKey": null
              },
              v10,
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountId",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": v11,
                "storageKey": null
              },
              v8,
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountId",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": v11,
                "storageKey": null
              },
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ipAddress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userAgent",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      v9
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateAccountCloseContainerQuery",
      "selections": [
        {
          "alias": "candidate",
          "args": v1,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CandidateAccountClose_candidate"
            },
            v9
          ],
          "storageKey": null
        },
        v12
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateAccountCloseContainerQuery",
      "selections": [
        {
          "alias": "candidate",
          "args": v1,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v10,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileThumbNailImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileImageS3Path",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTestUser",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSuspended",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAnonymised",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "anonymisedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isEmailVerified",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountApproved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountActivated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSignUpComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasAgreedToTerms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGdprConsented",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CandidatePhoneVerification",
              "kind": "LinkedField",
              "name": "phone",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneCountryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneCountryPrefix",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneVerificationStatus",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        },
        v12
      ]
    },
    "params": {
      "cacheID": "f8e4d1b268e05b8e46a96a5d6e8bdb8c",
      "id": null,
      "metadata": {},
      "name": "CandidateAccountCloseContainerQuery",
      "operationKind": "query",
      "text": "query CandidateAccountCloseContainerQuery(\n  $candidateCode: Long!\n  $where: AccountsCandidateAccountCloseRequestFilter!\n) {\n  candidate: accountCandidateAccountByCode(code: $candidateCode) {\n    id\n    accountId\n    code\n    firstName\n    lastName\n    email\n    updatedAt\n    ...CandidateAccountClose_candidate\n  }\n  queue: accountCandidateAccountCloseRequests(where: $where, order: {createdAt: DESC}) {\n    edges {\n      node {\n        id\n        accountCloseRequestId\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        code\n        status\n        ipAddress\n        userAgent\n      }\n    }\n  }\n}\n\nfragment CandidateAccountClose_candidate on AccountsCandidateAccount {\n  id\n  accountId\n  code\n  createdAt\n  updatedAt\n  firstName\n  lastName\n  email\n  profileImageUrl\n  profileThumbNailImageUrl\n  profileImageS3Path\n  isTestUser\n  isSuspended\n  isAnonymised\n  anonymisedOn\n  isEmailVerified\n  isAccountApproved\n  isAccountActivated\n  isSignUpComplete\n  hasAgreedToTerms\n  isGdprConsented\n  phone {\n    phoneCountryCode\n    phoneCountryPrefix\n    phoneNumber\n    phoneVerificationStatus\n  }\n}\n"
    }
  };
}();
node62.hash = "4b222ff67ed4dfec63243de60fbafeca";
var CandidateAccountCloseContainerQuery_graphql_default = node62;

// src/secure/accounts/candidates/components/CandidateAccountCloseContainer.tsx
import { Suspense as Suspense51, useMemo as useMemo7 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery7 } from "react-relay";
import { EdSkeleton as EdSkeleton35 } from "shared-ui";

// src/secure/accounts/candidates/components/__generated__/CandidateAccountClose_candidate.graphql.ts
var node63 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountClose_candidate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileThumbNailImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileImageS3Path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTestUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuspended",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAnonymised",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anonymisedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccountApproved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccountActivated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSignUpComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAgreedToTerms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGdprConsented",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CandidatePhoneVerification",
      "kind": "LinkedField",
      "name": "phone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryPrefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneVerificationStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node63.hash = "fe16f0a95df0a643b1ce8bce07c4d647";
var CandidateAccountClose_candidate_graphql_default = node63;

// src/secure/accounts/candidates/components/CandidateAccountClose.tsx
import { Suspense as Suspense50, useCallback as useCallback26 } from "react";
import { useFragment as useFragment4 } from "react-relay";
import { useNavigate as useNavigate15 } from "react-router-dom";
import { createClientMutationId as createClientMutationId11, timeAgo as timeAgo12 } from "shared-lib";
import { Button as Button16, EdSkeleton as EdSkeleton34, Size as Size8 } from "shared-ui";
import { Fragment as Fragment27, jsx as jsx63, jsxs as jsxs39 } from "react/jsx-runtime";
var fragmentDef7 = CandidateAccountClose_candidate_graphql_default;
var CandidateAccountClose = ({
  fragmentRef,
  pendingRequests,
  onCancelled
}) => {
  let pendingRequest = null;
  if (pendingRequests.length > 0) {
    pendingRequest = pendingRequests[0];
  }
  const navigate = useNavigate15();
  const data = useFragment4(
    fragmentDef7,
    fragmentRef
  );
  const [close, isClosing] = useCandidateAccountCloseSchedule();
  const [cancel, isCancelling] = useCandidateAccountCloseCancel();
  const onClose = useCallback26(async () => {
    const input = {
      candidateId: data.accountId,
      clientMutationId: createClientMutationId11(),
      reason: ""
    };
    const response = await close({ input });
    if (response.data.payload) {
      navigate(0);
    }
  }, [close]);
  const onCancel = useCallback26(async () => {
    if (!pendingRequest) {
      return;
    }
    const input = {
      id: pendingRequest.accountCloseRequestId,
      clientMutationId: createClientMutationId11()
    };
    const response = await cancel({ input });
    if (response.data.payload) {
      navigate(0);
    }
  }, [cancel]);
  if (data === null) {
    return /* @__PURE__ */ jsx63(EdSkeleton34, {});
  }
  if (data.isAnonymised && data.anonymisedOn) {
    return /* @__PURE__ */ jsx63("div", { className: "flex", children: /* @__PURE__ */ jsx63("div", { className: "border bg-white", children: /* @__PURE__ */ jsxs39("div", { className: "m-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx63("div", { className: "text-primary-500 border-b p-4 text-2xl font-bold", children: "Account Anonymized" }),
      /* @__PURE__ */ jsxs39("div", { className: "text-md p-4 font-medium text-gray-500", children: [
        "Anonymized ",
        timeAgo12(data.anonymisedOn)
      ] })
    ] }) }) });
  }
  let actionContainer = /* @__PURE__ */ jsx63("div", {});
  if (pendingRequest) {
    actionContainer = /* @__PURE__ */ jsxs39(Fragment27, { children: [
      /* @__PURE__ */ jsx63("div", { className: "my-4 flex items-center gap-2 border-b px-2 py-4 text-xl", children: "Request is already Pending" }),
      /* @__PURE__ */ jsx63("div", { className: "flex", children: /* @__PURE__ */ jsx63(
        Button16,
        {
          color: "danger",
          size: Size8.lg,
          clicked: onCancel,
          disabled: isCancelling,
          children: "Cancel Request"
        }
      ) })
    ] });
  } else {
    actionContainer = /* @__PURE__ */ jsxs39(Fragment27, { children: [
      /* @__PURE__ */ jsx63("div", { className: "my-4 flex items-center gap-2 border-b px-2 py-4 text-xl", children: "Request Account Closure, this will take up to 24 hours" }),
      /* @__PURE__ */ jsx63("div", { className: "flex", children: /* @__PURE__ */ jsx63(
        Button16,
        {
          color: "primary",
          size: Size8.lg,
          clicked: onClose,
          disabled: isClosing,
          children: "Request Closure"
        }
      ) })
    ] });
  }
  return /* @__PURE__ */ jsx63(Suspense50, { fallback: /* @__PURE__ */ jsx63(EdSkeleton34, {}), children: /* @__PURE__ */ jsx63("div", { className: "flex border bg-white p-8 sm:w-1/2", children: /* @__PURE__ */ jsxs39("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsxs39("div", { className: "text-primary-500 flex items-center gap-2 border-b p-2 font-medium", children: [
      /* @__PURE__ */ jsx63("div", { children: data.firstName }),
      /* @__PURE__ */ jsx63("div", { children: data.lastName })
    ] }),
    actionContainer
  ] }) }) });
};

// src/secure/accounts/candidates/components/CandidateAccountCloseContainer.tsx
import { Fragment as Fragment28, jsx as jsx64 } from "react/jsx-runtime";
var queryDef30 = CandidateAccountCloseContainerQuery_graphql_default;
var CandidateAccountCloseContainer = ({
  candidateId,
  candidateCode
}) => {
  const where2 = {
    accountId: { eq: candidateId },
    status: { eq: "PENDING" }
  };
  const query = useLazyLoadQuery7(
    queryDef30,
    { where: where2, candidateCode },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { candidate, queue } = query;
  if (!candidate) {
    return /* @__PURE__ */ jsx64(Fragment28, { children: "Loading..." });
  }
  const pendingRequests = useMemo7(() => {
    return (queue && queue.edges || []).map((e) => {
      return e.node;
    });
  }, [queue]);
  return /* @__PURE__ */ jsx64(Suspense51, { fallback: /* @__PURE__ */ jsx64(EdSkeleton35, {}), children: /* @__PURE__ */ jsx64("div", { children: /* @__PURE__ */ jsx64(
    CandidateAccountClose,
    {
      pendingRequests,
      fragmentRef: candidate
    }
  ) }) });
};

// src/secure/accounts/candidates/components/CandidateClose.tsx
import { Fragment as Fragment29, jsx as jsx65 } from "react/jsx-runtime";
var queryDef31 = CandidateCloseRouteQuery_graphql_default;
async function loader29(environment, params) {
  const code = params.candidateCode;
  const candidateCode = parseInt(code);
  return loadQuery29(environment, queryDef31, {
    candidateCode
  });
}
var CandidateClose = ({ routeId: routeId6 }) => {
  const data = useRouteData20(queryDef31, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx65(Fragment29, { children: "Loading..." });
  }
  const { candidate } = data;
  if (!candidate) {
    return /* @__PURE__ */ jsx65(Fragment29, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx65(Suspense52, { fallback: /* @__PURE__ */ jsx65(EdSkeleton36, {}), children: /* @__PURE__ */ jsx65("div", { className: "p-4", children: /* @__PURE__ */ jsx65(
    CandidateAccountCloseContainer,
    {
      candidateId: candidate.accountId,
      candidateCode: candidate.code
    }
  ) }) });
};
var createRoute17 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-close`;
  return {
    id: routeId6,
    path: "close",
    element: /* @__PURE__ */ jsx65(CandidateClose, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx65(Link22, { to: "close", children: "Close" })
    },
    loader: ({ params }) => {
      return loader29(environment, params);
    }
  };
};

// src/secure/accounts/candidates/components/CandidateSupport.tsx
import { Suspense as Suspense55 } from "react";
import { Link as Link23, Navigate as Navigate17 } from "react-router-dom";
import { EdSkeleton as EdSkeleton39 } from "shared-ui";

// src/secure/accounts/candidates/components/__generated__/CandidateSupportConversationsListContainerQuery.graphql.ts
var node64 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateSupportConversationsListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CandidateSupportConversationsListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateSupportConversationsListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "CustomerServiceCandidateSupportConversationsConnection",
          "kind": "LinkedField",
          "name": "customerServiceCandidateSupportConversations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomerServiceCandidateSupportConversationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CandidateSupportConversation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    v3,
                    v4,
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateUnreadCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "conversationEnded",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateSupportConversationMessage",
                      "kind": "LinkedField",
                      "name": "messages",
                      "plural": true,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateSupportConversationMessageId",
                          "storageKey": null
                        },
                        v3,
                        v4,
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "conversationId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "administratorStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "CandidateSupportConversationsList_list",
          "kind": "LinkedHandle",
          "name": "customerServiceCandidateSupportConversations"
        }
      ]
    },
    "params": {
      "cacheID": "6418562ea1252f1235135c2b2704be26",
      "id": null,
      "metadata": {},
      "name": "CandidateSupportConversationsListContainerQuery",
      "operationKind": "query",
      "text": "query CandidateSupportConversationsListContainerQuery(\n  $where: CandidateSupportConversationFilter!\n) {\n  ...CandidateSupportConversationsListContainer_list\n}\n\nfragment CandidateSupportConversationsListContainer_list on Query {\n  list: customerServiceCandidateSupportConversations(first: 10, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        description\n        status\n        candidateUnreadCount\n        conversationEnded\n        messages {\n          id\n          ...ConversationMessageRow_account\n        }\n        __typename\n      }\n    }\n  }\n}\n\nfragment ConversationMessageRow_account on CandidateSupportConversationMessage {\n  id\n  candidateSupportConversationMessageId\n  code\n  updatedAt\n  createdAt\n  conversationId\n  administratorStatus\n  candidateStatus\n}\n"
    }
  };
}();
node64.hash = "89ff67d36a20d337b836ea4986d4a164";
var CandidateSupportConversationsListContainerQuery_graphql_default = node64;

// src/secure/accounts/candidates/components/__generated__/CandidateSupportConversationsListContainerPaginationQuery.graphql.ts
var node65 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateSupportConversationsListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "CandidateSupportConversationsListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateSupportConversationsListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "CustomerServiceCandidateSupportConversationsConnection",
          "kind": "LinkedField",
          "name": "customerServiceCandidateSupportConversations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomerServiceCandidateSupportConversationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CandidateSupportConversation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateUnreadCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "conversationEnded",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateSupportConversationMessage",
                      "kind": "LinkedField",
                      "name": "messages",
                      "plural": true,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateSupportConversationMessageId",
                          "storageKey": null
                        },
                        v5,
                        v6,
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "conversationId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "administratorStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "CandidateSupportConversationsList_list",
          "kind": "LinkedHandle",
          "name": "customerServiceCandidateSupportConversations"
        }
      ]
    },
    "params": {
      "cacheID": "3ccf7074cce938bbe0e263598de9f782",
      "id": null,
      "metadata": {},
      "name": "CandidateSupportConversationsListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query CandidateSupportConversationsListContainerPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: CandidateSupportConversationFilter\n) {\n  ...CandidateSupportConversationsListContainer_list_2HEEH6\n}\n\nfragment CandidateSupportConversationsListContainer_list_2HEEH6 on Query {\n  list: customerServiceCandidateSupportConversations(first: $first, after: $after, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        description\n        status\n        candidateUnreadCount\n        conversationEnded\n        messages {\n          id\n          ...ConversationMessageRow_account\n        }\n        __typename\n      }\n    }\n  }\n}\n\nfragment ConversationMessageRow_account on CandidateSupportConversationMessage {\n  id\n  candidateSupportConversationMessageId\n  code\n  updatedAt\n  createdAt\n  conversationId\n  administratorStatus\n  candidateStatus\n}\n"
    }
  };
}();
node65.hash = "e2e6d803f84dcc2f9f01f1ef5bdd2d9a";
var CandidateSupportConversationsListContainerPaginationQuery_graphql_default = node65;

// src/secure/accounts/candidates/components/__generated__/CandidateSupportConversationsListContainer_list.graphql.ts
var node66 = function() {
  var v0 = [
    "list"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CandidateSupportConversationsListContainerPaginationQuery_graphql_default
      }
    },
    "name": "CandidateSupportConversationsListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "updatedAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "CustomerServiceCandidateSupportConversationsConnection",
        "kind": "LinkedField",
        "name": "__CandidateSupportConversationsList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerServiceCandidateSupportConversationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CandidateSupportConversation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateUnreadCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "conversationEnded",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateSupportConversationMessage",
                    "kind": "LinkedField",
                    "name": "messages",
                    "plural": true,
                    "selections": [
                      v1,
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ConversationMessageRow_account"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node66.hash = "e2e6d803f84dcc2f9f01f1ef5bdd2d9a";
var CandidateSupportConversationsListContainer_list_graphql_default = node66;

// src/secure/accounts/candidates/components/CandidateSupportConversationsListContainer.tsx
import { Suspense as Suspense53, useCallback as useCallback27, useState as useState10 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery8, usePaginationFragment as usePaginationFragment4 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow4, parseISO as parseISO4 } from "date-fns";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader4,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement4,
  EdSkeleton as EdSkeleton37,
  Input as Input4,
  ListLayout as ListLayout4
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined4, useDebounce as useDebounce4 } from "shared-lib";
import { jsx as jsx66, jsxs as jsxs40 } from "react/jsx-runtime";
var queryDef32 = CandidateSupportConversationsListContainerQuery_graphql_default;
var fragmentDef8 = CandidateSupportConversationsListContainer_list_graphql_default;
function createLinkTo4(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List3 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment4(fragmentDef8, fragmentRef);
  const onLoadNext = useCallback27(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined4).map((e) => e.node).map((ft) => {
    const name = `${ft.name}`;
    return {
      key: ft.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx66("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs40("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx66("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx66("div", { className: "text-md text-blue-500", children: ft.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs40("div", { className: "pt-2 text-sm", children: [
        "Updated ",
        formatDistanceToNow4(parseISO4(ft.updatedAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: ft.code
      },
      element: /* @__PURE__ */ jsx66(DefaultListLayoutSectionElement4, { children: /* @__PURE__ */ jsx66("div", { className: "grid", children: /* @__PURE__ */ jsx66("div", { children: ft.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx66(Suspense53, { fallback: /* @__PURE__ */ jsx66(EdSkeleton37, {}), children: /* @__PURE__ */ jsx66(
    ListLayout4,
    {
      title: "Conversations",
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx66(
        DefaultListLayoutItemHeader4,
        {
          title: "Conversations",
          to: createLinkTo4,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  ) });
};
var CandidateSupportConversationsListContainer = ({
  candidateId
}) => {
  const [filter, setFilter] = useState10(null);
  const searchTerm = useDebounce4(filter, 500);
  const where2 = {
    candidateAccountId: { eq: candidateId }
  };
  if (searchTerm) {
    where2.or = [{ name: { startsWith: filter } }];
  }
  const query = useLazyLoadQuery8(
    queryDef32,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs40("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx66("div", { className: "flex items-center justify-between space-x-4 border-b", children: /* @__PURE__ */ jsxs40("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx66("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx66("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx66(
        Input4,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx66("div", { className: "flex-1", children: /* @__PURE__ */ jsx66(List3, { fragmentRef: query }) })
  ] });
};

// src/secure/accounts/candidates/components/__generated__/CandidateSupportConversationContainerRouteQuery.graphql.ts
var node67 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "conversationCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v4 = [
    {
      "alias": "conversation",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "conversationCode"
        }
      ],
      "concreteType": "CandidateSupportConversation",
      "kind": "LinkedField",
      "name": "customerServiceCandidateSupportConversationByCode",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "candidateSupportConversationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        v2,
        v3,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "candidateUnreadCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "conversationEnded",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CandidateSupportConversationMessage",
          "kind": "LinkedField",
          "name": "messages",
          "plural": true,
          "selections": [
            v1,
            v3,
            v2,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "administratorStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "content",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsUser",
              "kind": "LinkedField",
              "name": "createdByUser",
              "plural": false,
              "selections": [
                v1,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAddress",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountType",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateSupportConversationContainerRouteQuery",
      "selections": v4,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateSupportConversationContainerRouteQuery",
      "selections": v4
    },
    "params": {
      "cacheID": "f5d5a574ea8c3817be473377c71e449c",
      "id": null,
      "metadata": {},
      "name": "CandidateSupportConversationContainerRouteQuery",
      "operationKind": "query",
      "text": "query CandidateSupportConversationContainerRouteQuery(\n  $conversationCode: Long!\n) {\n  conversation: customerServiceCandidateSupportConversationByCode(code: $conversationCode) {\n    id\n    candidateSupportConversationId\n    code\n    updatedAt\n    createdAt\n    name\n    description\n    status\n    candidateUnreadCount\n    conversationEnded\n    messages {\n      id\n      createdAt\n      updatedAt\n      candidateStatus\n      administratorStatus\n      content\n      createdByUser {\n        id\n        firstName\n        lastName\n        emailAddress\n        accountType\n      }\n    }\n  }\n}\n"
    }
  };
}();
node67.hash = "7970f8c9a9fee285b48ca694c708e8f8";
var CandidateSupportConversationContainerRouteQuery_graphql_default = node67;

// src/secure/accounts/candidates/components/CandidateSupportConversationContainer.tsx
import { Suspense as Suspense54 } from "react";
import { loadQuery as loadQuery30 } from "react-relay";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { timeAgo as timeAgo13, useRouteData as useRouteData21 } from "shared-lib";
import { classNames as classNames2, EdSkeleton as EdSkeleton38 } from "shared-ui";

// src/secure/accounts/candidates/components/CandidateSupportConversationForm.tsx
import { useCallback as useCallback28 } from "react";
import { useForm as useForm3 } from "react-hook-form";
import { z as z2 } from "zod";
import { zodResolver as zodResolver3 } from "@hookform/resolvers/zod";
import { createClientMutationId as createClientMutationId12 } from "shared-lib";
import {
  ActionContainer as ActionContainer2,
  ErrorField as ErrorField2,
  FormInputRow as FormInputRow2,
  FormTextAreaInput
} from "shared-ui";
import { jsx as jsx67, jsxs as jsxs41 } from "react/jsx-runtime";
var formSchema3 = z2.object({
  message: z2.string().min(1, { message: "Message is required" })
});
var CandidateSupportConversationForm = ({
  conversationId,
  onDone
}) => {
  const [createMessage, isCreatingMessage] = useCandidateSupportConversationAddMessage();
  const { register, handleSubmit, formState } = useForm3({
    mode: "onChange",
    resolver: zodResolver3(formSchema3)
  });
  const { errors, isDirty, isValid } = formState;
  const onSubmit = handleSubmit((data) => onCreateMessage(isValid, data));
  const onCreateMessage = useCallback28(
    async (isValid2, form) => {
      if (!form.message) {
        return;
      }
      const input = {
        conversationId,
        content: form.message,
        clientMutationId: createClientMutationId12()
      };
      const response = await createMessage({ input });
      if (response.data.candidateSupportConversation) {
        onDone();
        return;
      }
    },
    [createMessage, onDone]
  );
  return /* @__PURE__ */ jsx67("form", { onSubmit, children: /* @__PURE__ */ jsx67(
    ActionContainer2,
    {
      isDirty,
      showSubmit: true,
      submitText: "Send Message",
      isSaving: isCreatingMessage,
      isDisabled: !isValid,
      children: /* @__PURE__ */ jsxs41(FormInputRow2, { name: "message", title: "Reply", children: [
        /* @__PURE__ */ jsx67(
          FormTextAreaInput,
          {
            rows: 5,
            register,
            name: "message",
            required: true,
            placeholder: "Add a message"
          }
        ),
        /* @__PURE__ */ jsx67(ErrorField2, { field: errors.message })
      ] })
    }
  ) });
};

// src/secure/accounts/candidates/components/CandidateSupportConversationContainer.tsx
import { Fragment as Fragment30, jsx as jsx68, jsxs as jsxs42 } from "react/jsx-runtime";
var queryDef33 = CandidateSupportConversationContainerRouteQuery_graphql_default;
async function loader30(environment, params) {
  const code = params.conversationCode;
  const conversationCode = parseInt(code);
  try {
    return loadQuery30(
      environment,
      queryDef33,
      {
        conversationCode
      }
    );
  } catch (e) {
    console.error("CandidateSupportConversationContainer Loader Failed.");
    console.error(e);
    throw e;
  }
}
var CandidateSupportConversationContainer = ({ routeId: routeId6, inList }) => {
  const data = useRouteData21(
    queryDef33,
    routeId6
  );
  if (!data) {
    return /* @__PURE__ */ jsx68(Fragment30, { children: "Loading..." });
  }
  const { conversation } = data;
  if (!conversation) {
    return /* @__PURE__ */ jsx68(Fragment30, { children: "Loading..." });
  }
  const name = `${conversation.name}`;
  const messageRows = conversation.messages.map((message, messageIdx) => {
    const userName = `${message.createdByUser.firstName} ${message.createdByUser.lastName}`;
    return /* @__PURE__ */ jsxs42("li", { className: "relative flex gap-x-4", children: [
      /* @__PURE__ */ jsx68(
        "div",
        {
          className: classNames2(
            messageIdx === conversation.messages.length - 1 ? "h-6" : "-bottom-6",
            "absolute left-0 top-0 flex w-6 justify-center"
          ),
          children: /* @__PURE__ */ jsx68("div", { className: "w-px bg-gray-200" })
        }
      ),
      /* @__PURE__ */ jsx68("div", { className: "relative flex h-6 w-6 flex-none items-center justify-center bg-white", children: message.administratorStatus === "READ" ? /* @__PURE__ */ jsx68(
        CheckCircleIcon,
        {
          className: "h-6 w-6 text-indigo-600",
          "aria-hidden": "true"
        }
      ) : /* @__PURE__ */ jsx68("div", { className: "h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" }) }),
      /* @__PURE__ */ jsxs42("div", { className: "flex-auto rounded-md p-3 ring-1 ring-inset ring-gray-200", children: [
        /* @__PURE__ */ jsxs42("div", { className: "flex justify-between gap-x-4", children: [
          /* @__PURE__ */ jsx68("div", { className: "py-0.5 text-xs leading-5 text-gray-500", children: /* @__PURE__ */ jsx68("span", { className: "font-medium text-gray-900", children: userName }) }),
          /* @__PURE__ */ jsx68(
            "time",
            {
              dateTime: message.updatedAt,
              className: "flex-none py-0.5 text-xs leading-5 text-gray-500",
              children: timeAgo13(message.updatedAt)
            }
          )
        ] }),
        /* @__PURE__ */ jsx68("p", { className: "text-sm leading-6 text-gray-500", children: message.content })
      ] })
    ] }, message.id);
  });
  return /* @__PURE__ */ jsx68(Suspense54, { fallback: /* @__PURE__ */ jsx68(EdSkeleton38, {}), children: /* @__PURE__ */ jsxs42("div", { className: "flex flex-col gap-2 border bg-white p-4", children: [
    /* @__PURE__ */ jsxs42("div", { className: "my-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx68("div", { className: "text-primary-500 px-4 text-lg font-medium", children: name }),
      /* @__PURE__ */ jsxs42("div", { className: "text-primary-500 text-md px-4", children: [
        "Updated ",
        timeAgo13(conversation.updatedAt)
      ] })
    ] }),
    /* @__PURE__ */ jsx68("ul", { role: "list", className: "space-y-6", children: messageRows }),
    /* @__PURE__ */ jsx68("div", { className: "mt-2", children: /* @__PURE__ */ jsx68(
      CandidateSupportConversationForm,
      {
        conversationId: conversation.candidateSupportConversationId,
        onDone: () => {
        }
      }
    ) })
  ] }) });
};
var createRoute18 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-conversation`;
  return {
    id: routeId6,
    path: ":conversationCode",
    element: /* @__PURE__ */ jsx68(
      CandidateSupportConversationContainer,
      {
        routeId: routeId6,
        inList
      }
    ),
    loader: ({ params }) => {
      return loader30(environment, params);
    }
  };
};

// src/secure/accounts/candidates/components/CandidateSupport.tsx
import { OutletRoute as OutletRoute13 } from "app-core";
import { Fragment as Fragment31, jsx as jsx69 } from "react/jsx-runtime";
var ConversationsList = ({ layoutRouteId }) => {
  const layoutData = useCandidateLayoutRouteData(layoutRouteId);
  const { candidate } = layoutData;
  if (!candidate) {
    return /* @__PURE__ */ jsx69(Fragment31, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx69(Suspense55, { fallback: /* @__PURE__ */ jsx69(EdSkeleton39, {}), children: /* @__PURE__ */ jsx69("div", { className: "border bg-white p-2", children: /* @__PURE__ */ jsx69(
    CandidateSupportConversationsListContainer,
    {
      candidateId: candidate.accountId
    }
  ) }) });
};
var createRoute19 = (routePrefix, environment, context, inList = true, layoutRouteId) => {
  const routeId6 = `${routePrefix}-support`;
  const listRouteId = `${routeId6}-list`;
  return {
    id: routeId6,
    path: "support",
    element: /* @__PURE__ */ jsx69(OutletRoute13, {}),
    handle: {
      crumb: () => /* @__PURE__ */ jsx69(Link23, { to: "support", children: "Support" })
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx69(
          ConversationsList,
          {
            routeId: listRouteId,
            inList,
            layoutRouteId
          }
        ),
        children: [
          createRoute18(listRouteId, environment, context, inList)
        ]
      },
      createRoute18(routeId6, environment, context, inList),
      {
        path: "*",
        element: /* @__PURE__ */ jsx69(Navigate17, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/accounts/candidates/components/EmailNotifications.tsx
import { Suspense as Suspense58 } from "react";
import { Link as Link24, Navigate as Navigate18 } from "react-router-dom";
import { EdSkeleton as EdSkeleton42 } from "shared-ui";
import { OutletRoute as OutletRoute14 } from "app-core";

// src/secure/accounts/candidates/components/__generated__/EmailNotificationContainerRouteQuery.graphql.ts
var node68 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "notificationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "notificationCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailNotificationId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tenant",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fromEmail",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fromName",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "toEmail",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "toName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "concreteType": "NotificationsEmailNotificationData",
    "kind": "LinkedField",
    "name": "emailNotificationData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dotnetType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "concreteType": "NotificationsReceiver",
    "kind": "LinkedField",
    "name": "receiver",
    "plural": false,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "receiverType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "concreteType": "NotificationsNotificationAttribute",
    "kind": "LinkedField",
    "name": "attributes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailId",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "providerType",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasSent",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasDelivered",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasOpened",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasClicked",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasHardBounced",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasSoftBounced",
    "storageKey": null
  }, v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasMarkedAsSpam",
    "storageKey": null
  }, v23 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailNotificationContainerRouteQuery",
      "selections": [
        {
          "alias": "notification",
          "args": v1,
          "concreteType": "NotificationsEmailNotification",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmail",
              "kind": "LinkedField",
              "name": "emails",
              "plural": true,
              "selections": [
                v2,
                v14,
                v4,
                v5,
                v15,
                v16,
                v17,
                v18,
                v19,
                v20,
                v21,
                v22,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NotificationsEmailContainer_email"
                }
              ],
              "storageKey": null
            },
            v23
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailNotificationContainerRouteQuery",
      "selections": [
        {
          "alias": "notification",
          "args": v1,
          "concreteType": "NotificationsEmailNotification",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmail",
              "kind": "LinkedField",
              "name": "emails",
              "plural": true,
              "selections": [
                v2,
                v14,
                v4,
                v5,
                v15,
                v16,
                v17,
                v18,
                v19,
                v20,
                v21,
                v22,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NotificationsEmailEvent",
                  "kind": "LinkedField",
                  "name": "emailEvents",
                  "plural": true,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailEventId",
                      "storageKey": null
                    },
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "occuredAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v23
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "517660e63134b346ffb23573aee19c8a",
      "id": null,
      "metadata": {},
      "name": "EmailNotificationContainerRouteQuery",
      "operationKind": "query",
      "text": "query EmailNotificationContainerRouteQuery(\n  $notificationCode: Long!\n) {\n  notification: notificationsEmailNotificationByCode(code: $notificationCode) {\n    id\n    emailNotificationId\n    code\n    createdAt\n    tenant\n    fromEmail\n    fromName\n    toEmail\n    toName\n    emailNotificationData {\n      dotnetType\n      data\n    }\n    receiver {\n      id\n      receiverType\n    }\n    attributes {\n      type\n      value\n    }\n    emails {\n      id\n      emailId\n      code\n      createdAt\n      providerType\n      wasSent\n      wasDelivered\n      wasOpened\n      wasClicked\n      wasHardBounced\n      wasSoftBounced\n      wasMarkedAsSpam\n      ...NotificationsEmailContainer_email\n    }\n  }\n}\n\nfragment NotificationsEmailContainer_email on NotificationsEmail {\n  id\n  emailId\n  code\n  createdAt\n  providerType\n  wasSent\n  wasDelivered\n  wasOpened\n  wasClicked\n  wasHardBounced\n  wasSoftBounced\n  wasMarkedAsSpam\n  emailEvents {\n    id\n    emailEventId\n    createdAt\n    occuredAt\n    eventType\n  }\n}\n"
    }
  };
}();
node68.hash = "078baf3ed6f00c10d7d9cc337b7c1859";
var EmailNotificationContainerRouteQuery_graphql_default = node68;

// src/secure/accounts/candidates/components/EmailNotificationContainer.tsx
import { Suspense as Suspense56, useCallback as useCallback29, useState as useState11 } from "react";
import { loadQuery as loadQuery31 } from "react-relay";
import { timeAgo as timeAgo15, useRouteData as useRouteData22 } from "shared-lib";
import { BooleanIcon, Button as Button17, EdSkeleton as EdSkeleton40, LinkButton } from "shared-ui";

// src/secure/accounts/candidates/components/__generated__/NotificationsEmailContainer_email.graphql.ts
var node69 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsEmailContainer_email",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "providerType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasSent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasDelivered",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasOpened",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasClicked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasHardBounced",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasSoftBounced",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasMarkedAsSpam",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationsEmailEvent",
        "kind": "LinkedField",
        "name": "emailEvents",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailEventId",
            "storageKey": null
          },
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occuredAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eventType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "NotificationsEmail",
    "abstractKey": null
  };
}();
node69.hash = "1380d7124dcc6f1cb223ade1a3698d4e";
var NotificationsEmailContainer_email_graphql_default = node69;

// src/secure/accounts/candidates/components/NotificationsEmailContainer.tsx
import { useFragment as useFragment5 } from "react-relay";
import { classNames as classNames3 } from "shared-ui";
import { timeAgo as timeAgo14 } from "shared-lib";
import { jsx as jsx70, jsxs as jsxs43 } from "react/jsx-runtime";
var fragmentDef9 = NotificationsEmailContainer_email_graphql_default;
var NotificationsEmailContainer = ({ fragmentRef }) => {
  const data = useFragment5(fragmentDef9, fragmentRef);
  const eventRows = data.emailEvents.map((e) => {
    return /* @__PURE__ */ jsx70(
      "li",
      {
        className: classNames3(
          "focus-within:ring-info-600 relative cursor-pointer rounded-lg border px-6 py-5 focus-within:ring-2 focus-within:ring-inset hover:bg-gray-50"
        ),
        children: /* @__PURE__ */ jsxs43("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ jsx70("div", { className: "text-md text-gray-500", children: timeAgo14(e.occuredAt) }),
          /* @__PURE__ */ jsx70("div", { className: "text-md text-gray-500", children: e.eventType })
        ] })
      },
      e.id
    );
  });
  return /* @__PURE__ */ jsxs43("div", { className: "flex flex-col gap-2 border p-4", children: [
    /* @__PURE__ */ jsxs43("div", { className: "flex items-center gap-2 border-b p-2", children: [
      /* @__PURE__ */ jsx70("div", { className: "text-primary-500 text-lg font-bold", children: "Email" }),
      /* @__PURE__ */ jsx70("div", { className: "text-md text-primary-500", children: timeAgo14(data.createdAt) })
    ] }),
    /* @__PURE__ */ jsx70("div", { className: "p-2", children: /* @__PURE__ */ jsx70("div", { className: "text-primary-500 text-sm font-bold", children: "Events" }) }),
    /* @__PURE__ */ jsx70("ul", { className: "mt-2 flex flex-col gap-2", children: eventRows })
  ] });
};

// src/secure/accounts/candidates/components/EmailNotificationContainer.tsx
import { Fragment as Fragment32, jsx as jsx71, jsxs as jsxs44 } from "react/jsx-runtime";
var queryDef34 = EmailNotificationContainerRouteQuery_graphql_default;
async function loader31(environment, params) {
  const code = params.notificationCode;
  const notificationCode = parseInt(code);
  try {
    return loadQuery31(
      environment,
      queryDef34,
      {
        notificationCode
      }
    );
  } catch (e) {
    console.error("EmailNotificationContainer Loader Failed.");
    console.error(e);
    throw e;
  }
}
var EmailNotificationContainer = ({ routeId: routeId6 }) => {
  const [selectedId, setSelectedId] = useState11(null);
  const clearSelected = useCallback29(() => {
    setSelectedId(null);
  }, [setSelectedId]);
  const data = useRouteData22(
    queryDef34,
    routeId6
  );
  if (!data) {
    return /* @__PURE__ */ jsx71(Fragment32, { children: "Loading..." });
  }
  const { notification } = data;
  if (!notification) {
    return /* @__PURE__ */ jsx71(Fragment32, { children: "Loading..." });
  }
  const emails = notification.emails || [];
  const emailRows = emails.map((item) => {
    return /* @__PURE__ */ jsxs44("tr", { children: [
      /* @__PURE__ */ jsx71("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx71("div", { className: "text-gray-900", children: timeAgo15(item.createdAt) }) }),
      /* @__PURE__ */ jsx71("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx71("div", { className: "text-gray-900", children: item.providerType }) }),
      /* @__PURE__ */ jsx71("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx71(BooleanIcon, { value: item.wasClicked }) }),
      /* @__PURE__ */ jsx71("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx71(BooleanIcon, { value: item.wasDelivered }) }),
      /* @__PURE__ */ jsx71("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx71(BooleanIcon, { value: item.wasHardBounced }) }),
      /* @__PURE__ */ jsx71("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx71(BooleanIcon, { value: item.wasMarkedAsSpam }) }),
      /* @__PURE__ */ jsx71("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx71(BooleanIcon, { value: item.wasOpened }) }),
      /* @__PURE__ */ jsx71("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx71(BooleanIcon, { value: item.wasSent }) }),
      /* @__PURE__ */ jsx71("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx71(BooleanIcon, { value: item.wasSoftBounced }) }),
      /* @__PURE__ */ jsx71("td", { className: "whitespace-nowrap py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx71(
        LinkButton,
        {
          label: "Select",
          clicked: () => setSelectedId(item.emailId)
        }
      ) })
    ] }, item.id);
  });
  let displaySelected = null;
  if (selectedId) {
    const selected = emails.find((e) => e.emailId === selectedId);
    if (selected) {
      displaySelected = /* @__PURE__ */ jsx71(NotificationsEmailContainer, { fragmentRef: selected });
    }
  }
  return /* @__PURE__ */ jsx71(Suspense56, { fallback: /* @__PURE__ */ jsx71(EdSkeleton40, {}), children: /* @__PURE__ */ jsx71("div", { className: "flex", children: /* @__PURE__ */ jsxs44("div", { className: "flex flex-col gap-2 border bg-white p-4", children: [
    /* @__PURE__ */ jsxs44("div", { className: "my-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx71("div", { className: "text-primary-500 px-1 text-xl font-bold", children: "Notification" }),
      /* @__PURE__ */ jsxs44("div", { className: "text-primary-500 px-1 text-sm", children: [
        "Created ",
        timeAgo15(notification.createdAt)
      ] })
    ] }),
    displaySelected && /* @__PURE__ */ jsxs44("div", { className: "flex flex-col gap-2", children: [
      displaySelected,
      /* @__PURE__ */ jsx71("div", { className: "border bg-gray-50 px-4 py-2", children: /* @__PURE__ */ jsx71(Button17, { clicked: clearSelected, children: "Close" }) })
    ] }),
    /* @__PURE__ */ jsx71("div", { className: "mt-8 flow-root", children: /* @__PURE__ */ jsx71("div", { className: "-mx-4 -my-2 sm:-mx-6 lg:-mx-8", children: /* @__PURE__ */ jsx71("div", { className: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8", children: /* @__PURE__ */ jsxs44("table", { className: "min-w-full divide-y divide-gray-300 border", children: [
      /* @__PURE__ */ jsx71("thead", { children: /* @__PURE__ */ jsxs44("tr", { children: [
        /* @__PURE__ */ jsx71(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Created"
          }
        ),
        /* @__PURE__ */ jsx71(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Provider"
          }
        ),
        /* @__PURE__ */ jsx71(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Clicked"
          }
        ),
        /* @__PURE__ */ jsx71(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Delivered"
          }
        ),
        /* @__PURE__ */ jsx71(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Hard Bounced"
          }
        ),
        /* @__PURE__ */ jsx71(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Marked As Spam"
          }
        ),
        /* @__PURE__ */ jsx71(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Opened"
          }
        ),
        /* @__PURE__ */ jsx71(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Sent"
          }
        ),
        /* @__PURE__ */ jsx71(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Soft Bounced"
          }
        ),
        /* @__PURE__ */ jsx71(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Select"
          }
        )
      ] }) }),
      /* @__PURE__ */ jsx71("tbody", { className: "divide-y divide-gray-200 bg-white", children: emailRows })
    ] }) }) }) }),
    /* @__PURE__ */ jsxs44("div", { className: "mt-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx71("div", { className: "text-primary-500 px-1 text-sm font-bold", children: "Data" }),
      /* @__PURE__ */ jsx71("div", { className: "break-all border bg-yellow-50 p-4", children: /* @__PURE__ */ jsx71("p", { children: JSON.stringify(notification.emailNotificationData, null, 2) }) })
    ] })
  ] }) }) });
};
var createRoute20 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-email-notification`;
  return {
    id: routeId6,
    path: ":notificationCode",
    element: /* @__PURE__ */ jsx71(EmailNotificationContainer, { routeId: routeId6, inList }),
    loader: ({ params }) => {
      return loader31(environment, params);
    }
  };
};

// src/secure/accounts/candidates/components/__generated__/EmailNotificationListContainerQuery.graphql.ts
var node70 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailNotificationListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmailNotificationListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailNotificationListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "NotificationsEmailNotificationsConnection",
          "kind": "LinkedField",
          "name": "notificationsEmailNotifications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmailNotificationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NotificationsEmailNotification",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailNotificationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenant",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fromEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fromName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "toEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "toName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsEmailNotificationData",
                      "kind": "LinkedField",
                      "name": "emailNotificationData",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "data",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "dotnetType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsReceiver",
                      "kind": "LinkedField",
                      "name": "receiver",
                      "plural": false,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "receiverType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsNotificationAttribute",
                      "kind": "LinkedField",
                      "name": "attributes",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "type",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmailNotificationListContainer_list",
          "kind": "LinkedHandle",
          "name": "notificationsEmailNotifications"
        }
      ]
    },
    "params": {
      "cacheID": "5529309230957412f3600ffe9763df6b",
      "id": null,
      "metadata": {},
      "name": "EmailNotificationListContainerQuery",
      "operationKind": "query",
      "text": "query EmailNotificationListContainerQuery(\n  $where: NotificationsEmailNotificationFilter!\n) {\n  ...EmailNotificationListContainer_list\n}\n\nfragment EmailNotificationListContainer_list on Query {\n  list: notificationsEmailNotifications(first: 10, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        emailNotificationId\n        code\n        createdAt\n        tenant\n        fromEmail\n        fromName\n        toEmail\n        toName\n        emailNotificationData {\n          data\n          dotnetType\n        }\n        receiver {\n          id\n          receiverType\n        }\n        attributes {\n          type\n          value\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node70.hash = "ce499da0571872b70b00430112bc69e5";
var EmailNotificationListContainerQuery_graphql_default = node70;

// src/secure/accounts/candidates/components/__generated__/EmailNotificationsListContainerPaginationQuery.graphql.ts
var node71 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailNotificationsListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "EmailNotificationListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailNotificationsListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "NotificationsEmailNotificationsConnection",
          "kind": "LinkedField",
          "name": "notificationsEmailNotifications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmailNotificationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NotificationsEmailNotification",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailNotificationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenant",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fromEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fromName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "toEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "toName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsEmailNotificationData",
                      "kind": "LinkedField",
                      "name": "emailNotificationData",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "data",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "dotnetType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsReceiver",
                      "kind": "LinkedField",
                      "name": "receiver",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "receiverType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsNotificationAttribute",
                      "kind": "LinkedField",
                      "name": "attributes",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "type",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmailNotificationListContainer_list",
          "kind": "LinkedHandle",
          "name": "notificationsEmailNotifications"
        }
      ]
    },
    "params": {
      "cacheID": "cc93b6b00cc17005c2334ba21dd3ea82",
      "id": null,
      "metadata": {},
      "name": "EmailNotificationsListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query EmailNotificationsListContainerPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: NotificationsEmailNotificationFilter\n) {\n  ...EmailNotificationListContainer_list_2HEEH6\n}\n\nfragment EmailNotificationListContainer_list_2HEEH6 on Query {\n  list: notificationsEmailNotifications(first: $first, after: $after, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        emailNotificationId\n        code\n        createdAt\n        tenant\n        fromEmail\n        fromName\n        toEmail\n        toName\n        emailNotificationData {\n          data\n          dotnetType\n        }\n        receiver {\n          id\n          receiverType\n        }\n        attributes {\n          type\n          value\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node71.hash = "01099aaa05d2a09edc1e344b082fc3b5";
var EmailNotificationsListContainerPaginationQuery_graphql_default = node71;

// src/secure/accounts/candidates/components/__generated__/EmailNotificationListContainer_list.graphql.ts
var node72 = function() {
  var v0 = [
    "list"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmailNotificationsListContainerPaginationQuery_graphql_default
      }
    },
    "name": "EmailNotificationListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "createdAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "NotificationsEmailNotificationsConnection",
        "kind": "LinkedField",
        "name": "__EmailNotificationListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationsEmailNotificationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationsEmailNotification",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailNotificationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tenant",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fromEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fromName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "toEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "toName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationsEmailNotificationData",
                    "kind": "LinkedField",
                    "name": "emailNotificationData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "data",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dotnetType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationsReceiver",
                    "kind": "LinkedField",
                    "name": "receiver",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "receiverType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationsNotificationAttribute",
                    "kind": "LinkedField",
                    "name": "attributes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node72.hash = "01099aaa05d2a09edc1e344b082fc3b5";
var EmailNotificationListContainer_list_graphql_default = node72;

// src/secure/accounts/candidates/components/EmailNotificationListContainer.tsx
import { Suspense as Suspense57, useCallback as useCallback30, useState as useState12 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery9, usePaginationFragment as usePaginationFragment5 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow5, parseISO as parseISO5 } from "date-fns";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader5,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement5,
  EdSkeleton as EdSkeleton41,
  Input as Input5,
  ListLayout as ListLayout5
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined5, useDebounce as useDebounce5 } from "shared-lib";
import { jsx as jsx72, jsxs as jsxs45 } from "react/jsx-runtime";
var queryDef35 = EmailNotificationListContainerQuery_graphql_default;
var fragmentDef10 = EmailNotificationListContainer_list_graphql_default;
function createLinkTo5(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List4 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment5(fragmentDef10, fragmentRef);
  const onLoadNext = useCallback30(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined5).map((notification) => {
    const name = `${notification.toEmail}`;
    return {
      key: notification.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx72("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs45("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx72("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx72("div", { className: "text-md text-blue-500", children: notification.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs45("div", { className: "pt-2 text-sm", children: [
        "Created ",
        formatDistanceToNow5(parseISO5(notification.createdAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: notification.code
      },
      element: /* @__PURE__ */ jsx72(DefaultListLayoutSectionElement5, { children: /* @__PURE__ */ jsx72("div", { className: "grid", children: /* @__PURE__ */ jsx72("div", { children: notification.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx72(Suspense57, { fallback: /* @__PURE__ */ jsx72(EdSkeleton41, {}), children: /* @__PURE__ */ jsx72(
    ListLayout5,
    {
      title: "Notifications",
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx72(
        DefaultListLayoutItemHeader5,
        {
          title: "Notifications",
          to: createLinkTo5,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  ) });
};
var EmailNotificationsListContainer = ({ candidateId }) => {
  const [filter, setFilter] = useState12(null);
  const searchTerm = useDebounce5(filter, 500);
  const where2 = {
    receiver: {
      id: { eq: candidateId }
    }
  };
  if (searchTerm) {
    where2.or = [{ toEmail: { startsWith: filter } }];
  }
  const query = useLazyLoadQuery9(
    queryDef35,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs45("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx72("div", { className: "flex items-center justify-between space-x-4 border-b", children: /* @__PURE__ */ jsxs45("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx72("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx72("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx72(
        Input5,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx72("div", { className: "flex-1", children: /* @__PURE__ */ jsx72(List4, { fragmentRef: query }) })
  ] });
};

// src/secure/accounts/candidates/components/EmailNotifications.tsx
import { Fragment as Fragment33, jsx as jsx73 } from "react/jsx-runtime";
var EmailNotificationsList = ({ layoutRouteId }) => {
  const layoutData = useCandidateLayoutRouteData(layoutRouteId);
  const { candidate } = layoutData;
  if (!candidate) {
    return /* @__PURE__ */ jsx73(Fragment33, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx73(Suspense58, { fallback: /* @__PURE__ */ jsx73(EdSkeleton42, {}), children: /* @__PURE__ */ jsx73("div", { className: "border bg-white p-2", children: /* @__PURE__ */ jsx73(EmailNotificationsListContainer, { candidateId: candidate.accountId }) }) });
};
var createRoute21 = (routePrefix, environment, context, inList = true, layoutRouteId) => {
  const routeId6 = `${routePrefix}-email-notifications`;
  const listRouteId = `${routeId6}-list`;
  return {
    id: routeId6,
    path: "notifications",
    element: /* @__PURE__ */ jsx73(OutletRoute14, {}),
    handle: {
      crumb: () => /* @__PURE__ */ jsx73(Link24, { to: "notifications", children: "Notifications" })
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx73(
          EmailNotificationsList,
          {
            routeId: listRouteId,
            inList,
            layoutRouteId
          }
        ),
        children: [
          createRoute20(listRouteId, environment, context, inList)
        ]
      },
      createRoute20(routeId6, environment, context, inList),
      {
        path: "*",
        element: /* @__PURE__ */ jsx73(Navigate18, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/accounts/candidates/components/CandidateRoute.tsx
import { jsx as jsx74 } from "react/jsx-runtime";
var createCandidateRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const layoutRouteId = `${routePrefix}-candidate-layout`;
  return [
    {
      path: "*",
      id: layoutRouteId,
      element: /* @__PURE__ */ jsx74(CandidateLayout, { inList, showHeader }),
      errorElement: /* @__PURE__ */ jsx74(ErrorContainer9, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx74(CandidateLink, { routeId: layoutRouteId })
      },
      loader: ({ params }) => {
        return loader27(environment, params);
      },
      children: [
        createRoute16(routePrefix, environment, context, inList),
        createRoute17(routePrefix, environment, context, inList),
        createRoute19(routePrefix, environment, context, inList, layoutRouteId),
        createRoute21(
          routePrefix,
          environment,
          context,
          inList,
          layoutRouteId
        ),
        createCandidateImpersonateRoute(routePrefix, environment, context),
        {
          path: "*",
          element: /* @__PURE__ */ jsx74(Navigate19, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/candidates/components/CandidatesRoute.tsx
import { jsx as jsx75, jsxs as jsxs46 } from "react/jsx-runtime";
var Layout7 = () => {
  return /* @__PURE__ */ jsx75(Suspense59, { fallback: "Loading Employers...", children: /* @__PURE__ */ jsx75(ErrorBoundary7, { FallbackComponent: ErrorBoundaryFallback7, children: /* @__PURE__ */ jsxs46("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx75("div", { className: "flex items-center justify-between border-b bg-white px-4 py-2", children: /* @__PURE__ */ jsxs46("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ jsx75(EdLink4, { href: "../../", name: "List Candidates", children: /* @__PURE__ */ jsx75(Button18, { color: "primary", children: "Back" }) }),
      /* @__PURE__ */ jsx75(PageHeading3, { children: "Candidates" })
    ] }) }),
    /* @__PURE__ */ jsx75("div", { children: /* @__PURE__ */ jsx75(Outlet13, {}) })
  ] }) }) });
};
var ListRoute = () => {
  return /* @__PURE__ */ jsx75(Suspense59, { fallback: "Loading Candidates...", children: /* @__PURE__ */ jsx75(ErrorBoundary7, { FallbackComponent: ErrorBoundaryFallback7, children: /* @__PURE__ */ jsx75(CandidateAccountsListContainer, {}) }) });
};
var createCandidatesRoute = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-candidates`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx75(Layout7, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx75(ListRoute, {}),
          children: [
            {
              id: `${listRouteId}-candidate`,
              path: ":candidateCode/*",
              element: /* @__PURE__ */ jsx75(OutletRoute15, {}),
              children: createCandidateRoutes(
                `${listRouteId}-candidate`,
                environment,
                context,
                false,
                true
              )
            }
          ]
        },
        {
          id: `${routeId6}-candidate`,
          path: ":candidateCode/*",
          element: /* @__PURE__ */ jsx75(OutletRoute15, {}),
          children: createCandidateRoutes(
            `${routePrefix}-candidate`,
            environment,
            context,
            true,
            false
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx75(Navigate20, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/AccountsLayout.tsx
import { jsx as jsx76, jsxs as jsxs47 } from "react/jsx-runtime";
var tabs = [
  {
    label: "Employers",
    to: "../employers",
    description: "Administer Employer Accounts & Users"
  },
  {
    label: "Candidates",
    to: "../candidates",
    description: "Administer Candidate Accounts"
  },
  {
    label: "Administrators",
    to: "../administrators",
    description: "Administer Internal Accounts"
  },
  {
    label: "Identity",
    to: "../identity",
    description: "Administer Identity Accounts"
  }
];
var AccountsHomeList = () => {
  const links = tabs.map((t) => {
    return /* @__PURE__ */ jsxs47(
      EdLink5,
      {
        name: t.label,
        href: t.to,
        className: "border bg-white p-8",
        children: [
          /* @__PURE__ */ jsx76("div", { className: "text-primary-500 py-2 text-xl", children: t.label }),
          /* @__PURE__ */ jsx76("p", { className: "mt-2 py-2  text-sm text-gray-500", children: t.description })
        ]
      },
      t.to
    );
  });
  return /* @__PURE__ */ jsx76(Suspense60, { fallback: "Loading...", children: /* @__PURE__ */ jsx76(ErrorBoundary8, { FallbackComponent: ErrorBoundaryFallback8, children: /* @__PURE__ */ jsx76("div", { className: "flex sm:m-8", children: /* @__PURE__ */ jsx76("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-3", children: links }) }) }) });
};
var createAppAdminAccountsRoutes = (environment, context) => {
  return [
    {
      path: "home/*",
      element: /* @__PURE__ */ jsx76(AccountsHomeList, {})
    },
    {
      path: "candidates/*",
      element: /* @__PURE__ */ jsx76(OutletRoute16, {}),
      children: createCandidatesRoute("admin-candidates", environment, context)
    },
    {
      path: "employers/*",
      element: /* @__PURE__ */ jsx76(OutletRoute16, {}),
      children: createEmployersRoutes("admin-employers", environment, context)
    },
    {
      path: "administrators/*",
      element: /* @__PURE__ */ jsx76(OutletRoute16, {}),
      children: createAdminRoutes("admin-administrators", environment, context)
    },
    {
      path: "identity/*",
      element: /* @__PURE__ */ jsx76(OutletRoute16, {}),
      children: createIdentityRoutes("admin-identity", environment, context)
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx76(Navigate21, { to: "home", replace: true })
    }
  ];
};

// src/secure/index.ts
__reExport(secure_exports, accounts_exports);

// src/secure/integrations/bullhorn/pages/BullhornLayoutPage.tsx
import { Suspense as Suspense66 } from "react";
import { Route as Route3, Routes as Routes3, useNavigate as useNavigate18 } from "react-router-dom";
import { EdSkeleton as EdSkeleton48 } from "shared-ui";

// src/secure/integrations/bullhorn/pages/__generated__/BullhornTenantDetailsPageQuery.graphql.ts
var node73 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tenantId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v6 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantDetailsPageQuery",
      "selections": [
        {
          "alias": "tenant",
          "args": v1,
          "concreteType": "BullhornTenant",
          "kind": "LinkedField",
          "name": "bullhornTenantById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BullhornTenantDetail_bullhornTenant"
            },
            v6
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantDetailsPageQuery",
      "selections": [
        {
          "alias": "tenant",
          "args": v1,
          "concreteType": "BullhornTenant",
          "kind": "LinkedField",
          "name": "bullhornTenantById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f58ef692d26fdbb338910d0100dd8e19",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantDetailsPageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantDetailsPageQuery(\n  $id: UUID!\n) {\n  tenant: bullhornTenantById(id: $id) {\n    id\n    name\n    tenantId\n    employerId\n    ...BullhornTenantDetail_bullhornTenant\n  }\n}\n\nfragment BullhornTenantDetail_bullhornTenant on BullhornTenant {\n  id\n  name\n  tenantId\n}\n"
    }
  };
}();
node73.hash = "221b77f104dd7740b51bc05466f01915";
var BullhornTenantDetailsPageQuery_graphql_default = node73;

// src/secure/integrations/bullhorn/pages/BullhornTenantDetailsPage.tsx
import { useCallback as useCallback38, useMemo as useMemo9 } from "react";
import {
  Routes,
  Route,
  useParams as useParams8,
  useLocation as useLocation10,
  useNavigate as useNavigate17
} from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery19 } from "react-relay";
import { CircleStackIcon as CircleStackIcon2, UserIcon as UserIcon2 } from "@heroicons/react/24/solid";
import {
  Breadcrumbs,
  createLinkState as createLinkState9,
  TabUnderline as TabUnderline7
} from "shared-ui";
import { BullhornTenantDetail } from "feature-integrations";

// src/secure/integrations/bullhorn/pages/__generated__/BullhornTenantCandidatesPageQuery.graphql.ts
var node74 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedOn": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantCandidatesPageQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BullhornCandidatesList_bullhornCandidates"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantCandidatesPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "BullhornCandidatesConnection",
          "kind": "LinkedField",
          "name": "bullhornCandidates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornCandidatesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornCandidate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mappingStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorMessage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitProfileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitSyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vaultProfileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vaultSyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornCandidateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornSyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "BullhornCandidatesList_bullhornCandidates",
          "kind": "LinkedHandle",
          "name": "bullhornCandidates"
        }
      ]
    },
    "params": {
      "cacheID": "a3b5f4e1bd93a54d741794cbeb9c0aed",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantCandidatesPageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantCandidatesPageQuery(\n  $tenantId: UUID!\n  $where: BullhornCandidateFilter!\n) {\n  ...BullhornCandidatesList_bullhornCandidates\n}\n\nfragment BullhornCandidateRow_bullhornCandidate on BullhornCandidate {\n  id\n  bullhornCandidateId\n  status\n  createdOn\n  updatedOn\n  candidateId\n  description\n  firstName\n  lastName\n  email\n  mappingStatus\n  lastErrorCode\n  lastErrorMessage\n  recruitProfileId\n  recruitSyncStatus\n  vaultProfileId\n  vaultSyncStatus\n  bullhornSyncStatus\n}\n\nfragment BullhornCandidatesList_bullhornCandidates on Query {\n  bullhornCandidates(tenantId: $tenantId, first: 10, order: [{updatedOn: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        candidateId\n        firstName\n        lastName\n        email\n        createdOn\n        updatedOn\n        status\n        mappingStatus\n        lastErrorCode\n        lastErrorMessage\n        recruitProfileId\n        recruitSyncStatus\n        vaultProfileId\n        vaultSyncStatus\n        ...BullhornCandidateRow_bullhornCandidate\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node74.hash = "b444d4df3ffe989914d4ea82f8676375";
var BullhornTenantCandidatesPageQuery_graphql_default = node74;

// src/secure/integrations/bullhorn/pages/BullhornTenantCandidatesPage.tsx
import { useCallback as useCallback31, useState as useState13 } from "react";
import { useParams } from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery10 } from "react-relay";
import { BullhornCandidatesList } from "feature-integrations";
import { useDebounce as useDebounce6 } from "shared-lib";
import { Input as Input6, RadioList } from "shared-ui";
import { jsx as jsx77, jsxs as jsxs48 } from "react/jsx-runtime";
var graphqlQuery = BullhornTenantCandidatesPageQuery_graphql_default;
var statusList = [
  {
    id: "All",
    label: "All"
  },
  {
    id: "Done",
    label: "Done"
  },
  {
    id: "Pending",
    label: "Pending"
  },
  {
    id: "Failed",
    label: "Failed"
  }
];
var BullhornTenantCandidatesPage = ({
  onSelect,
  tenant
}) => {
  const { tenantId } = useParams();
  if (!tenantId) {
    throw Error("tenantId Required");
  }
  const [filter, setFilter] = useState13(null);
  const [mappingStatus, setMappingStatus] = useState13(statusList[0]);
  const onMappingStatusChanged = useCallback31(
    (ms) => {
      setMappingStatus(ms);
    },
    [mappingStatus]
  );
  const [recruitSyncStatus, setRecruitSyncStatus] = useState13(
    statusList[0]
  );
  const onRecruitSyncStatusChanged = useCallback31(
    (ms) => {
      setRecruitSyncStatus(ms);
    },
    [recruitSyncStatus]
  );
  const [vaultSyncStatus, setVaultSyncStatus] = useState13(
    statusList[0]
  );
  const onVaultSyncStatusChanged = useCallback31(
    (ms) => {
      setVaultSyncStatus(ms);
    },
    [vaultSyncStatus]
  );
  const searchTerm = useDebounce6(filter, 500);
  const where2 = {
    tenantId: { eq: tenant.tenantId }
  };
  if (recruitSyncStatus && recruitSyncStatus.id !== "All") {
    where2.recruitSyncStatus = { eq: recruitSyncStatus.id };
  }
  if (vaultSyncStatus && vaultSyncStatus.id !== "All") {
    where2.vaultSyncStatus = { eq: vaultSyncStatus.id };
  }
  if (mappingStatus && mappingStatus.id !== "All") {
    where2.mappingStatus = { eq: mappingStatus.id };
  }
  if (searchTerm) {
    where2.or = [
      { email: { startsWith: filter } },
      { firstName: { startsWith: filter } },
      { lastName: { startsWith: filter } }
    ];
  }
  const query = useLazyLoadQuery10(
    graphqlQuery,
    { tenantId, where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs48("div", { children: [
    /* @__PURE__ */ jsxs48("div", { className: "flex items-center space-x-4", children: [
      /* @__PURE__ */ jsxs48("div", { className: "flex items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx77("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
        /* @__PURE__ */ jsx77("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx77(
          Input6,
          {
            placeholder: " Name or Email ",
            name: "filter",
            onValueChange: (filter2) => setFilter(filter2)
          },
          "filter"
        ) })
      ] }),
      /* @__PURE__ */ jsxs48("div", { className: "flex items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx77("label", { className: "text-gray-700", htmlFor: "filter", children: "Mapping" }),
        /* @__PURE__ */ jsx77("div", { children: /* @__PURE__ */ jsx77(
          RadioList,
          {
            list: statusList,
            value: mappingStatus,
            onChange: (status) => onMappingStatusChanged(status)
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs48("div", { className: "flex items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx77("label", { className: "text-gray-700", htmlFor: "filter", children: "Vault" }),
        /* @__PURE__ */ jsx77("div", { children: /* @__PURE__ */ jsx77(
          RadioList,
          {
            list: statusList,
            value: vaultSyncStatus,
            onChange: (status) => onVaultSyncStatusChanged(status)
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs48("div", { className: "flex items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx77("label", { className: "text-gray-700", htmlFor: "filter", children: "Recruit" }),
        /* @__PURE__ */ jsx77("div", { children: /* @__PURE__ */ jsx77(
          RadioList,
          {
            list: statusList,
            value: recruitSyncStatus,
            onChange: (status) => onRecruitSyncStatusChanged(status)
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ jsx77("div", { children: /* @__PURE__ */ jsx77(
      BullhornCandidatesList,
      {
        onSelect,
        bullhornCandidatesKey: query
      }
    ) })
  ] });
};

// src/secure/integrations/bullhorn/pages/__generated__/BullhornTenantJobOrdersPageQuery.graphql.ts
var node75 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tenantId"
  }, v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v3 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v2
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantJobOrdersPageQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BullhornJobOrderList_bullhornJobOrders"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0,
        v2
      ],
      "kind": "Operation",
      "name": "BullhornTenantJobOrdersPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "BullhornJobOrdersConnection",
          "kind": "LinkedField",
          "name": "bullhornJobOrders",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornJobOrdersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornJobOrder",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobOrderId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "dateAdded",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancySyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornJobOrderId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornJobSubmission",
                      "kind": "LinkedField",
                      "name": "jobSubmissions",
                      "plural": true,
                      "selections": [
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "BullhornJobOrderList_bullhornJobOrders",
          "kind": "LinkedHandle",
          "name": "bullhornJobOrders"
        }
      ]
    },
    "params": {
      "cacheID": "c5685456d1abe128457b886f7005f55a",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantJobOrdersPageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantJobOrdersPageQuery(\n  $tenantId: UUID!\n  $order: [BullhornJobOrderSort!]!\n  $where: BullhornJobOrderFilter!\n) {\n  ...BullhornJobOrderList_bullhornJobOrders\n}\n\nfragment BullhornJobOrderList_bullhornJobOrders on Query {\n  bullhornJobOrders(tenantId: $tenantId, first: 10, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobOrderId\n        dateAdded\n        updatedOn\n        title\n        status\n        vacancySyncStatus\n        ...BullhornJobOrderRow_bullhornJobOrder\n        __typename\n      }\n    }\n  }\n}\n\nfragment BullhornJobOrderRow_bullhornJobOrder on BullhornJobOrder {\n  id\n  jobOrderId\n  bullhornJobOrderId\n  dateAdded\n  updatedOn\n  title\n  status\n  vacancySyncStatus\n  jobSubmissions {\n    id\n  }\n}\n"
    }
  };
}();
node75.hash = "3dad65f3e2de0c4bc0075f668327d44c";
var BullhornTenantJobOrdersPageQuery_graphql_default = node75;

// src/secure/integrations/bullhorn/pages/BullhornTenantJobOrdersPage.tsx
import { Suspense as Suspense61, useCallback as useCallback32, useState as useState14 } from "react";
import { useParams as useParams2 } from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery11 } from "react-relay";
import {
  BullhornJobOrderList,
  JobOrderDownloadForm
} from "feature-integrations";
import { Button as Button19, EdSkeleton as EdSkeleton43, Input as Input7, RadioList as RadioList2 } from "shared-ui";
import { useDebounce as useDebounce7, useToggle as useToggle7 } from "shared-lib";
import { jsx as jsx78, jsxs as jsxs49 } from "react/jsx-runtime";
var graphqlQuery2 = BullhornTenantJobOrdersPageQuery_graphql_default;
var statusList2 = [
  {
    id: "All",
    label: "All"
  },
  {
    id: "Synced",
    label: "Synced"
  },
  {
    id: "Pending",
    label: "Pending"
  },
  {
    id: "Failed",
    label: "Failed"
  }
];
var BullhornTenantJobOrdersPage = ({
  tenant,
  onSelect
}) => {
  const { tenantId } = useParams2();
  if (!tenantId) {
    throw Error("tenantId Required");
  }
  const [isDownloading, toggleIsDownloading] = useToggle7(false);
  const onToggleIsDownloading = useCallback32(() => {
    toggleIsDownloading();
  }, []);
  const [filter, setFilter] = useState14(null);
  const searchTerm = useDebounce7(filter, 500);
  const [vacancySyncStatus, setVacancySyncStatus] = useState14(
    statusList2[0]
  );
  const onSetVacancySyncStatus = useCallback32(
    (ms) => {
      setVacancySyncStatus(ms);
    },
    [vacancySyncStatus]
  );
  const order2 = [{ updatedOn: "DESC" }];
  const where2 = {
    tenantId: { eq: tenant.tenantId }
  };
  if (vacancySyncStatus && vacancySyncStatus.id !== "All") {
    where2.vacancySyncStatus = { eq: vacancySyncStatus.id };
  }
  if (searchTerm && filter) {
    let or = [{ title: { startsWith: filter } }];
    const code = Number(filter);
    if (!isNaN(code)) {
      or = [...or, { bullhornJobOrderId: { eq: code } }];
    }
    where2.or = or;
  }
  const query = useLazyLoadQuery11(
    graphqlQuery2,
    { tenantId, where: where2, order: order2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx78(Suspense61, { fallback: /* @__PURE__ */ jsx78(EdSkeleton43, {}), children: /* @__PURE__ */ jsxs49("div", { children: [
    /* @__PURE__ */ jsxs49("div", { className: "flex items-center justify-between space-x-4", children: [
      /* @__PURE__ */ jsxs49("div", { className: "flex items-center space-x-4", children: [
        /* @__PURE__ */ jsxs49("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx78("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
          /* @__PURE__ */ jsx78("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx78(
            Input7,
            {
              placeholder: " Title or Bullhorn Code ",
              name: "filter",
              onValueChange: (filter2) => setFilter(filter2)
            },
            "filter"
          ) })
        ] }),
        /* @__PURE__ */ jsxs49("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx78("label", { className: "text-gray-700", htmlFor: "filter", children: "Sync Status" }),
          /* @__PURE__ */ jsx78("div", { children: /* @__PURE__ */ jsx78(
            RadioList2,
            {
              list: statusList2,
              value: vacancySyncStatus,
              onChange: (status) => onSetVacancySyncStatus(status)
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsx78("div", { className: "flex items-center space-x-4 p-2", children: /* @__PURE__ */ jsx78(
        Button19,
        {
          className: "p-2",
          color: "primary",
          clicked: onToggleIsDownloading,
          children: isDownloading ? "Cancel Downloading" : "Download A JobOrder"
        }
      ) })
    ] }),
    isDownloading === false && /* @__PURE__ */ jsx78(
      BullhornJobOrderList,
      {
        onSelect,
        bullhornJobOrdersKey: query
      }
    ),
    isDownloading && /* @__PURE__ */ jsx78(
      JobOrderDownloadForm,
      {
        tenantId: tenant.tenantId,
        onDone: onToggleIsDownloading,
        onFail: (e) => (
          /* eslint-disable-next-line no-console */
          console.error(e)
        )
      }
    )
  ] }) });
};

// src/secure/integrations/bullhorn/pages/__generated__/BullhornTenantEventsPageQuery.graphql.ts
var node76 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdOn": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantEventsPageQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BullhornEventsList_bullhornStandardEvents"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantEventsPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "BullhornStandardEventsConnection",
          "kind": "LinkedField",
          "name": "bullhornStandardEvents",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornStandardEventsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornStandardEvent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityEventType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "standardEventId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "requestId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventTimestamp",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedProperties",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityProcessResult",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "BullhornEventsList_bullhornStandardEvents",
          "kind": "LinkedHandle",
          "name": "bullhornStandardEvents"
        }
      ]
    },
    "params": {
      "cacheID": "32824349ea4d250072dbd05cd042701a",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantEventsPageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantEventsPageQuery(\n  $tenantId: UUID!\n  $where: BullhornStandardEventFilter\n) {\n  ...BullhornEventsList_bullhornStandardEvents\n}\n\nfragment BullhornEventRow_bullhornStandardEvent on BullhornStandardEvent {\n  id\n  status\n  standardEventId\n  createdOn\n  requestId\n  entityName\n  entityEventType\n  eventId\n  eventTimestamp\n  eventType\n  updatedProperties\n  entityProcessResult\n}\n\nfragment BullhornEventsList_bullhornStandardEvents on Query {\n  bullhornStandardEvents(tenantId: $tenantId, first: 10, order: [{createdOn: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityName\n        entityEventType\n        ...BullhornEventRow_bullhornStandardEvent\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node76.hash = "8fcb3c8987e37c0f96e1ad715647747c";
var BullhornTenantEventsPageQuery_graphql_default = node76;

// src/secure/integrations/bullhorn/pages/BullhornTenantEventsPage.tsx
import { useCallback as useCallback33, useState as useState15 } from "react";
import { useParams as useParams3 } from "react-router-dom";
import {
  ConnectionHandler as ConnectionHandler3,
  useLazyLoadQuery as useLazyLoadQuery12,
  useRelayEnvironment
} from "react-relay";
import {
  AllEntityEventTypes,
  EntityEventTypes,
  BullhornEventsList,
  ProcessStandardEventMutation
} from "feature-integrations";
import { logInfo, useDebounce as useDebounce8 } from "shared-lib";
import { Button as Button20, Input as Input8, RadioList as RadioList3 } from "shared-ui";
import { jsx as jsx79, jsxs as jsxs50 } from "react/jsx-runtime";
var graphqlQuery3 = BullhornTenantEventsPageQuery_graphql_default;
var BullhornTenantEventsPage = ({
  tenant
}) => {
  const { tenantId } = useParams3();
  if (!tenantId) {
    throw Error("tenantId Required");
  }
  const [selectedEvent, setSelectedEvent] = useState15(null);
  const [filter, setFilter] = useState15(null);
  const [entityEventType, setEntityEventType] = useState15(
    EntityEventTypes[0]
  );
  const onEntityEventTypeChanged = useCallback33(
    (ms) => {
      setEntityEventType(ms);
    },
    [entityEventType]
  );
  const environment = useRelayEnvironment();
  const connectionId = ConnectionHandler3.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornEventsList_bullhornStandardEvents"
  );
  const onSelect = useCallback33((event) => {
    setSelectedEvent(event);
  }, []);
  function processEvent(standardEvent) {
    logInfo(JSON.stringify(standardEvent));
    const input = {
      id: standardEvent.standardEventId
    };
    ProcessStandardEventMutation.commit(
      environment,
      input,
      connectionId,
      () => {
        alert("Processed Event");
      }
    );
  }
  const searchTerm = useDebounce8(filter, 500);
  const where2 = {
    tenantId: { eq: tenant.tenantId }
  };
  if (searchTerm) {
    where2.or = [
      { eventType: { startsWith: filter } },
      { entityName: { startsWith: filter } }
    ];
  }
  if (entityEventType && entityEventType.id !== AllEntityEventTypes) {
    where2.entityEventType = { eq: entityEventType.id };
  }
  const query = useLazyLoadQuery12(
    graphqlQuery3,
    { tenantId, where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs50("div", { children: [
    !selectedEvent && /* @__PURE__ */ jsxs50("div", { children: [
      /* @__PURE__ */ jsxs50("div", { className: "flex items-center space-x-4", children: [
        /* @__PURE__ */ jsxs50("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx79("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
          /* @__PURE__ */ jsx79("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx79(
            Input8,
            {
              placeholder: " Event Type, Entity Name ",
              name: "filter",
              onValueChange: (filter2) => setFilter(filter2)
            },
            "filter"
          ) })
        ] }),
        /* @__PURE__ */ jsxs50("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx79("label", { className: "text-gray-700", htmlFor: "filter", children: "Mapping Status" }),
          /* @__PURE__ */ jsx79("div", { children: /* @__PURE__ */ jsx79(
            RadioList3,
            {
              list: EntityEventTypes,
              value: entityEventType,
              onChange: (status) => onEntityEventTypeChanged(status)
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsx79(
        BullhornEventsList,
        {
          onSelect,
          bullhornStandardEventsKey: query
        }
      )
    ] }),
    selectedEvent && /* @__PURE__ */ jsxs50("div", { className: "mt-2 border border-gray-200 p-4", children: [
      /* @__PURE__ */ jsxs50("div", { className: "flex", children: [
        /* @__PURE__ */ jsx79("div", { className: "px-2", children: selectedEvent.eventType }),
        /* @__PURE__ */ jsx79("div", { className: "px-2", children: selectedEvent.entityName }),
        /* @__PURE__ */ jsx79("div", { className: "px-2", children: selectedEvent.entityEventType })
      ] }),
      /* @__PURE__ */ jsx79("div", { className: "mt-2 bg-gray-100 p-4", children: /* @__PURE__ */ jsx79(Button20, { clicked: () => processEvent(selectedEvent), children: "Process" }) })
    ] })
  ] });
};

// src/secure/integrations/bullhorn/pages/__generated__/BullhornTenantJobOrderPageQuery.graphql.ts
var node77 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "jobOrderId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "jobOrderId"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tenantId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobOrderId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bullhornJobOrderId",
    "storageKey": null
  }, v6 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantJobOrderPageQuery",
      "selections": [
        {
          "alias": "jobOrder",
          "args": v1,
          "concreteType": "BullhornJobOrder",
          "kind": "LinkedField",
          "name": "bullhornJobOrderById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BullhornJobOrderDetail_bullhornJobOrder"
            },
            v6
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantJobOrderPageQuery",
      "selections": [
        {
          "alias": "jobOrder",
          "args": v1,
          "concreteType": "BullhornJobOrder",
          "kind": "LinkedField",
          "name": "bullhornJobOrderById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancySyncStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dateAdded",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornPerson",
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornJobOrderCustomData",
              "kind": "LinkedField",
              "name": "customData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText4",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText5",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText6",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText7",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText8",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText9",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText10",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText11",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText12",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText13",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText14",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText15",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText16",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText17",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText18",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText19",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText20",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText21",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText22",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText23",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText24",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText25",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText26",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText27",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText28",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText29",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText30",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText31",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText32",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText33",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText34",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText35",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText36",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText37",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText38",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText39",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText40",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt4",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt5",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt6",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt7",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt8",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock4",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock5",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomText1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomText2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomText3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomText4",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomText5",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomText6",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomText7",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomText8",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomText9",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomText10",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomFloat1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomFloat2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomFloat3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomDate1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomDate2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomDate3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomInt1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomInt2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomInt3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomTextBlock1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomTextBlock2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correlatedCustomTextBlock3",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v6
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8a5f4e435b844531ac651bd19da3f53d",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantJobOrderPageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantJobOrderPageQuery(\n  $jobOrderId: UUID!\n) {\n  jobOrder: bullhornJobOrderById(id: $jobOrderId) {\n    id\n    tenantId\n    jobOrderId\n    bullhornJobOrderId\n    ...BullhornJobOrderDetail_bullhornJobOrder\n  }\n}\n\nfragment BullhornJobOrderCustomFields_bullhornJobOrder on BullhornJobOrder {\n  id\n  jobOrderId\n  customData {\n    customText1\n    customText2\n    customText3\n    customText4\n    customText5\n    customText6\n    customText7\n    customText8\n    customText9\n    customText10\n    customText11\n    customText12\n    customText13\n    customText14\n    customText15\n    customText16\n    customText17\n    customText18\n    customText19\n    customText20\n    customText21\n    customText22\n    customText23\n    customText24\n    customText25\n    customText26\n    customText27\n    customText28\n    customText29\n    customText30\n    customText31\n    customText32\n    customText33\n    customText34\n    customText35\n    customText36\n    customText37\n    customText38\n    customText39\n    customText40\n    customDate1\n    customDate2\n    customDate3\n    customInt1\n    customInt2\n    customInt3\n    customInt4\n    customInt5\n    customInt6\n    customInt7\n    customInt8\n    customFloat1\n    customFloat2\n    customFloat3\n    customTextBlock1\n    customTextBlock2\n    customTextBlock3\n    customTextBlock4\n    customTextBlock5\n    correlatedCustomText1\n    correlatedCustomText2\n    correlatedCustomText3\n    correlatedCustomText4\n    correlatedCustomText5\n    correlatedCustomText6\n    correlatedCustomText7\n    correlatedCustomText8\n    correlatedCustomText9\n    correlatedCustomText10\n    correlatedCustomFloat1\n    correlatedCustomFloat2\n    correlatedCustomFloat3\n    correlatedCustomDate1\n    correlatedCustomDate2\n    correlatedCustomDate3\n    correlatedCustomInt1\n    correlatedCustomInt2\n    correlatedCustomInt3\n    correlatedCustomTextBlock1\n    correlatedCustomTextBlock2\n    correlatedCustomTextBlock3\n  }\n}\n\nfragment BullhornJobOrderDetail_bullhornJobOrder on BullhornJobOrder {\n  id\n  jobOrderId\n  title\n  bullhornJobOrderId\n  description\n  vacancySyncStatus\n  vacancyStatus\n  vacancyId\n  dateAdded\n  createdOn\n  updatedOn\n  owner {\n    userId\n    firstName\n    lastName\n  }\n  ...BullhornJobOrderCustomFields_bullhornJobOrder\n}\n"
    }
  };
}();
node77.hash = "815f06a184f3c6ca2b8f075b40971cae";
var BullhornTenantJobOrderPageQuery_graphql_default = node77;

// src/secure/integrations/bullhorn/pages/BullhornTenantJobOrderPage.tsx
import { useParams as useParams4 } from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery13 } from "react-relay";
import { ButtonTabPills, PageHeading as PageHeading4, useTabs } from "shared-ui";
import {
  BullhornJobOrderDetail,
  BullhornJobOrderJobSubmissionsList,
  CreateJobSubmissionsButton,
  RefreshJobOrderButton,
  SyncJobOrderButton,
  SubmitPendingJobSubmissionsButton,
  VacancyContainer
} from "feature-integrations";
import { jsx as jsx80, jsxs as jsxs51 } from "react/jsx-runtime";
var graphqlQuery4 = BullhornTenantJobOrderPageQuery_graphql_default;
var BullhornTenantJobOrderPage = ({
  tenant,
  onSelectJobSubmission
}) => {
  const { jobOrderId } = useParams4();
  if (!jobOrderId) {
    throw Error("JobOrderId Required");
  }
  const query = useLazyLoadQuery13(
    graphqlQuery4,
    { jobOrderId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const [current, tabLinks] = useTabs([
    { name: "Details" },
    { name: "Job Submissions" },
    { name: "Vacancy" }
  ]);
  const { jobOrder } = query;
  if (!jobOrder) {
    return /* @__PURE__ */ jsx80("div", { children: "Loading...." });
  }
  let currentTab;
  switch (current.name) {
    case "Details": {
      currentTab = /* @__PURE__ */ jsx80("div", { className: "m-2 flex-1", children: /* @__PURE__ */ jsx80(
        BullhornJobOrderDetail,
        {
          bullhornJobOrder: jobOrder,
          employerId: tenant.employerId,
          actions: /* @__PURE__ */ jsxs51("div", { className: "flex flex-wrap space-x-4 p-4", children: [
            /* @__PURE__ */ jsx80(
              SyncJobOrderButton,
              {
                color: "warning",
                onDone: () => {
                  alert("Stared JobOrder Sync");
                },
                jobOrderId: jobOrder.jobOrderId
              }
            ),
            /* @__PURE__ */ jsx80(
              RefreshJobOrderButton,
              {
                color: "warning",
                onDone: () => {
                  alert("Refresh JobOrder Started");
                },
                jobOrderId: jobOrder.jobOrderId
              }
            ),
            /* @__PURE__ */ jsx80(
              SubmitPendingJobSubmissionsButton,
              {
                color: "warning",
                onDone: () => {
                  alert("Requested");
                },
                jobOrderId: jobOrder.jobOrderId
              }
            ),
            /* @__PURE__ */ jsx80(
              CreateJobSubmissionsButton,
              {
                color: "warning",
                title: "Create JobSubmissions",
                onDone: () => {
                  alert("Stared JobOrder Sync");
                },
                jobOrderId: jobOrder.jobOrderId
              }
            )
          ] })
        }
      ) });
      break;
    }
    case "Job Submissions": {
      currentTab = /* @__PURE__ */ jsxs51("div", { className: "m-1 flex-1", children: [
        /* @__PURE__ */ jsx80(PageHeading4, { children: "Job Submissions" }),
        /* @__PURE__ */ jsx80(
          BullhornJobOrderJobSubmissionsList,
          {
            jobOrderId: jobOrder.jobOrderId,
            tenant,
            onSelect: onSelectJobSubmission
          }
        )
      ] });
      break;
    }
    case "Vacancy": {
      currentTab = /* @__PURE__ */ jsx80("div", { className: "m-1 flex-1", children: /* @__PURE__ */ jsx80(
        VacancyContainer,
        {
          externalVacancyId: jobOrder.bullhornJobOrderId.toString(),
          noVacancyContent: /* @__PURE__ */ jsxs51("div", { className: "border bg-white p-8", children: [
            /* @__PURE__ */ jsx80("div", { className: "pb-3 text-lg font-medium text-gray-500", children: "No Vacancy Found For Job Order" }),
            /* @__PURE__ */ jsx80(
              SyncJobOrderButton,
              {
                title: "Create Now",
                color: "warning",
                onDone: () => {
                  alert("Stared JobOrder Sync");
                },
                jobOrderId: jobOrder.jobOrderId
              }
            )
          ] })
        }
      ) });
      break;
    }
  }
  return /* @__PURE__ */ jsxs51("div", { children: [
    /* @__PURE__ */ jsx80("div", { className: "mb-2 rounded border border-gray-200 bg-white px-4 py-4", children: /* @__PURE__ */ jsx80(ButtonTabPills, { tabs: tabLinks }) }),
    /* @__PURE__ */ jsx80("div", { className: "flex", children: currentTab })
  ] });
};

// src/secure/integrations/bullhorn/pages/__generated__/BullhornTenantJobSubmissionsPageQuery.graphql.ts
var node78 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedOn": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantJobSubmissionsPageQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BullhornJobSubmissionList_bullhornJobSubmissions"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantJobSubmissionsPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "BullhornJobSubmissionsConnection",
          "kind": "LinkedField",
          "name": "bullhornJobSubmissions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornJobSubmissionsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornJobSubmission",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "source",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornSyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornJobSubmissionId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornJobOrder",
                      "kind": "LinkedField",
                      "name": "jobOrder",
                      "plural": false,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornCandidate",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitSyncStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "vaultProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "vaultSyncStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorMessage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "BullhornJobSubmissionList_bullhornJobSubmissions",
          "kind": "LinkedHandle",
          "name": "bullhornJobSubmissions"
        }
      ]
    },
    "params": {
      "cacheID": "622e0649e522e89556ef78208d0eeba5",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantJobSubmissionsPageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantJobSubmissionsPageQuery(\n  $tenantId: UUID!\n  $where: BullhornJobSubmissionFilter!\n) {\n  ...BullhornJobSubmissionList_bullhornJobSubmissions\n}\n\nfragment BullhornJobSubmissionList_bullhornJobSubmissions on Query {\n  bullhornJobSubmissions(tenantId: $tenantId, first: 10, order: [{updatedOn: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...BullhornJobSubmissionRow_bullhornJobSubmission\n        __typename\n      }\n    }\n  }\n}\n\nfragment BullhornJobSubmissionRow_bullhornJobSubmission on BullhornJobSubmission {\n  id\n  createdOn\n  updatedOn\n  source\n  status\n  bullhornSyncStatus\n  bullhornJobSubmissionId\n  jobOrder {\n    id\n    title\n  }\n  candidate {\n    id\n    firstName\n    lastName\n    email\n    recruitProfileId\n    recruitSyncStatus\n    vaultProfileId\n    vaultSyncStatus\n  }\n  lastErrorCode\n  lastErrorMessage\n}\n"
    }
  };
}();
node78.hash = "496e84bc6b0020d79f42aeb8f27d63df";
var BullhornTenantJobSubmissionsPageQuery_graphql_default = node78;

// src/secure/integrations/bullhorn/pages/BullhornTenantJobSubmissionsPage.tsx
import { Suspense as Suspense62, useCallback as useCallback34, useState as useState16 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery14 } from "react-relay";
import { BullhornJobSubmissionList } from "feature-integrations";
import { useDebounce as useDebounce9 } from "shared-lib";
import { EdSkeleton as EdSkeleton44, Input as Input9, RadioList as RadioList4 } from "shared-ui";
import { jsx as jsx81, jsxs as jsxs52 } from "react/jsx-runtime";
var graphqlQuery5 = BullhornTenantJobSubmissionsPageQuery_graphql_default;
var statusList3 = [
  {
    id: "All",
    label: "All"
  },
  {
    id: "Pending",
    label: "Pending"
  },
  {
    id: "Done",
    label: "Done"
  },
  {
    id: "Failed",
    label: "Failed"
  }
];
var BullhornTenantJobSubmissionsPage = ({
  tenant,
  onSelect
}) => {
  const { tenantId } = tenant;
  const [filter, setFilter] = useState16(null);
  const searchTerm = useDebounce9(filter, 500);
  const [bullhornSyncStatus, setBullhornSyncStatus] = useState16(
    statusList3[0]
  );
  const onSetBullhornSyncStatus = useCallback34(
    (ms) => {
      setBullhornSyncStatus(ms);
    },
    [bullhornSyncStatus]
  );
  const where2 = {
    tenantId: { eq: tenant.tenantId }
  };
  if (bullhornSyncStatus && bullhornSyncStatus.id !== "All") {
    where2.bullhornSyncStatus = { eq: bullhornSyncStatus.id };
  }
  if (searchTerm && filter) {
    let or = [];
    const code = Number(filter);
    if (!isNaN(code)) {
      or = [...or, { bullhornJobSubmissionId: { eq: code } }];
    }
    where2.or = or;
  }
  const query = useLazyLoadQuery14(
    graphqlQuery5,
    { tenantId, where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs52(Suspense62, { fallback: /* @__PURE__ */ jsx81(EdSkeleton44, {}), children: [
    /* @__PURE__ */ jsxs52("div", { className: "flex items-center space-x-4", children: [
      /* @__PURE__ */ jsxs52("div", { className: "flex items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx81("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
        /* @__PURE__ */ jsx81("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx81(
          Input9,
          {
            type: "number",
            placeholder: " Job Submission Id ",
            name: "filter",
            onValueChange: (filter2) => setFilter(filter2)
          },
          "filter"
        ) })
      ] }),
      /* @__PURE__ */ jsxs52("div", { className: "flex items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx81("label", { className: "text-gray-700", htmlFor: "filter", children: "Sync Status" }),
        /* @__PURE__ */ jsx81("div", { children: /* @__PURE__ */ jsx81(
          RadioList4,
          {
            list: statusList3,
            value: bullhornSyncStatus,
            onChange: (status) => onSetBullhornSyncStatus(status)
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ jsx81(
      BullhornJobSubmissionList,
      {
        onSelect,
        bullhornJobSubmissionsKey: query
      }
    )
  ] });
};

// src/secure/integrations/bullhorn/pages/__generated__/BullhornTenantJobSubmissionPageQuery.graphql.ts
var node79 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "jobSubmissionId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "jobSubmissionId"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobSubmissionId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobOrderId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v6 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantJobSubmissionPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "BullhornJobSubmission",
          "kind": "LinkedField",
          "name": "bullhornJobSubmissionById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BullhornJobSubmissionDetail_bullhornJobSubmission"
            },
            v6
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantJobSubmissionPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "BullhornJobSubmission",
          "kind": "LinkedField",
          "name": "bullhornJobSubmissionById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornJobOrder",
              "kind": "LinkedField",
              "name": "jobOrder",
              "plural": false,
              "selections": [
                v2,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornCandidate",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v2,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastErrorCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastErrorMessage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bullhornSyncStatus",
              "storageKey": null
            },
            v6
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "67ef77216a111646b1080f57eddde133",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantJobSubmissionPageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantJobSubmissionPageQuery(\n  $jobSubmissionId: ID!\n) {\n  bullhornJobSubmissionById(id: $jobSubmissionId) {\n    id\n    jobSubmissionId\n    jobOrderId\n    candidateId\n    ...BullhornJobSubmissionDetail_bullhornJobSubmission\n  }\n}\n\nfragment BullhornJobSubmissionDetail_bullhornJobSubmission on BullhornJobSubmission {\n  id\n  status\n  jobOrder {\n    id\n    title\n  }\n  candidate {\n    id\n    email\n    firstName\n    lastName\n  }\n  createdOn\n  updatedOn\n  lastErrorCode\n  lastErrorMessage\n  bullhornSyncStatus\n}\n"
    }
  };
}();
node79.hash = "7b691e0910ff49871c4455f6a657c36f";
var BullhornTenantJobSubmissionPageQuery_graphql_default = node79;

// src/secure/integrations/bullhorn/pages/BullhornTenantJobSubmissionPage.tsx
import { useCallback as useCallback35 } from "react";
import { useParams as useParams5 } from "react-router-dom";
import {
  ConnectionHandler as ConnectionHandler4,
  useLazyLoadQuery as useLazyLoadQuery15,
  useRelayEnvironment as useRelayEnvironment2
} from "react-relay";
import { createClientMutationId as createClientMutationId13 } from "shared-lib";
import { Button as Button21, DescriptionItem as DescriptionItem2 } from "shared-ui";
import {
  BullhornJobSubmissionDetail,
  SyncJobSubmissionMutation
} from "feature-integrations";
import { jsx as jsx82 } from "react/jsx-runtime";
var graphqlQuery6 = BullhornTenantJobSubmissionPageQuery_graphql_default;
var BullhornTenantJobSubmissionPage = ({
  onBack,
  onSelectJobOrder,
  onSelectCandidate
}) => {
  const { jobSubmissionId } = useParams5();
  if (!jobSubmissionId) {
    throw Error("jobSubmissionId Required");
  }
  const query = useLazyLoadQuery15(
    graphqlQuery6,
    { jobSubmissionId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { bullhornJobSubmissionById } = query;
  const environment = useRelayEnvironment2();
  const connectionId = ConnectionHandler4.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornJobSubmissionList_bullhornJobSubmissions"
  );
  const syncJobSubmissionEvent = useCallback35(() => {
    if (!bullhornJobSubmissionById) {
      return;
    }
    const clientMutationId = createClientMutationId13();
    const input = {
      id: bullhornJobSubmissionById.jobSubmissionId,
      clientMutationId
    };
    SyncJobSubmissionMutation.commit(environment, input, connectionId, () => {
      alert("Stared JobSubmission Sync");
    });
  }, []);
  return /* @__PURE__ */ jsx82("div", { children: bullhornJobSubmissionById && /* @__PURE__ */ jsx82("div", { className: "m-2", children: /* @__PURE__ */ jsx82(
    BullhornJobSubmissionDetail,
    {
      bullhornJobSubmission: bullhornJobSubmissionById,
      actions: /* @__PURE__ */ jsx82(DescriptionItem2, { label: "Actions", children: /* @__PURE__ */ jsx82(Button21, { color: "primary", clicked: syncJobSubmissionEvent, children: "Submit To Bullhorn" }) }),
      onSelectCandidate: () => {
        if (onSelectCandidate) {
          onSelectCandidate({
            id: bullhornJobSubmissionById.candidateId
          });
        }
      },
      onSelectJobOrder: () => {
        if (onSelectJobOrder) {
          onSelectJobOrder({
            id: bullhornJobSubmissionById.jobOrderId
          });
        }
      }
    }
  ) }) });
};

// src/secure/integrations/bullhorn/pages/__generated__/BullhornTenantCandidatePageQuery.graphql.ts
var node80 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "candidateId"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mappingStatus",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bullhornSyncStatus",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastErrorCode",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastErrorMessage",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitProfileId",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitSyncStatus",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vaultProfileId",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vaultSyncStatus",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantCandidatePageQuery",
      "selections": [
        {
          "alias": "candidate",
          "args": v1,
          "concreteType": "BullhornCandidate",
          "kind": "LinkedField",
          "name": "bullhornCandidateById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BullhornCandidateDetail_bullhornCandidate"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantCandidatePageQuery",
      "selections": [
        {
          "alias": "candidate",
          "args": v1,
          "concreteType": "BullhornCandidate",
          "kind": "LinkedField",
          "name": "bullhornCandidateById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bullhornCandidateId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornCandidateCustomData",
              "kind": "LinkedField",
              "name": "customData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText4",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText5",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText6",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText7",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText8",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText9",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText10",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText11",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText12",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText13",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText14",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText15",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText16",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText17",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText18",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText19",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText20",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText21",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText22",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText23",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText24",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText25",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText26",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText27",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText28",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText29",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText30",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText31",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText32",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText33",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText34",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText35",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText36",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText37",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText38",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText39",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText40",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText41",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText42",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText43",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText44",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText45",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText46",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText47",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText48",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText49",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText50",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText51",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText52",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText53",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText54",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText55",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText56",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText57",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText58",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText59",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customText60",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate4",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate5",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate6",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate7",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate8",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate9",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate10",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate11",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate12",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customDate13",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat4",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat5",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat6",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat7",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat8",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat9",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat10",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat11",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat12",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat13",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat14",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat15",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat16",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat17",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat18",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat19",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat20",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat21",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat22",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customFloat23",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt4",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt5",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt6",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt7",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt8",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt9",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt10",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt11",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt12",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt13",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt14",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt15",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt16",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt17",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt18",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt19",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt20",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt21",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt22",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInt23",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock4",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock5",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock6",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock7",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock8",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock9",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customTextBlock10",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "dd8a7c82a4c1c3a1a80a14cf767d08b4",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantCandidatePageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantCandidatePageQuery(\n  $candidateId: UUID!\n) {\n  candidate: bullhornCandidateById(id: $candidateId) {\n    id\n    candidateId\n    email\n    status\n    mappingStatus\n    bullhornSyncStatus\n    lastErrorCode\n    lastErrorMessage\n    recruitProfileId\n    recruitSyncStatus\n    vaultProfileId\n    vaultSyncStatus\n    ...BullhornCandidateDetail_bullhornCandidate\n  }\n}\n\nfragment BullhornCandidateCustomFields_bullhornCandidate on BullhornCandidate {\n  id\n  candidateId\n  customData {\n    customText1\n    customText2\n    customText3\n    customText4\n    customText5\n    customText6\n    customText7\n    customText8\n    customText9\n    customText10\n    customText11\n    customText12\n    customText13\n    customText14\n    customText15\n    customText16\n    customText17\n    customText18\n    customText19\n    customText20\n    customText21\n    customText22\n    customText23\n    customText24\n    customText25\n    customText26\n    customText27\n    customText28\n    customText29\n    customText30\n    customText31\n    customText32\n    customText33\n    customText34\n    customText35\n    customText36\n    customText37\n    customText38\n    customText39\n    customText40\n    customText41\n    customText42\n    customText43\n    customText44\n    customText45\n    customText46\n    customText47\n    customText48\n    customText49\n    customText50\n    customText51\n    customText52\n    customText53\n    customText54\n    customText55\n    customText56\n    customText57\n    customText58\n    customText59\n    customText60\n    customDate1\n    customDate2\n    customDate3\n    customDate4\n    customDate5\n    customDate6\n    customDate7\n    customDate8\n    customDate9\n    customDate10\n    customDate11\n    customDate12\n    customDate13\n    customFloat1\n    customFloat2\n    customFloat3\n    customFloat4\n    customFloat5\n    customFloat6\n    customFloat7\n    customFloat8\n    customFloat9\n    customFloat10\n    customFloat11\n    customFloat12\n    customFloat13\n    customFloat14\n    customFloat15\n    customFloat16\n    customFloat17\n    customFloat18\n    customFloat19\n    customFloat20\n    customFloat21\n    customFloat22\n    customFloat23\n    customInt1\n    customInt2\n    customInt3\n    customInt4\n    customInt5\n    customInt6\n    customInt7\n    customInt8\n    customInt9\n    customInt10\n    customInt11\n    customInt12\n    customInt13\n    customInt14\n    customInt15\n    customInt16\n    customInt17\n    customInt18\n    customInt19\n    customInt20\n    customInt21\n    customInt22\n    customInt23\n    customTextBlock1\n    customTextBlock2\n    customTextBlock3\n    customTextBlock4\n    customTextBlock5\n    customTextBlock6\n    customTextBlock7\n    customTextBlock8\n    customTextBlock9\n    customTextBlock10\n  }\n}\n\nfragment BullhornCandidateDetail_bullhornCandidate on BullhornCandidate {\n  id\n  bullhornCandidateId\n  candidateId\n  email\n  firstName\n  lastName\n  status\n  description\n  mappingStatus\n  bullhornSyncStatus\n  lastErrorCode\n  lastErrorMessage\n  recruitProfileId\n  recruitSyncStatus\n  vaultProfileId\n  vaultSyncStatus\n  createdOn\n  updatedOn\n  ...BullhornCandidateCustomFields_bullhornCandidate\n}\n"
    }
  };
}();
node80.hash = "b43081947b0d53cf92f0a2ac67cddb98";
var BullhornTenantCandidatePageQuery_graphql_default = node80;

// src/secure/integrations/bullhorn/pages/BullhornTenantCandidatePage.tsx
import { Suspense as Suspense63, useCallback as useCallback36 } from "react";
import { useNavigate as useNavigate16, useParams as useParams6 } from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery16 } from "react-relay";
import { useToggle as useToggle8 } from "shared-lib";
import { EdSkeleton as EdSkeleton45, LinkButton as LinkButton2 } from "shared-ui";
import {
  BullhornCandidateDetail,
  BullhornReplaceTalentPoolCandidateButton,
  BullhornSyncCandidateElevateButton,
  BullhornUploadCandidateResumeButton,
  BullhornRefreshVaultCandidateButton
} from "feature-integrations";

// src/lib/NavigationRegistry.ts
var root = "/admin/app/";
var NavigationRegistry = class {
  static navigateToVaultProfile(navigate, organisationId, id) {
    navigate(
      `${root}/vault/organisation/${organisationId}/profiles/${id}/profile`
    );
  }
};

// src/lib/UseRouteRegistry.ts
import { useEffect as useEffect2 } from "react";
import { useLocation as useLocation9 } from "react-router-dom";
import { useSetLinkRegistry } from "app-core";
var adminLinkRegistry = class {
  constructor(location) {
    this.location = location;
  }
  applicationLink(code) {
    return null;
  }
};
function useRouteRegistry() {
  const location = useLocation9();
  const setRegistry = useSetLinkRegistry();
  useEffect2(() => {
    console.log("useRouteRegistry");
    const registry = new adminLinkRegistry(location);
    setRegistry(registry);
  }, []);
}

// src/lib/UseUserManager.ts
import { ElevateAccountTypes, Tenant } from "app-core";

// src/config/config.ts
import { useContext, useMemo as useMemo8 } from "react";
import {
  loadEnvironmentConfig,
  GlobalSettingsContext,
  PortalApps
} from "shared-lib";

// src/config/oidc.config.ts
import { ElevateScopes } from "app-core";
var oidc_config_default = {
  responseType: "id_token token",
  acrValues: "tenant:admin",
  clientId: "admin.web",
  apiPath: `gateway`,
  automaticSilentRenew: true,
  scope: `openid profile email ${ElevateScopes.NotificationsScope} ${ElevateScopes.IdentityAdminApiScope} ${ElevateScopes.IntegrationsAdminApiScope} ${ElevateScopes.RecruitApiScope} ${ElevateScopes.EventTrackingApiScope} ${ElevateScopes.VaultScope} ${ElevateScopes.CompaniesScope}`
};

// src/config/config.ts
function useConfig() {
  const settings = useContext(GlobalSettingsContext);
  const environmentConfig = useMemo8(() => {
    return loadEnvironmentConfig(settings, PortalApps.Admin);
  }, [settings]);
  return {
    ...oidc_config_default,
    ...environmentConfig
  };
}

// src/lib/UseUserManager.ts
function useAuthConfig() {
  const config = useConfig();
  const signoutRedirectUri = `${window.location.protocol}//${window.location.host}/portal/admin/signout-oidc`;
  return {
    ...config,
    autoSignIn: false,
    accountType: ElevateAccountTypes.Internal,
    tenant: Tenant.Admin,
    signoutRedirectUri,
    onSetUserData: async () => {
      window.location.hash = "";
    }
  };
}

// src/secure/integrations/bullhorn/pages/BullhornTenantCandidatePage.tsx
import { jsx as jsx83, jsxs as jsxs53 } from "react/jsx-runtime";
var graphqlQuery7 = BullhornTenantCandidatePageQuery_graphql_default;
var BullhornTenantCandidatePage = ({
  tenant,
  onBack
}) => {
  const navigate = useNavigate16();
  const { candidateId } = useParams6();
  if (!candidateId) {
    throw Error("candidateId Required");
  }
  const query = useLazyLoadQuery16(
    graphqlQuery7,
    { candidateId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { candidate } = query;
  const [isBusy, toggleBusy] = useToggle8(false);
  const onToggleBusy = useCallback36(() => {
    toggleBusy();
  }, []);
  const onGoToProfile = useCallback36((id) => {
    NavigationRegistry.navigateToVaultProfile(navigate, tenant.employerId, id);
  }, []);
  if (!candidate) {
    return /* @__PURE__ */ jsx83("div", {});
  }
  return /* @__PURE__ */ jsxs53("div", { children: [
    isBusy && /* @__PURE__ */ jsx83("div", { className: "m-2", children: /* @__PURE__ */ jsx83("p", { children: "Updating" }) }),
    candidate && !isBusy && /* @__PURE__ */ jsxs53("div", { className: "my-2", children: [
      /* @__PURE__ */ jsx83("div", { className: "pb-2", children: /* @__PURE__ */ jsx83(LinkButton2, { clicked: onBack, children: "Back To Candidates" }) }),
      /* @__PURE__ */ jsxs53("div", { className: "items-top flex justify-between", children: [
        /* @__PURE__ */ jsx83("div", { className: "flex-1", children: /* @__PURE__ */ jsx83(
          BullhornCandidateDetail,
          {
            candidate,
            actions: /* @__PURE__ */ jsxs53("div", { className: "flex items-center justify-between space-x-4 p-4", children: [
              candidate.recruitProfileId == null ? null : /* @__PURE__ */ jsx83(
                BullhornReplaceTalentPoolCandidateButton,
                {
                  candidateId: candidate.candidateId,
                  onRequestStart: onToggleBusy,
                  onRequestDone: onToggleBusy,
                  onRequestError: onToggleBusy
                }
              ),
              /* @__PURE__ */ jsx83(
                BullhornSyncCandidateElevateButton,
                {
                  candidateId: candidate.candidateId,
                  onRequestStart: onToggleBusy,
                  onRequestDone: onToggleBusy,
                  onRequestError: onToggleBusy
                }
              ),
              /* @__PURE__ */ jsx83(
                BullhornUploadCandidateResumeButton,
                {
                  candidateId: candidate.candidateId,
                  onRequestStart: onToggleBusy,
                  onRequestDone: onToggleBusy,
                  onRequestError: onToggleBusy
                }
              ),
              /* @__PURE__ */ jsx83(
                BullhornRefreshVaultCandidateButton,
                {
                  candidateId: candidate.candidateId,
                  onRequestStart: onToggleBusy,
                  onRequestDone: onToggleBusy,
                  onRequestError: onToggleBusy
                }
              )
            ] })
          }
        ) }),
        /* @__PURE__ */ jsx83("div", { className: "flex-1", children: candidate.vaultProfileId && /* @__PURE__ */ jsxs53("div", { children: [
          /* @__PURE__ */ jsx83("div", { className: "mx-2 overflow-hidden bg-white p-6 shadow sm:rounded-lg", children: /* @__PURE__ */ jsxs53("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ jsx83("h3", { className: "text-lg font-medium leading-6 text-gray-900", children: "Vault Profile" }),
            /* @__PURE__ */ jsx83(
              LinkButton2,
              {
                clicked: () => {
                  if (candidate.vaultProfileId) {
                    onGoToProfile(candidate.vaultProfileId);
                  }
                },
                children: "Go To Profile"
              }
            )
          ] }) }),
          /* @__PURE__ */ jsx83("div", { className: "mx-2 pt-2", children: /* @__PURE__ */ jsx83(Suspense63, { fallback: /* @__PURE__ */ jsx83(EdSkeleton45, {}), children: /* @__PURE__ */ jsx83("div", { children: "TODO: Profile" }) }) })
        ] }) })
      ] })
    ] })
  ] });
};

// src/secure/integrations/bullhorn/pages/__generated__/BullhornTenantLogsPageQuery.graphql.ts
var node81 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "CreatedOn": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantLogsPageQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventLogList_eventLogItems"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantLogsPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "IntegrationEventLogItemsConnection",
          "kind": "LinkedField",
          "name": "integrationEventLogItems",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationEventLogItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationEventLogItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogSourceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogTitle",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogLevel",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogMessage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "EventLogList_integrationEventLogItems",
          "kind": "LinkedHandle",
          "name": "integrationEventLogItems"
        }
      ]
    },
    "params": {
      "cacheID": "865ee561bb40e0ec2418498fb2292951",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantLogsPageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantLogsPageQuery(\n  $tenantId: UUID!\n  $where: IntegrationEventLogItemFilter!\n) {\n  ...EventLogList_eventLogItems\n}\n\nfragment EventLogList_eventLogItems on Query {\n  integrationEventLogItems(tenantId: $tenantId, first: 10, order: [{CreatedOn: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        createdOn\n        ...EventLogRow_eventLogItem\n        __typename\n      }\n    }\n  }\n}\n\nfragment EventLogRow_eventLogItem on IntegrationEventLogItem {\n  id\n  createdOn\n  eventLogSourceId\n  eventLogType\n  eventLogTitle\n  eventLogLevel\n  eventLogMessage\n}\n"
    }
  };
}();
node81.hash = "56c0e4c306484a32abce655e5b541d62";
var BullhornTenantLogsPageQuery_graphql_default = node81;

// src/secure/integrations/bullhorn/pages/BullhornTenantLogsPage.tsx
import { Suspense as Suspense64, useCallback as useCallback37, useState as useState17 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery17 } from "react-relay";
import {
  EventLogItemLevelList,
  EventLogItemTypesList,
  EventLogList
} from "feature-integrations";
import {
  EdSkeleton as EdSkeleton46,
  Input as Input10,
  RadioList as RadioList5,
  SelectMenu
} from "shared-ui";
import { useDebounce as useDebounce10 } from "shared-lib";
import { jsx as jsx84, jsxs as jsxs54 } from "react/jsx-runtime";
var graphqlQuery8 = BullhornTenantLogsPageQuery_graphql_default;
var eventLogItemTypesList = EventLogItemTypesList;
var eventLogItemLevelsList = EventLogItemLevelList;
var BullhornTenantLogsPage = ({
  tenant,
  onSelect
}) => {
  const [filter, setFilter] = useState17(null);
  const searchTerm = useDebounce10(filter, 500);
  const [eventLogItemType, setEventLogItemType] = useState17(
    eventLogItemTypesList[0]
  );
  const onEventLogItemType = useCallback37(
    (ms) => {
      setEventLogItemType(ms);
    },
    [eventLogItemType]
  );
  const [eventLogItemLevel, setEventLogItemLevel] = useState17(
    eventLogItemLevelsList[0]
  );
  const onEventLogItemLevel = useCallback37(
    (ms) => {
      setEventLogItemLevel(ms);
    },
    [eventLogItemLevel]
  );
  const where2 = {
    tenantId: { eq: tenant.tenantId }
  };
  if (eventLogItemType && eventLogItemType.id !== "All") {
    where2.eventLogType = { eq: eventLogItemType.id };
  }
  if (eventLogItemLevel && eventLogItemLevel.id !== "All") {
    where2.eventLogLevel = { eq: eventLogItemLevel.id };
  }
  if (searchTerm && filter) {
    where2.or = [{ eventLogTitle: { eq: filter } }];
  }
  const query = useLazyLoadQuery17(
    graphqlQuery8,
    { tenantId: tenant.tenantId, where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx84(Suspense64, { fallback: /* @__PURE__ */ jsx84(EdSkeleton46, {}), children: /* @__PURE__ */ jsxs54("div", { children: [
    /* @__PURE__ */ jsxs54("div", { className: "flex flex-wrap items-center", children: [
      /* @__PURE__ */ jsxs54("div", { className: "flex flex-1 items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx84("label", { className: "text-gray-900", htmlFor: "filter", children: "Filter" }),
        /* @__PURE__ */ jsx84("div", { className: "sm:w-full", children: /* @__PURE__ */ jsx84(
          Input10,
          {
            placeholder: " Title ",
            name: "filter",
            onValueChange: (filter2) => setFilter(filter2)
          },
          "filter"
        ) })
      ] }),
      /* @__PURE__ */ jsxs54("div", { className: "flex flex-1 items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx84("label", { className: "text-gray-900", htmlFor: "filter", children: "Source" }),
        /* @__PURE__ */ jsx84(
          SelectMenu,
          {
            className: "w-full",
            items: eventLogItemTypesList,
            onChange: onEventLogItemType,
            value: eventLogItemType
          }
        )
      ] }),
      /* @__PURE__ */ jsxs54("div", { className: "flex flex-1 items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx84("label", { className: "text-gray-900", htmlFor: "filter", children: "Level" }),
        /* @__PURE__ */ jsx84("div", { children: /* @__PURE__ */ jsx84(
          RadioList5,
          {
            list: eventLogItemLevelsList,
            value: eventLogItemLevel,
            onChange: (item) => onEventLogItemLevel(item)
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ jsx84(EventLogList, { onSelect, eventLogItemsKey: query })
  ] }) });
};

// src/secure/integrations/bullhorn/pages/__generated__/BullhornTenantLogPageQuery.graphql.ts
var node82 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "eventLogLevel",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "eventLogMessage",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "eventLogSourceId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "eventLogTitle",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "eventLogType",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantLogPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "IntegrationEventLogItem",
          "kind": "LinkedField",
          "name": "integrationEventLogItemById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventLogItem_eventLogItem"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantLogPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "IntegrationEventLogItem",
          "kind": "LinkedField",
          "name": "integrationEventLogItemById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "cf674f517d5c9702c315afa59651b1aa",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantLogPageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantLogPageQuery(\n  $id: ID!\n) {\n  integrationEventLogItemById(id: $id) {\n    id\n    createdOn\n    eventLogLevel\n    eventLogMessage\n    eventLogSourceId\n    eventLogTitle\n    eventLogType\n    ...EventLogItem_eventLogItem\n  }\n}\n\nfragment EventLogItem_eventLogItem on IntegrationEventLogItem {\n  id\n  createdOn\n  eventLogSourceId\n  eventLogType\n  eventLogTitle\n  eventLogLevel\n  eventLogMessage\n}\n"
    }
  };
}();
node82.hash = "d739df6f92e4e2d966ea2ccb63a64752";
var BullhornTenantLogPageQuery_graphql_default = node82;

// src/secure/integrations/bullhorn/pages/BullhornTenantLogPage.tsx
import { Suspense as Suspense65 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery18 } from "react-relay";
import { useParams as useParams7 } from "react-router-dom";
import { EventLogItem } from "feature-integrations";
import { EdSkeleton as EdSkeleton47 } from "shared-ui";
import { jsx as jsx85 } from "react/jsx-runtime";
var graphqlQuery9 = BullhornTenantLogPageQuery_graphql_default;
var BullhornTenantLogPage = ({ onBack }) => {
  const { logId } = useParams7();
  if (!logId) {
    throw Error("logId Required");
  }
  const query = useLazyLoadQuery18(
    graphqlQuery9,
    { id: logId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { integrationEventLogItemById } = query;
  return /* @__PURE__ */ jsx85(Suspense65, { fallback: /* @__PURE__ */ jsx85(EdSkeleton47, {}), children: /* @__PURE__ */ jsx85(
    EventLogItem,
    {
      onBack,
      eventLogItem: integrationEventLogItemById
    }
  ) });
};

// src/secure/integrations/bullhorn/pages/BullhornTenantDetailsPage.tsx
import { jsx as jsx86, jsxs as jsxs55 } from "react/jsx-runtime";
var graphqlQuery10 = BullhornTenantDetailsPageQuery_graphql_default;
var BullhornTenantDetailsPage = ({
  integrationsUrl,
  tenantsUrl
}) => {
  const location = useLocation10();
  const navigate = useNavigate17();
  const { tenantId } = useParams8();
  if (!tenantId) {
    throw Error("tenantId Required");
  }
  const data = useLazyLoadQuery19(
    graphqlQuery10,
    { id: tenantId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const onSelectJobSubmission = useCallback38((submission) => {
    navigate(`job-submission/${submission.id}`);
  }, []);
  const onSelectJobOrder = useCallback38((order2) => {
    navigate(`job-order/${order2.id}`);
  }, []);
  const onSelectLogs = useCallback38(() => {
    navigate(`logs`);
  }, []);
  const onSelectLog = useCallback38((item) => {
    navigate(`log/${item.id}`);
  }, []);
  const onSelectJobOrders = useCallback38(() => {
    navigate(`job-orders`);
  }, []);
  const onSelectCandidate = useCallback38((c) => {
    navigate(`candidate/${c.id}`);
  }, []);
  const onSelectCandidates = useCallback38(() => {
    navigate(`candidates`);
  }, []);
  const onSelectJobSubmissions = useCallback38(() => {
    navigate(`job-submissions`);
  }, []);
  const links = [
    { name: "Bullhorn", href: tenantsUrl },
    { name: data.tenant?.name || "", href: "." }
  ];
  const tabs4 = useMemo9(() => {
    return [
      createLinkState9(location, "Details", ``, UserIcon2),
      createLinkState9(location, "Job Orders", `job-orders`, UserIcon2),
      createLinkState9(location, "Job Submissions", `job-submissions`, UserIcon2),
      createLinkState9(location, "Logs", `logs`, CircleStackIcon2),
      createLinkState9(location, "Events", `events`, UserIcon2),
      createLinkState9(location, "Candidates", `candidates`, UserIcon2)
    ];
  }, [location]);
  if (!data || !data.tenant) {
    return /* @__PURE__ */ jsx86("div", { children: "Tenant not available" });
  }
  return /* @__PURE__ */ jsxs55("div", { children: [
    /* @__PURE__ */ jsx86("div", { className: "flex border-b bg-white py-3", children: /* @__PURE__ */ jsx86("div", { className: "px-2", children: /* @__PURE__ */ jsx86(
      Breadcrumbs,
      {
        homeText: "Integrations",
        homeHref: integrationsUrl,
        links
      }
    ) }) }),
    /* @__PURE__ */ jsxs55("div", { children: [
      /* @__PURE__ */ jsx86("div", { className: "flex border-b bg-white pt-2 sm:pb-4", children: /* @__PURE__ */ jsx86("div", { className: "px-4", children: /* @__PURE__ */ jsx86(TabUnderline7, { tabs: tabs4 }) }) }),
      /* @__PURE__ */ jsx86("div", { className: "px-4 py-2 sm:px-8", children: /* @__PURE__ */ jsxs55(Routes, { children: [
        /* @__PURE__ */ jsx86(
          Route,
          {
            path: "job-orders",
            element: /* @__PURE__ */ jsx86(
              BullhornTenantJobOrdersPage,
              {
                tenant: data.tenant,
                onSelect: onSelectJobOrder
              }
            )
          }
        ),
        /* @__PURE__ */ jsx86(
          Route,
          {
            path: "job-order/:jobOrderId",
            element: /* @__PURE__ */ jsx86(
              BullhornTenantJobOrderPage,
              {
                tenant: data.tenant,
                onBack: onSelectJobOrders,
                onSelectJobSubmission
              }
            )
          }
        ),
        /* @__PURE__ */ jsx86(
          Route,
          {
            path: "events",
            element: /* @__PURE__ */ jsx86(BullhornTenantEventsPage, { tenant: data.tenant })
          }
        ),
        /* @__PURE__ */ jsx86(
          Route,
          {
            path: "job-submissions",
            element: /* @__PURE__ */ jsx86(
              BullhornTenantJobSubmissionsPage,
              {
                tenant: data.tenant,
                onSelect: onSelectJobSubmission
              }
            )
          }
        ),
        /* @__PURE__ */ jsx86(
          Route,
          {
            path: "job-submission/:jobSubmissionId",
            element: /* @__PURE__ */ jsx86(
              BullhornTenantJobSubmissionPage,
              {
                onBack: onSelectJobSubmissions,
                onSelectJobOrder: (jobOrder) => {
                  onSelectJobOrder(jobOrder);
                },
                onSelectCandidate: (candidate) => {
                  onSelectCandidate(candidate);
                }
              }
            )
          }
        ),
        /* @__PURE__ */ jsx86(
          Route,
          {
            path: "candidates",
            element: /* @__PURE__ */ jsx86(
              BullhornTenantCandidatesPage,
              {
                tenant: data.tenant,
                onSelect: onSelectCandidate
              }
            )
          }
        ),
        /* @__PURE__ */ jsx86(
          Route,
          {
            path: "candidate/:candidateId",
            element: /* @__PURE__ */ jsx86(
              BullhornTenantCandidatePage,
              {
                tenant: data.tenant,
                onBack: onSelectCandidates
              }
            )
          }
        ),
        /* @__PURE__ */ jsx86(
          Route,
          {
            path: "log/:logId",
            element: /* @__PURE__ */ jsx86(BullhornTenantLogPage, { onBack: onSelectLogs })
          }
        ),
        /* @__PURE__ */ jsx86(
          Route,
          {
            path: "logs",
            element: /* @__PURE__ */ jsx86(
              BullhornTenantLogsPage,
              {
                tenant: data.tenant,
                onSelect: onSelectLog
              }
            )
          }
        ),
        /* @__PURE__ */ jsx86(
          Route,
          {
            path: "/",
            element: /* @__PURE__ */ jsx86(BullhornTenantDetail, { tenant: data.tenant })
          }
        )
      ] }) })
    ] })
  ] });
};

// src/secure/integrations/bullhorn/pages/__generated__/BullhornTenantsListPageQuery.graphql.ts
var node83 = function() {
  var v0 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantsListPageQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BullhornTenantList_bullhornTenants"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "BullhornTenantsListPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v0,
          "concreteType": "BullhornTenantsConnection",
          "kind": "LinkedField",
          "name": "bullhornTenants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornTenantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornTenant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v1,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornTenantConfig",
                      "kind": "LinkedField",
                      "name": "config",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isEnabled",
                          "storageKey": null
                        },
                        v1
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": "bullhornTenants(first:10)"
        },
        {
          "alias": null,
          "args": v0,
          "filters": [],
          "handle": "connection",
          "key": "BullhornTenantList_bullhornTenants",
          "kind": "LinkedHandle",
          "name": "bullhornTenants"
        }
      ]
    },
    "params": {
      "cacheID": "4ad81564fe965f2e148fb78f4e376d4e",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantsListPageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantsListPageQuery {\n  ...BullhornTenantList_bullhornTenants\n}\n\nfragment BullhornTenantDetail_bullhornTenant on BullhornTenant {\n  id\n  name\n  tenantId\n}\n\nfragment BullhornTenantList_bullhornTenants on Query {\n  bullhornTenants(first: 10) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        tenantId\n        name\n        createdOn\n        updatedOn\n        config {\n          isEnabled\n          id\n        }\n        ...BullhornTenantRow_bullhornTenant\n        ...BullhornTenantDetail_bullhornTenant\n        __typename\n      }\n    }\n  }\n}\n\nfragment BullhornTenantRow_bullhornTenant on BullhornTenant {\n  id\n  tenantId\n  name\n  createdOn\n  updatedOn\n  config {\n    isEnabled\n    id\n  }\n}\n"
    }
  };
}();
node83.hash = "98a73afc3887497eb01f68caf4e1322b";
var BullhornTenantsListPageQuery_graphql_default = node83;

// src/secure/integrations/bullhorn/pages/BullhornTenantsListPage.tsx
import { Routes as Routes2, Route as Route2 } from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery20 } from "react-relay";
import { BullhornTenantList } from "feature-integrations";
import { Breadcrumbs as Breadcrumbs2 } from "shared-ui";
import { jsx as jsx87, jsxs as jsxs56 } from "react/jsx-runtime";
var graphqlQuery11 = BullhornTenantsListPageQuery_graphql_default;
var BullhornTenantsListPage = ({
  integrationsUrl,
  onSelect
}) => {
  const links = [{ name: "Bullhorn", href: "." }];
  const query = useLazyLoadQuery20(
    graphqlQuery11,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx87("div", { children: /* @__PURE__ */ jsx87(Routes2, { children: /* @__PURE__ */ jsx87(
    Route2,
    {
      path: "//*",
      element: /* @__PURE__ */ jsxs56("div", { children: [
        /* @__PURE__ */ jsx87("div", { className: "flex border-b bg-white py-3", children: /* @__PURE__ */ jsx87("div", { className: "px-2", children: /* @__PURE__ */ jsx87(
          Breadcrumbs2,
          {
            homeText: "Integrations",
            homeHref: integrationsUrl,
            links
          }
        ) }) }),
        /* @__PURE__ */ jsxs56("div", { className: "px-4 pt-2 sm:px-8", children: [
          /* @__PURE__ */ jsx87("div", { className: "p-2", children: /* @__PURE__ */ jsx87("h5", { children: "Tenants" }) }),
          /* @__PURE__ */ jsx87(
            BullhornTenantList,
            {
              onSelect,
              bullhornTenantsKey: query
            }
          )
        ] })
      ] })
    }
  ) }) });
};

// src/secure/integrations/bullhorn/pages/BullhornLayoutPage.tsx
import { jsx as jsx88, jsxs as jsxs57 } from "react/jsx-runtime";
var BullhornLayoutPage = () => {
  const navigate = useNavigate18();
  return /* @__PURE__ */ jsx88(Suspense66, { fallback: /* @__PURE__ */ jsx88(EdSkeleton48, {}), children: /* @__PURE__ */ jsxs57(Routes3, { children: [
    /* @__PURE__ */ jsx88(
      Route3,
      {
        path: "/tenant/:tenantId/*",
        element: /* @__PURE__ */ jsx88(
          BullhornTenantDetailsPage,
          {
            integrationsUrl: "../../",
            tenantsUrl: ".."
          }
        )
      }
    ),
    /* @__PURE__ */ jsx88(
      Route3,
      {
        path: "//*",
        element: /* @__PURE__ */ jsx88(
          BullhornTenantsListPage,
          {
            integrationsUrl: "../../../",
            onSelect: (tenant) => {
              navigate(`tenant/${tenant.id}`);
            }
          }
        )
      }
    )
  ] }) });
};

// src/secure/integrations/custom-data/pages/__generated__/CustomDataFieldMappingDetailPageQuery.graphql.ts
var node84 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fieldMappingId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "fieldMappingId"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fieldMappingConfigurationId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v7 = [
    v5,
    v6
  ], v8 = {
    "alias": null,
    "args": null,
    "concreteType": "IntegrationSystemsType",
    "kind": "LinkedField",
    "name": "sourceSystem",
    "plural": false,
    "selections": v7,
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceType",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "concreteType": "IntegrationSystemsType",
    "kind": "LinkedField",
    "name": "targetSystem",
    "plural": false,
    "selections": v7,
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "targetType",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }, v14 = [
    v6,
    v12,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    v13
  ], v15 = {
    "alias": null,
    "args": null,
    "concreteType": "IntegrationMappableAction",
    "kind": "LinkedField",
    "name": "mappings",
    "plural": true,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationMappable",
        "kind": "LinkedField",
        "name": "source",
        "plural": false,
        "selections": v14,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationMappable",
        "kind": "LinkedField",
        "name": "target",
        "plural": false,
        "selections": v14,
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v16 = [
    v6,
    v12,
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationFieldTypes",
      "kind": "LinkedField",
      "name": "dataType",
      "plural": false,
      "selections": [
        v6,
        v5,
        v13
      ],
      "storageKey": null
    }
  ], v17 = {
    "alias": null,
    "args": null,
    "concreteType": "IntegrationFieldDefinition",
    "kind": "LinkedField",
    "name": "sourceFieldNames",
    "plural": true,
    "selections": v16,
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "concreteType": "IntegrationFieldDefinition",
    "kind": "LinkedField",
    "name": "targetFieldNames",
    "plural": true,
    "selections": v16,
    "storageKey": null
  }, v19 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CustomDataFieldMappingDetailPageQuery",
      "selections": [
        {
          "alias": "mapping",
          "args": v1,
          "concreteType": "IntegrationFieldMappingConfiguration",
          "kind": "LinkedField",
          "name": "integrationFieldMappingById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v8,
            v9,
            v10,
            v11,
            v15,
            v17,
            v18,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FieldMappingConfigurationDetail_fieldMappingConfiguration"
            },
            v19
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CustomDataFieldMappingDetailPageQuery",
      "selections": [
        {
          "alias": "mapping",
          "args": v1,
          "concreteType": "IntegrationFieldMappingConfiguration",
          "kind": "LinkedField",
          "name": "integrationFieldMappingById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v8,
            v9,
            v10,
            v11,
            v15,
            v17,
            v18,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            v19
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e5f527f9e766d22682f006a58eed09c8",
      "id": null,
      "metadata": {},
      "name": "CustomDataFieldMappingDetailPageQuery",
      "operationKind": "query",
      "text": "query CustomDataFieldMappingDetailPageQuery(\n  $fieldMappingId: UUID!\n) {\n  mapping: integrationFieldMappingById(id: $fieldMappingId) {\n    id\n    fieldMappingConfigurationId\n    name\n    sourceSystem {\n      displayName\n      key\n    }\n    sourceType\n    targetSystem {\n      displayName\n      key\n    }\n    targetType\n    mappings {\n      id\n      source {\n        key\n        label\n        dataTypeKey\n        processorTypeKey\n        value\n      }\n      target {\n        key\n        label\n        dataTypeKey\n        processorTypeKey\n        value\n      }\n    }\n    sourceFieldNames {\n      key\n      label\n      dataType {\n        key\n        displayName\n        value\n      }\n    }\n    targetFieldNames {\n      key\n      label\n      dataType {\n        key\n        displayName\n        value\n      }\n    }\n    ...FieldMappingConfigurationDetail_fieldMappingConfiguration\n  }\n}\n\nfragment FieldMappingConfigurationDetail_fieldMappingConfiguration on IntegrationFieldMappingConfiguration {\n  id\n  createdOn\n  updatedOn\n  name\n  sourceSystem {\n    displayName\n    key\n  }\n  sourceType\n  targetSystem {\n    displayName\n    key\n  }\n  targetType\n  mappings {\n    id\n    source {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n    target {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n  }\n}\n"
    }
  };
}();
node84.hash = "644a714cd6197b8cb617131c3943d929";
var CustomDataFieldMappingDetailPageQuery_graphql_default = node84;

// src/secure/integrations/custom-data/pages/CustomDataFieldMappingDetailPage.tsx
import { useCallback as useCallback39 } from "react";
import {
  ConnectionHandler as ConnectionHandler5,
  useLazyLoadQuery as useLazyLoadQuery21,
  useRelayEnvironment as useRelayEnvironment3
} from "react-relay";
import { useParams as useParams9 } from "react-router-dom";
import { createClientMutationId as createClientMutationId14, useToggle as useToggle9 } from "shared-lib";
import { ButtonTabPills as ButtonTabPills2, LinkButton as LinkButton3, useTabs as useTabs2 } from "shared-ui";
import {
  FieldMappingConfigurationDetail,
  SaveFieldMappingConfigMutation,
  FieldMappingConfigurationFieldsForm
} from "feature-integrations";
import { jsx as jsx89, jsxs as jsxs58 } from "react/jsx-runtime";
var graphqlQuery12 = CustomDataFieldMappingDetailPageQuery_graphql_default;
var CustomDataFieldMappingDetailPage = ({
  onDone,
  onBack
}) => {
  const { fieldMappingId } = useParams9();
  if (fieldMappingId == null) {
    throw Error("fieldMappingId Required");
  }
  const [isBusy, toggleIsBusy] = useToggle9();
  const [current, tabLinks, setTab] = useTabs2([
    { name: "View" },
    { name: "Edit" }
  ]);
  const query = useLazyLoadQuery21(
    graphqlQuery12,
    { fieldMappingId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { mapping } = query;
  const environment = useRelayEnvironment3();
  const connectionId = ConnectionHandler5.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "FieldMappingConfigurationList_integrationFieldMappings"
  );
  const onSave = useCallback39((form) => {
    if (!mapping || !form.name || !form.actions) {
      return;
    }
    toggleIsBusy();
    const clientMutationId = createClientMutationId14();
    const input = {
      id: mapping.id,
      name: form.name,
      actions: form.actions,
      clientMutationId
    };
    SaveFieldMappingConfigMutation.commit(
      environment,
      input,
      connectionId,
      (response) => {
        onDone(response);
        toggleIsBusy();
      }
    );
  }, []);
  if (!mapping) {
    return /* @__PURE__ */ jsx89("div", { children: "Not Found" });
  }
  const actions = [...mapping.mappings];
  const sourceFields = mapping.sourceFieldNames.map(
    (field) => field
  );
  const targetFields = mapping.targetFieldNames.map(
    (field) => field
  );
  let currentTab;
  switch (current.name) {
    case "View": {
      currentTab = /* @__PURE__ */ jsx89("div", { className: "mt-8", children: /* @__PURE__ */ jsx89(
        FieldMappingConfigurationDetail,
        {
          actions: /* @__PURE__ */ jsx89("div", {}),
          fieldMappingConfiguration: mapping
        }
      ) });
      break;
    }
    case "Edit": {
      currentTab = /* @__PURE__ */ jsx89("div", { className: "flex sm:w-1/2", children: /* @__PURE__ */ jsx89(
        FieldMappingConfigurationFieldsForm,
        {
          sourceFieldDefinitions: sourceFields,
          targetFieldDefinitions: targetFields,
          name: mapping.name,
          isBusy,
          actions,
          onSave,
          onCancel: () => setTab({ name: "View" })
        }
      ) });
      break;
    }
  }
  return /* @__PURE__ */ jsxs58("div", { children: [
    /* @__PURE__ */ jsxs58("div", { className: "flex items-center space-x-4 border-b px-2 py-4", children: [
      /* @__PURE__ */ jsx89(LinkButton3, { label: "Back", clicked: () => onBack() }),
      /* @__PURE__ */ jsx89(ButtonTabPills2, { tabs: tabLinks })
    ] }),
    currentTab
  ] });
};

// src/secure/integrations/custom-data/pages/__generated__/CustomDataFieldMappingListPageQuery.graphql.ts
var node85 = function() {
  var v0 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedOn": "DESC"
        }
      ]
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "CustomDataFieldMappingListPageQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FieldMappingConfigurationList_fieldMappingConfigurations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "CustomDataFieldMappingListPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v0,
          "concreteType": "IntegrationFieldMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationFieldMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationFieldMappingConfiguration",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v1,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fieldMappingConfigurationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "targetType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationMappableAction",
                      "kind": "LinkedField",
                      "name": "mappings",
                      "plural": true,
                      "selections": [
                        v1,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "IntegrationMappable",
                          "kind": "LinkedField",
                          "name": "source",
                          "plural": false,
                          "selections": v2,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "IntegrationMappable",
                          "kind": "LinkedField",
                          "name": "target",
                          "plural": false,
                          "selections": v2,
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": 'integrationFieldMappings(first:10,order:[{"updatedOn":"DESC"}])'
        },
        {
          "alias": null,
          "args": v0,
          "filters": [],
          "handle": "connection",
          "key": "FieldMappingConfigurationList_integrationFieldMappings",
          "kind": "LinkedHandle",
          "name": "integrationFieldMappings"
        }
      ]
    },
    "params": {
      "cacheID": "d0263a2e1fb006d4b5d87a04769fe385",
      "id": null,
      "metadata": {},
      "name": "CustomDataFieldMappingListPageQuery",
      "operationKind": "query",
      "text": "query CustomDataFieldMappingListPageQuery {\n  ...FieldMappingConfigurationList_fieldMappingConfigurations\n}\n\nfragment FieldMappingConfigurationList_fieldMappingConfigurations on Query {\n  integrationFieldMappings(first: 10, order: [{updatedOn: DESC}]) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        ...FieldMappingConfigurationRow_fieldMappingConfiguration\n        __typename\n      }\n    }\n  }\n}\n\nfragment FieldMappingConfigurationRow_fieldMappingConfiguration on IntegrationFieldMappingConfiguration {\n  id\n  fieldMappingConfigurationId\n  createdOn\n  updatedOn\n  name\n  sourceType\n  targetType\n  mappings {\n    id\n    source {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n    target {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n  }\n}\n"
    }
  };
}();
node85.hash = "8d01bc3c32e7686d6bfa28d37657b809";
var CustomDataFieldMappingListPageQuery_graphql_default = node85;

// src/secure/integrations/custom-data/pages/CustomDataFieldMappingListPage.tsx
import { useLazyLoadQuery as useLazyLoadQuery22 } from "react-relay";
import { PageHeading as PageHeading5 } from "shared-ui";
import { FieldMappingConfigurationList } from "feature-integrations";
import { jsx as jsx90, jsxs as jsxs59 } from "react/jsx-runtime";
var graphqlQuery13 = CustomDataFieldMappingListPageQuery_graphql_default;
var CustomDataFieldMappingListPage = ({
  onSelect
}) => {
  const query = useLazyLoadQuery22(
    graphqlQuery13,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs59("div", { className: "pt-4", children: [
    /* @__PURE__ */ jsx90(PageHeading5, { children: "Field Mappings" }),
    /* @__PURE__ */ jsx90(
      FieldMappingConfigurationList,
      {
        onSelect: (node116) => onSelect({ id: node116.fieldMappingConfigurationId }),
        fieldMappingConfigurationsKey: query
      }
    )
  ] });
};

// src/secure/integrations/custom-data/pages/CustomDataFieldMappingNewPage.tsx
import { EmployerMappingNewForm } from "feature-integrations";
import { jsx as jsx91 } from "react/jsx-runtime";
var CustomDataFieldMappingNewPage = ({
  onDone,
  onCancel
}) => {
  return /* @__PURE__ */ jsx91("div", { className: "w-1/3", children: /* @__PURE__ */ jsx91(EmployerMappingNewForm, { onDone, onCancel }) });
};

// src/secure/integrations/custom-data/pages/CustomDataFieldMappingsLayoutPage.tsx
import { useCallback as useCallback40 } from "react";
import { Route as Route4, Routes as Routes4, useNavigate as useNavigate19 } from "react-router-dom";
import { PlusIcon as PlusIcon2 } from "@heroicons/react/24/outline";
import { Breadcrumbs as Breadcrumbs3, EdButtonLink as EdButtonLink6 } from "shared-ui";
import { jsx as jsx92, jsxs as jsxs60 } from "react/jsx-runtime";
var CustomDataFieldMappingsLayoutPage = ({
  integrationsUrl
}) => {
  const navigate = useNavigate19();
  const links = [
    { name: "Field Mappings", href: "" }
  ];
  const onGoToMapping = useCallback40(
    (id) => {
      navigate(`mapping/${id}`);
    },
    [navigate]
  );
  const onGoToList = useCallback40(() => {
    navigate(".");
  }, [navigate]);
  return /* @__PURE__ */ jsxs60("div", { children: [
    /* @__PURE__ */ jsx92("div", { className: "flex border-b bg-white py-3", children: /* @__PURE__ */ jsx92("div", { className: "px-2", children: /* @__PURE__ */ jsx92(
      Breadcrumbs3,
      {
        homeText: "Integrations",
        homeHref: integrationsUrl,
        links
      }
    ) }) }),
    /* @__PURE__ */ jsx92("div", { className: "px-4 pt-2 sm:px-8", children: /* @__PURE__ */ jsxs60(Routes4, { children: [
      /* @__PURE__ */ jsx92(
        Route4,
        {
          path: `new`,
          element: /* @__PURE__ */ jsx92(
            CustomDataFieldMappingNewPage,
            {
              onDone: onGoToMapping,
              onCancel: onGoToList
            }
          )
        }
      ),
      /* @__PURE__ */ jsx92(
        Route4,
        {
          path: `mapping/:fieldMappingId`,
          element: /* @__PURE__ */ jsx92(
            CustomDataFieldMappingDetailPage,
            {
              onDone: onGoToList,
              onBack: onGoToList
            }
          )
        }
      ),
      /* @__PURE__ */ jsx92(
        Route4,
        {
          path: "/",
          element: /* @__PURE__ */ jsxs60("div", { children: [
            /* @__PURE__ */ jsx92("div", { className: "flex items-center justify-between border-b pb-2", children: /* @__PURE__ */ jsx92(EdButtonLink6, { to: "new", name: "new", icon: PlusIcon2 }) }),
            /* @__PURE__ */ jsx92(
              CustomDataFieldMappingListPage,
              {
                onSelect: (m) => onGoToMapping(m.id)
              }
            )
          ] })
        }
      )
    ] }) })
  ] });
};

// src/secure/integrations/config/pages/IntegrationsConfigEmployerMappingDetailPage.tsx
import { useParams as useParams10 } from "react-router-dom";
import { LinkButton as LinkButton4 } from "shared-ui";
import { EmployerMappingEditForm } from "feature-integrations";
import { jsx as jsx93, jsxs as jsxs61 } from "react/jsx-runtime";
var IntegrationsConfigEmployerMappingDetailPage = ({ onDone, onBack }) => {
  const { employerMappingId } = useParams10();
  if (employerMappingId == null) {
    throw Error("employerMappingId Required");
  }
  return /* @__PURE__ */ jsxs61("div", { children: [
    /* @__PURE__ */ jsx93("div", { className: "flex items-center space-x-4 border-b px-2 py-4", children: /* @__PURE__ */ jsx93(LinkButton4, { label: "Back", clicked: () => onBack() }) }),
    /* @__PURE__ */ jsx93("div", { children: /* @__PURE__ */ jsx93(
      EmployerMappingEditForm,
      {
        id: employerMappingId,
        onDone: () => onDone({ id: employerMappingId })
      }
    ) })
  ] });
};

// src/secure/integrations/config/pages/IntegrationsConfigEmployerMappingNewPage.tsx
import { EmployerMappingNewForm as EmployerMappingNewForm2 } from "feature-integrations";
import { jsx as jsx94, jsxs as jsxs62 } from "react/jsx-runtime";
var IntegrationsConfigEmployerMappingNewPage = ({ onDone, onCancel }) => {
  return /* @__PURE__ */ jsxs62("div", { className: "p-8", children: [
    /* @__PURE__ */ jsx94("h1", { className: "text-info-500 text-xl font-medium", children: "Create a new Mapping" }),
    /* @__PURE__ */ jsx94(EmployerMappingNewForm2, { onDone, onCancel })
  ] });
};

// src/secure/integrations/config/pages/__generated__/IntegrationsConfigEmployerMappingListPageQuery.graphql.ts
var node86 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IntegrationsConfigEmployerMappingListPageQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployerMappingList_employerMappings"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IntegrationsConfigEmployerMappingListPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "IntegrationEmployerMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationEmployerMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationEmployerMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationsEmployerMapping",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerMappingId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "integrationType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "elevateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Employer",
                      "kind": "LinkedField",
                      "name": "employer",
                      "plural": false,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "EmployerMappingList_integrationEmployerMappings",
          "kind": "LinkedHandle",
          "name": "integrationEmployerMappings"
        }
      ]
    },
    "params": {
      "cacheID": "0e15eeab57978555d4ae54a7db5e281f",
      "id": null,
      "metadata": {},
      "name": "IntegrationsConfigEmployerMappingListPageQuery",
      "operationKind": "query",
      "text": "query IntegrationsConfigEmployerMappingListPageQuery(\n  $order: [IntegrationsEmployerMappingSort!]!\n  $where: IntegrationsEmployerMappingFilter!\n) {\n  ...EmployerMappingList_employerMappings\n}\n\nfragment EmployerMappingList_employerMappings on Query {\n  integrationEmployerMappings(first: 10, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        employerMappingId\n        createdOn\n        updatedOn\n        integrationType\n        elevateId\n        externalId\n        ...EmployerMappingRow_employerMapping\n        __typename\n      }\n    }\n  }\n}\n\nfragment EmployerMappingRow_employerMapping on IntegrationsEmployerMapping {\n  id\n  createdOn\n  updatedOn\n  integrationType\n  employerMappingId\n  elevateId\n  externalId\n  employer {\n    id\n    name\n  }\n}\n"
    }
  };
}();
node86.hash = "fdb9a4067a3b4bf1a69e6ef92d7ead24";
var IntegrationsConfigEmployerMappingListPageQuery_graphql_default = node86;

// src/secure/integrations/config/pages/IntegrationsConfigEmployerMappingListPage.tsx
import { useLazyLoadQuery as useLazyLoadQuery23 } from "react-relay";
import { PageHeading as PageHeading6 } from "shared-ui";
import { EmployerMappingList } from "feature-integrations";
import { jsx as jsx95, jsxs as jsxs63 } from "react/jsx-runtime";
var graphqlQuery14 = IntegrationsConfigEmployerMappingListPageQuery_graphql_default;
var order = [{ updatedOn: "DESC" }];
var where = {
  isActive: { eq: true }
};
var IntegrationsConfigEmployerMappingListPage = ({ onSelect }) => {
  const query = useLazyLoadQuery23(
    graphqlQuery14,
    { where, order },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs63("div", { className: "pt-4", children: [
    /* @__PURE__ */ jsx95(PageHeading6, { children: "Employer Mappings" }),
    /* @__PURE__ */ jsx95(
      EmployerMappingList,
      {
        onSelect: (node116) => onSelect({ id: node116.id }),
        employerMappingsKey: query
      }
    )
  ] });
};

// src/secure/integrations/config/pages/IntegrationsConfigLayoutPage.tsx
import { useCallback as useCallback41 } from "react";
import { Route as Route5, Routes as Routes5, useNavigate as useNavigate20 } from "react-router-dom";
import { PlusIcon as PlusIcon3 } from "@heroicons/react/24/outline";
import { Breadcrumbs as Breadcrumbs4, EdButtonLink as EdButtonLink7 } from "shared-ui";
import { jsx as jsx96, jsxs as jsxs64 } from "react/jsx-runtime";
var IntegrationsConfigLayoutPage = ({
  integrationsUrl
}) => {
  const navigate = useNavigate20();
  const links = [
    { name: "Elevate Configuration", href: "" }
  ];
  const onGoToMapping = useCallback41(
    (id) => {
      navigate(`mapping/${id}`);
    },
    [navigate]
  );
  const onGoToList = useCallback41(() => {
    navigate(".");
  }, [navigate]);
  return /* @__PURE__ */ jsxs64("div", { children: [
    /* @__PURE__ */ jsx96("div", { className: "flex border-b bg-white py-3", children: /* @__PURE__ */ jsx96("div", { className: "px-2", children: /* @__PURE__ */ jsx96(
      Breadcrumbs4,
      {
        homeText: "Integrations",
        homeHref: integrationsUrl,
        links
      }
    ) }) }),
    /* @__PURE__ */ jsx96("div", { className: "px-4 pt-2 sm:px-8", children: /* @__PURE__ */ jsxs64(Routes5, { children: [
      /* @__PURE__ */ jsx96(
        Route5,
        {
          path: `new`,
          element: /* @__PURE__ */ jsx96(
            IntegrationsConfigEmployerMappingNewPage,
            {
              onCancel: onGoToList,
              onDone: onGoToMapping
            }
          )
        }
      ),
      /* @__PURE__ */ jsx96(
        Route5,
        {
          path: `mapping/:employerMappingId`,
          element: /* @__PURE__ */ jsx96(
            IntegrationsConfigEmployerMappingDetailPage,
            {
              onDone: onGoToList,
              onBack: onGoToList
            }
          )
        }
      ),
      /* @__PURE__ */ jsx96(
        Route5,
        {
          path: "/",
          element: /* @__PURE__ */ jsxs64("div", { children: [
            /* @__PURE__ */ jsx96("div", { className: "flex items-center justify-between border-b pb-2", children: /* @__PURE__ */ jsx96(EdButtonLink7, { to: "new", name: "name", icon: PlusIcon3 }) }),
            /* @__PURE__ */ jsx96(
              IntegrationsConfigEmployerMappingListPage,
              {
                onSelect: (m) => onGoToMapping(m.id)
              }
            )
          ] })
        }
      )
    ] }) })
  ] });
};

// src/secure/integrations/IntegrationsLayout.tsx
import { Suspense as Suspense67 } from "react";
import { Routes as Routes6, Route as Route6, useNavigate as useNavigate21 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary9 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback9 } from "app-core";
import { EdCard, EdGridLayout, PageHeading as PageHeading7 } from "shared-ui";
import { BullhornLogo } from "feature-integrations";
import { jsx as jsx97, jsxs as jsxs65 } from "react/jsx-runtime";
var IntegrationsLayout = () => {
  const navigate = useNavigate21();
  return /* @__PURE__ */ jsx97(Suspense67, { fallback: "Loading Integrations...", children: /* @__PURE__ */ jsx97(ErrorBoundary9, { FallbackComponent: ErrorBoundaryFallback9, children: /* @__PURE__ */ jsxs65(Routes6, { children: [
    /* @__PURE__ */ jsx97(
      Route6,
      {
        path: "/",
        element: /* @__PURE__ */ jsxs65("div", { className: "p-2", children: [
          /* @__PURE__ */ jsx97(PageHeading7, { children: "Integrations" }),
          /* @__PURE__ */ jsxs65(EdGridLayout, { children: [
            /* @__PURE__ */ jsx97(
              EdCard,
              {
                logo: /* @__PURE__ */ jsx97(BullhornLogo, { height: "2em", width: "5em" }),
                description: /* @__PURE__ */ jsx97("div", { className: "prose-xl text-gray-900", children: "Bullhorn ATS" }),
                onSelected: () => {
                  navigate(`bullhorn`);
                }
              }
            ),
            /* @__PURE__ */ jsx97(
              EdCard,
              {
                title: "Matrix SCM",
                description: /* @__PURE__ */ jsx97("div", { className: "prose-xl text-gray-900", children: "Matrix VMS" }),
                onSelected: () => {
                  navigate(`matrix`);
                }
              }
            ),
            /* @__PURE__ */ jsx97(
              EdCard,
              {
                title: "Elevate Configuration",
                description: /* @__PURE__ */ jsx97("div", { className: "prose-xl text-gray-900", children: "Elevate Configuration" }),
                onSelected: () => {
                  navigate(`config`);
                }
              }
            ),
            /* @__PURE__ */ jsx97(
              EdCard,
              {
                title: "Custom Data",
                description: /* @__PURE__ */ jsx97("div", { className: "prose-xl text-gray-900", children: "Custom Data" }),
                onSelected: () => {
                  navigate(`custom-data`);
                }
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsx97(Route6, { path: "/bullhorn/*", element: /* @__PURE__ */ jsx97(BullhornLayoutPage, {}) }),
    /* @__PURE__ */ jsx97(
      Route6,
      {
        path: "/custom-data/*",
        element: /* @__PURE__ */ jsx97(CustomDataFieldMappingsLayoutPage, { integrationsUrl: "../" })
      }
    ),
    /* @__PURE__ */ jsx97(
      Route6,
      {
        path: "/config/*",
        element: /* @__PURE__ */ jsx97(IntegrationsConfigLayoutPage, { integrationsUrl: "../" })
      }
    ),
    /* @__PURE__ */ jsx97(
      Route6,
      {
        path: "/matrix/*",
        element: /* @__PURE__ */ jsx97("div", { className: "p-8", children: /* @__PURE__ */ jsx97("h1", { children: "Matrix" }) })
      }
    )
  ] }) }) });
};

// src/secure/notifications/AdminNotificationsLayout.tsx
import { Suspense as Suspense70 } from "react";
import { Navigate as Navigate22 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary10 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback10, OutletRoute as OutletRoute17 } from "app-core";
import {
  NotificationTypeLayout,
  NotificationCreateLayout
} from "feature-notifications";
import { EdLink as EdLink7 } from "shared-ui";

// src/secure/notifications/pages/TemplatesRoute.tsx
import { Suspense as Suspense68 } from "react";
import { useNavigate as useNavigate22 } from "react-router-dom";
import { PlusIcon as PlusIcon4 } from "@heroicons/react/24/solid";
import { EmailTemplatesListContainer } from "feature-notifications";
import { Button as Button22, EdLink as EdLink6, Loading as Loading2, PageHeading as PageHeading8 } from "shared-ui";
import { jsx as jsx98, jsxs as jsxs66 } from "react/jsx-runtime";
var TemplatesRoute = () => {
  const navigate = useNavigate22();
  return /* @__PURE__ */ jsx98(Suspense68, { fallback: /* @__PURE__ */ jsx98(Loading2, { label: "Loading Notifications..." }), children: /* @__PURE__ */ jsxs66("div", { className: "p-2", children: [
    /* @__PURE__ */ jsxs66("div", { className: "flex items-baseline border-b", children: [
      /* @__PURE__ */ jsx98(PageHeading8, { children: "Templates" }),
      /* @__PURE__ */ jsx98("div", { children: /* @__PURE__ */ jsx98(EdLink6, { href: "../template-create", name: "Create template", children: /* @__PURE__ */ jsxs66(Button22, { color: "primary", children: [
        "Create Template\xA0",
        /* @__PURE__ */ jsx98(PlusIcon4, { className: "h-5 w-5" })
      ] }) }) })
    ] }),
    /* @__PURE__ */ jsx98(
      EmailTemplatesListContainer,
      {
        onSelect: ({ tenant, notificationType, templateType }) => {
          navigate(
            `../template/${tenant}/${notificationType}/${templateType}`
          );
        }
      }
    )
  ] }) });
};

// src/secure/notifications/pages/NotificationsRoute.tsx
import { Suspense as Suspense69 } from "react";
import { useNavigate as useNavigate23 } from "react-router-dom";
import { Loading as Loading3, PageHeading as PageHeading9 } from "shared-ui";
import { EmailNotificationsListContainer as EmailNotificationsListContainer2 } from "feature-notifications";
import { jsx as jsx99, jsxs as jsxs67 } from "react/jsx-runtime";
var NotificationsRoute = () => {
  const navigate = useNavigate23();
  return /* @__PURE__ */ jsxs67(Suspense69, { fallback: /* @__PURE__ */ jsx99(Loading3, { label: "Loading Notifications..." }), children: [
    /* @__PURE__ */ jsx99("div", { className: "bg-white ", children: /* @__PURE__ */ jsx99("div", { className: "flex items-baseline border-b", children: /* @__PURE__ */ jsx99(PageHeading9, { children: "Notifications" }) }) }),
    /* @__PURE__ */ jsx99(
      EmailNotificationsListContainer2,
      {
        onSelectItem: ({ id }) => {
          navigate(`../notification/${id}`);
        }
      }
    )
  ] });
};

// src/secure/notifications/AdminNotificationsLayout.tsx
import { jsx as jsx100, jsxs as jsxs68 } from "react/jsx-runtime";
var tabs2 = [
  {
    label: "Email Templates",
    to: "../templates",
    description: "Email Templates"
  },
  {
    label: "Email Notifications",
    to: "../notifications",
    description: "Email Notifications"
  }
];
var AdminNotificationsLayout = () => {
  const links = tabs2.map((t) => {
    return /* @__PURE__ */ jsxs68(
      EdLink7,
      {
        name: t.label,
        href: t.to,
        className: "border bg-white p-8",
        children: [
          /* @__PURE__ */ jsx100("div", { className: "text-primary-500 py-2 text-xl", children: t.label }),
          /* @__PURE__ */ jsx100("p", { className: "mt-2 py-2  text-sm text-gray-500", children: t.description })
        ]
      },
      t.to
    );
  });
  return /* @__PURE__ */ jsx100(Suspense70, { fallback: "Loading...", children: /* @__PURE__ */ jsx100(ErrorBoundary10, { FallbackComponent: ErrorBoundaryFallback10, children: /* @__PURE__ */ jsx100("div", { className: "flex sm:m-8", children: /* @__PURE__ */ jsx100("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-3", children: links }) }) }) });
};
var createNotificationRoutes = (environment, context) => {
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx100(OutletRoute17, {}),
      children: [
        {
          path: "home/*",
          element: /* @__PURE__ */ jsx100(AdminNotificationsLayout, {})
        },
        {
          path: "templates/*",
          element: /* @__PURE__ */ jsx100(TemplatesRoute, {})
        },
        {
          path: "template-create/*",
          element: /* @__PURE__ */ jsx100(NotificationCreateLayout, {})
        },
        {
          path: "template/:tenant/:id/:type/*",
          element: /* @__PURE__ */ jsx100(NotificationTypeLayout, {})
        },
        {
          path: "notifications/*",
          element: /* @__PURE__ */ jsx100(NotificationsRoute, {})
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx100(Navigate22, { to: "home", replace: true })
        }
      ]
    }
  ];
};

// src/secure/workflows/pages/WorkflowDesignerPage.tsx
import { jsx as jsx101 } from "react/jsx-runtime";
var WorkflowDesignerPage = () => {
  return /* @__PURE__ */ jsx101("div", { className: "m-8", children: "Workflow Designer Is Hosted In A Specific Admin Portal" });
};

// src/secure/workflows/pages/WorkflowHomePage.tsx
import { jsx as jsx102 } from "react/jsx-runtime";
var WorkflowHomePage = () => {
  return /* @__PURE__ */ jsx102("div", { children: "Workflows" });
};

// src/secure/workflows/WorkflowsLayout.tsx
import { Routes as Routes7, Route as Route7, useLocation as useLocation11 } from "react-router-dom";
import { PhotoIcon as PhotoIcon2, Squares2X2Icon as Squares2X2Icon2 } from "@heroicons/react/24/outline";
import { ErrorBoundary as ErrorBoundary11 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback11 } from "app-core";
import { createLinkState as createLinkState10, TabPills as TabPills2 } from "shared-ui";
import { jsx as jsx103, jsxs as jsxs69 } from "react/jsx-runtime";
var WorkflowsLayout = () => {
  const location = useLocation11();
  const tabs4 = [
    createLinkState10(location, "Workflows", ``, Squares2X2Icon2),
    createLinkState10(location, "Designer", `designer`, PhotoIcon2)
  ];
  return /* @__PURE__ */ jsxs69(ErrorBoundary11, { FallbackComponent: ErrorBoundaryFallback11, children: [
    /* @__PURE__ */ jsx103("div", { className: "border-b px-4 py-2 sm:px-8", children: /* @__PURE__ */ jsx103(TabPills2, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsxs69(Routes7, { children: [
      /* @__PURE__ */ jsx103(Route7, { path: "/", element: /* @__PURE__ */ jsx103(WorkflowHomePage, {}) }),
      /* @__PURE__ */ jsx103(Route7, { path: "/designer", element: /* @__PURE__ */ jsx103(WorkflowDesignerPage, {}) })
    ] })
  ] });
};

// src/secure/system/SystemsLayout.tsx
import { Routes as Routes9, Route as Route9 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary12 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback12 } from "app-core";

// src/secure/system/components/SystemConfigurationLayout.tsx
import { Navigate as Navigate23, Route as Route8, Routes as Routes8, useLocation as useLocation12 } from "react-router-dom";
import { Squares2X2Icon as Squares2X2Icon3 } from "@heroicons/react/24/outline";
import { createLinkState as createLinkState11, TabPills as TabPills3 } from "shared-ui";

// src/secure/system/components/hosting/__generated__/HostingTenantsContainerQuery.graphql.ts
var node87 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "HostingTenantsContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HostingTenantsList_tenants"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "HostingTenantsContainerQuery",
      "selections": [
        {
          "alias": "tenants",
          "args": v1,
          "concreteType": "PlatformHostingTenantsConnection",
          "kind": "LinkedField",
          "name": "platformHostingTenants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PlatformHostingTenantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "HostingTenant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HostStyleConfiguration",
                      "kind": "LinkedField",
                      "name": "styling",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "faviconUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "logoUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "primaryColor",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "secondaryColor",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "tenants",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "HostingTenantsList_tenants",
          "kind": "LinkedHandle",
          "name": "platformHostingTenants"
        }
      ]
    },
    "params": {
      "cacheID": "fe2642917c311ee5aac2891087999ca9",
      "id": null,
      "metadata": {},
      "name": "HostingTenantsContainerQuery",
      "operationKind": "query",
      "text": "query HostingTenantsContainerQuery(\n  $order: [HostingTenantSortInput!]!\n  $where: HostingTenantFilter!\n) {\n  ...HostingTenantsList_tenants\n}\n\nfragment HostingTenantRow_tenant on HostingTenant {\n  id\n  name\n  isDefault\n  version\n  styling {\n    faviconUrl\n    logoUrl\n    primaryColor\n    secondaryColor\n  }\n}\n\nfragment HostingTenantsList_tenants on Query {\n  tenants: platformHostingTenants(first: 10, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...HostingTenantRow_tenant\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node87.hash = "b47542d5a91ce3b2e00a0ac2190e9096";
var HostingTenantsContainerQuery_graphql_default = node87;

// src/secure/system/components/hosting/HostingTenantsContainer.tsx
import { useLazyLoadQuery as useLazyLoadQuery24 } from "react-relay/hooks";

// src/secure/system/components/hosting/__generated__/HostingTenantsListPaginationQuery.graphql.ts
var node88 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "HostingTenantsListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "HostingTenantsList_tenants"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "HostingTenantsListPaginationQuery",
      "selections": [
        {
          "alias": "tenants",
          "args": v3,
          "concreteType": "PlatformHostingTenantsConnection",
          "kind": "LinkedField",
          "name": "platformHostingTenants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PlatformHostingTenantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "HostingTenant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HostStyleConfiguration",
                      "kind": "LinkedField",
                      "name": "styling",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "faviconUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "logoUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "primaryColor",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "secondaryColor",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "tenants",
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "HostingTenantsList_tenants",
          "kind": "LinkedHandle",
          "name": "platformHostingTenants"
        }
      ]
    },
    "params": {
      "cacheID": "dc95576d47292e878654c9aabc053687",
      "id": null,
      "metadata": {},
      "name": "HostingTenantsListPaginationQuery",
      "operationKind": "query",
      "text": "query HostingTenantsListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $order: [HostingTenantSortInput!]\n  $where: HostingTenantFilter\n) {\n  ...HostingTenantsList_tenants_2HEEH6\n}\n\nfragment HostingTenantRow_tenant on HostingTenant {\n  id\n  name\n  isDefault\n  version\n  styling {\n    faviconUrl\n    logoUrl\n    primaryColor\n    secondaryColor\n  }\n}\n\nfragment HostingTenantsList_tenants_2HEEH6 on Query {\n  tenants: platformHostingTenants(first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...HostingTenantRow_tenant\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node88.hash = "3142d2441a11a8a5873cc2fd8550137c";
var HostingTenantsListPaginationQuery_graphql_default = node88;

// src/secure/system/components/hosting/__generated__/HostingTenantsList_tenants.graphql.ts
var node89 = function() {
  var v0 = [
    "tenants"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": HostingTenantsListPaginationQuery_graphql_default
      }
    },
    "name": "HostingTenantsList_tenants",
    "selections": [
      {
        "alias": "tenants",
        "args": null,
        "concreteType": "PlatformHostingTenantsConnection",
        "kind": "LinkedField",
        "name": "__HostingTenantsList_tenants_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlatformHostingTenantsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HostingTenant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "HostingTenantRow_tenant"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node89.hash = "3142d2441a11a8a5873cc2fd8550137c";
var HostingTenantsList_tenants_graphql_default = node89;

// src/secure/system/components/hosting/HostingTenantsList.tsx
import { useCallback as useCallback43 } from "react";
import { usePaginationFragment as usePaginationFragment6 } from "react-relay/hooks";
import { isNotNull } from "shared-lib";
import { EdListHeader, EdTable } from "shared-ui";

// src/secure/system/components/hosting/__generated__/HostingTenantRow_tenant.graphql.ts
var node90 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HostingTenantRow_tenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HostStyleConfiguration",
      "kind": "LinkedField",
      "name": "styling",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "faviconUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logoUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondaryColor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HostingTenant",
  "abstractKey": null
};
node90.hash = "8b38852fb7ddc252577433e1277354d3";
var HostingTenantRow_tenant_graphql_default = node90;

// src/secure/system/components/hosting/HostingTenantRow.tsx
import { useCallback as useCallback42 } from "react";
import { useFragment as useFragment6 } from "react-relay";
import {
  EdActionCell,
  EdColumnCell,
  EdRow,
  LinkButton as LinkButton5
} from "shared-ui";
import { jsx as jsx104, jsxs as jsxs70 } from "react/jsx-runtime";
var fragmentDef11 = HostingTenantRow_tenant_graphql_default;
var HostingTenantTableColumns = [
  { id: "name", name: "Name" },
  { id: "isDefault", name: "Default" },
  { id: "version", name: "Version" },
  { id: "styling", name: "Styling" }
];
var HostingTenantRow = ({
  fragmentRef,
  selected
}) => {
  const data = useFragment6(fragmentDef11, fragmentRef);
  const select = useCallback42(() => {
    selected(data);
  }, [data, selected]);
  return /* @__PURE__ */ jsxs70(EdRow, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx104(EdColumnCell, { children: data.name }),
    /* @__PURE__ */ jsx104(EdColumnCell, { children: data.isDefault ? "Yes" : "No" }),
    /* @__PURE__ */ jsx104(EdColumnCell, { children: data.version }),
    /* @__PURE__ */ jsxs70(EdColumnCell, { children: [
      data.styling?.faviconUrl && /* @__PURE__ */ jsxs70("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx104("div", { className: "text-primary-500 w-16", children: "favicon" }),
        /* @__PURE__ */ jsx104("div", { children: data.styling?.faviconUrl })
      ] }),
      data.styling?.logoUrl && /* @__PURE__ */ jsxs70("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx104("div", { className: "text-primary-500 w-16", children: "logo" }),
        /* @__PURE__ */ jsx104("div", { children: data.styling?.logoUrl })
      ] })
    ] }),
    /* @__PURE__ */ jsx104(EdActionCell, { children: /* @__PURE__ */ jsx104(LinkButton5, { label: "Select", clicked: select }) })
  ] });
};

// src/secure/system/components/hosting/HostingTenantsList.tsx
import { jsx as jsx105, jsxs as jsxs71 } from "react/jsx-runtime";
var fragmentDef12 = HostingTenantsList_tenants_graphql_default;
var HostingTenantsList = ({
  fragmentRef
}) => {
  const paging = usePaginationFragment6(fragmentDef12, fragmentRef);
  const { data, refetch } = paging;
  const onSortChanged = useCallback43((columns) => {
    console.log(columns);
  }, []);
  const rows = data.tenants?.edges?.map((e) => e.node).filter(isNotNull).map((e) => {
    return /* @__PURE__ */ jsx105(
      HostingTenantRow,
      {
        fragmentRef: e,
        selected: () => {
          console.log(e);
        }
      },
      e.id
    );
  });
  return /* @__PURE__ */ jsxs71("div", { className: "flex flex-col overflow-hidden", children: [
    /* @__PURE__ */ jsx105(EdListHeader, { total: data.tenants?.totalCount, paging }),
    /* @__PURE__ */ jsx105("div", { className: "flex ", children: /* @__PURE__ */ jsx105("div", { className: "w-full", children: /* @__PURE__ */ jsx105(
      EdTable,
      {
        defaultColumns: HostingTenantTableColumns,
        rows,
        onSortChanged
      }
    ) }) })
  ] });
};

// src/secure/system/components/hosting/HostingTenantsContainer.tsx
import { jsx as jsx106, jsxs as jsxs72 } from "react/jsx-runtime";
var queryDef36 = HostingTenantsContainerQuery_graphql_default;
var HostingTenantsContainer = () => {
  const order2 = [{ updatedOn: "DESC" }];
  const where2 = {};
  const query = useLazyLoadQuery24(
    queryDef36,
    { order: order2, where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs72("div", { children: [
    /* @__PURE__ */ jsx106("div", { className: "mb-2 py-2", children: /* @__PURE__ */ jsx106("h1", { children: "Hosting Tenants" }) }),
    /* @__PURE__ */ jsx106(HostingTenantsList, { fragmentRef: query })
  ] });
};

// src/secure/system/components/SystemConfigurationLayout.tsx
import { jsx as jsx107, jsxs as jsxs73 } from "react/jsx-runtime";
var SystemConfigurationLayout = () => {
  const location = useLocation12();
  const tabs4 = [
    createLinkState11(location, "Hosting", `hosting`, Squares2X2Icon3)
  ];
  return /* @__PURE__ */ jsxs73("div", { className: "m-4 p-4", children: [
    /* @__PURE__ */ jsx107("div", { className: "border-b px-4 py-2 sm:px-8", children: /* @__PURE__ */ jsx107(TabPills3, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsxs73(Routes8, { children: [
      /* @__PURE__ */ jsx107(Route8, { path: "/", element: /* @__PURE__ */ jsx107(Navigate23, { to: "hosting" }) }),
      /* @__PURE__ */ jsx107(
        Route8,
        {
          path: "/hosting/*",
          element: /* @__PURE__ */ jsx107("div", { className: "p-2", children: /* @__PURE__ */ jsx107(HostingTenantsContainer, {}) })
        }
      )
    ] })
  ] });
};

// src/secure/system/SystemsLayout.tsx
import { jsx as jsx108 } from "react/jsx-runtime";
var SystemsLayout = () => {
  return /* @__PURE__ */ jsx108(ErrorBoundary12, { FallbackComponent: ErrorBoundaryFallback12, children: /* @__PURE__ */ jsx108(Routes9, { children: /* @__PURE__ */ jsx108(Route9, { path: "/*", element: /* @__PURE__ */ jsx108(SystemConfigurationLayout, {}) }) }) });
};

// src/secure/recruit/talent-pools/TalentPoolsLayout.tsx
import { useCallback as useCallback54 } from "react";
import {
  Navigate as Navigate27,
  Outlet as Outlet15,
  useLocation as useLocation14,
  useNavigate as useNavigate33
} from "react-router-dom";
import { UsersIcon as UsersIcon3 } from "@heroicons/react/24/outline";
import { createLinkState as createLinkState13, TabPills as TabPills5 } from "shared-ui";
import { TalentPoolListContainer } from "feature-recruit";

// src/secure/recruit/talent-pools/components/TalentPoolCreateContainer.tsx
import { Suspense as Suspense71, useCallback as useCallback44 } from "react";
import { useNavigate as useNavigate24 } from "react-router-dom";
import { EdSkeleton as EdSkeleton49 } from "shared-ui";
import { TalentPoolCreateEditor } from "feature-recruit";
import { jsx as jsx109 } from "react/jsx-runtime";
var TalentPoolCreateContainer = () => {
  const navigate = useNavigate24();
  const onCreated = useCallback44(
    ({ code }) => {
      navigate(`../${code}`);
    },
    [navigate]
  );
  const onCancel = useCallback44(() => {
    navigate(`../list`);
  }, [navigate]);
  return /* @__PURE__ */ jsx109(Suspense71, { fallback: /* @__PURE__ */ jsx109(EdSkeleton49, {}), children: /* @__PURE__ */ jsx109(TalentPoolCreateEditor, { onDone: onCreated, onCancel }) });
};

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolRouteQuery.graphql.ts
var node91 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "theme",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enabled",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "inviteOnly",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "customInviteLink",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "joinDeclinedLink",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitTalentPoolTheme",
    "kind": "LinkedField",
    "name": "customTheme",
    "plural": false,
    "selections": [
      v2,
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "logoUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heroBgColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heroBorderColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heroTextColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryButtonTextColor",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v14 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolRouteQuery",
      "selections": [
        {
          "alias": "talentPool",
          "args": v1,
          "concreteType": "RecruitTalentPool",
          "kind": "LinkedField",
          "name": "recruitTalentPoolByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TalentPoolContainer_talentPool"
            },
            v14
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolRouteQuery",
      "selections": [
        {
          "alias": "talentPool",
          "args": v1,
          "concreteType": "RecruitTalentPool",
          "kind": "LinkedField",
          "name": "recruitTalentPoolByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            v14
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "3074a3f5590e063fa2a5d832b3eca568",
      "id": null,
      "metadata": {},
      "name": "TalentPoolRouteQuery",
      "operationKind": "query",
      "text": "query TalentPoolRouteQuery(\n  $talentPoolCode: Int!\n) {\n  talentPool: recruitTalentPoolByCode(code: $talentPoolCode) {\n    id\n    code\n    talentPoolId\n    name\n    description\n    theme\n    enabled\n    inviteOnly\n    slug\n    customInviteLink\n    joinDeclinedLink\n    customTheme {\n      id\n      name\n      primaryColor\n      logoUrl\n      heroBgColor\n      heroBorderColor\n      heroTextColor\n      primaryButtonTextColor\n    }\n    ...TalentPoolContainer_talentPool\n  }\n}\n\nfragment TalentPoolContainer_talentPool on RecruitTalentPool {\n  id\n  talentPoolId\n  name\n  description\n  theme\n  enabled\n  inviteOnly\n  slug\n  customInviteLink\n  joinDeclinedLink\n  customTheme {\n    id\n    name\n    primaryColor\n    logoUrl\n    heroBgColor\n    heroBorderColor\n    heroTextColor\n    primaryButtonTextColor\n  }\n  ...TalentPoolUpdateEditor_talentPool\n}\n\nfragment TalentPoolUpdateEditor_talentPool on RecruitTalentPool {\n  id\n  talentPoolId\n  name\n  description\n  theme\n  enabled\n  inviteOnly\n  slug\n  customInviteLink\n  joinDeclinedLink\n  customTheme {\n    id\n    name\n    primaryColor\n    logoUrl\n    heroBgColor\n    heroBorderColor\n    heroTextColor\n    primaryButtonTextColor\n  }\n}\n"
    }
  };
}();
node91.hash = "131cd053e77e2d58444a954747f8146c";
var TalentPoolRouteQuery_graphql_default = node91;

// src/secure/recruit/talent-pools/components/TalentPoolRoute.tsx
import { Suspense as Suspense80, useCallback as useCallback53 } from "react";
import {
  Navigate as Navigate26,
  Outlet as Outlet14,
  useLocation as useLocation13,
  useNavigate as useNavigate32,
  useRouteLoaderData as useRouteLoaderData8
} from "react-router-dom";
import {
  loadQuery as loadQuery35,
  usePreloadedQuery as usePreloadedQuery10
} from "react-relay";
import { UserGroupIcon as UserGroupIcon2, UsersIcon as UsersIcon2 } from "@heroicons/react/24/outline";
import { useRouteData as useRouteData27 } from "shared-lib";
import { createLinkState as createLinkState12, EdSkeleton as EdSkeleton58, TabPills as TabPills4 } from "shared-ui";
import { OutletRoute as OutletRoute20 } from "app-core";
import { TalentPoolContainer } from "feature-recruit";

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolEmployerAccessListContainerQuery.graphql.ts
var node92 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "seqId": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolEmployerAccessListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TalentPoolEmployerAccessListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolEmployerAccessListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitTalentPoolEmployerAccessConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolEmployerAccessEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolEmployerAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolEmployerAccessId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canUpdate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canInviteMembers",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canViewMembers",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canAddAccess",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "TalentPoolEmployerAccessListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitTalentPoolEmployerAccess"
        }
      ]
    },
    "params": {
      "cacheID": "b2fd7e22ab7aeddb09de277232c687a1",
      "id": null,
      "metadata": {},
      "name": "TalentPoolEmployerAccessListContainerQuery",
      "operationKind": "query",
      "text": "query TalentPoolEmployerAccessListContainerQuery(\n  $where: RecruitTalentPoolEmployerAccessFilter!\n) {\n  ...TalentPoolEmployerAccessListContainer_list\n}\n\nfragment TalentPoolEmployerAccessListContainer_list on Query {\n  list: recruitTalentPoolEmployerAccess(first: 10, order: [{seqId: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        talentPoolEmployerAccessId\n        code\n        version\n        talentPoolId\n        employerId\n        employerName\n        canUpdate\n        canInviteMembers\n        canViewMembers\n        canAddAccess\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node92.hash = "8063d0021be73912516c21661a67409d";
var TalentPoolEmployerAccessListContainerQuery_graphql_default = node92;

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolEmployerAccessListContainerPaginationQuery.graphql.ts
var node93 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "seqId": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolEmployerAccessListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "TalentPoolEmployerAccessListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolEmployerAccessListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "RecruitTalentPoolEmployerAccessConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolEmployerAccessEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolEmployerAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolEmployerAccessId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canUpdate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canInviteMembers",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canViewMembers",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canAddAccess",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "TalentPoolEmployerAccessListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitTalentPoolEmployerAccess"
        }
      ]
    },
    "params": {
      "cacheID": "5e3e75b31c1422c5d0618ca755524f27",
      "id": null,
      "metadata": {},
      "name": "TalentPoolEmployerAccessListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query TalentPoolEmployerAccessListContainerPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RecruitTalentPoolEmployerAccessFilter\n) {\n  ...TalentPoolEmployerAccessListContainer_list_2HEEH6\n}\n\nfragment TalentPoolEmployerAccessListContainer_list_2HEEH6 on Query {\n  list: recruitTalentPoolEmployerAccess(first: $first, after: $after, order: [{seqId: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        talentPoolEmployerAccessId\n        code\n        version\n        talentPoolId\n        employerId\n        employerName\n        canUpdate\n        canInviteMembers\n        canViewMembers\n        canAddAccess\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node93.hash = "9f8b0eee4dd4b774c6e35ac52f32cd3f";
var TalentPoolEmployerAccessListContainerPaginationQuery_graphql_default = node93;

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolEmployerAccessListContainer_list.graphql.ts
var node94 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": TalentPoolEmployerAccessListContainerPaginationQuery_graphql_default
      }
    },
    "name": "TalentPoolEmployerAccessListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "seqId": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitTalentPoolEmployerAccessConnection",
        "kind": "LinkedField",
        "name": "__TalentPoolEmployerAccessListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitTalentPoolEmployerAccessEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitTalentPoolEmployerAccess",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "talentPoolEmployerAccessId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "talentPoolId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canUpdate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canInviteMembers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canViewMembers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canAddAccess",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node94.hash = "9f8b0eee4dd4b774c6e35ac52f32cd3f";
var TalentPoolEmployerAccessListContainer_list_graphql_default = node94;

// src/secure/recruit/talent-pools/components/TalentPoolEmployerAccessListContainer.tsx
import { Suspense as Suspense72, useCallback as useCallback45, useState as useState18 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery25, usePaginationFragment as usePaginationFragment7 } from "react-relay";
import {
  Button as Button23,
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader6,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement6,
  EdSkeleton as EdSkeleton50,
  Input as Input11,
  ListLayout as ListLayout6
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined6, useDebounce as useDebounce11 } from "shared-lib";
import { jsx as jsx110, jsxs as jsxs74 } from "react/jsx-runtime";
var queryDef37 = TalentPoolEmployerAccessListContainerQuery_graphql_default;
var fragmentDef13 = TalentPoolEmployerAccessListContainer_list_graphql_default;
function createLinkTo6(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List5 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment7(fragmentDef13, fragmentRef);
  const onLoadNext = useCallback45(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined6).map((access) => {
    const name = `${access.employerName}`;
    return {
      key: access.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx110("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs74("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx110("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx110("div", { className: "text-md text-blue-500", children: access.code })
      ] }) }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: access.code
      },
      element: /* @__PURE__ */ jsx110(DefaultListLayoutSectionElement6, { children: /* @__PURE__ */ jsx110("div", { className: "grid", children: /* @__PURE__ */ jsx110("div", { children: access.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx110(Suspense72, { fallback: /* @__PURE__ */ jsx110(EdSkeleton50, {}), children: /* @__PURE__ */ jsx110(
    ListLayout6,
    {
      title: "Employer Access",
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx110(
        DefaultListLayoutItemHeader6,
        {
          title: "Employer Access",
          to: createLinkTo6,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  ) });
};
var TalentPoolEmployerAccessListContainer = ({
  onCreate,
  talentPoolId
}) => {
  const [filter, setFilter] = useState18(null);
  const searchTerm = useDebounce11(filter, 500);
  let where2 = {};
  if (talentPoolId) {
    where2 = {
      ...where2,
      talentPoolId: { eq: talentPoolId }
    };
  }
  if (searchTerm) {
    where2.or = [{ employerName: { startsWith: filter } }];
  }
  const query = useLazyLoadQuery25(
    queryDef37,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs74("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsxs74("div", { className: "flex items-center justify-between space-x-4 border-b", children: [
      /* @__PURE__ */ jsxs74("div", { className: "flex items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx110("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
        /* @__PURE__ */ jsx110("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx110(
          Input11,
          {
            placeholder: " Name ",
            name: "filter",
            onValueChange: (filter2) => setFilter(filter2)
          },
          "filter"
        ) })
      ] }),
      /* @__PURE__ */ jsx110("div", { children: /* @__PURE__ */ jsx110(Button23, { clicked: onCreate, color: "primary", children: "Add Access" }) })
    ] }),
    /* @__PURE__ */ jsx110("div", { className: "flex-1", children: /* @__PURE__ */ jsx110(List5, { fragmentRef: query }) })
  ] });
};

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolEmployerAccessContainerQuery.graphql.ts
var node95 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolEmployerAccessCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolEmployerAccessCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolEmployerAccessId",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canUpdate",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canInviteMembers",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canViewMembers",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canAddAccess",
    "storageKey": null
  }, v12 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolEmployerAccessContainerQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "RecruitTalentPoolEmployerAccess",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TalentPoolEmployerAccessForm_talentPoolAccess"
            },
            v12
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolEmployerAccessContainerQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "RecruitTalentPoolEmployerAccess",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c3ef1708a27c76eade5a07550d91d782",
      "id": null,
      "metadata": {},
      "name": "TalentPoolEmployerAccessContainerQuery",
      "operationKind": "query",
      "text": "query TalentPoolEmployerAccessContainerQuery(\n  $talentPoolEmployerAccessCode: Int!\n) {\n  access: recruitTalentPoolEmployerAccessByCode(code: $talentPoolEmployerAccessCode) {\n    talentPoolEmployerAccessId\n    code\n    version\n    talentPoolId\n    employerId\n    employerName\n    canUpdate\n    canInviteMembers\n    canViewMembers\n    canAddAccess\n    ...TalentPoolEmployerAccessForm_talentPoolAccess\n    id\n  }\n}\n\nfragment TalentPoolEmployerAccessForm_talentPoolAccess on RecruitTalentPoolEmployerAccess {\n  talentPoolEmployerAccessId\n  code\n  version\n  talentPoolId\n  employerId\n  employerName\n  canUpdate\n  canInviteMembers\n  canViewMembers\n  canAddAccess\n}\n"
    }
  };
}();
node95.hash = "ac52e61e9e07be826f2984b09dc498f1";
var TalentPoolEmployerAccessContainerQuery_graphql_default = node95;

// src/secure/recruit/talent-pools/components/TalentPoolEmployerAccessContainer.tsx
import { Fragment as Fragment34, Suspense as Suspense73, useCallback as useCallback46 } from "react";
import { useNavigate as useNavigate25 } from "react-router-dom";
import { loadQuery as loadQuery32 } from "react-relay";
import { createClientMutationId as createClientMutationId15, useRouteData as useRouteData23, useToggle as useToggle10 } from "shared-lib";
import {
  BooleanIcon as BooleanIcon2,
  Button as Button24,
  DescriptionItem as DescriptionItem3,
  DescriptionList as DescriptionList2,
  EdSkeleton as EdSkeleton51,
  Size as Size9
} from "shared-ui";
import {
  TalentPoolEmployerAccessForm,
  useTalentPoolEmployerAccessRemove
} from "feature-recruit";
import { Fragment as Fragment35, jsx as jsx111, jsxs as jsxs75 } from "react/jsx-runtime";
var queryDef38 = TalentPoolEmployerAccessContainerQuery_graphql_default;
async function loader32(environment, params) {
  const code = params.talentPoolEmployerAccessCode;
  const talentPoolEmployerAccessCode = parseInt(code);
  return loadQuery32(
    environment,
    queryDef38,
    {
      talentPoolEmployerAccessCode
    }
  );
}
var TalentPoolEmployerAccessContainer = ({ routeId: routeId6 }) => {
  const navigate = useNavigate25();
  const [removeAccess, isRemovingAccess] = useTalentPoolEmployerAccessRemove();
  const [isEditing, toggleIsEditing] = useToggle10();
  const [isRemoving, toggleIsRemoving] = useToggle10();
  const data = useRouteData23(
    queryDef38,
    routeId6
  );
  const { access } = data;
  const onRemoveAccess = useCallback46(async () => {
    if (!access) {
      return;
    }
    const input = {
      talentPoolId: access.talentPoolId,
      employerId: access.employerId,
      clientMutationId: createClientMutationId15()
    };
    const response = await removeAccess({ input });
    if (response.data.payload) {
      navigate(`../`);
    }
  }, [removeAccess]);
  if (!data) {
    return /* @__PURE__ */ jsx111(Fragment35, { children: "Loading..." });
  }
  if (!access) {
    return /* @__PURE__ */ jsx111(EdSkeleton51, {});
  }
  return /* @__PURE__ */ jsx111(Suspense73, { fallback: /* @__PURE__ */ jsx111(EdSkeleton51, {}), children: /* @__PURE__ */ jsx111("div", { className: "flex-1", children: /* @__PURE__ */ jsxs75("div", { className: "flex flex-1 flex-col gap-2 border bg-white p-4", children: [
    /* @__PURE__ */ jsxs75("div", { className: "flex items-center justify-between gap-2 border-b p-4", children: [
      /* @__PURE__ */ jsxs75("div", { className: "flex items-center gap-4 pt-2 text-sm", children: [
        /* @__PURE__ */ jsx111("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx111("div", { className: "text-primary-500 px-1 text-xl font-bold", children: access.employerName }) }),
        /* @__PURE__ */ jsx111("div", { className: "flex items-center gap-2 pt-2 text-sm", children: /* @__PURE__ */ jsx111("div", { className: "text-primary-500 text-sm font-bold", children: access.code }) })
      ] }),
      /* @__PURE__ */ jsxs75("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx111(Button24, { color: "warning", clicked: toggleIsRemoving, children: "Remove" }),
        isEditing ? /* @__PURE__ */ jsx111(Button24, { color: "gray", clicked: toggleIsEditing, children: "Cancel" }) : /* @__PURE__ */ jsx111(Button24, { color: "primary", clicked: toggleIsEditing, children: "Edit" })
      ] })
    ] }),
    isRemoving && /* @__PURE__ */ jsx111("div", { className: "m-8 flex items-center justify-center", children: /* @__PURE__ */ jsx111("div", { className: "sm:w-1/2", children: /* @__PURE__ */ jsx111(
      Button24,
      {
        color: "warning",
        size: Size9.xl,
        clicked: onRemoveAccess,
        disabled: isRemovingAccess,
        children: "Remove, Are you Sure ?"
      }
    ) }) }),
    isEditing ? /* @__PURE__ */ jsx111("div", { className: "m-4 border border-gray-100", children: /* @__PURE__ */ jsx111(
      TalentPoolEmployerAccessForm,
      {
        fragmentRef: access,
        onDone: toggleIsEditing,
        onCancel: toggleIsEditing
      }
    ) }) : /* @__PURE__ */ jsx111(
      DescriptionList2,
      {
        classes: "w-full",
        heading: /* @__PURE__ */ jsx111("div", { className: "flex items-center", children: "Access Controls" }),
        items: /* @__PURE__ */ jsxs75(Fragment34, { children: [
          /* @__PURE__ */ jsx111(DescriptionItem3, { label: "Can Update", children: /* @__PURE__ */ jsx111(BooleanIcon2, { value: access.canUpdate }) }),
          /* @__PURE__ */ jsx111(DescriptionItem3, { label: "Can Add Access", children: /* @__PURE__ */ jsx111(BooleanIcon2, { value: access.canAddAccess }) }),
          /* @__PURE__ */ jsx111(DescriptionItem3, { label: "Can Invite Members", children: /* @__PURE__ */ jsx111(BooleanIcon2, { value: access.canInviteMembers }) }),
          /* @__PURE__ */ jsx111(DescriptionItem3, { label: "Can View Members", children: /* @__PURE__ */ jsx111(BooleanIcon2, { value: access.canViewMembers }) })
        ] })
      }
    )
  ] }) }) });
};
var createRoute22 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-employer-access`;
  return {
    id: routeId6,
    path: ":talentPoolEmployerAccessCode",
    element: /* @__PURE__ */ jsx111(TalentPoolEmployerAccessContainer, { routeId: routeId6, inList }),
    loader: ({ params }) => {
      return loader32(environment, params);
    }
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolAddAccessRoute.tsx
import { Suspense as Suspense74, useCallback as useCallback47 } from "react";
import { useNavigate as useNavigate26 } from "react-router-dom";
import { useRouteData as useRouteData24 } from "shared-lib";
import { EdSkeleton as EdSkeleton52 } from "shared-ui";
import { TalentPoolAddAccessContainer } from "feature-recruit";
import { Fragment as Fragment36, jsx as jsx112 } from "react/jsx-runtime";
var TalentPoolAddAccessRoute = ({ routeId: routeId6 }) => {
  const data = useRouteData24(queryDef39, routeId6);
  const { talentPool } = data;
  const navigate = useNavigate26();
  const onCancel = useCallback47(() => {
    if (!talentPool) {
      return;
    }
    navigate(`../access`);
  }, [navigate]);
  const onDone = useCallback47(
    (code) => {
      navigate(`../${code}`);
    },
    [navigate]
  );
  if (!data) {
    return /* @__PURE__ */ jsx112(Fragment36, { children: "Loading..." });
  }
  if (!talentPool) {
    return /* @__PURE__ */ jsx112(EdSkeleton52, {});
  }
  return /* @__PURE__ */ jsx112(Suspense74, { fallback: /* @__PURE__ */ jsx112(EdSkeleton52, {}), children: /* @__PURE__ */ jsx112(
    TalentPoolAddAccessContainer,
    {
      talentPool,
      onDone,
      onCancel
    }
  ) });
};

// src/secure/recruit/talent-pools/components/TalentPoolInvitesRoute.tsx
import { Suspense as Suspense76, useCallback as useCallback49 } from "react";
import { Link as Link25, Navigate as Navigate24, useNavigate as useNavigate28 } from "react-router-dom";
import { EdSkeleton as EdSkeleton54 } from "shared-ui";
import { OutletRoute as OutletRoute18 } from "app-core";
import { TalentPoolInvitesListContainer } from "feature-recruit";

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolInviteRouteQuery.graphql.ts
var node96 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolInviteCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolInviteCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolInviteId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "source",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateFirstName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateLastName",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateEmail",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceId",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v17 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolInviteRouteQuery",
      "selections": [
        {
          "alias": "invite",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v14,
                v15,
                v16
              ],
              "storageKey": null
            },
            v17
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolInviteRouteQuery",
      "selections": [
        {
          "alias": "invite",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v14,
                v15,
                v16,
                v2
              ],
              "storageKey": null
            },
            v17
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1ee923049f74fef822dc9a54cc1e24a1",
      "id": null,
      "metadata": {},
      "name": "TalentPoolInviteRouteQuery",
      "operationKind": "query",
      "text": "query TalentPoolInviteRouteQuery(\n  $talentPoolInviteCode: Int!\n) {\n  invite: recruitTalentPoolInviteByCode(code: $talentPoolInviteCode) {\n    id\n    talentPoolInviteId\n    code\n    updatedAt\n    talentPoolId\n    candidateId\n    status\n    source\n    candidateFirstName\n    candidateLastName\n    candidateEmail\n    sourceId\n    candidate {\n      firstName\n      lastName\n      email\n      id\n    }\n  }\n}\n"
    }
  };
}();
node96.hash = "0f4427aa6285a7f249828cf08abc8d63";
var TalentPoolInviteRouteQuery_graphql_default = node96;

// src/secure/recruit/talent-pools/components/TalentPoolInviteRoute.tsx
import { Fragment as Fragment37, Suspense as Suspense75, useCallback as useCallback48 } from "react";
import { useNavigate as useNavigate27 } from "react-router-dom";
import { loadQuery as loadQuery33 } from "react-relay";
import { createClientMutationId as createClientMutationId16, useRouteData as useRouteData25, useToggle as useToggle11 } from "shared-lib";
import {
  Button as Button25,
  DescriptionItem as DescriptionItem4,
  DescriptionList as DescriptionList3,
  EdSkeleton as EdSkeleton53,
  Size as Size10
} from "shared-ui";
import {
  useTalentPoolInviteExpire
} from "feature-recruit";
import { Fragment as Fragment38, jsx as jsx113, jsxs as jsxs76 } from "react/jsx-runtime";
var queryDef40 = TalentPoolInviteRouteQuery_graphql_default;
async function loader33(environment, params) {
  const code = params.talentPoolInviteCode;
  const talentPoolInviteCode = parseInt(code);
  return loadQuery33(environment, queryDef40, {
    talentPoolInviteCode
  });
}
var TalentPoolInviteRoute = ({ routeId: routeId6 }) => {
  const navigate = useNavigate27();
  const [expireInvite, isExpiringInvite] = useTalentPoolInviteExpire();
  const [isEditing, toggleIsEditing] = useToggle11();
  const [isRemoving, toggleIsRemoving] = useToggle11();
  const data = useRouteData25(queryDef40, routeId6);
  const { invite } = data;
  const onExpireInvite = useCallback48(async () => {
    if (!invite) {
      return;
    }
    const input = {
      id: invite.talentPoolInviteId,
      clientMutationId: createClientMutationId16()
    };
    const response = await expireInvite({ input });
    if (response.data.payload) {
      navigate(`../`);
    }
  }, [expireInvite]);
  if (!data) {
    return /* @__PURE__ */ jsx113(Fragment38, { children: "Loading..." });
  }
  if (!invite) {
    return /* @__PURE__ */ jsx113(EdSkeleton53, {});
  }
  return /* @__PURE__ */ jsx113(Suspense75, { fallback: /* @__PURE__ */ jsx113(EdSkeleton53, {}), children: /* @__PURE__ */ jsx113("div", { className: "flex-1", children: /* @__PURE__ */ jsxs76("div", { className: "flex flex-1 flex-col gap-2 border bg-white p-4", children: [
    /* @__PURE__ */ jsxs76("div", { className: "flex items-center justify-between gap-2 border-b p-4", children: [
      /* @__PURE__ */ jsxs76("div", { className: "flex items-center gap-4 pt-2 text-sm", children: [
        /* @__PURE__ */ jsxs76("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx113("div", { className: "text-primary-500 text-xl font-bold", children: invite.candidateFirstName }),
          /* @__PURE__ */ jsx113("div", { className: "text-primary-500 text-xl font-bold", children: invite.candidateLastName })
        ] }),
        /* @__PURE__ */ jsxs76("div", { className: "flex items-center gap-2 pt-1 text-sm", children: [
          /* @__PURE__ */ jsx113("div", { className: "text-primary-500 text-sm font-bold", children: invite.code }),
          /* @__PURE__ */ jsx113("div", { className: "text-md text-blue-500", children: invite.status })
        ] })
      ] }),
      /* @__PURE__ */ jsxs76("div", { className: "flex items-center gap-2", children: [
        invite.status !== "Withdrawn" && /* @__PURE__ */ jsx113(Button25, { color: "warning", clicked: toggleIsRemoving, children: "Expire" }),
        isEditing ? /* @__PURE__ */ jsx113(Button25, { color: "gray", clicked: toggleIsEditing, children: "Cancel" }) : /* @__PURE__ */ jsx113(Button25, { color: "primary", clicked: toggleIsEditing, children: "Edit" })
      ] })
    ] }),
    isRemoving && /* @__PURE__ */ jsx113("div", { className: "m-8 flex items-center justify-center", children: /* @__PURE__ */ jsx113("div", { className: "sm:w-1/2", children: /* @__PURE__ */ jsx113(
      Button25,
      {
        color: "warning",
        size: Size10.xl,
        clicked: onExpireInvite,
        disabled: isExpiringInvite,
        children: "Expire, Are you Sure ?"
      }
    ) }) }),
    isEditing ? /* @__PURE__ */ jsx113("div", { className: "m-4 border border-gray-100", children: "Editing" }) : /* @__PURE__ */ jsx113(
      DescriptionList3,
      {
        classes: "w-full",
        heading: /* @__PURE__ */ jsx113("div", { className: "flex items-center", children: "Invite" }),
        items: /* @__PURE__ */ jsxs76(Fragment37, { children: [
          /* @__PURE__ */ jsx113(DescriptionItem4, { label: "First Name", children: invite.candidateFirstName }),
          /* @__PURE__ */ jsx113(DescriptionItem4, { label: "Last Name", children: invite.candidateLastName }),
          /* @__PURE__ */ jsx113(DescriptionItem4, { label: "Email", children: invite.candidateEmail }),
          /* @__PURE__ */ jsx113(DescriptionItem4, { label: "source", children: invite.source })
        ] })
      }
    )
  ] }) }) });
};
var createRoute23 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-invite`;
  return {
    id: routeId6,
    path: ":talentPoolInviteCode",
    element: /* @__PURE__ */ jsx113(TalentPoolInviteRoute, { routeId: routeId6, inList }),
    loader: ({ params }) => {
      return loader33(environment, params);
    }
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolInvitesRoute.tsx
import { jsx as jsx114 } from "react/jsx-runtime";
var TalentPoolInvitesRoute = ({ routeId: routeId6 }) => {
  const navigate = useNavigate28();
  const data = useTalentPoolRouteData(routeId6);
  const { talentPool } = data;
  const onCreate = useCallback49(() => {
    navigate("../../../create-invite");
  }, [navigate]);
  if (!talentPool) {
    return /* @__PURE__ */ jsx114(EdSkeleton54, {});
  }
  return /* @__PURE__ */ jsx114(Suspense76, { fallback: /* @__PURE__ */ jsx114(EdSkeleton54, {}), children: /* @__PURE__ */ jsx114("div", { className: "border bg-white p-2", children: /* @__PURE__ */ jsx114(
    TalentPoolInvitesListContainer,
    {
      talentPoolId: talentPool.talentPoolId,
      onCreate
    }
  ) }) });
};
var createRoute24 = (parentRouteId, environment, context) => {
  const routeId6 = `${parentRouteId}-invites`;
  const listRouteId = `${routeId6}-list`;
  return {
    id: routeId6,
    path: "*",
    element: /* @__PURE__ */ jsx114(OutletRoute18, {}),
    handle: {
      crumb: () => /* @__PURE__ */ jsx114(Link25, { to: "invites", children: "Invites" })
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx114(TalentPoolInvitesRoute, { routeId: parentRouteId }),
        children: [createRoute23(listRouteId, environment, context, true)]
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx114(Navigate24, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolMembersRoute.tsx
import { Suspense as Suspense78, useCallback as useCallback51 } from "react";
import { Link as Link26, Navigate as Navigate25, useNavigate as useNavigate30 } from "react-router-dom";
import { EdSkeleton as EdSkeleton56 } from "shared-ui";
import { OutletRoute as OutletRoute19 } from "app-core";
import { TalentPoolMemberListContainer } from "feature-recruit";

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolMemberRouteQuery.graphql.ts
var node97 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolMemberCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolMemberCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolMemberRouteQuery",
      "selections": [
        {
          "alias": "member",
          "args": v1,
          "concreteType": "RecruitTalentPoolMembership",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TalentPoolMemberContainer_member"
            },
            v4
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolMemberRouteQuery",
      "selections": [
        {
          "alias": "member",
          "args": v1,
          "concreteType": "RecruitTalentPoolMembership",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "talentPoolMembershipId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "talentPoolId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAddress",
                  "storageKey": null
                },
                v2
              ],
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "87be4cde47071d82e7087866587ad04b",
      "id": null,
      "metadata": {},
      "name": "TalentPoolMemberRouteQuery",
      "operationKind": "query",
      "text": "query TalentPoolMemberRouteQuery(\n  $talentPoolMemberCode: Long!\n) {\n  member: recruitTalentPoolMembershipByCode(code: $talentPoolMemberCode) {\n    id\n    code\n    ...TalentPoolMemberContainer_member\n  }\n}\n\nfragment TalentPoolMemberContainer_member on RecruitTalentPoolMembership {\n  id\n  talentPoolMembershipId\n  code\n  talentPoolId\n  status\n  updatedOn\n  profile {\n    recruitProfileId\n    firstName\n    lastName\n    emailAddress\n    id\n  }\n}\n"
    }
  };
}();
node97.hash = "c5a0a76db3c1985aa73259c6d94e6a30";
var TalentPoolMemberRouteQuery_graphql_default = node97;

// src/secure/recruit/talent-pools/components/TalentPoolMemberRoute.tsx
import { Suspense as Suspense77, useCallback as useCallback50 } from "react";
import { useNavigate as useNavigate29 } from "react-router-dom";
import { loadQuery as loadQuery34 } from "react-relay";
import { useRouteData as useRouteData26 } from "shared-lib";
import { EdSkeleton as EdSkeleton55 } from "shared-ui";
import { TalentPoolMemberContainer } from "feature-recruit";
import { jsx as jsx115 } from "react/jsx-runtime";
var queryDef41 = TalentPoolMemberRouteQuery_graphql_default;
async function loader34(environment, params) {
  const code = params.talentPoolMemberCode;
  const talentPoolMemberCode = parseInt(code);
  return loadQuery34(environment, queryDef41, {
    talentPoolMemberCode
  });
}
var TalentPoolMemberRoute = ({ routeId: routeId6 }) => {
  const navigate = useNavigate29();
  const data = useRouteData26(queryDef41, routeId6);
  const onRevoked = useCallback50(() => {
    navigate("../");
  }, []);
  const { member } = data;
  if (!member) {
    return /* @__PURE__ */ jsx115(EdSkeleton55, {});
  }
  return /* @__PURE__ */ jsx115(Suspense77, { fallback: /* @__PURE__ */ jsx115(EdSkeleton55, {}), children: /* @__PURE__ */ jsx115("div", { className: "flex-1", children: /* @__PURE__ */ jsx115(TalentPoolMemberContainer, { onRevoked, fragmentRef: member }) }) });
};
var createRoute25 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-member`;
  return {
    id: routeId6,
    path: ":talentPoolMemberCode",
    element: /* @__PURE__ */ jsx115(TalentPoolMemberRoute, { routeId: routeId6, inList }),
    loader: ({ params }) => {
      return loader34(environment, params);
    }
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolMembersRoute.tsx
import { jsx as jsx116 } from "react/jsx-runtime";
var TalentPoolMembersRoute = ({ routeId: routeId6 }) => {
  const navigate = useNavigate30();
  const data = useTalentPoolRouteData(routeId6);
  const { talentPool } = data;
  const onCreate = useCallback51(() => {
    navigate("../../../create-invite");
  }, [navigate]);
  if (!talentPool) {
    return /* @__PURE__ */ jsx116(EdSkeleton56, {});
  }
  return /* @__PURE__ */ jsx116(Suspense78, { fallback: /* @__PURE__ */ jsx116(EdSkeleton56, {}), children: /* @__PURE__ */ jsx116("div", { className: "bg-white", children: /* @__PURE__ */ jsx116(
    TalentPoolMemberListContainer,
    {
      talentPoolId: talentPool.talentPoolId,
      onCreate
    }
  ) }) });
};
var createRoute26 = (parentRouteId, environment, context) => {
  const routeId6 = `${parentRouteId}-members`;
  const listRouteId = `${routeId6}-list`;
  return {
    id: routeId6,
    path: "*",
    element: /* @__PURE__ */ jsx116(OutletRoute19, {}),
    handle: {
      crumb: () => /* @__PURE__ */ jsx116(Link26, { to: "members", children: "Members" })
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx116(TalentPoolMembersRoute, { routeId: parentRouteId }),
        children: [createRoute25(listRouteId, environment, context, true)]
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx116(Navigate25, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolCreateInviteRoute.tsx
import { Suspense as Suspense79, useCallback as useCallback52 } from "react";
import { useNavigate as useNavigate31 } from "react-router-dom";
import { EdSkeleton as EdSkeleton57 } from "shared-ui";
import { TalentPoolCreateInviteContainer } from "feature-recruit";
import { jsx as jsx117 } from "react/jsx-runtime";
var TalentPoolCreateInviteRoute = ({ parentRouteId }) => {
  const data = useTalentPoolRouteData(parentRouteId);
  const navigate = useNavigate31();
  const onDone = useCallback52(
    (talentPoolInviteId) => {
      navigate(`../${talentPoolInviteId}`);
    },
    [navigate]
  );
  const onCancel = useCallback52(() => {
    navigate(`../`);
  }, [navigate]);
  const { talentPool } = data;
  if (!talentPool) {
    return /* @__PURE__ */ jsx117(EdSkeleton57, {});
  }
  return /* @__PURE__ */ jsx117(Suspense79, { fallback: /* @__PURE__ */ jsx117(EdSkeleton57, {}), children: /* @__PURE__ */ jsx117(
    TalentPoolCreateInviteContainer,
    {
      talentPool,
      onDone,
      onCancel
    }
  ) });
};
var createRoute27 = (parentRouteId, environment, context, inList = true) => {
  const routeId6 = `${parentRouteId}-create-invite`;
  return {
    id: routeId6,
    path: "create-invite",
    element: /* @__PURE__ */ jsx117(
      TalentPoolCreateInviteRoute,
      {
        parentRouteId,
        routeId: routeId6,
        inList
      }
    )
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolRoute.tsx
import { Fragment as Fragment39, jsx as jsx118, jsxs as jsxs77 } from "react/jsx-runtime";
var queryDef39 = TalentPoolRouteQuery_graphql_default;
async function loader35(environment, params) {
  const code = params.talentPoolCode;
  const talentPoolCode = parseInt(code);
  return loadQuery35(environment, queryDef39, {
    talentPoolCode
  });
}
function useTalentPoolRouteData(routeId6) {
  const queryRef = useRouteLoaderData8(
    routeId6
  );
  const data = usePreloadedQuery10(queryDef39, queryRef);
  return data;
}
var TalentPoolDetails = ({ routeId: routeId6 }) => {
  const data = useRouteData27(queryDef39, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx118(Fragment39, { children: "Loading..." });
  }
  const { talentPool } = data;
  if (!talentPool) {
    return /* @__PURE__ */ jsx118(EdSkeleton58, {});
  }
  return /* @__PURE__ */ jsx118(Suspense80, { fallback: /* @__PURE__ */ jsx118(EdSkeleton58, {}), children: /* @__PURE__ */ jsx118(TalentPoolContainer, { fragmentRef: talentPool }) });
};
var TalentPoolEmployerAccess = ({ routeId: routeId6 }) => {
  const data = useRouteData27(queryDef39, routeId6);
  const navigate = useNavigate32();
  const onCreate = useCallback53(() => {
    navigate(`../add-access`);
  }, [navigate]);
  if (!data) {
    return /* @__PURE__ */ jsx118(Fragment39, { children: "Loading..." });
  }
  const { talentPool } = data;
  if (!talentPool) {
    return /* @__PURE__ */ jsx118(Fragment39, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx118(Suspense80, { fallback: /* @__PURE__ */ jsx118(EdSkeleton58, {}), children: /* @__PURE__ */ jsx118(
    TalentPoolEmployerAccessListContainer,
    {
      talentPoolId: talentPool.talentPoolId,
      onCreate
    }
  ) });
};
var Layout8 = () => {
  const location = useLocation13();
  const tabs4 = [
    createLinkState12(location, "Details", `details`, UsersIcon2),
    createLinkState12(location, "Access", `access`, UserGroupIcon2),
    createLinkState12(location, "Invites", `invites`, UsersIcon2),
    createLinkState12(location, "Members", `members`, UsersIcon2)
  ];
  return /* @__PURE__ */ jsxs77("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsx118("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx118(TabPills4, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx118(Outlet14, {})
  ] });
};
var createRoute28 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-job-board`;
  const listRouteId = `${routeId6}-list`;
  return {
    id: routeId6,
    path: ":talentPoolCode",
    element: /* @__PURE__ */ jsx118(Layout8, {}),
    loader: ({ params }) => {
      return loader35(environment, params);
    },
    children: [
      {
        id: `${routeId6}-details`,
        path: "details/*",
        element: /* @__PURE__ */ jsx118("div", { className: "flex-1", children: /* @__PURE__ */ jsx118(TalentPoolDetails, { routeId: routeId6, inList }) })
      },
      {
        id: listRouteId,
        path: "access/*",
        element: /* @__PURE__ */ jsx118("div", { className: "flex-1", children: /* @__PURE__ */ jsx118(TalentPoolEmployerAccess, { routeId: routeId6 }) }),
        children: [
          createRoute22(listRouteId, environment, context, true)
        ]
      },
      createRoute22(routeId6, environment, context, false),
      {
        path: "add-access",
        element: /* @__PURE__ */ jsx118(TalentPoolAddAccessRoute, { routeId: routeId6 })
      },
      {
        path: "invites/*",
        element: /* @__PURE__ */ jsx118(OutletRoute20, {}),
        children: [createRoute24(routeId6, environment, context)]
      },
      {
        path: "members/*",
        element: /* @__PURE__ */ jsx118(OutletRoute20, {}),
        children: [createRoute26(routeId6, environment, context)]
      },
      createRoute27(routeId6, environment, context, false),
      {
        path: "*",
        element: /* @__PURE__ */ jsx118(Navigate26, { to: "details", replace: true })
      }
    ]
  };
};

// src/secure/recruit/talent-pools/TalentPoolsLayout.tsx
import { jsx as jsx119, jsxs as jsxs78 } from "react/jsx-runtime";
var Layout9 = () => {
  const location = useLocation14();
  const tabs4 = [
    createLinkState13(location, "List", `list`, UsersIcon3),
    createLinkState13(location, "Create", `create`, UsersIcon3)
  ];
  return /* @__PURE__ */ jsxs78("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx119("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx119(TabPills5, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx119("div", { className: "p-2", children: /* @__PURE__ */ jsx119(Outlet15, {}) })
  ] });
};
var List6 = () => {
  const navigate = useNavigate33();
  const onCreate = useCallback54(() => {
    navigate(`../create`);
  }, [navigate]);
  return /* @__PURE__ */ jsx119(TalentPoolListContainer, { onCreate });
};
var createTalentPoolsRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-talent-pools`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx119(Layout9, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx119(List6, {}),
          children: [
            createRoute28(listRouteId, environment, context, true)
          ]
        },
        createRoute28(routeId6, environment, context, false),
        {
          path: "create",
          element: /* @__PURE__ */ jsx119(TalentPoolCreateContainer, {})
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx119(Navigate27, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/RecruitLayout.tsx
import { Suspense as Suspense95 } from "react";
import { Navigate as Navigate37 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary14 } from "react-error-boundary";
import { EdLink as EdLink8 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback14, OutletRoute as OutletRoute28 } from "app-core";

// src/secure/recruit/config/components/__generated__/RecommendationConfigQuery.graphql.ts
var node98 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = [
    {
      "alias": "config",
      "args": null,
      "concreteType": "RecruitCandidateRecommendationConfig",
      "kind": "LinkedField",
      "name": "recruitRecommendationCandidateConfig",
      "plural": false,
      "selections": [
        v0,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountId",
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": [
            v0,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "experienceSimilarityThreshold",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "combinedScoreThreshold",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobMatchScoreThreshold",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxVacancyOpenDays",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recommendEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sendEnabled",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "RecommendationConfigQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "RecommendationConfigQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "1223de0b651c4355700b9ddc490a8afe",
      "id": null,
      "metadata": {},
      "name": "RecommendationConfigQuery",
      "operationKind": "query",
      "text": "query RecommendationConfigQuery {\n  config: recruitRecommendationCandidateConfig {\n    id\n    version\n    createdOn\n    createdBy {\n      id\n      accountType\n    }\n    experienceSimilarityThreshold\n    combinedScoreThreshold\n    jobMatchScoreThreshold\n    maxVacancyOpenDays\n    recommendEnabled\n    sendEnabled\n  }\n}\n"
    }
  };
}();
node98.hash = "b0eb405e3623bf11c3b1a2198b8370a2";
var RecommendationConfigQuery_graphql_default = node98;

// src/secure/recruit/config/components/RecommendationConfig.tsx
import { Suspense as Suspense81 } from "react";
import { loadQuery as loadQuery36 } from "react-relay";
import { useRouteData as useRouteData28, useToggle as useToggle12 } from "shared-lib";
import {
  BooleanLabel,
  Button as Button26,
  ButtonList as ButtonList4,
  DescriptionItem as DescriptionItem5,
  DescriptionList as DescriptionList4,
  EdSkeleton as EdSkeleton59
} from "shared-ui";

// src/secure/recruit/config/components/RecommendationConfigEditor.tsx
import { useCallback as useCallback55 } from "react";
import * as zod2 from "zod";
import { useForm as useForm4 } from "react-hook-form";
import { zodResolver as zodResolver4 } from "@hookform/resolvers/zod";
import {
  ActionContainer as ActionContainer3,
  ErrorField as ErrorField3,
  FormErrorCodes as FormErrorCodes2,
  FormInputRow as FormInputRow3,
  InputField as InputField3
} from "shared-ui";
import { createClientMutationId as createClientMutationId17 } from "shared-lib";

// src/secure/recruit/config/mutations/__generated__/UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation.graphql.ts
var node99 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitCandidateRecommendationConfig",
    "kind": "LinkedField",
    "name": "recommendation",
    "plural": false,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountId",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountType",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "experienceSimilarityThreshold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "combinedScoreThreshold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobMatchScoreThreshold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxVacancyOpenDays",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recommendEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sendEnabled",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateRecommendationConfigUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateRecommendationConfigUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateRecommendationConfigUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateRecommendationConfigUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d2cd189da409dfb3dc67c6858d64bc73",
      "id": null,
      "metadata": {},
      "name": "UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation(\n  $input: RecruitCandidateRecommendationConfigUpdateInput!\n) {\n  data: recruitCandidateRecommendationConfigUpdate(input: $input) {\n    recommendation {\n      id\n      version\n      createdOn\n      createdBy {\n        id\n        accountType\n      }\n      experienceSimilarityThreshold\n      combinedScoreThreshold\n      jobMatchScoreThreshold\n      maxVacancyOpenDays\n      recommendEnabled\n      sendEnabled\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node99.hash = "55b7ac008f40d0b91c6aef2559ffb2f2";
var UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation_graphql_default = node99;

// src/secure/recruit/config/mutations/UseJobBoardAdCreateCandidateRecommendationConfigUpdate.ts
import { useAsyncMutation as useAsyncMutation18 } from "shared-lib";
var mutationDef18 = UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation_graphql_default;
function useJobBoardAdCreateCandidateRecommendationConfigUpdate() {
  const [commit, isBusy] = useAsyncMutation18(
    mutationDef18
  );
  return [commit, isBusy];
}

// src/secure/recruit/config/components/RecommendationConfigEditor.tsx
import { jsx as jsx120, jsxs as jsxs79 } from "react/jsx-runtime";
var formSchema4 = zod2.object({
  recommendEnabled: zod2.boolean(),
  sendEnabled: zod2.boolean(),
  experienceSimilarityThreshold: zod2.coerce.number(),
  combinedScoreThreshold: zod2.coerce.number(),
  jobMatchScoreThreshold: zod2.coerce.number(),
  maxVacancyOpenDays: zod2.coerce.number()
});
var RecommendationConfigEditor = ({
  onDone,
  onCancel,
  recommendEnabled,
  sendEnabled,
  experienceSimilarityThreshold,
  combinedScoreThreshold,
  jobMatchScoreThreshold,
  maxVacancyOpenDays
}) => {
  const defaultValues = {
    recommendEnabled,
    sendEnabled,
    experienceSimilarityThreshold: Number(experienceSimilarityThreshold),
    combinedScoreThreshold: Number(combinedScoreThreshold),
    jobMatchScoreThreshold: Number(jobMatchScoreThreshold),
    maxVacancyOpenDays: Number(maxVacancyOpenDays)
  };
  const [update, isUpdating] = useJobBoardAdCreateCandidateRecommendationConfigUpdate();
  const { register, handleSubmit, watch, formState, control } = useForm4({
    resolver: zodResolver4(formSchema4),
    defaultValues,
    mode: "onChange"
  });
  const onUpdate = useCallback55(
    async (form) => {
      const input = {
        clientMutationId: createClientMutationId17(),
        recommendEnabled: form.recommendEnabled,
        sendEnabled: form.sendEnabled,
        combinedScoreThreshold: form.combinedScoreThreshold,
        experienceSimilarityThreshold: form.experienceSimilarityThreshold,
        jobMatchScoreThreshold: form.jobMatchScoreThreshold,
        maxVacancyOpenDays: form.maxVacancyOpenDays
      };
      return await update({ input });
    },
    [update]
  );
  const { errors, isValid, isDirty } = formState;
  const onSubmit = handleSubmit(
    async (form) => {
      const response = await onUpdate(form);
      if (response.data.recommendation) {
        onDone();
      }
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  return /* @__PURE__ */ jsxs79("div", { className: "w-full p-4", children: [
    /* @__PURE__ */ jsx120(FormErrorCodes2, {}),
    /* @__PURE__ */ jsx120("form", { onSubmit, children: /* @__PURE__ */ jsxs79(
      ActionContainer3,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        onCancel,
        isDisabled: isUpdating,
        titleTop: `Update Recommendation Config`,
        children: [
          /* @__PURE__ */ jsxs79(FormInputRow3, { name: "recommendEnabled", title: "Enabled *", children: [
            /* @__PURE__ */ jsx120(
              InputField3,
              {
                register,
                type: "checkbox",
                name: "recommendEnabled",
                required: false
              }
            ),
            /* @__PURE__ */ jsx120(ErrorField3, { field: errors.recommendEnabled })
          ] }),
          /* @__PURE__ */ jsxs79(FormInputRow3, { name: "sendEnabled", title: "Send Enabled *", children: [
            /* @__PURE__ */ jsx120(
              InputField3,
              {
                register,
                name: "sendEnabled",
                type: "checkbox",
                required: true
              }
            ),
            /* @__PURE__ */ jsx120(ErrorField3, { field: errors.sendEnabled })
          ] }),
          /* @__PURE__ */ jsxs79(FormInputRow3, { name: "maxVacancyOpenDays", title: "Max Vacancy Open Days", children: [
            /* @__PURE__ */ jsx120(
              InputField3,
              {
                register,
                type: "number",
                name: "maxVacancyOpenDays",
                required: false
              }
            ),
            /* @__PURE__ */ jsx120(ErrorField3, { field: errors.maxVacancyOpenDays })
          ] }),
          /* @__PURE__ */ jsxs79(
            FormInputRow3,
            {
              name: "combinedScoreThreshold",
              title: "Combined Score Threshold",
              children: [
                /* @__PURE__ */ jsx120(
                  InputField3,
                  {
                    register,
                    type: "number",
                    name: "combinedScoreThreshold",
                    required: false
                  }
                ),
                /* @__PURE__ */ jsx120(ErrorField3, { field: errors.combinedScoreThreshold })
              ]
            }
          ),
          /* @__PURE__ */ jsxs79(
            FormInputRow3,
            {
              name: "experienceSimilarityThreshold",
              title: "Experience Similarity Threshold",
              children: [
                /* @__PURE__ */ jsx120(
                  InputField3,
                  {
                    register,
                    type: "number",
                    name: "experienceSimilarityThreshold",
                    required: false
                  }
                ),
                /* @__PURE__ */ jsx120(ErrorField3, { field: errors.experienceSimilarityThreshold })
              ]
            }
          ),
          /* @__PURE__ */ jsxs79(
            FormInputRow3,
            {
              name: "jobMatchScoreThreshold",
              title: "Job Match Score Threshold",
              children: [
                /* @__PURE__ */ jsx120(
                  InputField3,
                  {
                    register,
                    type: "number",
                    name: "jobMatchScoreThreshold",
                    required: false
                  }
                ),
                /* @__PURE__ */ jsx120(ErrorField3, { field: errors.jobMatchScoreThreshold })
              ]
            }
          )
        ]
      }
    ) })
  ] });
};

// src/secure/recruit/config/components/RecommendationConfig.tsx
import { Fragment as Fragment40, jsx as jsx121, jsxs as jsxs80 } from "react/jsx-runtime";
var queryDef42 = RecommendationConfigQuery_graphql_default;
async function loader36(environment, params) {
  return loadQuery36(environment, queryDef42, {});
}
var RecommendationConfig = ({ routeId: routeId6 }) => {
  const [isEditing, toggleIsEditing] = useToggle12();
  const data = useRouteData28(queryDef42, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx121(Fragment40, { children: "Loading..." });
  }
  const { config } = data;
  if (!config) {
    return /* @__PURE__ */ jsx121(EdSkeleton59, {});
  }
  return /* @__PURE__ */ jsx121(Suspense81, { fallback: /* @__PURE__ */ jsx121(EdSkeleton59, {}), children: /* @__PURE__ */ jsx121("div", { className: "bg-white", children: /* @__PURE__ */ jsx121("div", { className: "p-4 lg:p-8", children: /* @__PURE__ */ jsx121("div", { className: "lg:w-1/2", children: isEditing ? /* @__PURE__ */ jsx121("div", { className: "rounded-lg border bg-gray-100", children: /* @__PURE__ */ jsx121(
    RecommendationConfigEditor,
    {
      onDone: toggleIsEditing,
      onCancel: toggleIsEditing,
      recommendEnabled: config.recommendEnabled,
      sendEnabled: config.sendEnabled,
      experienceSimilarityThreshold: config.experienceSimilarityThreshold,
      combinedScoreThreshold: config.combinedScoreThreshold,
      jobMatchScoreThreshold: config.jobMatchScoreThreshold,
      maxVacancyOpenDays: config.maxVacancyOpenDays
    }
  ) }) : /* @__PURE__ */ jsxs80("div", { className: "rounded-lg border bg-gray-100", children: [
    /* @__PURE__ */ jsx121(
      DescriptionList4,
      {
        classes: "w-full",
        heading: /* @__PURE__ */ jsx121("div", { className: "flex items-center", children: "Recommend Config" }),
        items: /* @__PURE__ */ jsxs80(Fragment40, { children: [
          /* @__PURE__ */ jsx121(DescriptionItem5, { label: "Enabled", children: /* @__PURE__ */ jsx121(BooleanLabel, { value: config.recommendEnabled }) }),
          /* @__PURE__ */ jsx121(DescriptionItem5, { label: "Send Enabled", children: /* @__PURE__ */ jsx121(BooleanLabel, { value: config.sendEnabled }) }),
          /* @__PURE__ */ jsx121(DescriptionItem5, { label: "Max Vacancy Open Days", children: config.maxVacancyOpenDays }),
          /* @__PURE__ */ jsx121(DescriptionItem5, { label: "Combined Score Threshold", children: config.combinedScoreThreshold }),
          /* @__PURE__ */ jsx121(
            DescriptionItem5,
            {
              label: "Experience Similarity Threshold",
              children: config.experienceSimilarityThreshold
            }
          ),
          /* @__PURE__ */ jsx121(DescriptionItem5, { label: "Job Match Score Threshold", children: config.jobMatchScoreThreshold })
        ] })
      }
    ),
    /* @__PURE__ */ jsx121("div", { className: "p-4 lg:p-8", children: /* @__PURE__ */ jsx121(ButtonList4, { children: /* @__PURE__ */ jsx121(Button26, { color: "primary", clicked: toggleIsEditing, children: "Edit" }) }) })
  ] }) }) }) }) });
};

// src/secure/recruit/config/ConfigLayout.tsx
import { Navigate as Navigate28 } from "react-router-dom";
import { OutletRoute as OutletRoute21 } from "app-core";
import { jsx as jsx122 } from "react/jsx-runtime";
var createConfigRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-config`;
  const recommendationConfigRouteId = `${routeId6}-recommendation-config`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx122(OutletRoute21, {}),
      children: [
        {
          id: recommendationConfigRouteId,
          path: "recommendation-config/*",
          element: /* @__PURE__ */ jsx122(RecommendationConfig, { routeId: recommendationConfigRouteId }),
          loader: ({ params }) => {
            return loader36(environment, params);
          }
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx122(Navigate28, { to: "recommendation-config", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/vacancies/AdminVacanciesRoutes.tsx
import { Outlet as Outlet17, useLocation as useLocation16 } from "react-router-dom";
import { UsersIcon as UsersIcon5 } from "@heroicons/react/24/outline";
import { createLinkState as createLinkState15, TabPills as TabPills7 } from "shared-ui";

// src/secure/recruit/vacancies/vacancies/AdminVacanciesRoute.tsx
import { Navigate as Navigate32 } from "react-router-dom";
import { OutletRoute as OutletRoute24 } from "app-core";
import {
  VacancyLink,
  VacancySearchLoader,
  vacancyLoader as vacancyLoader2
} from "feature-recruit";

// src/secure/recruit/vacancies/vacancies/AdminVacancyRoute.tsx
import { Suspense as Suspense89 } from "react";
import { Link as Link27, Navigate as Navigate31 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary13 } from "react-error-boundary";
import {
  BreadcrumbLink,
  ErrorContainer as ErrorContainer10,
  ListLayoutMobileList
} from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback13, OutletRoute as OutletRoute23 } from "app-core";
import {
  VacancyRecommendationsRoute,
  VacancyConversations,
  VacancyApplicationsRoute,
  VacancyRoute,
  vacancyLoader,
  createVacancyEditRoutes,
  vacancyEditLoader,
  VacancyRoot,
  vacancyRootLoader,
  createCandidateApplicationRoutes,
  createVacancyRecommendationRoutes,
  VacancyMatchesLayout,
  createMatchRoutes
} from "feature-recruit";

// src/secure/recruit/vacancies/vacancies/AdminVacancyJobBoardAdsRoute.tsx
import { Suspense as Suspense87 } from "react";
import { ConnectionHandler as ConnectionHandler6 } from "react-relay";
import { Button as Button30, EdSkeleton as EdSkeleton64 } from "shared-ui";
import { useToggle as useToggle14 } from "shared-lib";
import { useVacancyRouteData } from "feature-recruit";

// src/secure/recruit/job-boards/components/JobBoardListContainer.tsx
import { useState as useState19 } from "react";
import { Input as Input12 } from "shared-ui";
import { useDebounce as useDebounce12 } from "shared-lib";
import { JobBoardList } from "feature-recruit";
import { jsx as jsx123, jsxs as jsxs81 } from "react/jsx-runtime";
var JobBoardsListContainer = () => {
  const [filter, setFilter] = useState19(null);
  const searchTerm = useDebounce12(filter, 500);
  const where2 = {
    isDeleted: { eq: false }
  };
  if (searchTerm) {
    where2.or = [{ name: { startsWith: filter } }];
  }
  return /* @__PURE__ */ jsxs81("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx123("div", { className: "flex items-center justify-between space-x-4 border-b", children: /* @__PURE__ */ jsxs81("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx123("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx123("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx123(
        Input12,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx123("div", { className: "flex-1", children: /* @__PURE__ */ jsx123(JobBoardList, { where: where2 }) })
  ] });
};

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdListQuery.graphql.ts
var node100 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardAdListQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardAdList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardAdListQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitJobBoardAdsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoardAds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardAdsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardAdId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "reference",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoard",
                      "kind": "LinkedField",
                      "name": "jobBoard",
                      "plural": false,
                      "selections": [
                        v3,
                        v2
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v3,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v2
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "JobBoardAdList_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoardAds"
        }
      ]
    },
    "params": {
      "cacheID": "7bc2ceba0b76c71e9b2cb46a41ed1d71",
      "id": null,
      "metadata": {},
      "name": "JobBoardAdListQuery",
      "operationKind": "query",
      "text": "query JobBoardAdListQuery(\n  $where: RecruitJobBoardAdFilter!\n) {\n  ...JobBoardAdList_list\n}\n\nfragment JobBoardAdList_list on Query {\n  list: recruitJobBoardAds(first: 10, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardAdId\n        code\n        reference\n        createdAt\n        jobBoard {\n          name\n          id\n        }\n        vacancy {\n          name\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node100.hash = "ca8e21d1ac49f81f45d6247ffbff5b13";
var JobBoardAdListQuery_graphql_default = node100;

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdListPaginationQuery.graphql.ts
var node101 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardAdListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "JobBoardAdList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardAdListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "RecruitJobBoardAdsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoardAds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardAdsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardAdId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "reference",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoard",
                      "kind": "LinkedField",
                      "name": "jobBoard",
                      "plural": false,
                      "selections": [
                        v5,
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "JobBoardAdList_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoardAds"
        }
      ]
    },
    "params": {
      "cacheID": "8ad03d45261a0a64715601aba352f9a4",
      "id": null,
      "metadata": {},
      "name": "JobBoardAdListPaginationQuery",
      "operationKind": "query",
      "text": "query JobBoardAdListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RecruitJobBoardAdFilter\n) {\n  ...JobBoardAdList_list_2HEEH6\n}\n\nfragment JobBoardAdList_list_2HEEH6 on Query {\n  list: recruitJobBoardAds(first: $first, after: $after, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardAdId\n        code\n        reference\n        createdAt\n        jobBoard {\n          name\n          id\n        }\n        vacancy {\n          name\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node101.hash = "d5088f7843c3956dcad1acf22b838ebb";
var JobBoardAdListPaginationQuery_graphql_default = node101;

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdList_list.graphql.ts
var node102 = function() {
  var v0 = [
    "list"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": JobBoardAdListPaginationQuery_graphql_default
      }
    },
    "name": "JobBoardAdList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "RecruitJobBoardAdsConnection",
        "kind": "LinkedField",
        "name": "__JobBoardAdList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitJobBoardAdsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitJobBoardAd",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobBoardAdId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitJobBoard",
                    "kind": "LinkedField",
                    "name": "jobBoard",
                    "plural": false,
                    "selections": [
                      v1
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node102.hash = "d5088f7843c3956dcad1acf22b838ebb";
var JobBoardAdList_list_graphql_default = node102;

// src/secure/recruit/job-boards/components/JobBoardAdList.tsx
import { Suspense as Suspense82, useCallback as useCallback56, useState as useState20 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery26, usePaginationFragment as usePaginationFragment8 } from "react-relay";
import { Button as Button27, EdSkeleton as EdSkeleton60, Size as Size11 } from "shared-ui";
import {
  createClientMutationId as createClientMutationId18,
  isNotNullOrUndefined as isNotNullOrUndefined7,
  timeAgo as timeAgo16
} from "shared-lib";

// src/secure/recruit/job-boards/mutations/__generated__/UseJobBoardAdCreateMutation.graphql.ts
var node103 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobBoardAdId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reference",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v10 = {
    "kind": "InlineFragment",
    "selections": [
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UseJobBoardAdCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v2,
          "concreteType": "RecruitJobBoardAdCreatePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfJobboardAd",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoard",
                      "kind": "LinkedField",
                      "name": "jobBoard",
                      "plural": false,
                      "selections": [
                        v8
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v8,
                        v9
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UseJobBoardAdCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v2,
          "concreteType": "RecruitJobBoardAdCreatePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfJobboardAd",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoard",
                      "kind": "LinkedField",
                      "name": "jobBoard",
                      "plural": false,
                      "selections": [
                        v8,
                        v3
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v8,
                        v9,
                        v3
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "payload",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2d76a95f6f4f3e89d324da5f3b8b438e",
      "id": null,
      "metadata": {},
      "name": "UseJobBoardAdCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseJobBoardAdCreateMutation(\n  $input: RecruitJobBoardAdCreateInput!\n) {\n  data: recruitJobBoardAdCreate(input: $input) {\n    payload {\n      node {\n        id\n        jobBoardAdId\n        code\n        reference\n        createdAt\n        jobBoard {\n          name\n          id\n        }\n        vacancy {\n          name\n          employerName\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node103.hash = "d7b321fc3a4c75cd7ebca598d10983b9";
var UseJobBoardAdCreateMutation_graphql_default = node103;

// src/secure/recruit/job-boards/mutations/UseJobBoardAdCreate.ts
import { useAsyncMutation as useAsyncMutation19 } from "shared-lib";
var mutationDef19 = UseJobBoardAdCreateMutation_graphql_default;
function useJobBoardAdCreate() {
  const [commit, isBusy] = useAsyncMutation19(mutationDef19);
  return [commit, isBusy];
}

// src/secure/recruit/job-boards/mutations/__generated__/UseJobBoardAdRemoveMutation.graphql.ts
var node104 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "succeeded",
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseJobBoardAdRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitJobBoardAdRemovePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeleteResultOfJobboardAd",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfJobboardAd",
                  "kind": "LinkedField",
                  "name": "edge",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoardAd",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseJobBoardAdRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitJobBoardAdRemovePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeleteResultOfJobboardAd",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfJobboardAd",
                  "kind": "LinkedField",
                  "name": "edge",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoardAd",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "filters": null,
                          "handle": "deleteRecord",
                          "key": "",
                          "kind": "ScalarHandle",
                          "name": "id"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b02a9c6d47d68134f5c827c89f00549a",
      "id": null,
      "metadata": {},
      "name": "UseJobBoardAdRemoveMutation",
      "operationKind": "mutation",
      "text": "mutation UseJobBoardAdRemoveMutation(\n  $input: RecruitJobBoardAdRemoveInput!\n) {\n  data: recruitJobBoardAdRemove(input: $input) {\n    payload {\n      edge {\n        node {\n          id\n        }\n      }\n      succeeded\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node104.hash = "9ee2f94186fd2805e2edce9fc236f8f0";
var UseJobBoardAdRemoveMutation_graphql_default = node104;

// src/secure/recruit/job-boards/mutations/UseJobBoardAdRemove.ts
import { useAsyncMutation as useAsyncMutation20 } from "shared-lib";
var mutationDef20 = UseJobBoardAdRemoveMutation_graphql_default;
function useJobBoardAdRemove() {
  const [commit, isBusy] = useAsyncMutation20(mutationDef20);
  return [commit, isBusy];
}

// src/secure/recruit/job-boards/mutations/__generated__/UseJobBoardUpdateMutation.graphql.ts
var node105 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfJobBoardEmailConfiguration",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitJobBoard",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobBoardId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isVisible",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inboxEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateEmailLocation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateEmailRegex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobReferenceLocation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobReferenceCustomHeader",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobReferenceRegex",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseJobBoardUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitJobBoardUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseJobBoardUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitJobBoardUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "34c0166da12868b3f69916ecaa2bfe04",
      "id": null,
      "metadata": {},
      "name": "UseJobBoardUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseJobBoardUpdateMutation(\n  $input: RecruitJobBoardUpdateInput!\n) {\n  data: recruitJobBoardUpdate(input: $input) {\n    payload {\n      node {\n        id\n        jobBoardId\n        code\n        isDeleted\n        isVisible\n        name\n        inboxEmail\n        candidateEmailLocation\n        candidateEmailRegex\n        jobReferenceLocation\n        jobReferenceCustomHeader\n        jobReferenceRegex\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node105.hash = "71ef140dda18f5a1a0297942b95fe964";
var UseJobBoardUpdateMutation_graphql_default = node105;

// src/secure/recruit/job-boards/mutations/UseJobBoardUpdate.ts
import { useAsyncMutation as useAsyncMutation21 } from "shared-lib";
var mutationDef21 = UseJobBoardUpdateMutation_graphql_default;
function useJobBoardUpdate() {
  const [commit, isBusy] = useAsyncMutation21(mutationDef21);
  return [commit, isBusy];
}

// src/secure/recruit/job-boards/components/JobBoardAdList.tsx
import { jsx as jsx124, jsxs as jsxs82 } from "react/jsx-runtime";
var queryDef43 = JobBoardAdListQuery_graphql_default;
var fragmentDef14 = JobBoardAdList_list_graphql_default;
var List7 = ({ fragmentRef }) => {
  const [deleteId, setDeleteId] = useState20(null);
  const [deleteAd, isDeletingAd] = useJobBoardAdRemove();
  const onDelete = useCallback56(async () => {
    console.log(deleteId);
    if (!deleteId) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId18(),
      jobBoardAdId: deleteId
    };
    const response = await deleteAd({ input });
    if (response.data.payload) {
      setDeleteId(null);
    }
  }, [deleteId, setDeleteId, deleteAd]);
  const { data, loadNext } = usePaginationFragment8(fragmentDef14, fragmentRef);
  const onLoadNext = useCallback56(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const ads = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined7);
  const rows = ads.map((jobBoardAd, idx) => {
    return /* @__PURE__ */ jsxs82(
      "tr",
      {
        className: idx % 2 === 0 ? "bg-white" : "bg-gray-50",
        children: [
          /* @__PURE__ */ jsx124("td", { className: "whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900", children: jobBoardAd.jobBoard.name }),
          /* @__PURE__ */ jsx124("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: jobBoardAd.reference }),
          /* @__PURE__ */ jsx124("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: jobBoardAd.createdAt ? timeAgo16(jobBoardAd.createdAt) : "unknown" }),
          /* @__PURE__ */ jsx124("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: /* @__PURE__ */ jsx124(
            Button27,
            {
              color: "danger",
              clicked: () => setDeleteId(jobBoardAd.jobBoardAdId),
              children: "Delete"
            }
          ) })
        ]
      },
      jobBoardAd.code
    );
  });
  const jobBoardAdToDelete = deleteId ? ads.find((a) => a.jobBoardAdId === deleteId) : null;
  return /* @__PURE__ */ jsxs82(Suspense82, { fallback: /* @__PURE__ */ jsx124(EdSkeleton60, {}), children: [
    jobBoardAdToDelete && /* @__PURE__ */ jsxs82("div", { className: "m-8 flex flex-col gap-5 border bg-white p-4", children: [
      /* @__PURE__ */ jsx124("div", { className: "flex justify-center border-b pb-4", children: /* @__PURE__ */ jsxs82("div", { className: "text-danger-500 text-2xl", children: [
        "Delete Ad for ",
        jobBoardAdToDelete.jobBoard.name
      ] }) }),
      /* @__PURE__ */ jsx124("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx124("div", { children: /* @__PURE__ */ jsx124(Button27, { color: "danger", size: Size11.xl, clicked: onDelete, children: "Yes, Delete Now" }) }) })
    ] }),
    /* @__PURE__ */ jsx124("div", { className: "border bg-white", children: /* @__PURE__ */ jsxs82("table", { className: "min-w-full divide-y divide-gray-200", children: [
      /* @__PURE__ */ jsx124("thead", { className: "bg-gray-50", children: /* @__PURE__ */ jsxs82("tr", { children: [
        /* @__PURE__ */ jsx124(
          "th",
          {
            scope: "col",
            className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
            children: "Job Board"
          }
        ),
        /* @__PURE__ */ jsx124(
          "th",
          {
            scope: "col",
            className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
            children: "Reference"
          }
        ),
        /* @__PURE__ */ jsx124(
          "th",
          {
            scope: "col",
            className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
            children: "Created"
          }
        ),
        /* @__PURE__ */ jsx124("th", { scope: "col" })
      ] }) }),
      /* @__PURE__ */ jsx124("tbody", { children: rows })
    ] }) })
  ] });
};
var JobBoardAdsList = ({ jobBoardId, vacancyId }) => {
  let where2 = {
    isDeleted: { eq: false }
  };
  if (jobBoardId) {
    where2 = {
      ...where2,
      jobboardId: { eq: jobBoardId }
    };
  }
  if (vacancyId) {
    where2 = {
      ...where2,
      vacancyId: { eq: vacancyId }
    };
  }
  const query = useLazyLoadQuery26(
    queryDef43,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx124(List7, { fragmentRef: query });
};

// src/secure/recruit/job-boards/components/JobBoardAdReferenceEditor.tsx
import { Suspense as Suspense83, useCallback as useCallback57, useState as useState21 } from "react";
import { createClientMutationId as createClientMutationId19 } from "shared-lib";
import { Button as Button28, Input as Input13 } from "shared-ui";
import {
  JobBoardSearchBoxContainer
} from "feature-recruit";
import { jsx as jsx125, jsxs as jsxs83 } from "react/jsx-runtime";
var JobBoardAdReferenceEditor = ({
  connectionId,
  vacancyId,
  onDone,
  onCancel
}) => {
  const [reference, setReference] = useState21(null);
  const [jobBoard, setJobBoard] = useState21(null);
  const [createAd, isCreatingAd] = useJobBoardAdCreate();
  const onCreateAd = useCallback57(async () => {
    if (!reference || !jobBoard) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId19(),
      boardId: jobBoard.jobBoardId,
      reference,
      vacancyId
    };
    const response = await createAd({ connections: [connectionId], input });
    if (response.data.payload) {
      onDone();
    }
  }, [createAd]);
  return /* @__PURE__ */ jsx125(Suspense83, { fallback: "Loading...", children: /* @__PURE__ */ jsxs83("div", { className: "flex flex-col gap-3 border bg-white p-4 sm:w-1/2", children: [
    /* @__PURE__ */ jsxs83("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx125("div", { className: "w-32", children: "Job Board" }),
      /* @__PURE__ */ jsx125("div", { className: "flex-1", children: /* @__PURE__ */ jsx125(JobBoardSearchBoxContainer, { onSearchCompleted: setJobBoard }) })
    ] }),
    /* @__PURE__ */ jsxs83("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx125("div", { className: "w-32", children: "Reference" }),
      /* @__PURE__ */ jsx125("div", { className: "flex-1", children: /* @__PURE__ */ jsx125(Input13, { onValueChange: setReference }) })
    ] }),
    /* @__PURE__ */ jsxs83("div", { className: "flex items-center gap-2 border-t pt-4", children: [
      /* @__PURE__ */ jsx125("div", { children: /* @__PURE__ */ jsx125(Button28, { color: "primary", clicked: onCreateAd, children: "Add Reference" }) }),
      /* @__PURE__ */ jsx125("div", { children: /* @__PURE__ */ jsx125(Button28, { color: "gray", clicked: onCancel, children: "Cancel" }) })
    ] })
  ] }) });
};

// src/secure/recruit/job-boards/components/__generated__/JobBoardContainerRouteQuery.graphql.ts
var node106 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "jobBoardCode"
    }
  ], v1 = [
    {
      "alias": "jobBoard",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "jobBoardCode"
        }
      ],
      "concreteType": "RecruitJobBoard",
      "kind": "LinkedField",
      "name": "recruitJobBoardByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobBoardId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isVisible",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inboxEmail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "candidateEmailLocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "candidateEmailRegex",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobReferenceLocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobReferenceCustomHeader",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobReferenceRegex",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardContainerRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardContainerRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "9345fcff01217317eefad6d7e45a03fd",
      "id": null,
      "metadata": {},
      "name": "JobBoardContainerRouteQuery",
      "operationKind": "query",
      "text": "query JobBoardContainerRouteQuery(\n  $jobBoardCode: Int!\n) {\n  jobBoard: recruitJobBoardByCode(code: $jobBoardCode) {\n    id\n    jobBoardId\n    code\n    isVisible\n    name\n    inboxEmail\n    candidateEmailLocation\n    candidateEmailRegex\n    jobReferenceLocation\n    jobReferenceCustomHeader\n    jobReferenceRegex\n  }\n}\n"
    }
  };
}();
node106.hash = "93d252004a553883fd4dce821d8c5010";
var JobBoardContainerRouteQuery_graphql_default = node106;

// src/secure/recruit/job-boards/components/JobBoardContainer.tsx
import { Fragment as Fragment43, Suspense as Suspense86 } from "react";
import { Navigate as Navigate29, Outlet as Outlet16, useLocation as useLocation15 } from "react-router-dom";
import { loadQuery as loadQuery38 } from "react-relay";
import { UserGroupIcon as UserGroupIcon3, UsersIcon as UsersIcon4 } from "@heroicons/react/24/outline";
import { useRouteData as useRouteData30, useToggle as useToggle13 } from "shared-lib";
import {
  BooleanIcon as BooleanIcon3,
  Button as Button29,
  createLinkState as createLinkState14,
  DescriptionItem as DescriptionItem7,
  DescriptionList as DescriptionList6,
  EdSkeleton as EdSkeleton63,
  Size as Size12,
  TabPills as TabPills6
} from "shared-ui";

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdListContainerQuery.graphql.ts
var node107 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardAdListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardAdListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardAdListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitJobBoardAdsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoardAds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardAdsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardAdId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v2
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobBoardAdListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoardAds"
        }
      ]
    },
    "params": {
      "cacheID": "b7b34afd5018e2d0b756b51e71da15e9",
      "id": null,
      "metadata": {},
      "name": "JobBoardAdListContainerQuery",
      "operationKind": "query",
      "text": "query JobBoardAdListContainerQuery(\n  $where: RecruitJobBoardAdFilter!\n) {\n  ...JobBoardAdListContainer_list\n}\n\nfragment JobBoardAdListContainer_list on Query {\n  list: recruitJobBoardAds(first: 10, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardAdId\n        code\n        createdAt\n        vacancy {\n          name\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node107.hash = "26f9d8be81cd54b9304c9f9e3a81fc70";
var JobBoardAdListContainerQuery_graphql_default = node107;

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdsListContainerPaginationQuery.graphql.ts
var node108 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardAdsListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "JobBoardAdListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardAdsListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "RecruitJobBoardAdsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoardAds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardAdsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardAdId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobBoardAdListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoardAds"
        }
      ]
    },
    "params": {
      "cacheID": "e2ebe1e6800e7b53ccf3a109e058c62c",
      "id": null,
      "metadata": {},
      "name": "JobBoardAdsListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query JobBoardAdsListContainerPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RecruitJobBoardAdFilter\n) {\n  ...JobBoardAdListContainer_list_2HEEH6\n}\n\nfragment JobBoardAdListContainer_list_2HEEH6 on Query {\n  list: recruitJobBoardAds(first: $first, after: $after, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardAdId\n        code\n        createdAt\n        vacancy {\n          name\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node108.hash = "3572e79037e79fa65f4f6fd32058702e";
var JobBoardAdsListContainerPaginationQuery_graphql_default = node108;

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdListContainer_list.graphql.ts
var node109 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": JobBoardAdsListContainerPaginationQuery_graphql_default
      }
    },
    "name": "JobBoardAdListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "createdAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitJobBoardAdsConnection",
        "kind": "LinkedField",
        "name": "__JobBoardAdListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitJobBoardAdsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitJobBoardAd",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobBoardAdId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node109.hash = "3572e79037e79fa65f4f6fd32058702e";
var JobBoardAdListContainer_list_graphql_default = node109;

// src/secure/recruit/job-boards/components/JobBoardAdListContainer.tsx
import { Suspense as Suspense84, useCallback as useCallback58, useState as useState22 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery27, usePaginationFragment as usePaginationFragment9 } from "react-relay";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader7,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement7,
  EdSkeleton as EdSkeleton61,
  Input as Input14,
  ListLayout as ListLayout7
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined8, useDebounce as useDebounce13 } from "shared-lib";
import { jsx as jsx126, jsxs as jsxs84 } from "react/jsx-runtime";
var queryDef44 = JobBoardAdListContainerQuery_graphql_default;
var fragmentDef15 = JobBoardAdListContainer_list_graphql_default;
function createLinkTo7(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List8 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment9(fragmentDef15, fragmentRef);
  const onLoadNext = useCallback58(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined8).map((jobBoardAd) => {
    const name = `${jobBoardAd.vacancy.name}`;
    return {
      key: jobBoardAd.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx126("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs84("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx126("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx126("div", { className: "text-md text-blue-500", children: jobBoardAd.code })
      ] }) }),
      description: /* @__PURE__ */ jsx126("div", { className: "flex items-center gap-2 pt-2 text-sm", children: jobBoardAd.createdAt && /* @__PURE__ */ jsxs84("div", { className: "text-info-600", children: [
        /* @__PURE__ */ jsx126("div", { children: "Created" }),
        /* @__PURE__ */ jsx126("div", { children: jobBoardAd.createdAt })
      ] }) }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: jobBoardAd.code
      },
      element: /* @__PURE__ */ jsx126(DefaultListLayoutSectionElement7, { children: /* @__PURE__ */ jsx126("div", { className: "grid", children: /* @__PURE__ */ jsx126("div", { children: jobBoardAd.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx126(Suspense84, { fallback: /* @__PURE__ */ jsx126(EdSkeleton61, {}), children: /* @__PURE__ */ jsx126(
    ListLayout7,
    {
      title: "Job Board Ads",
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx126(
        DefaultListLayoutItemHeader7,
        {
          title: "Ads",
          to: createLinkTo7,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  ) });
};
var JobBoardAdsListContainer = ({
  jobBoardId,
  vacancyId
}) => {
  const [filter, setFilter] = useState22(null);
  const searchTerm = useDebounce13(filter, 500);
  let where2 = {
    isDeleted: { eq: false }
  };
  if (jobBoardId) {
    where2 = {
      ...where2,
      jobboardId: { eq: jobBoardId }
    };
  }
  if (vacancyId) {
    where2 = {
      ...where2,
      vacancyId: { eq: vacancyId }
    };
  }
  if (searchTerm) {
    where2.or = [{ reference: { startsWith: filter } }];
  }
  const query = useLazyLoadQuery27(
    queryDef44,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs84("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx126("div", { className: "flex items-center justify-between space-x-4 border-b", children: /* @__PURE__ */ jsxs84("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx126("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx126("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx126(
        Input14,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx126("div", { className: "flex-1", children: /* @__PURE__ */ jsx126(List8, { fragmentRef: query }) })
  ] });
};

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdContainerRouteQuery.graphql.ts
var node110 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "jobBoardAdCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "jobBoardAdCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobBoardAdId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDeleted",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reference",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobboardId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v11 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardAdContainerRouteQuery",
      "selections": [
        {
          "alias": "jobBoardAd",
          "args": v1,
          "concreteType": "RecruitJobBoardAd",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v9,
                v10
              ],
              "storageKey": null
            },
            v11
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardAdContainerRouteQuery",
      "selections": [
        {
          "alias": "jobBoardAd",
          "args": v1,
          "concreteType": "RecruitJobBoardAd",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v9,
                v10,
                v2
              ],
              "storageKey": null
            },
            v11
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "07aa8b3b09fdac3e71bb40d64d0c0825",
      "id": null,
      "metadata": {},
      "name": "JobBoardAdContainerRouteQuery",
      "operationKind": "query",
      "text": "query JobBoardAdContainerRouteQuery(\n  $jobBoardAdCode: Int!\n) {\n  jobBoardAd: recruitJobBoardAdByCode(code: $jobBoardAdCode) {\n    id\n    jobBoardAdId\n    code\n    isDeleted\n    createdAt\n    reference\n    jobboardId\n    vacancy {\n      name\n      employerName\n      id\n    }\n  }\n}\n"
    }
  };
}();
node110.hash = "6518b3f54eeff27d48d230248e16c9f1";
var JobBoardAdContainerRouteQuery_graphql_default = node110;

// src/secure/recruit/job-boards/components/JobBoardAdContainer.tsx
import { Fragment as Fragment41, Suspense as Suspense85 } from "react";
import { loadQuery as loadQuery37 } from "react-relay";
import { useRouteData as useRouteData29 } from "shared-lib";
import { DescriptionItem as DescriptionItem6, DescriptionList as DescriptionList5, EdSkeleton as EdSkeleton62 } from "shared-ui";
import { Fragment as Fragment42, jsx as jsx127, jsxs as jsxs85 } from "react/jsx-runtime";
var queryDef45 = JobBoardAdContainerRouteQuery_graphql_default;
async function loader37(environment, params) {
  const code = params.jobBoardAdCode;
  const jobBoardAdCode = parseInt(code);
  return loadQuery37(environment, queryDef45, {
    jobBoardAdCode
  });
}
var JobBoardAdContainer = ({ routeId: routeId6 }) => {
  const data = useRouteData29(queryDef45, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx127(Fragment42, { children: "Loading..." });
  }
  const { jobBoardAd } = data;
  if (!jobBoardAd) {
    return /* @__PURE__ */ jsx127(Fragment42, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx127(Suspense85, { fallback: /* @__PURE__ */ jsx127(EdSkeleton62, {}), children: /* @__PURE__ */ jsx127("div", { className: "flex-1", children: /* @__PURE__ */ jsxs85("div", { className: "flex flex-1 flex-col gap-2 border bg-white p-4", children: [
    /* @__PURE__ */ jsxs85("div", { className: "flex items-center justify-between gap-2 p-4", children: [
      /* @__PURE__ */ jsxs85("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx127("div", { className: "text-primary-500 px-1 text-xl font-bold", children: jobBoardAd.vacancy.employerName }),
        /* @__PURE__ */ jsx127("div", { className: "text-primary-500 px-1 text-xl font-bold", children: jobBoardAd.vacancy.name })
      ] }),
      /* @__PURE__ */ jsx127("div", { className: "flex items-center gap-2 pt-2 text-sm", children: /* @__PURE__ */ jsx127("div", { className: "text-primary-500 text-sm font-bold", children: jobBoardAd.code }) })
    ] }),
    /* @__PURE__ */ jsx127(
      DescriptionList5,
      {
        classes: "w-full",
        heading: /* @__PURE__ */ jsx127("div", { className: "flex items-center", children: jobBoardAd.createdAt && /* @__PURE__ */ jsxs85("div", { className: "text-info-600", children: [
          /* @__PURE__ */ jsx127("div", { children: "Created" }),
          /* @__PURE__ */ jsx127("div", { children: jobBoardAd.createdAt })
        ] }) }),
        items: /* @__PURE__ */ jsx127(Fragment41, { children: /* @__PURE__ */ jsx127(DescriptionItem6, { label: "Reference", children: jobBoardAd.reference }) })
      }
    )
  ] }) }) });
};
var createRoute29 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-job-board`;
  return {
    id: routeId6,
    path: ":jobBoardAdCode",
    element: /* @__PURE__ */ jsx127(JobBoardAdContainer, { routeId: routeId6, inList }),
    loader: ({ params }) => {
      return loader37(environment, params);
    }
  };
};

// src/secure/recruit/job-boards/components/JobBoardEditor.tsx
import { useCallback as useCallback59 } from "react";
import * as zod3 from "zod";
import { useForm as useForm5 } from "react-hook-form";
import { zodResolver as zodResolver5 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId20,
  useSetUserErrorCodes as useSetUserErrorCodes2,
  useUserErrorCode as useUserErrorCode2
} from "shared-lib";
import {
  ActionContainer as ActionContainer4,
  ErrorField as ErrorField4,
  FormErrorCode as FormErrorCode2,
  FormErrorCodes as FormErrorCodes3,
  FormInputRow as FormInputRow4,
  InputField as InputField4,
  SwitchInput as SwitchInput2
} from "shared-ui";
import { jsx as jsx128, jsxs as jsxs86 } from "react/jsx-runtime";
var formSchema5 = zod3.object({
  name: zod3.string().min(1, { message: "Name is required" }),
  inboxEmail: zod3.string().email().min(1, { message: "Inbox Email is required" }),
  jobReferenceCustomHeader: zod3.string().min(1, { message: "uppSenderId is required" }).nullable(),
  jobReferenceLocation: zod3.string().min(1, { message: "uppSenderId is required" }),
  jobReferenceRegex: zod3.string().min(1, { message: "uppSenderId is required" }),
  candidateEmailAddressLocation: zod3.string().min(1, { message: "Email Address Location is required" }),
  candidateEmailAddressRegex: zod3.string().min(1, { message: "Email Address Regex is required" }),
  isVisible: zod3.boolean()
});
var JobBoardEditor = ({
  jobBoardId,
  jobBoard,
  onDone,
  onCancel
}) => {
  const defaultValues = {
    name: jobBoard?.name,
    inboxEmail: jobBoard?.inboxEmail,
    candidateEmailAddressLocation: jobBoard?.candidateEmailLocation,
    candidateEmailAddressRegex: jobBoard?.candidateEmailRegex,
    jobReferenceLocation: jobBoard?.jobReferenceLocation,
    jobReferenceCustomHeader: jobBoard?.jobReferenceCustomHeader || null,
    jobReferenceRegex: jobBoard?.jobReferenceRegex,
    isVisible: jobBoard?.isVisible || false
  };
  const setErrorCode = useSetUserErrorCodes2();
  const { register, handleSubmit, watch, formState, control } = useForm5({
    resolver: zodResolver5(formSchema5),
    defaultValues,
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode2();
  const [updateJobBoard, isUpdatingJobBoard] = useJobBoardUpdate();
  const onSave = useCallback59(
    async (form) => {
      setErrorCode(null);
      if (!form.name || !form.inboxEmail || !form.candidateEmailAddressLocation || !form.candidateEmailAddressRegex || !form.jobReferenceLocation || !form.jobReferenceRegex) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId20(),
        id: jobBoardId,
        name: form.name,
        inboxEmail: form.inboxEmail,
        candidateEmailAddressLocation: form.candidateEmailAddressLocation,
        candidateEmailAddressRegex: form.candidateEmailAddressRegex,
        jobReferenceLocation: form.jobReferenceLocation,
        jobReferenceCustomHeader: form.jobReferenceCustomHeader,
        jobReferenceRegex: form.jobReferenceRegex,
        isVisible: form.isVisible
      };
      const response = await updateJobBoard({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onDone(response.data.payload.node);
      }
    },
    [updateJobBoard]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  let errorDisplay = /* @__PURE__ */ jsx128(FormErrorCodes3, {});
  if (userErrorCode) {
    errorDisplay = /* @__PURE__ */ jsx128(FormErrorCode2, { message: userErrorCode });
  }
  return /* @__PURE__ */ jsxs86("div", { className: "m-4 flex w-full flex-col items-center justify-center", children: [
    errorDisplay,
    /* @__PURE__ */ jsx128("form", { className: "w-full", onSubmit, children: /* @__PURE__ */ jsxs86(
      ActionContainer4,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        onCancel,
        isDisabled: isUpdatingJobBoard,
        titleTop: `Update Job Board`,
        children: [
          /* @__PURE__ */ jsxs86(FormInputRow4, { name: "name", title: "Name *", children: [
            /* @__PURE__ */ jsx128(
              InputField4,
              {
                register,
                name: "name",
                required: true,
                placeholder: "Name"
              }
            ),
            /* @__PURE__ */ jsx128(ErrorField4, { field: errors.name })
          ] }),
          /* @__PURE__ */ jsxs86(FormInputRow4, { name: "inboxEmail", title: "Inbox Email *", children: [
            /* @__PURE__ */ jsx128(
              InputField4,
              {
                register,
                name: "inboxEmail",
                required: true,
                placeholder: "Inbox Email"
              }
            ),
            /* @__PURE__ */ jsx128(ErrorField4, { field: errors.inboxEmail })
          ] }),
          /* @__PURE__ */ jsxs86(
            FormInputRow4,
            {
              name: "jobReferenceLocation",
              title: "Reference Location *",
              children: [
                /* @__PURE__ */ jsx128(
                  InputField4,
                  {
                    register,
                    name: "jobReferenceLocation",
                    required: true,
                    placeholder: "Reference Location"
                  }
                ),
                /* @__PURE__ */ jsx128(ErrorField4, { field: errors.jobReferenceLocation })
              ]
            }
          ),
          /* @__PURE__ */ jsxs86(FormInputRow4, { name: "jobReferenceRegex", title: "Reference Regex *", children: [
            /* @__PURE__ */ jsx128(
              InputField4,
              {
                register,
                name: "jobReferenceRegex",
                required: true,
                placeholder: "Reference Regex"
              }
            ),
            /* @__PURE__ */ jsx128(ErrorField4, { field: errors.jobReferenceRegex })
          ] }),
          /* @__PURE__ */ jsxs86(
            FormInputRow4,
            {
              name: "jobReferenceCustomHeader",
              title: "Reference Custom Header *",
              children: [
                /* @__PURE__ */ jsx128(
                  InputField4,
                  {
                    register,
                    name: "jobReferenceCustomHeader",
                    required: false,
                    placeholder: "Reference Custom Header"
                  }
                ),
                /* @__PURE__ */ jsx128(ErrorField4, { field: errors.jobReferenceCustomHeader })
              ]
            }
          ),
          /* @__PURE__ */ jsxs86(
            FormInputRow4,
            {
              name: "candidateEmailAddressLocation",
              title: "Email Location *",
              children: [
                /* @__PURE__ */ jsx128(
                  InputField4,
                  {
                    register,
                    name: "candidateEmailAddressLocation",
                    required: true,
                    placeholder: "Inbox Email"
                  }
                ),
                /* @__PURE__ */ jsx128(ErrorField4, { field: errors.candidateEmailAddressLocation })
              ]
            }
          ),
          /* @__PURE__ */ jsxs86(FormInputRow4, { name: "candidateEmailAddressRegex", title: "Email Regex *", children: [
            /* @__PURE__ */ jsx128(
              InputField4,
              {
                register,
                name: "candidateEmailAddressRegex",
                required: true,
                placeholder: "Email Regex"
              }
            ),
            /* @__PURE__ */ jsx128(ErrorField4, { field: errors.candidateEmailAddressRegex })
          ] }),
          /* @__PURE__ */ jsxs86(FormInputRow4, { name: "isVisible", title: "Visible *", children: [
            /* @__PURE__ */ jsx128(
              SwitchInput2,
              {
                control,
                name: "isVisible",
                defaultChecked: false
              }
            ),
            /* @__PURE__ */ jsx128(ErrorField4, { field: errors.isVisible })
          ] })
        ]
      }
    ) })
  ] });
};

// src/secure/recruit/job-boards/components/JobBoardContainer.tsx
import { Fragment as Fragment44, jsx as jsx129, jsxs as jsxs87 } from "react/jsx-runtime";
var queryDef46 = JobBoardContainerRouteQuery_graphql_default;
async function loader38(environment, params) {
  const code = params.jobBoardCode;
  const jobBoardCode = parseInt(code);
  return loadQuery38(environment, queryDef46, {
    jobBoardCode
  });
}
var JobBoardContainer = ({ routeId: routeId6 }) => {
  const [isEditing, toggleIsEditing] = useToggle13();
  const data = useRouteData30(queryDef46, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx129(Fragment44, { children: "Loading..." });
  }
  const { jobBoard } = data;
  if (!jobBoard) {
    return /* @__PURE__ */ jsx129(Fragment44, { children: "Loading..." });
  }
  let content = null;
  if (isEditing) {
    content = /* @__PURE__ */ jsx129("div", { className: "flex py-4", children: /* @__PURE__ */ jsx129(
      JobBoardEditor,
      {
        jobBoardId: jobBoard.jobBoardId,
        jobBoard,
        onDone: toggleIsEditing,
        onCancel: toggleIsEditing
      }
    ) });
  } else {
    content = /* @__PURE__ */ jsx129("div", { className: "flex py-4", children: /* @__PURE__ */ jsx129(
      DescriptionList6,
      {
        classes: "w-full border",
        heading: /* @__PURE__ */ jsx129("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx129("span", { className: "text-info-600", children: jobBoard.name }) }),
        items: /* @__PURE__ */ jsxs87(Fragment43, { children: [
          /* @__PURE__ */ jsx129(DescriptionItem7, { label: "Inbox Email", children: jobBoard.inboxEmail }),
          /* @__PURE__ */ jsx129(DescriptionItem7, { label: "Reference Custom Header", children: jobBoard.jobReferenceCustomHeader }),
          /* @__PURE__ */ jsx129(DescriptionItem7, { label: "Reference Location", children: jobBoard.jobReferenceLocation }),
          /* @__PURE__ */ jsx129(DescriptionItem7, { label: "Reference Regex", children: jobBoard.jobReferenceRegex }),
          /* @__PURE__ */ jsx129(DescriptionItem7, { label: "Candidate Email Location", children: jobBoard.candidateEmailLocation }),
          /* @__PURE__ */ jsx129(DescriptionItem7, { label: "Candidate Email Regex", children: jobBoard.candidateEmailRegex })
        ] })
      }
    ) });
  }
  return /* @__PURE__ */ jsx129(Suspense86, { fallback: /* @__PURE__ */ jsx129(EdSkeleton63, {}), children: /* @__PURE__ */ jsxs87("div", { className: "flex flex-1 flex-col gap-2 border bg-white p-4", children: [
    /* @__PURE__ */ jsxs87("div", { className: "flex items-center justify-between gap-2 border-b", children: [
      /* @__PURE__ */ jsxs87("div", { className: "flex items-center justify-between gap-2 p-4", children: [
        /* @__PURE__ */ jsx129("div", { className: "text-primary-500 px-1 text-xl font-bold", children: jobBoard.name }),
        /* @__PURE__ */ jsxs87("div", { className: "flex items-center gap-2 text-sm", children: [
          /* @__PURE__ */ jsx129("div", { children: "Visible" }),
          /* @__PURE__ */ jsx129(BooleanIcon3, { value: jobBoard.isVisible || false })
        ] })
      ] }),
      /* @__PURE__ */ jsx129("div", { children: /* @__PURE__ */ jsx129(Button29, { size: Size12.lg, color: "primary", clicked: toggleIsEditing, children: "Edit Configuration" }) })
    ] }),
    content
  ] }) });
};
var JobBoardAds = ({ routeId: routeId6 }) => {
  const data = useRouteData30(queryDef46, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx129(Fragment44, { children: "Loading..." });
  }
  const { jobBoard } = data;
  if (!jobBoard) {
    return /* @__PURE__ */ jsx129(Fragment44, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx129(Suspense86, { fallback: /* @__PURE__ */ jsx129(EdSkeleton63, {}), children: /* @__PURE__ */ jsx129(JobBoardAdsListContainer, { jobBoardId: jobBoard.jobBoardId }) });
};
var Layout10 = () => {
  const location = useLocation15();
  const tabs4 = [
    createLinkState14(location, "Details", `details`, UsersIcon4),
    createLinkState14(location, "Ads", `ads`, UserGroupIcon3)
  ];
  return /* @__PURE__ */ jsxs87("div", { className: "flex flex-1 flex-col gap-2", children: [
    /* @__PURE__ */ jsx129("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx129(TabPills6, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx129("div", { className: "", children: /* @__PURE__ */ jsx129(Outlet16, {}) })
  ] });
};
var createRoute30 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-job-board`;
  const listRouteId = `${routeId6}-ads-list`;
  return {
    id: routeId6,
    path: ":jobBoardCode",
    element: /* @__PURE__ */ jsx129(Layout10, {}),
    loader: ({ params }) => {
      return loader38(environment, params);
    },
    children: [
      {
        id: `${routeId6}-details`,
        path: "details/*",
        element: /* @__PURE__ */ jsx129(JobBoardContainer, { routeId: routeId6, inList })
      },
      {
        id: listRouteId,
        path: "ads/*",
        element: /* @__PURE__ */ jsx129(JobBoardAds, { routeId: routeId6 }),
        children: [
          createRoute29(listRouteId, environment, context, true)
        ]
      },
      createRoute29(routeId6, environment, context, false),
      {
        path: "*",
        element: /* @__PURE__ */ jsx129(Navigate29, { to: "details", replace: true })
      }
    ]
  };
};

// src/secure/recruit/job-boards/JobBoardsLayout.tsx
import { Navigate as Navigate30 } from "react-router-dom";
import { OutletRoute as OutletRoute22 } from "app-core";
import { jsx as jsx130 } from "react/jsx-runtime";
var List9 = () => {
  return /* @__PURE__ */ jsx130(JobBoardsListContainer, {});
};
var createJobBoardsRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-job-boards`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx130(OutletRoute22, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx130(List9, {}),
          children: [
            createRoute30(listRouteId, environment, context, true)
          ]
        },
        createRoute30(routeId6, environment, context, false),
        {
          path: "*",
          element: /* @__PURE__ */ jsx130(Navigate30, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/vacancies/vacancies/AdminVacancyJobBoardAdsRoute.tsx
import { jsx as jsx131, jsxs as jsxs88 } from "react/jsx-runtime";
var AdminVacancyJobBoardAdsRoute = ({ parentRouteId }) => {
  const [isCreating, toggleIsCreating] = useToggle14();
  const data = useVacancyRouteData(parentRouteId);
  const { vacancy } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx131(EdSkeleton64, {});
  }
  const connectionId = ConnectionHandler6.getConnectionID(
    "root",
    "JobBoardAdList_list"
  );
  return /* @__PURE__ */ jsx131(Suspense87, { fallback: "Loading...", children: /* @__PURE__ */ jsxs88("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx131("div", { className: "m-8 sm:w-1/2", children: /* @__PURE__ */ jsx131(JobBoardAdsList, { vacancyId: vacancy.vacancyId }) }),
    /* @__PURE__ */ jsx131("div", { className: "mx-8 sm:w-1/2", children: isCreating ? /* @__PURE__ */ jsx131("div", { children: /* @__PURE__ */ jsx131(
      JobBoardAdReferenceEditor,
      {
        connectionId,
        vacancyId: vacancy.vacancyId,
        onDone: toggleIsCreating,
        onCancel: toggleIsCreating
      }
    ) }) : /* @__PURE__ */ jsx131("div", { children: /* @__PURE__ */ jsx131(Button30, { color: "primary", clicked: toggleIsCreating, children: "Create" }) }) })
  ] }) });
};

// src/secure/recruit/vacancies/vacancies/__generated__/AdminVacancyJobPublishRouteQuery.graphql.ts
var node111 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "alias": "config",
      "args": [
        {
          "kind": "Variable",
          "name": "vacancyId",
          "variableName": "id"
        }
      ],
      "concreteType": "RecruitVacancyIdibuState",
      "kind": "LinkedField",
      "name": "recruitIdibuVacancyConfigByVacancyId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vacancyId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actionUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasConfig",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitIdibuUppParameters",
          "kind": "LinkedField",
          "name": "params",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "partnerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hash",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "senderId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobRef",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "location",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "duration",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minSalary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxSalary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "salaryDescription",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "appUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobDesc",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "term",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "per",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hideRef",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminVacancyJobPublishRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminVacancyJobPublishRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "bcb18b786a0c153530f232d6e8d04e83",
      "id": null,
      "metadata": {},
      "name": "AdminVacancyJobPublishRouteQuery",
      "operationKind": "query",
      "text": "query AdminVacancyJobPublishRouteQuery(\n  $id: UUID!\n) {\n  config: recruitIdibuVacancyConfigByVacancyId(vacancyId: $id) {\n    vacancyId\n    actionUrl\n    hasConfig\n    params {\n      partnerId\n      hash\n      senderId\n      jobTitle\n      jobRef\n      startDate\n      location\n      duration\n      minSalary\n      maxSalary\n      salaryDescription\n      appUrl\n      jobDesc\n      term\n      currency\n      per\n      hideRef\n    }\n  }\n}\n"
    }
  };
}();
node111.hash = "193c50bdd8cd3892a3cd2cd2ce5da3d4";
var AdminVacancyJobPublishRouteQuery_graphql_default = node111;

// src/secure/recruit/vacancies/vacancies/AdminVacancyJobPublishRoute.tsx
import { Suspense as Suspense88, useEffect as useEffect3, useRef } from "react";
import { useLazyLoadQuery as useLazyLoadQuery28 } from "react-relay";
import Frame from "react-frame-component";
import { EdSkeleton as EdSkeleton65 } from "shared-ui";
import { useVacancyRouteData as useVacancyRouteData2 } from "feature-recruit";
import { jsx as jsx132, jsxs as jsxs89 } from "react/jsx-runtime";
var queryDef47 = AdminVacancyJobPublishRouteQuery_graphql_default;
var AdminVacancyJobPublishRoute = ({ parentRouteId }) => {
  const data = useVacancyRouteData2(parentRouteId);
  const { vacancy } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx132(EdSkeleton65, {});
  }
  return /* @__PURE__ */ jsx132(Suspense88, { fallback: "Loading...", children: /* @__PURE__ */ jsx132(IdibuContainer, { vacancyId: vacancy.vacancyId }) });
};
var styles = {
  border: 0,
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  left: 0
};
var IdibuContainer = ({ vacancyId }) => {
  const query = useLazyLoadQuery28(
    queryDef47,
    { id: vacancyId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { config } = query;
  if (!config) {
    return /* @__PURE__ */ jsx132(EdSkeleton65, {});
  }
  if (!config.actionUrl || !config.params) {
    return /* @__PURE__ */ jsx132("div", { className: "flex flex-col gap-5", children: /* @__PURE__ */ jsx132("div", { className: "text-primary-500 font-bold", children: "No Idibu Config" }) });
  }
  return /* @__PURE__ */ jsx132(Suspense88, { fallback: "Loading...", children: /* @__PURE__ */ jsx132("div", { className: "relative flex h-screen flex-col gap-5 overflow-hidden bg-white", children: /* @__PURE__ */ jsx132(Frame, { style: styles, children: /* @__PURE__ */ jsx132(IdibuForm, { actionUrl: config.actionUrl, params: config.params }) }) }) });
};
var IdibuForm = ({ actionUrl, params }) => {
  const action = actionUrl + "?method=post";
  const formRef = useRef(null);
  useEffect3(() => {
    if (!formRef.current) {
      return;
    }
    formRef.current?.submit();
  }, [formRef]);
  const formattedHTMLText = params?.jobDesc?.replace(/(?:\r\n|\r|\n)/g, "<br>");
  return /* @__PURE__ */ jsxs89(
    "form",
    {
      id: "idibu-iframe-post-form",
      method: "post",
      action,
      ref: formRef,
      children: [
        params.appUrl && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "appUrl", value: params.appUrl }),
        params.currency && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "currency", value: params.currency }),
        params.duration && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "duration", value: params.duration }),
        params.hash && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "hash", value: params.hash }),
        params.hideRef && /* @__PURE__ */ jsx132(
          "input",
          {
            type: "hidden",
            name: "hideRef",
            value: params.hideRef ? "true" : "false"
          }
        ),
        params.jobDesc && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "jobDesc", value: formattedHTMLText }),
        params.jobRef && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "jobRef", value: params.jobRef }),
        params.jobTitle && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "jobTitle", value: params.jobTitle }),
        params.location && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "location", value: params.location }),
        params.maxSalary && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "maxSalary", value: params.maxSalary }),
        params.minSalary && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "minSalary", value: params.minSalary }),
        params.partnerId && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "partnerId", value: params.partnerId }),
        params.per && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "per", value: params.per }),
        params.salaryDescription && /* @__PURE__ */ jsx132(
          "input",
          {
            type: "hidden",
            name: "salaryDescription",
            value: params.salaryDescription
          }
        ),
        params.senderId && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "senderId", value: params.senderId }),
        params.startDate && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "startDate", value: params.startDate }),
        params.term && /* @__PURE__ */ jsx132("input", { type: "hidden", name: "term", value: params.term })
      ]
    }
  );
};

// src/secure/recruit/vacancies/vacancies/AdminVacancyRoute.tsx
import { jsx as jsx133 } from "react/jsx-runtime";
var vacancyTabs = [
  { name: "Dashboard", to: "dashboard" },
  { name: "Applications", to: "applications" },
  { name: "Matches", to: "matches" },
  { name: "Recommendations", to: "recommendations" },
  { name: "Edit", to: "edit" },
  { name: "Job Boards", to: "job-ads" },
  { name: "Job Publish", to: "job-publish" }
];
var createAdminVacancyRoute = (routePrefix, environment, context, options) => {
  return [
    {
      path: "*",
      id: `${routePrefix}-vacancy`,
      element: /* @__PURE__ */ jsx133(ErrorBoundary13, { FallbackComponent: ErrorBoundaryFallback13, children: /* @__PURE__ */ jsx133(VacancyRoute, { hideHeader: options?.hideHeader, tabs: vacancyTabs }) }),
      errorElement: /* @__PURE__ */ jsx133(ErrorContainer10, {}),
      handle: {},
      loader: ({ params }) => {
        return vacancyLoader(environment, params);
      },
      children: [
        {
          path: "dashboard",
          id: `${routePrefix}-vacancy-root`,
          element: /* @__PURE__ */ jsx133(VacancyRoot, { id: `${routePrefix}-vacancy-root` }),
          handle: {},
          loader: ({ params }) => {
            return vacancyRootLoader(environment, params);
          }
        },
        {
          path: "job-ads",
          id: `${routePrefix}-vacancy-job-ads`,
          element: /* @__PURE__ */ jsx133(AdminVacancyJobBoardAdsRoute, { parentRouteId: routePrefix })
        },
        {
          path: "job-publish",
          id: `${routePrefix}-vacancy-job-publish`,
          element: /* @__PURE__ */ jsx133(AdminVacancyJobPublishRoute, { parentRouteId: routePrefix })
        },
        {
          id: `${routePrefix}-vacancy-conversations`,
          path: "inbox",
          element: /* @__PURE__ */ jsx133(VacancyConversations, { id: `${routePrefix}-vacancy-conversations` }),
          handle: {
            crumb: () => /* @__PURE__ */ jsx133(BreadcrumbLink, { to: "edit", label: "Edit" })
          },
          loader: ({ params }) => {
            return vacancyEditLoader(environment, params);
          }
        },
        {
          id: `${routePrefix}-vacancy-edit`,
          path: "edit",
          element: /* @__PURE__ */ jsx133(OutletRoute23, {}),
          children: createVacancyEditRoutes(
            `${routePrefix}-vacancy-edit`,
            environment,
            context
          ),
          handle: {
            crumb: () => /* @__PURE__ */ jsx133(BreadcrumbLink, { to: "edit", label: "Edit" })
          },
          loader: ({ params }) => {
            return vacancyEditLoader(environment, params);
          }
        },
        {
          id: `${routePrefix}-vacancy-recommendations`,
          path: "recommendations/*",
          element: /* @__PURE__ */ jsx133(
            VacancyRecommendationsRoute,
            {
              id: `${routePrefix}-vacancy-recommendations`
            }
          ),
          errorElement: /* @__PURE__ */ jsx133(ErrorContainer10, {}),
          loader: ({ params }) => {
            return vacancyLoader(environment, params);
          },
          handle: {
            crumb: () => /* @__PURE__ */ jsx133(Link27, { className: "text-md text-gray-500", to: "recommendations", children: "Recommendations" })
          },
          children: [
            {
              path: "",
              element: /* @__PURE__ */ jsx133(ListLayoutMobileList, {}),
              errorElement: /* @__PURE__ */ jsx133(ErrorContainer10, {})
            },
            {
              id: `${routePrefix}-vacancy-recommendations-recommendation`,
              path: ":recommendationCode/*",
              element: /* @__PURE__ */ jsx133(OutletRoute23, {}),
              errorElement: /* @__PURE__ */ jsx133(ErrorContainer10, {}),
              children: createVacancyRecommendationRoutes(
                `${routePrefix}-vacancy-recommendations-recommendation`,
                environment,
                context,
                false,
                true
              )
            }
          ]
        },
        {
          id: `${routePrefix}-vacancy-recommendations-recommendation-view`,
          path: "recommendation/:recommendationCode/*",
          element: /* @__PURE__ */ jsx133(OutletRoute23, {}),
          errorElement: /* @__PURE__ */ jsx133(ErrorContainer10, {}),
          children: createVacancyRecommendationRoutes(
            `${routePrefix}-vacancy-recommendations-recommendation-view`,
            environment,
            context,
            false,
            false
          )
        },
        {
          id: `${routePrefix}-vacancy-applications`,
          path: "applications/*",
          element: /* @__PURE__ */ jsx133(
            VacancyApplicationsRoute,
            {
              id: `${routePrefix}-vacancy-applications`
            }
          ),
          loader: ({ params }) => {
            return vacancyLoader(environment, params);
          },
          errorElement: /* @__PURE__ */ jsx133(ErrorContainer10, {}),
          handle: {
            crumb: () => /* @__PURE__ */ jsx133(Link27, { className: "text-md text-gray-500", to: "applications", children: "Applications" })
          },
          children: [
            {
              path: "",
              element: /* @__PURE__ */ jsx133(ListLayoutMobileList, {}),
              errorElement: /* @__PURE__ */ jsx133(ErrorContainer10, {})
            },
            {
              id: `${routePrefix}-vacancy-applications-application`,
              path: ":applicationCode/*",
              element: /* @__PURE__ */ jsx133(OutletRoute23, {}),
              errorElement: /* @__PURE__ */ jsx133(ErrorContainer10, {}),
              children: createCandidateApplicationRoutes(
                `${routePrefix}-vacancy-applications-application`,
                environment,
                context,
                false
              )
            }
          ]
        },
        {
          id: `${routePrefix}-vacancy-matches`,
          path: "matches/*",
          element: /* @__PURE__ */ jsx133(Suspense89, { fallback: "Loading...", children: /* @__PURE__ */ jsx133(OutletRoute23, {}) }),
          errorElement: /* @__PURE__ */ jsx133(ErrorContainer10, {}),
          handle: {
            crumb: () => /* @__PURE__ */ jsx133(Link27, { className: "text-md text-gray-500", to: "matches", children: "Matches" })
          },
          children: [
            {
              path: "*",
              element: /* @__PURE__ */ jsx133(
                VacancyMatchesLayout,
                {
                  vacancyRouteId: routePrefix,
                  environment
                }
              )
            },
            {
              id: `${routePrefix}-vacancy-matches-match`,
              path: ":matchCode/*",
              element: /* @__PURE__ */ jsx133(OutletRoute23, {}),
              errorElement: /* @__PURE__ */ jsx133(ErrorContainer10, {}),
              children: createMatchRoutes(
                `${routePrefix}-vacancy-matches-match`,
                environment,
                context,
                false,
                true
              )
            }
          ]
        },
        {
          id: `${routePrefix}-vacancy-application`,
          path: ":applicationCode/*",
          element: /* @__PURE__ */ jsx133(OutletRoute23, {}),
          errorElement: /* @__PURE__ */ jsx133(ErrorContainer10, {}),
          children: createCandidateApplicationRoutes(
            `${routePrefix}-vacancy-application-application`,
            environment,
            context,
            false,
            false
          )
        },
        {
          id: `${routePrefix}-vacancy-dashboard`,
          path: "*",
          element: /* @__PURE__ */ jsx133(Navigate31, { to: "dashboard", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/vacancies/vacancies/AdminVacanciesRoute.tsx
import { jsx as jsx134 } from "react/jsx-runtime";
var AdminVacanciesRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-vacancies`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx134(OutletRoute24, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx134(VacancySearchLoader, { showAddVacancy: false }),
          children: [
            {
              id: `${listRouteId}-vacancy`,
              path: ":vacancyCode/*",
              element: /* @__PURE__ */ jsx134(OutletRoute24, {}),
              children: createAdminVacancyRoute(
                `${listRouteId}-vacancy`,
                environment,
                context
              ),
              handle: {
                crumb: () => /* @__PURE__ */ jsx134(VacancyLink, { id: `${listRouteId}-vacancy` })
              },
              loader: ({ params }) => {
                return vacancyLoader2(environment, params);
              }
            }
          ]
        },
        {
          id: `${routeId6}-vacancy`,
          path: "view/:vacancyCode/*",
          element: /* @__PURE__ */ jsx134(OutletRoute24, {}),
          children: createAdminVacancyRoute(
            `${routeId6}-vacancy`,
            environment,
            context,
            { hideHeader: true }
          ),
          handle: {
            crumb: () => /* @__PURE__ */ jsx134(VacancyLink, { id: `${routeId6}-vacancy` })
          },
          loader: ({ params }) => {
            return vacancyLoader2(environment, params);
          }
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx134(Navigate32, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/vacancies/AdminVacanciesRoutes.tsx
import { jsx as jsx135, jsxs as jsxs90 } from "react/jsx-runtime";
var Layout11 = () => {
  const location = useLocation16();
  const tabs4 = [createLinkState15(location, "List", `list`, UsersIcon5)];
  return /* @__PURE__ */ jsxs90("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx135("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx135(TabPills7, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx135(Outlet17, {})
  ] });
};
var createVacanciesAdministrationRoutes = (environment, context) => {
  const routeId6 = "admin-vacancies";
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx135(Layout11, {}),
      children: AdminVacanciesRoutes(routeId6, environment, context)
    }
  ];
};

// src/secure/recruit/vacancies/vacancy-qa/components/VacancyQualityAssuranceDashboardRoute.tsx
import { Suspense as Suspense90 } from "react";
import { Navigate as Navigate33 } from "react-router-dom";
import { OutletRoute as OutletRoute25 } from "app-core";
import {
  VacancyQualityAssurancesListContainer,
  createVacancyQualityAssuranceRoute
} from "feature-recruit";
import { jsx as jsx136 } from "react/jsx-runtime";
var List10 = () => {
  return /* @__PURE__ */ jsx136(Suspense90, { fallback: "Loading...", children: /* @__PURE__ */ jsx136(VacancyQualityAssurancesListContainer, {}) });
};
var createVacancyQualityAssuranceDashboardRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-vacancy-quality-assurance`;
  const listRouteId = `${routeId6}-list`;
  const listQARouteId = `${listRouteId}-qa`;
  const qaRouteId = `${routeId6}-qa`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx136(OutletRoute25, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx136(List10, {}),
          children: [
            createVacancyQualityAssuranceRoute(
              listQARouteId,
              environment,
              context
            )
          ]
        },
        createVacancyQualityAssuranceRoute(qaRouteId, environment, context),
        {
          path: "*",
          element: /* @__PURE__ */ jsx136(Navigate33, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/job-board-search/pages/__generated__/JobBoardSearchPageQuery.graphql.ts
var node112 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "code"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "searchId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v7 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ], v8 = {
    "alias": null,
    "args": null,
    "concreteType": "SearchRunStats",
    "kind": "LinkedField",
    "name": "searchRunStats",
    "plural": false,
    "selections": v7,
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "concreteType": "SearchResultStats",
    "kind": "LinkedField",
    "name": "searchResultStats",
    "plural": false,
    "selections": v7,
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobBoardId",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchPageQuery",
      "selections": [
        {
          "alias": "search",
          "args": v1,
          "concreteType": "JobBoardSearchSearch",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v8,
            v9,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "JobBoardSearchContainer_search"
            },
            v10
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchPageQuery",
      "selections": [
        {
          "alias": "search",
          "args": v1,
          "concreteType": "JobBoardSearchSearch",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v8,
            v9,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "organisationId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "query",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resumeDaysOld",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "radius",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "postCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "locationsPattern",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scheduleStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchSearchTriggerSpec",
              "kind": "LinkedField",
              "name": "searchTrigger",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startsOn",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endsOn",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cronExpression",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchSearchJobBoard",
              "kind": "LinkedField",
              "name": "jobBoards",
              "plural": true,
              "selections": [
                v11,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobBoardSearchSearchParameter",
                  "kind": "LinkedField",
                  "name": "parameters",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "autoDownload",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchJobBoard",
              "kind": "LinkedField",
              "name": "jobBoardDefinitions",
              "plural": true,
              "selections": [
                v2,
                v11,
                v5,
                v3
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b8a9b184d692797ab109c1326605e5b7",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchPageQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchPageQuery(\n  $code: Long!\n) {\n  search: jobBoardSearchSearchByCode(code: $code) {\n    id\n    code\n    searchId\n    name\n    description\n    searchRunStats {\n      count\n    }\n    searchResultStats {\n      count\n    }\n    ...JobBoardSearchContainer_search\n  }\n}\n\nfragment JobBoardSearchActivateButton_search on JobBoardSearchSearch {\n  id\n  searchId\n}\n\nfragment JobBoardSearchCloseButton_search on JobBoardSearchSearch {\n  id\n  searchId\n}\n\nfragment JobBoardSearchContainer_search on JobBoardSearchSearch {\n  id\n  searchId\n  createdAt\n  updatedAt\n  name\n  description\n  organisationId\n  query\n  resumeDaysOld\n  radius\n  postCode\n  locationsPattern\n  status\n  scheduleStatus\n  searchTrigger {\n    startsOn\n    endsOn\n    cronExpression\n  }\n  searchRunStats {\n    count\n  }\n  searchResultStats {\n    count\n  }\n  jobBoards {\n    jobBoardId\n    parameters {\n      value\n      formId\n    }\n    autoDownload\n  }\n  jobBoardDefinitions {\n    id\n    jobBoardId\n    name\n    code\n  }\n  ...JobBoardSearchDetailForm_search\n  ...JobBoardSearchDetailView_search\n  ...JobBoardSearchCreateRunButton_search\n  ...JobBoardSearchActivateButton_search\n  ...JobBoardSearchCloseButton_search\n}\n\nfragment JobBoardSearchCreateRunButton_search on JobBoardSearchSearch {\n  id\n  searchId\n}\n\nfragment JobBoardSearchDetailForm_search on JobBoardSearchSearch {\n  id\n  searchId\n  query\n  resumeDaysOld\n  radius\n  postCode\n  locationsPattern\n  description\n  jobBoards {\n    jobBoardId\n    parameters {\n      value\n      formId\n    }\n    autoDownload\n  }\n  jobBoardDefinitions {\n    id\n    jobBoardId\n    name\n    code\n  }\n  ...JobBoardSearchJobBoardEditor_search\n}\n\nfragment JobBoardSearchDetailView_search on JobBoardSearchSearch {\n  id\n  searchId\n  createdAt\n  updatedAt\n  name\n  description\n  organisationId\n  query\n  resumeDaysOld\n  radius\n  postCode\n  locationsPattern\n  status\n  scheduleStatus\n  jobBoards {\n    jobBoardId\n    autoDownload\n    parameters {\n      formId\n      value\n    }\n  }\n  jobBoardDefinitions {\n    id\n    jobBoardId\n    name\n    code\n  }\n}\n\nfragment JobBoardSearchJobBoardEditor_search on JobBoardSearchSearch {\n  id\n  searchId\n  jobBoards {\n    jobBoardId\n    parameters {\n      value\n      formId\n    }\n    autoDownload\n  }\n  jobBoardDefinitions {\n    id\n    jobBoardId\n    name\n    code\n  }\n}\n"
    }
  };
}();
node112.hash = "b47c7724cae0ad73fcaa02012c2b59ef";
var JobBoardSearchPageQuery_graphql_default = node112;

// src/secure/recruit/job-board-search/pages/JobBoardSearchPage.tsx
import { loadQuery as loadQuery40, usePreloadedQuery as usePreloadedQuery12 } from "react-relay";
import { useRouteLoaderData as useRouteLoaderData10 } from "react-router-dom";
import { useRefresh } from "shared-lib";
import { ButtonTabUnderline, useTabs as useTabs3 } from "shared-ui";
import {
  JobBoardSearchContainer,
  JobBoardSearchRunsContainer,
  JobBoardSearchResultsContainer
} from "feature-recruit";

// src/secure/recruit/job-board-search/pages/__generated__/EmployerJobBoardSearchLayoutQuery.graphql.ts
var node113 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v6 = [
    {
      "alias": "employer",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "employerCode"
        }
      ],
      "concreteType": "Employer",
      "kind": "LinkedField",
      "name": "accountsEmployerByCode",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        v2,
        v3,
        v4,
        v5
      ],
      "storageKey": null
    },
    {
      "alias": "module",
      "args": [
        {
          "kind": "Variable",
          "name": "employerCode",
          "variableName": "employerCode"
        }
      ],
      "concreteType": "JobBoardSearchModule",
      "kind": "LinkedField",
      "name": "jobBoardSearchJobBoardSearchModuleByEmployerCode",
      "plural": false,
      "selections": [
        v1,
        v2,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        v4,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTest",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        v3,
        v5
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerJobBoardSearchLayoutQuery",
      "selections": v6,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerJobBoardSearchLayoutQuery",
      "selections": v6
    },
    "params": {
      "cacheID": "8b425c1825bbf961d41d8d2eaea5ac35",
      "id": null,
      "metadata": {},
      "name": "EmployerJobBoardSearchLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerJobBoardSearchLayoutQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    employerId\n    code\n    updatedAt\n    name\n  }\n  module: jobBoardSearchJobBoardSearchModuleByEmployerCode(employerCode: $employerCode) {\n    id\n    code\n    status\n    name\n    isTest\n    createdAt\n    updatedAt\n  }\n}\n"
    }
  };
}();
node113.hash = "66b7fb317668400ee7c673e2dbef9179";
var EmployerJobBoardSearchLayoutQuery_graphql_default = node113;

// src/secure/recruit/job-board-search/pages/EmployerJobBoardSearchLayout.tsx
import { Suspense as Suspense91, useMemo as useMemo10 } from "react";
import {
  Link as Link28,
  Outlet as Outlet18,
  useLoaderData as useLoaderData9,
  useLocation as useLocation17,
  useRouteLoaderData as useRouteLoaderData9
} from "react-router-dom";
import {
  loadQuery as loadQuery39,
  usePreloadedQuery as usePreloadedQuery11
} from "react-relay";
import { ArrowsPointingOutIcon as ArrowsPointingOutIcon6 } from "@heroicons/react/24/outline";
import {
  createLinkState as createLinkState16,
  EdButtonLink as EdButtonLink8,
  IconJustify as IconJustify6,
  TabUnderline as TabUnderline8
} from "shared-ui";
import { Fragment as Fragment45, jsx as jsx137, jsxs as jsxs91 } from "react/jsx-runtime";
var layoutQueryDef2 = EmployerJobBoardSearchLayoutQuery_graphql_default;
function useEmployerJobBoardSearchLayoutRouteData(routeId6) {
  const queryRef = useRouteLoaderData9(
    routeId6
  );
  const data = usePreloadedQuery11(
    layoutQueryDef2,
    queryRef
  );
  return data;
}
var EmployerJobBoardSearchLayout = ({
  showHeader,
  inList
}) => {
  const location = useLocation17();
  const preloadedQuery = useLoaderData9();
  const data = usePreloadedQuery11(layoutQueryDef2, preloadedQuery);
  const tabs4 = useMemo10(() => {
    return [
      createLinkState16(location, "Dashboard", `dashboard`),
      createLinkState16(location, "Searches", `searches`),
      createLinkState16(location, "New Search", `new-search`)
    ];
  }, [location]);
  const { employer, module } = data;
  if (employer === null || employer === void 0) {
    return /* @__PURE__ */ jsx137("div", { children: "Not Found" });
  }
  const name = `${employer.name}`;
  return /* @__PURE__ */ jsx137(Suspense91, { fallback: "Loading...", children: /* @__PURE__ */ jsxs91("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsxs91("div", { className: "flex flex-wrap items-center gap-2 border-b py-4", children: [
      /* @__PURE__ */ jsx137("div", { className: "text-primary-500 px-2 font-medium uppercase sm:px-8", children: name }),
      module ? /* @__PURE__ */ jsx137("div", { className: "text-success-500 px-2 font-medium", children: "Enabled" }) : /* @__PURE__ */ jsx137("div", { className: "text-danger-500 px-2 font-medium", children: "Disabled" })
    ] }),
    /* @__PURE__ */ jsxs91("div", { className: "flex flex-wrap items-center justify-between border-b bg-white py-3", children: [
      /* @__PURE__ */ jsx137("div", { className: "px-4", children: /* @__PURE__ */ jsx137(TabUnderline8, { tabs: tabs4 }) }),
      inList && /* @__PURE__ */ jsx137("div", { children: /* @__PURE__ */ jsx137(
        EdButtonLink8,
        {
          to: `../../../../${employer.code}`,
          name: "View",
          icon: ArrowsPointingOutIcon6,
          iconJustify: IconJustify6.Right
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx137(Outlet18, {})
  ] }) });
};
async function loader39(environment, params) {
  const code = params.employerCode;
  const employerCode = parseInt(code);
  return loadQuery39(
    environment,
    layoutQueryDef2,
    {
      employerCode
    }
  );
}

// src/secure/recruit/job-board-search/pages/JobBoardSearchPage.tsx
import { jsx as jsx138, jsxs as jsxs92 } from "react/jsx-runtime";
var queryDef48 = JobBoardSearchPageQuery_graphql_default;
function useJobBoardSearchPageRouteData(routeId6) {
  const queryRef = useRouteLoaderData10(
    routeId6
  );
  const data = usePreloadedQuery12(queryDef48, queryRef);
  return data;
}
async function loader40(environment, params) {
  return loadQuery40(environment, queryDef48, {
    code: Number(params.searchCode)
  });
}
var JobBoardSearchPage = ({
  routeId: routeId6,
  employerRouteId
}) => {
  const [options, refresh] = useRefresh();
  const { employer } = useEmployerJobBoardSearchLayoutRouteData(employerRouteId);
  const { search } = useJobBoardSearchPageRouteData(routeId6);
  const [current, tabLinks] = useTabs3([
    { name: "Details", label: "Details" },
    {
      name: "Runs",
      label: search?.searchRunStats ? `Runs (${search.searchRunStats.count})` : "Runs"
    },
    {
      name: "Results",
      label: search?.searchResultStats ? `Results (${search.searchResultStats.count})` : "Results"
    }
  ]);
  if (!search || !employer) {
    return /* @__PURE__ */ jsx138("div", { children: "Loading...." });
  }
  let currentTab;
  switch (current.name) {
    case "Details": {
      currentTab = /* @__PURE__ */ jsx138("div", { className: "m-2 flex-1", children: /* @__PURE__ */ jsx138(JobBoardSearchContainer, { search, onUpdate: refresh }) });
      break;
    }
    case "Runs": {
      currentTab = /* @__PURE__ */ jsx138("div", { className: "mx-1 flex-1", children: /* @__PURE__ */ jsx138(
        JobBoardSearchRunsContainer,
        {
          organisationId: employer.employerId,
          searchId: search.searchId
        }
      ) });
      break;
    }
    case "Results": {
      currentTab = /* @__PURE__ */ jsx138("div", { className: "m-1 flex-1", children: /* @__PURE__ */ jsx138(
        JobBoardSearchResultsContainer,
        {
          organisationId: employer.employerId,
          searchId: search.searchId
        }
      ) });
      break;
    }
  }
  return /* @__PURE__ */ jsxs92("div", { className: "rounded-lg border border-gray-200 bg-white p-3", children: [
    /* @__PURE__ */ jsx138("div", { className: "mb-2 font-medium text-gray-500", children: /* @__PURE__ */ jsx138("div", { children: search.name }) }),
    /* @__PURE__ */ jsx138("div", { className: "mb-2 pb-4", children: /* @__PURE__ */ jsx138(ButtonTabUnderline, { tabs: tabLinks }) }),
    /* @__PURE__ */ jsx138("div", { className: "flex", children: currentTab })
  ] });
};
var createRoute31 = (routePrefix, environment, context, employerRouteId) => {
  const routeId6 = `${routePrefix}-search`;
  return {
    id: routeId6,
    path: "search/:searchCode",
    element: /* @__PURE__ */ jsx138(JobBoardSearchPage, { routeId: routeId6, employerRouteId }),
    loader: ({ params }) => {
      return loader40(environment, params);
    }
  };
};

// src/secure/recruit/job-board-search/pages/JobBoardSearchesPage.tsx
import { Suspense as Suspense93, useCallback as useCallback61 } from "react";
import { Link as Link29, useNavigate as useNavigate34 } from "react-router-dom";
import { EdSkeleton as EdSkeleton67 } from "shared-ui";

// src/secure/recruit/job-board-search/pages/__generated__/JobBoardSearchesContainerQuery.graphql.ts
var node114 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organisationId"
  }, v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v3 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "organisationId",
      "variableName": "organisationId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v2
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchesContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardSearchList_searches"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0,
        v2
      ],
      "kind": "Operation",
      "name": "JobBoardSearchesContainerQuery",
      "selections": [
        {
          "alias": "searches",
          "args": v3,
          "concreteType": "JobBoardSearchSearchesConnection",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearches",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchSearchesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobBoardSearchSearch",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "searchId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "query",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumeDaysOld",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "radius",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "postCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "locationsPattern",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scheduleStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "searches",
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "JobBoardSearchList_searches",
          "kind": "LinkedHandle",
          "name": "jobBoardSearchSearches"
        }
      ]
    },
    "params": {
      "cacheID": "197429b2a60422ce3089f03c0591ef3f",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchesContainerQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchesContainerQuery(\n  $organisationId: UUID!\n  $order: [JobBoardSearchSearchSort!]!\n  $where: JobBoardSearchSearchFilter!\n) {\n  ...JobBoardSearchList_searches\n}\n\nfragment JobBoardSearchList_searches on Query {\n  searches: jobBoardSearchSearches(organisationId: $organisationId, first: 10, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        searchId\n        ...JobBoardSearchRow_search\n        __typename\n      }\n    }\n  }\n}\n\nfragment JobBoardSearchRow_search on JobBoardSearchSearch {\n  id\n  code\n  searchId\n  createdAt\n  updatedAt\n  name\n  description\n  organisationId\n  query\n  resumeDaysOld\n  radius\n  postCode\n  locationsPattern\n  status\n  scheduleStatus\n}\n"
    }
  };
}();
node114.hash = "9210fb1990fbf78b769fde8df1438b9f";
var JobBoardSearchesContainerQuery_graphql_default = node114;

// src/secure/recruit/job-board-search/pages/JobBoardSearchesContainer.tsx
import { Suspense as Suspense92, useCallback as useCallback60, useState as useState23 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery29 } from "react-relay/hooks";
import { useDebounce as useDebounce14 } from "shared-lib";
import { Button as Button31, EdSkeleton as EdSkeleton66, Input as Input15, RadioList as RadioList6 } from "shared-ui";
import { JobBoardSearchList, JobBoardSearchStatus } from "feature-recruit";
import { jsx as jsx139, jsxs as jsxs93 } from "react/jsx-runtime";
var statusList4 = [
  {
    id: "All",
    label: "All"
  },
  {
    id: JobBoardSearchStatus.Active.toString(),
    label: "Active"
  },
  {
    id: JobBoardSearchStatus.Draft.toString(),
    label: "Draft"
  },
  {
    id: JobBoardSearchStatus.Closed.toString(),
    label: "Closed"
  }
];
var graphqlQuery15 = JobBoardSearchesContainerQuery_graphql_default;
var JobBoardSearchesContainer = ({
  employer,
  onSelect
}) => {
  const onNewSearch = useCallback60(() => {
  }, []);
  const [filter, setFilter] = useState23(null);
  const searchTerm = useDebounce14(filter, 500);
  const [searchStatus, setSearchStatus] = useState23(statusList4[0]);
  const onSetVacancySyncStatus = useCallback60(
    (ms) => {
      setSearchStatus(ms);
    },
    [searchStatus]
  );
  const order2 = [{ updatedAt: "DESC" }];
  const where2 = {
    organisationId: { eq: employer.employerId }
  };
  const query = useLazyLoadQuery29(
    graphqlQuery15,
    { organisationId: employer.employerId, where: where2, order: order2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (!employer) {
    return /* @__PURE__ */ jsx139(EdSkeleton66, {});
  }
  return /* @__PURE__ */ jsx139(Suspense92, { fallback: /* @__PURE__ */ jsx139(EdSkeleton66, {}), children: /* @__PURE__ */ jsxs93("div", { children: [
    /* @__PURE__ */ jsxs93("div", { className: "flex items-center justify-between space-x-4", children: [
      /* @__PURE__ */ jsxs93("div", { className: "flex items-center space-x-4", children: [
        /* @__PURE__ */ jsxs93("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx139("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
          /* @__PURE__ */ jsx139("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx139(
            Input15,
            {
              placeholder: " Title or Bullhorn Code ",
              name: "filter",
              onValueChange: (filter2) => setFilter(filter2)
            },
            "filter"
          ) })
        ] }),
        /* @__PURE__ */ jsxs93("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx139("label", { className: "text-gray-700", htmlFor: "filter", children: "Sync Status" }),
          /* @__PURE__ */ jsx139("div", { children: /* @__PURE__ */ jsx139(
            RadioList6,
            {
              list: statusList4,
              value: searchStatus,
              onChange: (status) => onSetVacancySyncStatus(status)
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsx139("div", { className: "flex items-center space-x-4 p-2", children: /* @__PURE__ */ jsx139(Button31, { className: "p-2", color: "primary", clicked: onNewSearch, children: "New Search" }) })
    ] }),
    /* @__PURE__ */ jsx139(JobBoardSearchList, { onSelect, searchesKey: query })
  ] }) });
};

// src/secure/recruit/job-board-search/pages/JobBoardSearchesPage.tsx
import { jsx as jsx140 } from "react/jsx-runtime";
var JobBoardSearchesPage = ({ employerRouteId }) => {
  const navigate = useNavigate34();
  const { employer } = useEmployerJobBoardSearchLayoutRouteData(employerRouteId);
  const onSelect = useCallback61(
    ({ code }) => {
      navigate(`../search/${code}`);
    },
    [navigate]
  );
  if (!employer) {
    return /* @__PURE__ */ jsx140(EdSkeleton67, {});
  }
  return /* @__PURE__ */ jsx140(Suspense93, { fallback: /* @__PURE__ */ jsx140(EdSkeleton67, {}), children: /* @__PURE__ */ jsx140("div", { children: /* @__PURE__ */ jsx140(JobBoardSearchesContainer, { employer, onSelect }) }) });
};
var createRoute32 = (routePrefix, environment, context, employerRouteId) => {
  const routeId6 = `${routePrefix}-searches`;
  return {
    id: routeId6,
    path: "searches",
    element: /* @__PURE__ */ jsx140(JobBoardSearchesPage, { employerRouteId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx140(Link29, { to: "searches", children: "Searches" })
    }
  };
};

// src/secure/recruit/job-board-search/pages/EmployerJobBoardDashboard.tsx
import { useCallback as useCallback62 } from "react";
import { Link as Link30 } from "react-router-dom";
import { Button as Button32, EdSkeleton as EdSkeleton68 } from "shared-ui";
import {
  useEnableJobBoardSearchModule
} from "feature-recruit";
import { jsx as jsx141, jsxs as jsxs94 } from "react/jsx-runtime";
var Page = ({ employerRouteId }) => {
  const { employer, module } = useEmployerJobBoardSearchLayoutRouteData(employerRouteId);
  const [enable, isEnabling] = useEnableJobBoardSearchModule();
  const onEnable = useCallback62(async () => {
    if (!employer) {
      return;
    }
    const input = {
      organisationId: employer.employerId
    };
    const result = await enable({ connections: [], input });
    if (result.result) {
    }
  }, [enable]);
  const onNew = useCallback62(() => {
  }, []);
  const onCancel = useCallback62(() => {
  }, []);
  if (!employer) {
    return /* @__PURE__ */ jsx141(EdSkeleton68, {});
  }
  return /* @__PURE__ */ jsx141("div", { className: "m-8 rounded-lg border border-gray-200 bg-white p-3 md:w-1/3", children: module ? /* @__PURE__ */ jsx141("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsx141("div", { className: "text-success-500 px-2 font-medium", children: "Enabled" }) }) : /* @__PURE__ */ jsxs94("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx141("div", { className: "border-b p-2", children: /* @__PURE__ */ jsx141("div", { className: "text-danger-500 px-2 font-medium", children: "Disabled" }) }),
    /* @__PURE__ */ jsx141("div", { className: "p-2", children: /* @__PURE__ */ jsx141(Button32, { color: "primary", clicked: onEnable, disabled: isEnabling, children: "Enable" }) })
  ] }) });
};
var createRoute33 = (routePrefix, environment, context, employerRouteId) => {
  const routeId6 = `${routePrefix}-dashboard`;
  return {
    id: routeId6,
    path: "dashboard",
    element: /* @__PURE__ */ jsx141(Page, { employerRouteId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx141(Link30, { to: "dashboard", children: "Dashboard" })
    }
  };
};

// src/secure/recruit/job-board-search/pages/JobBoardNewSearchPage.tsx
import { useCallback as useCallback63 } from "react";
import { Link as Link31, useNavigate as useNavigate35 } from "react-router-dom";
import { JobBoardSearchNewForm } from "feature-recruit";
import { EdSkeleton as EdSkeleton69 } from "shared-ui";
import { jsx as jsx142, jsxs as jsxs95 } from "react/jsx-runtime";
var JobBoardNewSearchPage = ({ employerRouteId }) => {
  const navigate = useNavigate35();
  const { employer } = useEmployerJobBoardSearchLayoutRouteData(employerRouteId);
  const onNew = useCallback63(
    (code) => {
      navigate(`../search/${code}`);
    },
    [navigate]
  );
  const onCancel = useCallback63(() => {
    navigate(`../searches`);
  }, [navigate]);
  if (!employer) {
    return /* @__PURE__ */ jsx142(EdSkeleton69, {});
  }
  return /* @__PURE__ */ jsxs95("div", { className: "m-8 rounded-lg border border-gray-200 bg-white p-3 md:w-1/3", children: [
    /* @__PURE__ */ jsx142("div", { className: "mb-2 font-medium text-gray-500", children: /* @__PURE__ */ jsx142("div", { children: "Create A Search" }) }),
    /* @__PURE__ */ jsx142("div", { className: "mb-2 pb-4", children: /* @__PURE__ */ jsx142(
      JobBoardSearchNewForm,
      {
        organisationId: employer.employerId,
        onDone: onNew,
        onCancel
      }
    ) })
  ] });
};
var createRoute34 = (routePrefix, environment, context, employerRouteId) => {
  const routeId6 = `${routePrefix}-new-search`;
  return {
    id: routeId6,
    path: "new-search",
    element: /* @__PURE__ */ jsx142(JobBoardNewSearchPage, { employerRouteId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx142(Link31, { to: "new-search", children: "New Search" })
    }
  };
};

// src/secure/recruit/job-board-search/JobBoardSearchLayout.tsx
import { Navigate as Navigate34 } from "react-router-dom";
import { OutletRoute as OutletRoute26 } from "app-core";

// src/secure/recruit/employers/EmployersList.tsx
import { useCallback as useCallback64 } from "react";
import { useNavigate as useNavigate36 } from "react-router-dom";
import {
  EmployerSearchContainer as EmployerSearchContainer2
} from "feature-employer-accounts";
import { jsx as jsx143, jsxs as jsxs96 } from "react/jsx-runtime";
var EmployersList = ({ navigateTo: navigateTo2 }) => {
  const navigate = useNavigate36();
  const onSelect = useCallback64(
    (result) => {
      navigate(navigateTo2(result));
    },
    [navigate]
  );
  return /* @__PURE__ */ jsxs96("div", { className: "container m-auto flex flex-col gap-2 border bg-white p-8", children: [
    /* @__PURE__ */ jsx143("div", { className: "text-primary-500 border-b p-2 text-lg", children: "Search for Employer" }),
    /* @__PURE__ */ jsx143("div", { className: "p-2", children: /* @__PURE__ */ jsx143(EmployerSearchContainer2, { onSearchCompleted: onSelect }) })
  ] });
};

// src/secure/recruit/job-board-search/JobBoardSearchLayout.tsx
import { jsx as jsx144 } from "react/jsx-runtime";
function navigateTo(result) {
  return `../employer/${result.code}`;
}
var createJobBoardSearchRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-job-board-search`;
  const employerRouteId = `${routeId6}-employer`;
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx144(OutletRoute26, {}),
      children: [
        {
          path: "list/*",
          element: /* @__PURE__ */ jsx144(EmployersList, { navigateTo })
        },
        {
          id: employerRouteId,
          path: "employer/:employerCode/*",
          element: /* @__PURE__ */ jsx144(EmployerJobBoardSearchLayout, { inList: false, showHeader: true }),
          loader: ({ params }) => {
            return loader39(environment, params);
          },
          children: [
            createRoute33(routeId6, environment, context, employerRouteId),
            createRoute34(routeId6, environment, context, employerRouteId),
            createRoute32(routeId6, environment, context, employerRouteId),
            createRoute31(routeId6, environment, context, employerRouteId),
            {
              path: "*",
              element: /* @__PURE__ */ jsx144(Navigate34, { to: "dashboard", replace: true })
            }
          ]
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx144(Navigate34, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/email-applications/EmailApplicationsLayout.tsx
import { Navigate as Navigate36 } from "react-router-dom";
import { OutletRoute as OutletRoute27 } from "app-core";
import { EmailApplicationList } from "feature-recruit";

// src/secure/recruit/email-applications/components/__generated__/EmailApplicationRouteQuery.graphql.ts
var node115 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "emailApplicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "emailApplicationCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailApplicationId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailApplicationRouteQuery",
      "selections": [
        {
          "alias": "emailApplication",
          "args": v1,
          "concreteType": "RecruitEmailApplication",
          "kind": "LinkedField",
          "name": "recruitEmailApplicationByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmailApplicationContainer_emailApplication"
            },
            v8
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailApplicationRouteQuery",
      "selections": [
        {
          "alias": "emailApplication",
          "args": v1,
          "concreteType": "RecruitEmailApplication",
          "kind": "LinkedField",
          "name": "recruitEmailApplicationByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobBoardName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyUnknown",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyClosed",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "receivedDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailSubject",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rawContents",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitEmailApplicationEvent",
              "kind": "LinkedField",
              "name": "events",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "details",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "eventTiming",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isFailure",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "7efa6f3fd84e6d39cca58bc7b5a1c816",
      "id": null,
      "metadata": {},
      "name": "EmailApplicationRouteQuery",
      "operationKind": "query",
      "text": "query EmailApplicationRouteQuery(\n  $emailApplicationCode: Int!\n) {\n  emailApplication: recruitEmailApplicationByCode(code: $emailApplicationCode) {\n    id\n    code\n    emailApplicationId\n    firstName\n    lastName\n    emailAddress\n    ...EmailApplicationContainer_emailApplication\n  }\n}\n\nfragment EmailApplicationContainer_emailApplication on RecruitEmailApplication {\n  id\n  code\n  emailApplicationId\n  firstName\n  lastName\n  emailAddress\n  jobReference\n  jobBoardName\n  vacancyUnknown\n  vacancyClosed\n  receivedDate\n  emailSubject\n  rawContents\n  events {\n    date\n    details\n    eventTiming\n    isFailure\n  }\n}\n"
    }
  };
}();
node115.hash = "aefbfc892165a0dfc28babcadf3c0fdd";
var EmailApplicationRouteQuery_graphql_default = node115;

// src/secure/recruit/email-applications/components/EmailApplicationRoute.tsx
import { Suspense as Suspense94 } from "react";
import {
  Navigate as Navigate35,
  Outlet as Outlet19,
  useLocation as useLocation18,
  useRouteLoaderData as useRouteLoaderData11
} from "react-router-dom";
import {
  loadQuery as loadQuery41,
  usePreloadedQuery as usePreloadedQuery13
} from "react-relay";
import { UsersIcon as UsersIcon6 } from "@heroicons/react/24/outline";
import { useRouteData as useRouteData31 } from "shared-lib";
import { createLinkState as createLinkState17, EdSkeleton as EdSkeleton70, TabPills as TabPills8 } from "shared-ui";
import { EmailApplicationContainer } from "feature-recruit";
import { Fragment as Fragment46, jsx as jsx145, jsxs as jsxs97 } from "react/jsx-runtime";
var queryDef49 = EmailApplicationRouteQuery_graphql_default;
async function loader41(environment, params) {
  const code = params.emailApplicationCode;
  const emailApplicationCode = parseInt(code);
  return loadQuery41(environment, queryDef49, {
    emailApplicationCode
  });
}
var EmailApplicationDetails = ({ routeId: routeId6 }) => {
  const data = useRouteData31(queryDef49, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx145(Fragment46, { children: "Loading..." });
  }
  const { emailApplication } = data;
  if (!emailApplication) {
    return /* @__PURE__ */ jsx145(EdSkeleton70, {});
  }
  return /* @__PURE__ */ jsx145(Suspense94, { fallback: /* @__PURE__ */ jsx145(EdSkeleton70, {}), children: /* @__PURE__ */ jsx145("div", { className: "p-4", children: /* @__PURE__ */ jsx145(EmailApplicationContainer, { fragmentRef: emailApplication }) }) });
};
var Layout12 = () => {
  const location = useLocation18();
  const tabs4 = [createLinkState17(location, "Details", `details`, UsersIcon6)];
  return /* @__PURE__ */ jsxs97("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsx145("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx145(TabPills8, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx145(Outlet19, {})
  ] });
};
var createRoute35 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-email-application`;
  return {
    id: routeId6,
    path: ":emailApplicationCode",
    element: /* @__PURE__ */ jsx145(Layout12, {}),
    loader: ({ params }) => {
      return loader41(environment, params);
    },
    children: [
      {
        id: `${routeId6}-details`,
        path: "details/*",
        element: /* @__PURE__ */ jsx145("div", { className: "flex-1", children: /* @__PURE__ */ jsx145(EmailApplicationDetails, { routeId: routeId6, inList }) })
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx145(Navigate35, { to: "details", replace: true })
      }
    ]
  };
};

// src/secure/recruit/email-applications/EmailApplicationsLayout.tsx
import { jsx as jsx146 } from "react/jsx-runtime";
var List11 = () => {
  return /* @__PURE__ */ jsx146("div", { children: /* @__PURE__ */ jsx146(EmailApplicationList, {}) });
};
var createEmailApplicationsRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-email-applications`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx146(OutletRoute27, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx146(List11, {}),
          children: [
            createRoute35(
              listRouteId,
              environment,
              context,
              true
            )
          ]
        },
        createRoute35(routeId6, environment, context, false),
        {
          path: "*",
          element: /* @__PURE__ */ jsx146(Navigate36, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/RecruitLayout.tsx
import { jsx as jsx147, jsxs as jsxs98 } from "react/jsx-runtime";
var tabs3 = [
  {
    label: "Vacancies",
    to: "../vacancies",
    description: "Administer Vacancies"
  },
  {
    label: "Talent Pools",
    to: "../talent-pools",
    description: "Administer Talent Pools"
  },
  { label: "Job Boards", to: "../job-boards", description: "Job Boards" },
  {
    label: "Job Board Search",
    to: "../job-board-search",
    description: "Job Board Search"
  },
  {
    label: "Email Applications",
    to: "../email-applications",
    description: "Email Applications"
  },
  {
    label: "Config",
    to: "../config",
    description: "Config"
  },
  {
    label: "Vacancy QA",
    to: "../vacancy-qa",
    description: "Vacancy Quality Assurance"
  }
];
var AccountsHome = () => {
  const links = tabs3.map((t) => {
    return /* @__PURE__ */ jsxs98(
      EdLink8,
      {
        name: t.label,
        href: t.to,
        className: "border bg-white p-8",
        children: [
          /* @__PURE__ */ jsx147("div", { className: "text-primary-500 py-2 text-xl", children: t.label }),
          /* @__PURE__ */ jsx147("p", { className: "mt-2 py-2  text-sm text-gray-500", children: t.description })
        ]
      },
      t.to
    );
  });
  return /* @__PURE__ */ jsx147(Suspense95, { fallback: "Loading...", children: /* @__PURE__ */ jsx147(ErrorBoundary14, { FallbackComponent: ErrorBoundaryFallback14, children: /* @__PURE__ */ jsx147("div", { className: "flex sm:m-8", children: /* @__PURE__ */ jsx147("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-3", children: links }) }) }) });
};
var createAppAdminRecruitRoutes = (environment, context) => {
  const routeId6 = "admin-recruit";
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx147(OutletRoute28, {}),
      children: [
        {
          path: "home/*",
          element: /* @__PURE__ */ jsx147(AccountsHome, {})
        },
        {
          path: "vacancies/*",
          element: /* @__PURE__ */ jsx147(OutletRoute28, {}),
          children: createVacanciesAdministrationRoutes(environment, context)
        },
        {
          path: "talent-pools/*",
          element: /* @__PURE__ */ jsx147(OutletRoute28, {}),
          children: createTalentPoolsRoutes(
            "admin-job-talent-pools",
            environment,
            context
          )
        },
        {
          path: "job-board-search/*",
          element: /* @__PURE__ */ jsx147(OutletRoute28, {}),
          children: createJobBoardSearchRoutes(routeId6, environment, context)
        },
        {
          path: "job-boards/*",
          element: /* @__PURE__ */ jsx147(OutletRoute28, {}),
          children: createJobBoardsRoutes(routeId6, environment, context)
        },
        {
          path: "config/*",
          element: /* @__PURE__ */ jsx147(OutletRoute28, {}),
          children: createConfigRoutes(routeId6, environment, context)
        },
        {
          path: "email-applications/*",
          element: /* @__PURE__ */ jsx147(OutletRoute28, {}),
          children: createEmailApplicationsRoutes(
            routeId6,
            environment,
            context
          )
        },
        {
          path: "vacancy-qa/*",
          element: /* @__PURE__ */ jsx147(OutletRoute28, {}),
          children: createVacancyQualityAssuranceDashboardRoutes(
            routeId6,
            environment,
            context
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx147(Navigate37, { to: "home", replace: true })
        }
      ]
    }
  ];
};

// src/AppAdminRoutes.tsx
import { jsx as jsx148 } from "react/jsx-runtime";
var AppAdminRoutes = (environment, context) => {
  return [
    {
      path: "signin-oidc/*",
      element: /* @__PURE__ */ jsx148(SignInLoader, {}),
      errorElement: /* @__PURE__ */ jsx148(ErrorContainer11, {})
    },
    {
      path: "signout-oidc",
      element: /* @__PURE__ */ jsx148(Navigate38, { replace: true, to: "/employers" }),
      errorElement: /* @__PURE__ */ jsx148(ErrorContainer11, {})
    },
    {
      path: "app/*",
      element: /* @__PURE__ */ jsx148(AppAdminSecureLayout, {}),
      errorElement: /* @__PURE__ */ jsx148(ErrorContainer11, {}),
      loader: () => {
        return loader(environment);
      },
      children: AppAdminSecureRoutes(environment, context)
    },
    {
      path: "debugger/*",
      element: /* @__PURE__ */ jsx148(DebuggerConfig, { onDone: () => console.log(``) }),
      errorElement: /* @__PURE__ */ jsx148(ErrorContainer11, {})
    },
    {
      index: true,
      element: /* @__PURE__ */ jsx148(HomePage, {}),
      errorElement: /* @__PURE__ */ jsx148(ErrorContainer11, {})
    }
  ];
};

// src/AppAdmin.tsx
import { Suspense as Suspense96, useEffect as useEffect4 } from "react";
import { Outlet as Outlet20 } from "react-router-dom";
import {
  AuthProvider,
  getAppContext,
  setAppContext,
  Tenant as Tenant2,
  useOIDC as useOIDC2
} from "app-core";
import { jsx as jsx149 } from "react/jsx-runtime";
var app = {
  tenant: Tenant2.Admin
};
var AppAdmin = () => {
  const oidc = useOIDC2();
  const authConfig = useAuthConfig();
  useRouteRegistry();
  useEffect4(() => {
    let isMounted = true;
    const currentContext = getAppContext();
    if (currentContext && currentContext.tenant != app.tenant) {
      setAppContext(app);
      window.location.reload();
      return;
    }
    setAppContext(app);
    async function checkSessionAsync() {
      oidc.setTenant(Tenant2.Admin);
      await oidc.checkSession();
    }
    checkSessionAsync();
    return () => {
      isMounted = false;
    };
  }, [oidc]);
  return /* @__PURE__ */ jsx149(AuthProvider, { ...authConfig, children: /* @__PURE__ */ jsx149(Suspense96, { fallback: "Loading Admin...", children: /* @__PURE__ */ jsx149(Outlet20, {}) }) });
};
export {
  AppAdmin,
  AppAdminRoutes
};
//# sourceMappingURL=index.mjs.map